function _mergeNamespaces(e, t) {
  for (var o = 0; o < t.length; o++) {
    const i = t[o];
    if (typeof i != "string" && !Array.isArray(i)) {
      for (const d in i)
        if (d !== "default" && !(d in e)) {
          const s = Object.getOwnPropertyDescriptor(i, d);
          s && Object.defineProperty(e, d, s.get ? s : {
            enumerable: !0,
            get: () => i[d]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var browser, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  var e = function(t, o, i, d, s, n, r, u) {
    if (process.env.NODE_ENV !== "production" && o === void 0)
      throw new Error("invariant requires an error message argument");
    if (!t) {
      var l;
      if (o === void 0)
        l = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var c = [i, d, s, n, r, u], g = 0;
        l = new Error(
          o.replace(/%s/g, function() {
            return c[g++];
          })
        ), l.name = "Invariant Violation";
      }
      throw l.framesToPop = 1, l;
    }
  };
  return browser = e, browser;
}
var browserExports = requireBrowser();
const invariant = /* @__PURE__ */ getDefaultExportFromCjs(browserExports), isFunction = (function(e) {
  return typeof e == "function";
}), isSymbol = (function(e) {
  return typeof e == "symbol" || typeof e == "object" && Object.prototype.toString.call(e) === "[object Symbol]";
}), isEmpty = (function(e) {
  return e.length === 0;
}), toString = (function(e) {
  return e.toString();
}), isString = (function(e) {
  return typeof e == "string";
});
var DEFAULT_NAMESPACE = "/", ACTION_TYPE_DELIMITER = "||";
function isValidActionType(e) {
  return isString(e) || isFunction(e) || isSymbol(e);
}
function isValidActionTypes(e) {
  return isEmpty(e) ? !1 : e.every(isValidActionType);
}
function combineActions() {
  for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++)
    t[o] = arguments[o];
  invariant(isValidActionTypes(t), "Expected action types to be strings, symbols, or action creators");
  var i = t.map(toString).join(ACTION_TYPE_DELIMITER);
  return {
    toString: function() {
      return i;
    }
  };
}
const identity = (function(e) {
  return e;
}), isNull = (function(e) {
  return e === null;
});
function createAction(e, t, o) {
  t === void 0 && (t = identity), invariant(isFunction(t) || isNull(t), "Expected payloadCreator to be a function, undefined or null");
  var i = isNull(t) || t === identity ? identity : function(r) {
    for (var u = arguments.length, l = new Array(u > 1 ? u - 1 : 0), c = 1; c < u; c++)
      l[c - 1] = arguments[c];
    return r instanceof Error ? r : t.apply(void 0, [r].concat(l));
  }, d = isFunction(o), s = e.toString(), n = function() {
    var u = i.apply(void 0, arguments), l = {
      type: e
    };
    return u instanceof Error && (l.error = !0), u !== void 0 && (l.payload = u), d && (l.meta = o.apply(void 0, arguments)), l;
  };
  return n.toString = function() {
    return s;
  }, n;
}
const isPlainObject = (function(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}), isArray = (function(e) {
  return Array.isArray(e);
}), isNil = (function(e) {
  return e == null;
}), getLastElement = (function(e) {
  return e[e.length - 1];
});
var toNoCase_1, hasRequiredToNoCase;
function requireToNoCase() {
  if (hasRequiredToNoCase) return toNoCase_1;
  hasRequiredToNoCase = 1, toNoCase_1 = i;
  var e = /\s/, t = /(_|-|\.|:)/, o = /([a-z][A-Z]|[A-Z][a-z])/;
  function i(u) {
    return e.test(u) ? u.toLowerCase() : t.test(u) ? (s(u) || u).toLowerCase() : o.test(u) ? r(u).toLowerCase() : u.toLowerCase();
  }
  var d = /[\W_]+(.|$)/g;
  function s(u) {
    return u.replace(d, function(l, c) {
      return c ? " " + c : "";
    });
  }
  var n = /(.)([A-Z]+)/g;
  function r(u) {
    return u.replace(n, function(l, c, g) {
      return c + " " + g.toLowerCase().split("").join(" ");
    });
  }
  return toNoCase_1;
}
var toSpaceCase_1, hasRequiredToSpaceCase;
function requireToSpaceCase() {
  if (hasRequiredToSpaceCase) return toSpaceCase_1;
  hasRequiredToSpaceCase = 1;
  var e = requireToNoCase();
  toSpaceCase_1 = t;
  function t(o) {
    return e(o).replace(/[\W_]+(.|$)/g, function(i, d) {
      return d ? " " + d : "";
    }).trim();
  }
  return toSpaceCase_1;
}
var toCamelCase_1, hasRequiredToCamelCase;
function requireToCamelCase() {
  if (hasRequiredToCamelCase) return toCamelCase_1;
  hasRequiredToCamelCase = 1;
  var e = requireToSpaceCase();
  toCamelCase_1 = t;
  function t(o) {
    return e(o).replace(/\s(\w)/g, function(i, d) {
      return d.toUpperCase();
    });
  }
  return toCamelCase_1;
}
var toCamelCaseExports = requireToCamelCase();
const camelCase$1 = /* @__PURE__ */ getDefaultExportFromCjs(toCamelCaseExports);
var namespacer = "/";
const camelCase = (function(e) {
  return e.indexOf(namespacer) === -1 ? camelCase$1(e) : e.split(namespacer).map(camelCase$1).join(namespacer);
}), arrayToObject = (function(e, t) {
  return e.reduce(function(o, i) {
    return t(o, i);
  }, {});
}), isMap = (function(e) {
  return typeof Map < "u" && e instanceof Map;
});
function ownKeys(e) {
  if (isMap(e))
    return Array.from(e.keys());
  if (typeof Reflect < "u" && typeof Reflect.ownKeys == "function")
    return Reflect.ownKeys(e);
  var t = Object.getOwnPropertyNames(e);
  return typeof Object.getOwnPropertySymbols == "function" && (t = t.concat(Object.getOwnPropertySymbols(e))), t;
}
function get(e, t) {
  return isMap(t) ? t.get(e) : t[e];
}
const flattenWhenNode = (function(e) {
  return function t(o, i, d, s) {
    var n = i === void 0 ? {} : i, r = n.namespace, u = r === void 0 ? DEFAULT_NAMESPACE : r, l = n.prefix;
    d === void 0 && (d = {}), s === void 0 && (s = "");
    function c(p) {
      var m;
      if (!s) return p;
      var h = p.toString().split(ACTION_TYPE_DELIMITER), f = s.split(ACTION_TYPE_DELIMITER);
      return (m = []).concat.apply(m, f.map(function(y) {
        return h.map(function(N) {
          return "" + y + u + N;
        });
      })).join(ACTION_TYPE_DELIMITER);
    }
    function g(p) {
      return s || !l || l && new RegExp("^" + l + u).test(p) ? p : "" + l + u + p;
    }
    return ownKeys(o).forEach(function(p) {
      var m = g(c(p)), h = get(p, o);
      e(h) ? t(h, {
        namespace: u,
        prefix: l
      }, d, m) : d[m] = h;
    }), d;
  };
}), flattenActionMap = flattenWhenNode(isPlainObject);
function unflattenActionCreators(e, t) {
  var o = t === void 0 ? {} : t, i = o.namespace, d = i === void 0 ? DEFAULT_NAMESPACE : i, s = o.prefix;
  function n(u, l, c) {
    var g = camelCase(c.shift());
    isEmpty(c) ? l[g] = e[u] : (l[g] || (l[g] = {}), n(u, l[g], c));
  }
  var r = {};
  return Object.getOwnPropertyNames(e).forEach(function(u) {
    var l = s ? u.replace("" + s + d, "") : u;
    return n(u, r, l.split(d));
  }), r;
}
function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = arguments[t] != null ? arguments[t] : {}, i = Object.keys(o);
    typeof Object.getOwnPropertySymbols == "function" && (i = i.concat(Object.getOwnPropertySymbols(o).filter(function(d) {
      return Object.getOwnPropertyDescriptor(o, d).enumerable;
    }))), i.forEach(function(d) {
      _defineProperty(e, d, o[d]);
    });
  }
  return e;
}
function _defineProperty(e, t, o) {
  return t in e ? Object.defineProperty(e, t, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = o, e;
}
function createActions(e) {
  for (var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    o[i - 1] = arguments[i];
  var d = isPlainObject(getLastElement(o)) ? o.pop() : {};
  return invariant(o.every(isString) && (isString(e) || isPlainObject(e)), "Expected optional object followed by string action types"), isString(e) ? actionCreatorsFromIdentityActions([e].concat(o), d) : _objectSpread({}, actionCreatorsFromActionMap(e, d), actionCreatorsFromIdentityActions(o, d));
}
function actionCreatorsFromActionMap(e, t) {
  var o = flattenActionMap(e, t), i = actionMapToActionCreators(o);
  return unflattenActionCreators(i, t);
}
function actionMapToActionCreators(e, t) {
  var o = t === void 0 ? {} : t, i = o.prefix, d = o.namespace, s = d === void 0 ? DEFAULT_NAMESPACE : d;
  function n(r) {
    if (isFunction(r) || isNil(r))
      return !0;
    if (isArray(r)) {
      var u = r[0], l = u === void 0 ? identity : u, c = r[1];
      return isFunction(l) && isFunction(c);
    }
    return !1;
  }
  return arrayToObject(Object.keys(e), function(r, u) {
    var l, c = e[u];
    invariant(n(c), "Expected function, undefined, null, or array with payload and meta " + ("functions for " + u));
    var g = i ? "" + i + s + u : u, p = isArray(c) ? createAction.apply(void 0, [g].concat(c)) : createAction(g, c);
    return _objectSpread({}, r, (l = {}, l[u] = p, l));
  });
}
function actionCreatorsFromIdentityActions(e, t) {
  var o = arrayToObject(e, function(d, s) {
    var n;
    return _objectSpread({}, d, (n = {}, n[s] = identity, n));
  }), i = actionMapToActionCreators(o, t);
  return arrayToObject(Object.keys(i), function(d, s) {
    var n;
    return _objectSpread({}, d, (n = {}, n[camelCase(s)] = i[s], n));
  });
}
const isUndefined = (function(e) {
  return e === void 0;
});
function handleAction(e, t, o) {
  t === void 0 && (t = identity);
  var i = toString(e).split(ACTION_TYPE_DELIMITER);
  invariant(!isUndefined(o), "defaultState for reducer handling " + i.join(", ") + " should be defined"), invariant(isFunction(t) || isPlainObject(t), "Expected reducer to be a function or object with next and throw reducers");
  var d = isFunction(t) ? [t, t] : [t.next, t.throw].map(function(r) {
    return isNil(r) ? identity : r;
  }), s = d[0], n = d[1];
  return function(r, u) {
    r === void 0 && (r = o);
    var l = u.type;
    return !l || i.indexOf(toString(l)) === -1 ? r : (u.error === !0 ? n : s)(r, u);
  };
}
const reduceReducers = (function() {
  for (var e = arguments.length, t = Array(e), o = 0; o < e; o++)
    t[o] = arguments[o];
  var i = typeof t[t.length - 1] != "function" && t.pop(), d = t;
  if (typeof i > "u")
    throw new TypeError("The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.");
  return function(s, n) {
    for (var r = arguments.length, u = Array(r > 2 ? r - 2 : 0), l = 2; l < r; l++)
      u[l - 2] = arguments[l];
    var c = typeof s > "u", g = typeof n > "u";
    return c && g && i ? i : d.reduce(function(p, m) {
      return m.apply(void 0, [p, n].concat(u));
    }, c && !g && i ? i : s);
  };
});
function hasGeneratorInterface(e) {
  var t = ownKeys(e), o = t.every(function(i) {
    return i === "next" || i === "throw";
  });
  return t.length && t.length <= 2 && o;
}
const flattenReducerMap = flattenWhenNode(function(e) {
  return (isPlainObject(e) || isMap(e)) && !hasGeneratorInterface(e);
});
function handleActions(e, t, o) {
  o === void 0 && (o = {}), invariant(isPlainObject(e) || isMap(e), "Expected handlers to be a plain object.");
  var i = flattenReducerMap(e, o), d = ownKeys(i).map(function(n) {
    return handleAction(n, get(n, i), t);
  }), s = reduceReducers.apply(void 0, d.concat([t]));
  return function(n, r) {
    return n === void 0 && (n = t), s(n, r);
  };
}
var util;
(function(e) {
  e.assertEqual = (d) => d;
  function t(d) {
  }
  e.assertIs = t;
  function o(d) {
    throw new Error();
  }
  e.assertNever = o, e.arrayToEnum = (d) => {
    const s = {};
    for (const n of d)
      s[n] = n;
    return s;
  }, e.getValidEnumValues = (d) => {
    const s = e.objectKeys(d).filter((r) => typeof d[d[r]] != "number"), n = {};
    for (const r of s)
      n[r] = d[r];
    return e.objectValues(n);
  }, e.objectValues = (d) => e.objectKeys(d).map(function(s) {
    return d[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (d) => Object.keys(d) : (d) => {
    const s = [];
    for (const n in d)
      Object.prototype.hasOwnProperty.call(d, n) && s.push(n);
    return s;
  }, e.find = (d, s) => {
    for (const n of d)
      if (s(n))
        return n;
  }, e.isInteger = typeof Number.isInteger == "function" ? (d) => Number.isInteger(d) : (d) => typeof d == "number" && isFinite(d) && Math.floor(d) === d;
  function i(d, s = " | ") {
    return d.map((n) => typeof n == "string" ? `'${n}'` : n).join(s);
  }
  e.joinValues = i, e.jsonStringifyReplacer = (d, s) => typeof s == "bigint" ? s.toString() : s;
})(util || (util = {}));
var objectUtil;
(function(e) {
  e.mergeShapes = (t, o) => ({
    ...t,
    ...o
    // second overwrites first
  });
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), getParsedType = (e) => {
  switch (typeof e) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(e) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      return Array.isArray(e) ? ZodParsedType.array : e === null ? ZodParsedType.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? ZodParsedType.promise : typeof Map < "u" && e instanceof Map ? ZodParsedType.map : typeof Set < "u" && e instanceof Set ? ZodParsedType.set : typeof Date < "u" && e instanceof Date ? ZodParsedType.date : ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
}, ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), quotelessJson = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class ZodError extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (i) => {
      this.issues = [...this.issues, i];
    }, this.addIssues = (i = []) => {
      this.issues = [...this.issues, ...i];
    };
    const o = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, o) : this.__proto__ = o, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const o = t || function(s) {
      return s.message;
    }, i = { _errors: [] }, d = (s) => {
      for (const n of s.issues)
        if (n.code === "invalid_union")
          n.unionErrors.map(d);
        else if (n.code === "invalid_return_type")
          d(n.returnTypeError);
        else if (n.code === "invalid_arguments")
          d(n.argumentsError);
        else if (n.path.length === 0)
          i._errors.push(o(n));
        else {
          let r = i, u = 0;
          for (; u < n.path.length; ) {
            const l = n.path[u];
            u === n.path.length - 1 ? (r[l] = r[l] || { _errors: [] }, r[l]._errors.push(o(n))) : r[l] = r[l] || { _errors: [] }, r = r[l], u++;
          }
        }
    };
    return d(this), i;
  }
  static assert(t) {
    if (!(t instanceof ZodError))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (o) => o.message) {
    const o = {}, i = [];
    for (const d of this.issues)
      d.path.length > 0 ? (o[d.path[0]] = o[d.path[0]] || [], o[d.path[0]].push(t(d))) : i.push(t(d));
    return { formErrors: i, fieldErrors: o };
  }
  get formErrors() {
    return this.flatten();
  }
}
ZodError.create = (e) => new ZodError(e);
const errorMap = (e, t) => {
  let o;
  switch (e.code) {
    case ZodIssueCode.invalid_type:
      e.received === ZodParsedType.undefined ? o = "Required" : o = `Expected ${e.expected}, received ${e.received}`;
      break;
    case ZodIssueCode.invalid_literal:
      o = `Invalid literal value, expected ${JSON.stringify(e.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      o = `Unrecognized key(s) in object: ${util.joinValues(e.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      o = "Invalid input";
      break;
    case ZodIssueCode.invalid_union_discriminator:
      o = `Invalid discriminator value. Expected ${util.joinValues(e.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      o = `Invalid enum value. Expected ${util.joinValues(e.options)}, received '${e.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      o = "Invalid function arguments";
      break;
    case ZodIssueCode.invalid_return_type:
      o = "Invalid function return type";
      break;
    case ZodIssueCode.invalid_date:
      o = "Invalid date";
      break;
    case ZodIssueCode.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (o = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (o = `${o} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? o = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? o = `Invalid input: must end with "${e.validation.endsWith}"` : util.assertNever(e.validation) : e.validation !== "regex" ? o = `Invalid ${e.validation}` : o = "Invalid";
      break;
    case ZodIssueCode.too_small:
      e.type === "array" ? o = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? o = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? o = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? o = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : o = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      e.type === "array" ? o = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? o = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? o = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? o = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? o = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : o = "Invalid input";
      break;
    case ZodIssueCode.custom:
      o = "Invalid input";
      break;
    case ZodIssueCode.invalid_intersection_types:
      o = "Intersection results could not be merged";
      break;
    case ZodIssueCode.not_multiple_of:
      o = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      o = "Number must be finite";
      break;
    default:
      o = t.defaultError, util.assertNever(e);
  }
  return { message: o };
};
let overrideErrorMap = errorMap;
function setErrorMap(e) {
  overrideErrorMap = e;
}
function getErrorMap() {
  return overrideErrorMap;
}
const makeIssue = (e) => {
  const { data: t, path: o, errorMaps: i, issueData: d } = e, s = [...o, ...d.path || []], n = {
    ...d,
    path: s
  };
  if (d.message !== void 0)
    return {
      ...d,
      path: s,
      message: d.message
    };
  let r = "";
  const u = i.filter((l) => !!l).slice().reverse();
  for (const l of u)
    r = l(n, { data: t, defaultError: r }).message;
  return {
    ...d,
    path: s,
    message: r
  };
}, EMPTY_PATH = [];
function addIssueToContext(e, t) {
  const o = getErrorMap(), i = makeIssue({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      o,
      o === errorMap ? void 0 : errorMap
      // then global default map
    ].filter((d) => !!d)
  });
  e.common.issues.push(i);
}
class ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, o) {
    const i = [];
    for (const d of o) {
      if (d.status === "aborted")
        return INVALID;
      d.status === "dirty" && t.dirty(), i.push(d.value);
    }
    return { status: t.value, value: i };
  }
  static async mergeObjectAsync(t, o) {
    const i = [];
    for (const d of o) {
      const s = await d.key, n = await d.value;
      i.push({
        key: s,
        value: n
      });
    }
    return ParseStatus.mergeObjectSync(t, i);
  }
  static mergeObjectSync(t, o) {
    const i = {};
    for (const d of o) {
      const { key: s, value: n } = d;
      if (s.status === "aborted" || n.status === "aborted")
        return INVALID;
      s.status === "dirty" && t.dirty(), n.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof n.value < "u" || d.alwaysSet) && (i[s.value] = n.value);
    }
    return { status: t.value, value: i };
  }
}
const INVALID = Object.freeze({
  status: "aborted"
}), DIRTY = (e) => ({ status: "dirty", value: e }), OK = (e) => ({ status: "valid", value: e }), isAborted = (e) => e.status === "aborted", isDirty = (e) => e.status === "dirty", isValid = (e) => e.status === "valid", isAsync = (e) => typeof Promise < "u" && e instanceof Promise;
function __classPrivateFieldGet(e, t, o, i) {
  if (typeof t == "function" ? e !== t || !0 : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function __classPrivateFieldSet(e, t, o, i, d) {
  if (typeof t == "function" ? e !== t || !0 : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, o), o;
}
typeof SuppressedError == "function" && SuppressedError;
var errorUtil;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t?.message;
})(errorUtil || (errorUtil = {}));
var _ZodEnum_cache, _ZodNativeEnum_cache;
class ParseInputLazyPath {
  constructor(t, o, i, d) {
    this._cachedPath = [], this.parent = t, this.data = o, this._path = i, this._key = d;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const handleResult = (e, t) => {
  if (isValid(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const o = new ZodError(e.common.issues);
      return this._error = o, this._error;
    }
  };
};
function processCreateParams(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: o, required_error: i, description: d } = e;
  if (t && (o || i))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: d } : { errorMap: (n, r) => {
    var u, l;
    const { message: c } = e;
    return n.code === "invalid_enum_value" ? { message: c ?? r.defaultError } : typeof r.data > "u" ? { message: (u = c ?? i) !== null && u !== void 0 ? u : r.defaultError } : n.code !== "invalid_type" ? { message: r.defaultError } : { message: (l = c ?? o) !== null && l !== void 0 ? l : r.defaultError };
  }, description: d };
}
class ZodType {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return getParsedType(t.data);
  }
  _getOrReturnCtx(t, o) {
    return o || {
      common: t.parent.common,
      data: t.data,
      parsedType: getParsedType(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: getParsedType(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const o = this._parse(t);
    if (isAsync(o))
      throw new Error("Synchronous parse encountered promise.");
    return o;
  }
  _parseAsync(t) {
    const o = this._parse(t);
    return Promise.resolve(o);
  }
  parse(t, o) {
    const i = this.safeParse(t, o);
    if (i.success)
      return i.data;
    throw i.error;
  }
  safeParse(t, o) {
    var i;
    const d = {
      common: {
        issues: [],
        async: (i = o?.async) !== null && i !== void 0 ? i : !1,
        contextualErrorMap: o?.errorMap
      },
      path: o?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: getParsedType(t)
    }, s = this._parseSync({ data: t, path: d.path, parent: d });
    return handleResult(d, s);
  }
  async parseAsync(t, o) {
    const i = await this.safeParseAsync(t, o);
    if (i.success)
      return i.data;
    throw i.error;
  }
  async safeParseAsync(t, o) {
    const i = {
      common: {
        issues: [],
        contextualErrorMap: o?.errorMap,
        async: !0
      },
      path: o?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: getParsedType(t)
    }, d = this._parse({ data: t, path: i.path, parent: i }), s = await (isAsync(d) ? d : Promise.resolve(d));
    return handleResult(i, s);
  }
  refine(t, o) {
    const i = (d) => typeof o == "string" || typeof o > "u" ? { message: o } : typeof o == "function" ? o(d) : o;
    return this._refinement((d, s) => {
      const n = t(d), r = () => s.addIssue({
        code: ZodIssueCode.custom,
        ...i(d)
      });
      return typeof Promise < "u" && n instanceof Promise ? n.then((u) => u ? !0 : (r(), !1)) : n ? !0 : (r(), !1);
    });
  }
  refinement(t, o) {
    return this._refinement((i, d) => t(i) ? !0 : (d.addIssue(typeof o == "function" ? o(i, d) : o), !1));
  }
  _refinement(t) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(t) {
    return ZodUnion.create([this, t], this._def);
  }
  and(t) {
    return ZodIntersection.create(this, t, this._def);
  }
  transform(t) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const o = typeof t == "function" ? t : () => t;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: o,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(t) {
    const o = typeof t == "function" ? t : () => t;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: o,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(t) {
    const o = this.constructor;
    return new o({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return ZodPipeline.create(this, t);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const cuidRegex = /^c[^\s-]{8,}$/i, cuid2Regex = /^[0-9a-z]+$/, ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/, uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, nanoidRegex = /^[a-z0-9_-]{21}$/i, durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, emailRegex$1 = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, _emojiRegex = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let emojiRegex;
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, dateRegexSource = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", dateRegex$1 = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function timeRegex(e) {
  return new RegExp(`^${timeRegexSource(e)}$`);
}
function datetimeRegex(e) {
  let t = `${dateRegexSource}T${timeRegexSource(e)}`;
  const o = [];
  return o.push(e.local ? "Z?" : "Z"), e.offset && o.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${o.join("|")})`, new RegExp(`^${t}$`);
}
function isValidIP(e, t) {
  return !!((t === "v4" || !t) && ipv4Regex.test(e) || (t === "v6" || !t) && ipv6Regex.test(e));
}
class ZodString extends ZodType {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== ZodParsedType.string) {
      const s = this._getOrReturnCtx(t);
      return addIssueToContext(s, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: s.parsedType
      }), INVALID;
    }
    const i = new ParseStatus();
    let d;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
          code: ZodIssueCode.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), i.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
          code: ZodIssueCode.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), i.dirty());
      else if (s.kind === "length") {
        const n = t.data.length > s.value, r = t.data.length < s.value;
        (n || r) && (d = this._getOrReturnCtx(t, d), n ? addIssueToContext(d, {
          code: ZodIssueCode.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : r && addIssueToContext(d, {
          code: ZodIssueCode.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), i.dirty());
      } else if (s.kind === "email")
        emailRegex$1.test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
          validation: "email",
          code: ZodIssueCode.invalid_string,
          message: s.message
        }), i.dirty());
      else if (s.kind === "emoji")
        emojiRegex || (emojiRegex = new RegExp(_emojiRegex, "u")), emojiRegex.test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
          validation: "emoji",
          code: ZodIssueCode.invalid_string,
          message: s.message
        }), i.dirty());
      else if (s.kind === "uuid")
        uuidRegex.test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
          validation: "uuid",
          code: ZodIssueCode.invalid_string,
          message: s.message
        }), i.dirty());
      else if (s.kind === "nanoid")
        nanoidRegex.test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
          validation: "nanoid",
          code: ZodIssueCode.invalid_string,
          message: s.message
        }), i.dirty());
      else if (s.kind === "cuid")
        cuidRegex.test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
          validation: "cuid",
          code: ZodIssueCode.invalid_string,
          message: s.message
        }), i.dirty());
      else if (s.kind === "cuid2")
        cuid2Regex.test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
          validation: "cuid2",
          code: ZodIssueCode.invalid_string,
          message: s.message
        }), i.dirty());
      else if (s.kind === "ulid")
        ulidRegex.test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
          validation: "ulid",
          code: ZodIssueCode.invalid_string,
          message: s.message
        }), i.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: s.message
          }), i.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        validation: "regex",
        code: ZodIssueCode.invalid_string,
        message: s.message
      }), i.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), i.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), i.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), i.dirty()) : s.kind === "datetime" ? datetimeRegex(s).test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: "datetime",
        message: s.message
      }), i.dirty()) : s.kind === "date" ? dateRegex$1.test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: "date",
        message: s.message
      }), i.dirty()) : s.kind === "time" ? timeRegex(s).test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: "time",
        message: s.message
      }), i.dirty()) : s.kind === "duration" ? durationRegex.test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        validation: "duration",
        code: ZodIssueCode.invalid_string,
        message: s.message
      }), i.dirty()) : s.kind === "ip" ? isValidIP(t.data, s.version) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        validation: "ip",
        code: ZodIssueCode.invalid_string,
        message: s.message
      }), i.dirty()) : s.kind === "base64" ? base64Regex.test(t.data) || (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        validation: "base64",
        code: ZodIssueCode.invalid_string,
        message: s.message
      }), i.dirty()) : util.assertNever(s);
    return { status: i.value, value: t.data };
  }
  _regex(t, o, i) {
    return this.refinement((d) => t.test(d), {
      validation: o,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(i)
    });
  }
  _addCheck(t) {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...errorUtil.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(t) });
  }
  datetime(t) {
    var o, i;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      offset: (o = t?.offset) !== null && o !== void 0 ? o : !1,
      local: (i = t?.local) !== null && i !== void 0 ? i : !1,
      ...errorUtil.errToObj(t?.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      ...errorUtil.errToObj(t?.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...errorUtil.errToObj(t) });
  }
  regex(t, o) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...errorUtil.errToObj(o)
    });
  }
  includes(t, o) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: o?.position,
      ...errorUtil.errToObj(o?.message)
    });
  }
  startsWith(t, o) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...errorUtil.errToObj(o)
    });
  }
  endsWith(t, o) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...errorUtil.errToObj(o)
    });
  }
  min(t, o) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...errorUtil.errToObj(o)
    });
  }
  max(t, o) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...errorUtil.errToObj(o)
    });
  }
  length(t, o) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...errorUtil.errToObj(o)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, errorUtil.errToObj(t));
  }
  trim() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get minLength() {
    let t = null;
    for (const o of this._def.checks)
      o.kind === "min" && (t === null || o.value > t) && (t = o.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const o of this._def.checks)
      o.kind === "max" && (t === null || o.value < t) && (t = o.value);
    return t;
  }
}
ZodString.create = (e) => {
  var t;
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (t = e?.coerce) !== null && t !== void 0 ? t : !1,
    ...processCreateParams(e)
  });
};
function floatSafeRemainder(e, t) {
  const o = (e.toString().split(".")[1] || "").length, i = (t.toString().split(".")[1] || "").length, d = o > i ? o : i, s = parseInt(e.toFixed(d).replace(".", "")), n = parseInt(t.toFixed(d).replace(".", ""));
  return s % n / Math.pow(10, d);
}
class ZodNumber extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== ZodParsedType.number) {
      const s = this._getOrReturnCtx(t);
      return addIssueToContext(s, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: s.parsedType
      }), INVALID;
    }
    let i;
    const d = new ParseStatus();
    for (const s of this._def.checks)
      s.kind === "int" ? util.isInteger(t.data) || (i = this._getOrReturnCtx(t, i), addIssueToContext(i, {
        code: ZodIssueCode.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), d.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (i = this._getOrReturnCtx(t, i), addIssueToContext(i, {
        code: ZodIssueCode.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), d.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (i = this._getOrReturnCtx(t, i), addIssueToContext(i, {
        code: ZodIssueCode.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), d.dirty()) : s.kind === "multipleOf" ? floatSafeRemainder(t.data, s.value) !== 0 && (i = this._getOrReturnCtx(t, i), addIssueToContext(i, {
        code: ZodIssueCode.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), d.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (i = this._getOrReturnCtx(t, i), addIssueToContext(i, {
        code: ZodIssueCode.not_finite,
        message: s.message
      }), d.dirty()) : util.assertNever(s);
    return { status: d.value, value: t.data };
  }
  gte(t, o) {
    return this.setLimit("min", t, !0, errorUtil.toString(o));
  }
  gt(t, o) {
    return this.setLimit("min", t, !1, errorUtil.toString(o));
  }
  lte(t, o) {
    return this.setLimit("max", t, !0, errorUtil.toString(o));
  }
  lt(t, o) {
    return this.setLimit("max", t, !1, errorUtil.toString(o));
  }
  setLimit(t, o, i, d) {
    return new ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: o,
          inclusive: i,
          message: errorUtil.toString(d)
        }
      ]
    });
  }
  _addCheck(t) {
    return new ZodNumber({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: errorUtil.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: errorUtil.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: errorUtil.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: errorUtil.toString(t)
    });
  }
  multipleOf(t, o) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: errorUtil.toString(o)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const o of this._def.checks)
      o.kind === "min" && (t === null || o.value > t) && (t = o.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const o of this._def.checks)
      o.kind === "max" && (t === null || o.value < t) && (t = o.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && util.isInteger(t.value));
  }
  get isFinite() {
    let t = null, o = null;
    for (const i of this._def.checks) {
      if (i.kind === "finite" || i.kind === "int" || i.kind === "multipleOf")
        return !0;
      i.kind === "min" ? (o === null || i.value > o) && (o = i.value) : i.kind === "max" && (t === null || i.value < t) && (t = i.value);
    }
    return Number.isFinite(o) && Number.isFinite(t);
  }
}
ZodNumber.create = (e) => new ZodNumber({
  checks: [],
  typeName: ZodFirstPartyTypeKind.ZodNumber,
  coerce: e?.coerce || !1,
  ...processCreateParams(e)
});
class ZodBigInt extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== ZodParsedType.bigint) {
      const s = this._getOrReturnCtx(t);
      return addIssueToContext(s, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: s.parsedType
      }), INVALID;
    }
    let i;
    const d = new ParseStatus();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (i = this._getOrReturnCtx(t, i), addIssueToContext(i, {
        code: ZodIssueCode.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), d.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (i = this._getOrReturnCtx(t, i), addIssueToContext(i, {
        code: ZodIssueCode.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), d.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (i = this._getOrReturnCtx(t, i), addIssueToContext(i, {
        code: ZodIssueCode.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), d.dirty()) : util.assertNever(s);
    return { status: d.value, value: t.data };
  }
  gte(t, o) {
    return this.setLimit("min", t, !0, errorUtil.toString(o));
  }
  gt(t, o) {
    return this.setLimit("min", t, !1, errorUtil.toString(o));
  }
  lte(t, o) {
    return this.setLimit("max", t, !0, errorUtil.toString(o));
  }
  lt(t, o) {
    return this.setLimit("max", t, !1, errorUtil.toString(o));
  }
  setLimit(t, o, i, d) {
    return new ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: o,
          inclusive: i,
          message: errorUtil.toString(d)
        }
      ]
    });
  }
  _addCheck(t) {
    return new ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: errorUtil.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: errorUtil.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: errorUtil.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: errorUtil.toString(t)
    });
  }
  multipleOf(t, o) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: errorUtil.toString(o)
    });
  }
  get minValue() {
    let t = null;
    for (const o of this._def.checks)
      o.kind === "min" && (t === null || o.value > t) && (t = o.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const o of this._def.checks)
      o.kind === "max" && (t === null || o.value < t) && (t = o.value);
    return t;
  }
}
ZodBigInt.create = (e) => {
  var t;
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (t = e?.coerce) !== null && t !== void 0 ? t : !1,
    ...processCreateParams(e)
  });
};
class ZodBoolean extends ZodType {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== ZodParsedType.boolean) {
      const i = this._getOrReturnCtx(t);
      return addIssueToContext(i, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: i.parsedType
      }), INVALID;
    }
    return OK(t.data);
  }
}
ZodBoolean.create = (e) => new ZodBoolean({
  typeName: ZodFirstPartyTypeKind.ZodBoolean,
  coerce: e?.coerce || !1,
  ...processCreateParams(e)
});
class ZodDate extends ZodType {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== ZodParsedType.date) {
      const s = this._getOrReturnCtx(t);
      return addIssueToContext(s, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: s.parsedType
      }), INVALID;
    }
    if (isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return addIssueToContext(s, {
        code: ZodIssueCode.invalid_date
      }), INVALID;
    }
    const i = new ParseStatus();
    let d;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        code: ZodIssueCode.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), i.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (d = this._getOrReturnCtx(t, d), addIssueToContext(d, {
        code: ZodIssueCode.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), i.dirty()) : util.assertNever(s);
    return {
      status: i.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new ZodDate({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, o) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: errorUtil.toString(o)
    });
  }
  max(t, o) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: errorUtil.toString(o)
    });
  }
  get minDate() {
    let t = null;
    for (const o of this._def.checks)
      o.kind === "min" && (t === null || o.value > t) && (t = o.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const o of this._def.checks)
      o.kind === "max" && (t === null || o.value < t) && (t = o.value);
    return t != null ? new Date(t) : null;
  }
}
ZodDate.create = (e) => new ZodDate({
  checks: [],
  coerce: e?.coerce || !1,
  typeName: ZodFirstPartyTypeKind.ZodDate,
  ...processCreateParams(e)
});
class ZodSymbol extends ZodType {
  _parse(t) {
    if (this._getType(t) !== ZodParsedType.symbol) {
      const i = this._getOrReturnCtx(t);
      return addIssueToContext(i, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: i.parsedType
      }), INVALID;
    }
    return OK(t.data);
  }
}
ZodSymbol.create = (e) => new ZodSymbol({
  typeName: ZodFirstPartyTypeKind.ZodSymbol,
  ...processCreateParams(e)
});
class ZodUndefined extends ZodType {
  _parse(t) {
    if (this._getType(t) !== ZodParsedType.undefined) {
      const i = this._getOrReturnCtx(t);
      return addIssueToContext(i, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: i.parsedType
      }), INVALID;
    }
    return OK(t.data);
  }
}
ZodUndefined.create = (e) => new ZodUndefined({
  typeName: ZodFirstPartyTypeKind.ZodUndefined,
  ...processCreateParams(e)
});
class ZodNull extends ZodType {
  _parse(t) {
    if (this._getType(t) !== ZodParsedType.null) {
      const i = this._getOrReturnCtx(t);
      return addIssueToContext(i, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: i.parsedType
      }), INVALID;
    }
    return OK(t.data);
  }
}
ZodNull.create = (e) => new ZodNull({
  typeName: ZodFirstPartyTypeKind.ZodNull,
  ...processCreateParams(e)
});
class ZodAny extends ZodType {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return OK(t.data);
  }
}
ZodAny.create = (e) => new ZodAny({
  typeName: ZodFirstPartyTypeKind.ZodAny,
  ...processCreateParams(e)
});
class ZodUnknown extends ZodType {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return OK(t.data);
  }
}
ZodUnknown.create = (e) => new ZodUnknown({
  typeName: ZodFirstPartyTypeKind.ZodUnknown,
  ...processCreateParams(e)
});
class ZodNever extends ZodType {
  _parse(t) {
    const o = this._getOrReturnCtx(t);
    return addIssueToContext(o, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: o.parsedType
    }), INVALID;
  }
}
ZodNever.create = (e) => new ZodNever({
  typeName: ZodFirstPartyTypeKind.ZodNever,
  ...processCreateParams(e)
});
class ZodVoid extends ZodType {
  _parse(t) {
    if (this._getType(t) !== ZodParsedType.undefined) {
      const i = this._getOrReturnCtx(t);
      return addIssueToContext(i, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: i.parsedType
      }), INVALID;
    }
    return OK(t.data);
  }
}
ZodVoid.create = (e) => new ZodVoid({
  typeName: ZodFirstPartyTypeKind.ZodVoid,
  ...processCreateParams(e)
});
class ZodArray extends ZodType {
  _parse(t) {
    const { ctx: o, status: i } = this._processInputParams(t), d = this._def;
    if (o.parsedType !== ZodParsedType.array)
      return addIssueToContext(o, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: o.parsedType
      }), INVALID;
    if (d.exactLength !== null) {
      const n = o.data.length > d.exactLength.value, r = o.data.length < d.exactLength.value;
      (n || r) && (addIssueToContext(o, {
        code: n ? ZodIssueCode.too_big : ZodIssueCode.too_small,
        minimum: r ? d.exactLength.value : void 0,
        maximum: n ? d.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: d.exactLength.message
      }), i.dirty());
    }
    if (d.minLength !== null && o.data.length < d.minLength.value && (addIssueToContext(o, {
      code: ZodIssueCode.too_small,
      minimum: d.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: d.minLength.message
    }), i.dirty()), d.maxLength !== null && o.data.length > d.maxLength.value && (addIssueToContext(o, {
      code: ZodIssueCode.too_big,
      maximum: d.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: d.maxLength.message
    }), i.dirty()), o.common.async)
      return Promise.all([...o.data].map((n, r) => d.type._parseAsync(new ParseInputLazyPath(o, n, o.path, r)))).then((n) => ParseStatus.mergeArray(i, n));
    const s = [...o.data].map((n, r) => d.type._parseSync(new ParseInputLazyPath(o, n, o.path, r)));
    return ParseStatus.mergeArray(i, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, o) {
    return new ZodArray({
      ...this._def,
      minLength: { value: t, message: errorUtil.toString(o) }
    });
  }
  max(t, o) {
    return new ZodArray({
      ...this._def,
      maxLength: { value: t, message: errorUtil.toString(o) }
    });
  }
  length(t, o) {
    return new ZodArray({
      ...this._def,
      exactLength: { value: t, message: errorUtil.toString(o) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
ZodArray.create = (e, t) => new ZodArray({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: ZodFirstPartyTypeKind.ZodArray,
  ...processCreateParams(t)
});
function deepPartialify(e) {
  if (e instanceof ZodObject) {
    const t = {};
    for (const o in e.shape) {
      const i = e.shape[o];
      t[o] = ZodOptional.create(deepPartialify(i));
    }
    return new ZodObject({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof ZodArray ? new ZodArray({
    ...e._def,
    type: deepPartialify(e.element)
  }) : e instanceof ZodOptional ? ZodOptional.create(deepPartialify(e.unwrap())) : e instanceof ZodNullable ? ZodNullable.create(deepPartialify(e.unwrap())) : e instanceof ZodTuple ? ZodTuple.create(e.items.map((t) => deepPartialify(t))) : e;
}
class ZodObject extends ZodType {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), o = util.objectKeys(t);
    return this._cached = { shape: t, keys: o };
  }
  _parse(t) {
    if (this._getType(t) !== ZodParsedType.object) {
      const l = this._getOrReturnCtx(t);
      return addIssueToContext(l, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: l.parsedType
      }), INVALID;
    }
    const { status: i, ctx: d } = this._processInputParams(t), { shape: s, keys: n } = this._getCached(), r = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip"))
      for (const l in d.data)
        n.includes(l) || r.push(l);
    const u = [];
    for (const l of n) {
      const c = s[l], g = d.data[l];
      u.push({
        key: { status: "valid", value: l },
        value: c._parse(new ParseInputLazyPath(d, g, d.path, l)),
        alwaysSet: l in d.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const c of r)
          u.push({
            key: { status: "valid", value: c },
            value: { status: "valid", value: d.data[c] }
          });
      else if (l === "strict")
        r.length > 0 && (addIssueToContext(d, {
          code: ZodIssueCode.unrecognized_keys,
          keys: r
        }), i.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const c of r) {
        const g = d.data[c];
        u.push({
          key: { status: "valid", value: c },
          value: l._parse(
            new ParseInputLazyPath(d, g, d.path, c)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: c in d.data
        });
      }
    }
    return d.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const c of u) {
        const g = await c.key, p = await c.value;
        l.push({
          key: g,
          value: p,
          alwaysSet: c.alwaysSet
        });
      }
      return l;
    }).then((l) => ParseStatus.mergeObjectSync(i, l)) : ParseStatus.mergeObjectSync(i, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return errorUtil.errToObj, new ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (o, i) => {
          var d, s, n, r;
          const u = (n = (s = (d = this._def).errorMap) === null || s === void 0 ? void 0 : s.call(d, o, i).message) !== null && n !== void 0 ? n : i.defaultError;
          return o.code === "unrecognized_keys" ? {
            message: (r = errorUtil.errToObj(t).message) !== null && r !== void 0 ? r : u
          } : {
            message: u
          };
        }
      } : {}
    });
  }
  strip() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new ZodObject({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, o) {
    return this.augment({ [t]: o });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new ZodObject({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const o = {};
    return util.objectKeys(t).forEach((i) => {
      t[i] && this.shape[i] && (o[i] = this.shape[i]);
    }), new ZodObject({
      ...this._def,
      shape: () => o
    });
  }
  omit(t) {
    const o = {};
    return util.objectKeys(this.shape).forEach((i) => {
      t[i] || (o[i] = this.shape[i]);
    }), new ZodObject({
      ...this._def,
      shape: () => o
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(t) {
    const o = {};
    return util.objectKeys(this.shape).forEach((i) => {
      const d = this.shape[i];
      t && !t[i] ? o[i] = d : o[i] = d.optional();
    }), new ZodObject({
      ...this._def,
      shape: () => o
    });
  }
  required(t) {
    const o = {};
    return util.objectKeys(this.shape).forEach((i) => {
      if (t && !t[i])
        o[i] = this.shape[i];
      else {
        let s = this.shape[i];
        for (; s instanceof ZodOptional; )
          s = s._def.innerType;
        o[i] = s;
      }
    }), new ZodObject({
      ...this._def,
      shape: () => o
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
}
ZodObject.create = (e, t) => new ZodObject({
  shape: () => e,
  unknownKeys: "strip",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(t)
});
ZodObject.strictCreate = (e, t) => new ZodObject({
  shape: () => e,
  unknownKeys: "strict",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(t)
});
ZodObject.lazycreate = (e, t) => new ZodObject({
  shape: e,
  unknownKeys: "strip",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(t)
});
class ZodUnion extends ZodType {
  _parse(t) {
    const { ctx: o } = this._processInputParams(t), i = this._def.options;
    function d(s) {
      for (const r of s)
        if (r.result.status === "valid")
          return r.result;
      for (const r of s)
        if (r.result.status === "dirty")
          return o.common.issues.push(...r.ctx.common.issues), r.result;
      const n = s.map((r) => new ZodError(r.ctx.common.issues));
      return addIssueToContext(o, {
        code: ZodIssueCode.invalid_union,
        unionErrors: n
      }), INVALID;
    }
    if (o.common.async)
      return Promise.all(i.map(async (s) => {
        const n = {
          ...o,
          common: {
            ...o.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: o.data,
            path: o.path,
            parent: n
          }),
          ctx: n
        };
      })).then(d);
    {
      let s;
      const n = [];
      for (const u of i) {
        const l = {
          ...o,
          common: {
            ...o.common,
            issues: []
          },
          parent: null
        }, c = u._parseSync({
          data: o.data,
          path: o.path,
          parent: l
        });
        if (c.status === "valid")
          return c;
        c.status === "dirty" && !s && (s = { result: c, ctx: l }), l.common.issues.length && n.push(l.common.issues);
      }
      if (s)
        return o.common.issues.push(...s.ctx.common.issues), s.result;
      const r = n.map((u) => new ZodError(u));
      return addIssueToContext(o, {
        code: ZodIssueCode.invalid_union,
        unionErrors: r
      }), INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
}
ZodUnion.create = (e, t) => new ZodUnion({
  options: e,
  typeName: ZodFirstPartyTypeKind.ZodUnion,
  ...processCreateParams(t)
});
const getDiscriminator = (e) => e instanceof ZodLazy ? getDiscriminator(e.schema) : e instanceof ZodEffects ? getDiscriminator(e.innerType()) : e instanceof ZodLiteral ? [e.value] : e instanceof ZodEnum ? e.options : e instanceof ZodNativeEnum ? util.objectValues(e.enum) : e instanceof ZodDefault ? getDiscriminator(e._def.innerType) : e instanceof ZodUndefined ? [void 0] : e instanceof ZodNull ? [null] : e instanceof ZodOptional ? [void 0, ...getDiscriminator(e.unwrap())] : e instanceof ZodNullable ? [null, ...getDiscriminator(e.unwrap())] : e instanceof ZodBranded || e instanceof ZodReadonly ? getDiscriminator(e.unwrap()) : e instanceof ZodCatch ? getDiscriminator(e._def.innerType) : [];
class ZodDiscriminatedUnion extends ZodType {
  _parse(t) {
    const { ctx: o } = this._processInputParams(t);
    if (o.parsedType !== ZodParsedType.object)
      return addIssueToContext(o, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: o.parsedType
      }), INVALID;
    const i = this.discriminator, d = o.data[i], s = this.optionsMap.get(d);
    return s ? o.common.async ? s._parseAsync({
      data: o.data,
      path: o.path,
      parent: o
    }) : s._parseSync({
      data: o.data,
      path: o.path,
      parent: o
    }) : (addIssueToContext(o, {
      code: ZodIssueCode.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [i]
    }), INVALID);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, o, i) {
    const d = /* @__PURE__ */ new Map();
    for (const s of o) {
      const n = getDiscriminator(s.shape[t]);
      if (!n.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const r of n) {
        if (d.has(r))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(r)}`);
        d.set(r, s);
      }
    }
    return new ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator: t,
      options: o,
      optionsMap: d,
      ...processCreateParams(i)
    });
  }
}
function mergeValues(e, t) {
  const o = getParsedType(e), i = getParsedType(t);
  if (e === t)
    return { valid: !0, data: e };
  if (o === ZodParsedType.object && i === ZodParsedType.object) {
    const d = util.objectKeys(t), s = util.objectKeys(e).filter((r) => d.indexOf(r) !== -1), n = { ...e, ...t };
    for (const r of s) {
      const u = mergeValues(e[r], t[r]);
      if (!u.valid)
        return { valid: !1 };
      n[r] = u.data;
    }
    return { valid: !0, data: n };
  } else if (o === ZodParsedType.array && i === ZodParsedType.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const d = [];
    for (let s = 0; s < e.length; s++) {
      const n = e[s], r = t[s], u = mergeValues(n, r);
      if (!u.valid)
        return { valid: !1 };
      d.push(u.data);
    }
    return { valid: !0, data: d };
  } else return o === ZodParsedType.date && i === ZodParsedType.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class ZodIntersection extends ZodType {
  _parse(t) {
    const { status: o, ctx: i } = this._processInputParams(t), d = (s, n) => {
      if (isAborted(s) || isAborted(n))
        return INVALID;
      const r = mergeValues(s.value, n.value);
      return r.valid ? ((isDirty(s) || isDirty(n)) && o.dirty(), { status: o.value, value: r.data }) : (addIssueToContext(i, {
        code: ZodIssueCode.invalid_intersection_types
      }), INVALID);
    };
    return i.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: i.data,
        path: i.path,
        parent: i
      }),
      this._def.right._parseAsync({
        data: i.data,
        path: i.path,
        parent: i
      })
    ]).then(([s, n]) => d(s, n)) : d(this._def.left._parseSync({
      data: i.data,
      path: i.path,
      parent: i
    }), this._def.right._parseSync({
      data: i.data,
      path: i.path,
      parent: i
    }));
  }
}
ZodIntersection.create = (e, t, o) => new ZodIntersection({
  left: e,
  right: t,
  typeName: ZodFirstPartyTypeKind.ZodIntersection,
  ...processCreateParams(o)
});
class ZodTuple extends ZodType {
  _parse(t) {
    const { status: o, ctx: i } = this._processInputParams(t);
    if (i.parsedType !== ZodParsedType.array)
      return addIssueToContext(i, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: i.parsedType
      }), INVALID;
    if (i.data.length < this._def.items.length)
      return addIssueToContext(i, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), INVALID;
    !this._def.rest && i.data.length > this._def.items.length && (addIssueToContext(i, {
      code: ZodIssueCode.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), o.dirty());
    const s = [...i.data].map((n, r) => {
      const u = this._def.items[r] || this._def.rest;
      return u ? u._parse(new ParseInputLazyPath(i, n, i.path, r)) : null;
    }).filter((n) => !!n);
    return i.common.async ? Promise.all(s).then((n) => ParseStatus.mergeArray(o, n)) : ParseStatus.mergeArray(o, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new ZodTuple({
      ...this._def,
      rest: t
    });
  }
}
ZodTuple.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ZodTuple({
    items: e,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(t)
  });
};
class ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: o, ctx: i } = this._processInputParams(t);
    if (i.parsedType !== ZodParsedType.object)
      return addIssueToContext(i, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: i.parsedType
      }), INVALID;
    const d = [], s = this._def.keyType, n = this._def.valueType;
    for (const r in i.data)
      d.push({
        key: s._parse(new ParseInputLazyPath(i, r, i.path, r)),
        value: n._parse(new ParseInputLazyPath(i, i.data[r], i.path, r)),
        alwaysSet: r in i.data
      });
    return i.common.async ? ParseStatus.mergeObjectAsync(o, d) : ParseStatus.mergeObjectSync(o, d);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, o, i) {
    return o instanceof ZodType ? new ZodRecord({
      keyType: t,
      valueType: o,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(i)
    }) : new ZodRecord({
      keyType: ZodString.create(),
      valueType: t,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(o)
    });
  }
}
class ZodMap extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: o, ctx: i } = this._processInputParams(t);
    if (i.parsedType !== ZodParsedType.map)
      return addIssueToContext(i, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: i.parsedType
      }), INVALID;
    const d = this._def.keyType, s = this._def.valueType, n = [...i.data.entries()].map(([r, u], l) => ({
      key: d._parse(new ParseInputLazyPath(i, r, i.path, [l, "key"])),
      value: s._parse(new ParseInputLazyPath(i, u, i.path, [l, "value"]))
    }));
    if (i.common.async) {
      const r = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of n) {
          const l = await u.key, c = await u.value;
          if (l.status === "aborted" || c.status === "aborted")
            return INVALID;
          (l.status === "dirty" || c.status === "dirty") && o.dirty(), r.set(l.value, c.value);
        }
        return { status: o.value, value: r };
      });
    } else {
      const r = /* @__PURE__ */ new Map();
      for (const u of n) {
        const l = u.key, c = u.value;
        if (l.status === "aborted" || c.status === "aborted")
          return INVALID;
        (l.status === "dirty" || c.status === "dirty") && o.dirty(), r.set(l.value, c.value);
      }
      return { status: o.value, value: r };
    }
  }
}
ZodMap.create = (e, t, o) => new ZodMap({
  valueType: t,
  keyType: e,
  typeName: ZodFirstPartyTypeKind.ZodMap,
  ...processCreateParams(o)
});
class ZodSet extends ZodType {
  _parse(t) {
    const { status: o, ctx: i } = this._processInputParams(t);
    if (i.parsedType !== ZodParsedType.set)
      return addIssueToContext(i, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: i.parsedType
      }), INVALID;
    const d = this._def;
    d.minSize !== null && i.data.size < d.minSize.value && (addIssueToContext(i, {
      code: ZodIssueCode.too_small,
      minimum: d.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: d.minSize.message
    }), o.dirty()), d.maxSize !== null && i.data.size > d.maxSize.value && (addIssueToContext(i, {
      code: ZodIssueCode.too_big,
      maximum: d.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: d.maxSize.message
    }), o.dirty());
    const s = this._def.valueType;
    function n(u) {
      const l = /* @__PURE__ */ new Set();
      for (const c of u) {
        if (c.status === "aborted")
          return INVALID;
        c.status === "dirty" && o.dirty(), l.add(c.value);
      }
      return { status: o.value, value: l };
    }
    const r = [...i.data.values()].map((u, l) => s._parse(new ParseInputLazyPath(i, u, i.path, l)));
    return i.common.async ? Promise.all(r).then((u) => n(u)) : n(r);
  }
  min(t, o) {
    return new ZodSet({
      ...this._def,
      minSize: { value: t, message: errorUtil.toString(o) }
    });
  }
  max(t, o) {
    return new ZodSet({
      ...this._def,
      maxSize: { value: t, message: errorUtil.toString(o) }
    });
  }
  size(t, o) {
    return this.min(t, o).max(t, o);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
ZodSet.create = (e, t) => new ZodSet({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: ZodFirstPartyTypeKind.ZodSet,
  ...processCreateParams(t)
});
class ZodFunction extends ZodType {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: o } = this._processInputParams(t);
    if (o.parsedType !== ZodParsedType.function)
      return addIssueToContext(o, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: o.parsedType
      }), INVALID;
    function i(r, u) {
      return makeIssue({
        data: r,
        path: o.path,
        errorMaps: [
          o.common.contextualErrorMap,
          o.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((l) => !!l),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: u
        }
      });
    }
    function d(r, u) {
      return makeIssue({
        data: r,
        path: o.path,
        errorMaps: [
          o.common.contextualErrorMap,
          o.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((l) => !!l),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: u
        }
      });
    }
    const s = { errorMap: o.common.contextualErrorMap }, n = o.data;
    if (this._def.returns instanceof ZodPromise) {
      const r = this;
      return OK(async function(...u) {
        const l = new ZodError([]), c = await r._def.args.parseAsync(u, s).catch((m) => {
          throw l.addIssue(i(u, m)), l;
        }), g = await Reflect.apply(n, this, c);
        return await r._def.returns._def.type.parseAsync(g, s).catch((m) => {
          throw l.addIssue(d(g, m)), l;
        });
      });
    } else {
      const r = this;
      return OK(function(...u) {
        const l = r._def.args.safeParse(u, s);
        if (!l.success)
          throw new ZodError([i(u, l.error)]);
        const c = Reflect.apply(n, this, l.data), g = r._def.returns.safeParse(c, s);
        if (!g.success)
          throw new ZodError([d(c, g.error)]);
        return g.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new ZodFunction({
      ...this._def,
      args: ZodTuple.create(t).rest(ZodUnknown.create())
    });
  }
  returns(t) {
    return new ZodFunction({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, o, i) {
    return new ZodFunction({
      args: t || ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: o || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(i)
    });
  }
}
class ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: o } = this._processInputParams(t);
    return this._def.getter()._parse({ data: o.data, path: o.path, parent: o });
  }
}
ZodLazy.create = (e, t) => new ZodLazy({
  getter: e,
  typeName: ZodFirstPartyTypeKind.ZodLazy,
  ...processCreateParams(t)
});
class ZodLiteral extends ZodType {
  _parse(t) {
    if (t.data !== this._def.value) {
      const o = this._getOrReturnCtx(t);
      return addIssueToContext(o, {
        received: o.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      }), INVALID;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
ZodLiteral.create = (e, t) => new ZodLiteral({
  value: e,
  typeName: ZodFirstPartyTypeKind.ZodLiteral,
  ...processCreateParams(t)
});
function createZodEnum(e, t) {
  return new ZodEnum({
    values: e,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(t)
  });
}
class ZodEnum extends ZodType {
  constructor() {
    super(...arguments), _ZodEnum_cache.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const o = this._getOrReturnCtx(t), i = this._def.values;
      return addIssueToContext(o, {
        expected: util.joinValues(i),
        received: o.parsedType,
        code: ZodIssueCode.invalid_type
      }), INVALID;
    }
    if (__classPrivateFieldGet(this, _ZodEnum_cache) || __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values)), !__classPrivateFieldGet(this, _ZodEnum_cache).has(t.data)) {
      const o = this._getOrReturnCtx(t), i = this._def.values;
      return addIssueToContext(o, {
        received: o.data,
        code: ZodIssueCode.invalid_enum_value,
        options: i
      }), INVALID;
    }
    return OK(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const o of this._def.values)
      t[o] = o;
    return t;
  }
  get Values() {
    const t = {};
    for (const o of this._def.values)
      t[o] = o;
    return t;
  }
  get Enum() {
    const t = {};
    for (const o of this._def.values)
      t[o] = o;
    return t;
  }
  extract(t, o = this._def) {
    return ZodEnum.create(t, {
      ...this._def,
      ...o
    });
  }
  exclude(t, o = this._def) {
    return ZodEnum.create(this.options.filter((i) => !t.includes(i)), {
      ...this._def,
      ...o
    });
  }
}
_ZodEnum_cache = /* @__PURE__ */ new WeakMap();
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
  constructor() {
    super(...arguments), _ZodNativeEnum_cache.set(this, void 0);
  }
  _parse(t) {
    const o = util.getValidEnumValues(this._def.values), i = this._getOrReturnCtx(t);
    if (i.parsedType !== ZodParsedType.string && i.parsedType !== ZodParsedType.number) {
      const d = util.objectValues(o);
      return addIssueToContext(i, {
        expected: util.joinValues(d),
        received: i.parsedType,
        code: ZodIssueCode.invalid_type
      }), INVALID;
    }
    if (__classPrivateFieldGet(this, _ZodNativeEnum_cache) || __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util.getValidEnumValues(this._def.values))), !__classPrivateFieldGet(this, _ZodNativeEnum_cache).has(t.data)) {
      const d = util.objectValues(o);
      return addIssueToContext(i, {
        received: i.data,
        code: ZodIssueCode.invalid_enum_value,
        options: d
      }), INVALID;
    }
    return OK(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
_ZodNativeEnum_cache = /* @__PURE__ */ new WeakMap();
ZodNativeEnum.create = (e, t) => new ZodNativeEnum({
  values: e,
  typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
  ...processCreateParams(t)
});
class ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: o } = this._processInputParams(t);
    if (o.parsedType !== ZodParsedType.promise && o.common.async === !1)
      return addIssueToContext(o, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: o.parsedType
      }), INVALID;
    const i = o.parsedType === ZodParsedType.promise ? o.data : Promise.resolve(o.data);
    return OK(i.then((d) => this._def.type.parseAsync(d, {
      path: o.path,
      errorMap: o.common.contextualErrorMap
    })));
  }
}
ZodPromise.create = (e, t) => new ZodPromise({
  type: e,
  typeName: ZodFirstPartyTypeKind.ZodPromise,
  ...processCreateParams(t)
});
class ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: o, ctx: i } = this._processInputParams(t), d = this._def.effect || null, s = {
      addIssue: (n) => {
        addIssueToContext(i, n), n.fatal ? o.abort() : o.dirty();
      },
      get path() {
        return i.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), d.type === "preprocess") {
      const n = d.transform(i.data, s);
      if (i.common.async)
        return Promise.resolve(n).then(async (r) => {
          if (o.value === "aborted")
            return INVALID;
          const u = await this._def.schema._parseAsync({
            data: r,
            path: i.path,
            parent: i
          });
          return u.status === "aborted" ? INVALID : u.status === "dirty" || o.value === "dirty" ? DIRTY(u.value) : u;
        });
      {
        if (o.value === "aborted")
          return INVALID;
        const r = this._def.schema._parseSync({
          data: n,
          path: i.path,
          parent: i
        });
        return r.status === "aborted" ? INVALID : r.status === "dirty" || o.value === "dirty" ? DIRTY(r.value) : r;
      }
    }
    if (d.type === "refinement") {
      const n = (r) => {
        const u = d.refinement(r, s);
        if (i.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return r;
      };
      if (i.common.async === !1) {
        const r = this._def.schema._parseSync({
          data: i.data,
          path: i.path,
          parent: i
        });
        return r.status === "aborted" ? INVALID : (r.status === "dirty" && o.dirty(), n(r.value), { status: o.value, value: r.value });
      } else
        return this._def.schema._parseAsync({ data: i.data, path: i.path, parent: i }).then((r) => r.status === "aborted" ? INVALID : (r.status === "dirty" && o.dirty(), n(r.value).then(() => ({ status: o.value, value: r.value }))));
    }
    if (d.type === "transform")
      if (i.common.async === !1) {
        const n = this._def.schema._parseSync({
          data: i.data,
          path: i.path,
          parent: i
        });
        if (!isValid(n))
          return n;
        const r = d.transform(n.value, s);
        if (r instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: o.value, value: r };
      } else
        return this._def.schema._parseAsync({ data: i.data, path: i.path, parent: i }).then((n) => isValid(n) ? Promise.resolve(d.transform(n.value, s)).then((r) => ({ status: o.value, value: r })) : n);
    util.assertNever(d);
  }
}
ZodEffects.create = (e, t, o) => new ZodEffects({
  schema: e,
  typeName: ZodFirstPartyTypeKind.ZodEffects,
  effect: t,
  ...processCreateParams(o)
});
ZodEffects.createWithPreprocess = (e, t, o) => new ZodEffects({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: ZodFirstPartyTypeKind.ZodEffects,
  ...processCreateParams(o)
});
class ZodOptional extends ZodType {
  _parse(t) {
    return this._getType(t) === ZodParsedType.undefined ? OK(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodOptional.create = (e, t) => new ZodOptional({
  innerType: e,
  typeName: ZodFirstPartyTypeKind.ZodOptional,
  ...processCreateParams(t)
});
class ZodNullable extends ZodType {
  _parse(t) {
    return this._getType(t) === ZodParsedType.null ? OK(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodNullable.create = (e, t) => new ZodNullable({
  innerType: e,
  typeName: ZodFirstPartyTypeKind.ZodNullable,
  ...processCreateParams(t)
});
class ZodDefault extends ZodType {
  _parse(t) {
    const { ctx: o } = this._processInputParams(t);
    let i = o.data;
    return o.parsedType === ZodParsedType.undefined && (i = this._def.defaultValue()), this._def.innerType._parse({
      data: i,
      path: o.path,
      parent: o
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ZodDefault.create = (e, t) => new ZodDefault({
  innerType: e,
  typeName: ZodFirstPartyTypeKind.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...processCreateParams(t)
});
class ZodCatch extends ZodType {
  _parse(t) {
    const { ctx: o } = this._processInputParams(t), i = {
      ...o,
      common: {
        ...o.common,
        issues: []
      }
    }, d = this._def.innerType._parse({
      data: i.data,
      path: i.path,
      parent: {
        ...i
      }
    });
    return isAsync(d) ? d.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new ZodError(i.common.issues);
        },
        input: i.data
      })
    })) : {
      status: "valid",
      value: d.status === "valid" ? d.value : this._def.catchValue({
        get error() {
          return new ZodError(i.common.issues);
        },
        input: i.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ZodCatch.create = (e, t) => new ZodCatch({
  innerType: e,
  typeName: ZodFirstPartyTypeKind.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...processCreateParams(t)
});
class ZodNaN extends ZodType {
  _parse(t) {
    if (this._getType(t) !== ZodParsedType.nan) {
      const i = this._getOrReturnCtx(t);
      return addIssueToContext(i, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: i.parsedType
      }), INVALID;
    }
    return { status: "valid", value: t.data };
  }
}
ZodNaN.create = (e) => new ZodNaN({
  typeName: ZodFirstPartyTypeKind.ZodNaN,
  ...processCreateParams(e)
});
const BRAND = /* @__PURE__ */ Symbol("zod_brand");
class ZodBranded extends ZodType {
  _parse(t) {
    const { ctx: o } = this._processInputParams(t), i = o.data;
    return this._def.type._parse({
      data: i,
      path: o.path,
      parent: o
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ZodPipeline extends ZodType {
  _parse(t) {
    const { status: o, ctx: i } = this._processInputParams(t);
    if (i.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: i.data,
          path: i.path,
          parent: i
        });
        return s.status === "aborted" ? INVALID : s.status === "dirty" ? (o.dirty(), DIRTY(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: i.path,
          parent: i
        });
      })();
    {
      const d = this._def.in._parseSync({
        data: i.data,
        path: i.path,
        parent: i
      });
      return d.status === "aborted" ? INVALID : d.status === "dirty" ? (o.dirty(), {
        status: "dirty",
        value: d.value
      }) : this._def.out._parseSync({
        data: d.value,
        path: i.path,
        parent: i
      });
    }
  }
  static create(t, o) {
    return new ZodPipeline({
      in: t,
      out: o,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
}
class ZodReadonly extends ZodType {
  _parse(t) {
    const o = this._def.innerType._parse(t), i = (d) => (isValid(d) && (d.value = Object.freeze(d.value)), d);
    return isAsync(o) ? o.then((d) => i(d)) : i(o);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodReadonly.create = (e, t) => new ZodReadonly({
  innerType: e,
  typeName: ZodFirstPartyTypeKind.ZodReadonly,
  ...processCreateParams(t)
});
function custom(e, t = {}, o) {
  return e ? ZodAny.create().superRefine((i, d) => {
    var s, n;
    if (!e(i)) {
      const r = typeof t == "function" ? t(i) : typeof t == "string" ? { message: t } : t, u = (n = (s = r.fatal) !== null && s !== void 0 ? s : o) !== null && n !== void 0 ? n : !0, l = typeof r == "string" ? { message: r } : r;
      d.addIssue({ code: "custom", ...l, fatal: u });
    }
  }) : ZodAny.create();
}
const late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (e, t = {
  message: `Input not instance of ${e.name}`
}) => custom((o) => o instanceof e, t), stringType = ZodString.create, numberType = ZodNumber.create, nanType = ZodNaN.create, bigIntType = ZodBigInt.create, booleanType = ZodBoolean.create, dateType = ZodDate.create, symbolType = ZodSymbol.create, undefinedType = ZodUndefined.create, nullType = ZodNull.create, anyType = ZodAny.create, unknownType = ZodUnknown.create, neverType = ZodNever.create, voidType = ZodVoid.create, arrayType = ZodArray.create, objectType = ZodObject.create, strictObjectType = ZodObject.strictCreate, unionType = ZodUnion.create, discriminatedUnionType = ZodDiscriminatedUnion.create, intersectionType = ZodIntersection.create, tupleType = ZodTuple.create, recordType = ZodRecord.create, mapType = ZodMap.create, setType = ZodSet.create, functionType = ZodFunction.create, lazyType = ZodLazy.create, literalType = ZodLiteral.create, enumType = ZodEnum.create, nativeEnumType = ZodNativeEnum.create, promiseType = ZodPromise.create, effectsType = ZodEffects.create, optionalType = ZodOptional.create, nullableType = ZodNullable.create, preprocessType = ZodEffects.createWithPreprocess, pipelineType = ZodPipeline.create, ostring = () => stringType().optional(), onumber = () => numberType().optional(), oboolean = () => booleanType().optional(), coerce = {
  string: ((e) => ZodString.create({ ...e, coerce: !0 })),
  number: ((e) => ZodNumber.create({ ...e, coerce: !0 })),
  boolean: ((e) => ZodBoolean.create({
    ...e,
    coerce: !0
  })),
  bigint: ((e) => ZodBigInt.create({ ...e, coerce: !0 })),
  date: ((e) => ZodDate.create({ ...e, coerce: !0 }))
}, NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  datetimeRegex,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  enum: enumType,
  function: functionType,
  instanceof: instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  null: nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  undefined: undefinedType,
  union: unionType,
  unknown: unknownType,
  void: voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
});
function commonjsRequire(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var libphonenumber = { exports: {} }, hasRequiredLibphonenumber;
function requireLibphonenumber() {
  return hasRequiredLibphonenumber || (hasRequiredLibphonenumber = 1, (function(module, exports$1) {
    (function(e) {
      module.exports = e();
    })(function() {
      return (/* @__PURE__ */ (function() {
        function e(t, o, i) {
          function d(r, u) {
            if (!o[r]) {
              if (!t[r]) {
                var l = typeof commonjsRequire == "function" && commonjsRequire;
                if (!u && l) return l(r, !0);
                if (s) return s(r, !0);
                var c = new Error("Cannot find module '" + r + "'");
                throw c.code = "MODULE_NOT_FOUND", c;
              }
              var g = o[r] = { exports: {} };
              t[r][0].call(g.exports, function(p) {
                var m = t[r][1][p];
                return d(m || p);
              }, g, g.exports, e, t, o, i);
            }
            return o[r].exports;
          }
          for (var s = typeof commonjsRequire == "function" && commonjsRequire, n = 0; n < i.length; n++) d(i[n]);
          return d;
        }
        return e;
      })())({ 1: [function(require, module, exports$1) {
        (function(global) {
          (function() {
            var $jscomp = $jscomp || {};
            $jscomp.scope = {}, $jscomp.createTemplateTagFirstArg = function(e) {
              return e.raw = e;
            }, $jscomp.createTemplateTagFirstArgWithRaw = function(e, t) {
              return e.raw = t, e;
            }, $jscomp.arrayIteratorImpl = function(e) {
              var t = 0;
              return function() {
                return t < e.length ? { done: !1, value: e[t++] } : { done: !0 };
              };
            }, $jscomp.arrayIterator = function(e) {
              return { next: $jscomp.arrayIteratorImpl(e) };
            }, $jscomp.makeIterator = function(e) {
              var t = typeof Symbol < "u" && Symbol.iterator && e[Symbol.iterator];
              return t ? t.call(e) : $jscomp.arrayIterator(e);
            }, $jscomp.arrayFromIterator = function(e) {
              for (var t, o = []; !(t = e.next()).done; ) o.push(t.value);
              return o;
            }, $jscomp.arrayFromIterable = function(e) {
              return e instanceof Array ? e : $jscomp.arrayFromIterator($jscomp.makeIterator(e));
            }, $jscomp.checkStringArgs = function(e, t, o) {
              if (e == null) throw new TypeError("The 'this' value for String.prototype." + o + " must not be null or undefined");
              if (t instanceof RegExp) throw new TypeError("First argument to String.prototype." + o + " must not be a regular expression");
              return e + "";
            }, $jscomp.ASSUME_ES5 = !1, $jscomp.ASSUME_NO_NATIVE_MAP = !1, $jscomp.ASSUME_NO_NATIVE_SET = !1, $jscomp.SIMPLE_FROUND_POLYFILL = !1, $jscomp.ISOLATE_POLYFILLS = !1, $jscomp.FORCE_POLYFILL_PROMISE = !1, $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1, $jscomp.defineProperty = $jscomp.ASSUME_ES5 || typeof Object.defineProperties == "function" ? Object.defineProperty : function(e, t, o) {
              return e == Array.prototype || e == Object.prototype || (e[t] = o.value), e;
            }, $jscomp.getGlobal = function(e) {
              e = [typeof globalThis == "object" && globalThis, e, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
              for (var t = 0; t < e.length; ++t) {
                var o = e[t];
                if (o && o.Math == Math) return o;
              }
              throw Error("Cannot find global object");
            }, $jscomp.global = $jscomp.getGlobal(this), $jscomp.IS_SYMBOL_NATIVE = typeof Symbol == "function" && typeof /* @__PURE__ */ Symbol("x") == "symbol", $jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE, $jscomp.polyfills = {}, $jscomp.propertyToPolyfillSymbol = {}, $jscomp.POLYFILL_PREFIX = "$jscp$", $jscomp.polyfill = function(e, t, o, i) {
              t && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(e, t, o, i) : $jscomp.polyfillUnisolated(e, t, o, i));
            }, $jscomp.polyfillUnisolated = function(e, t, o, i) {
              for (o = $jscomp.global, e = e.split("."), i = 0; i < e.length - 1; i++) {
                var d = e[i];
                if (!(d in o)) return;
                o = o[d];
              }
              e = e[e.length - 1], i = o[e], t = t(i), t != i && t != null && $jscomp.defineProperty(o, e, { configurable: !0, writable: !0, value: t });
            }, $jscomp.polyfillIsolated = function(e, t, o, i) {
              var d = e.split(".");
              e = d.length === 1, i = d[0], i = !e && i in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
              for (var s = 0; s < d.length - 1; s++) {
                var n = d[s];
                if (!(n in i)) return;
                i = i[n];
              }
              d = d[d.length - 1], o = $jscomp.IS_SYMBOL_NATIVE && o === "es6" ? i[d] : null, t = t(o), t != null && (e ? $jscomp.defineProperty($jscomp.polyfills, d, { configurable: !0, writable: !0, value: t }) : t !== o && ($jscomp.propertyToPolyfillSymbol[d] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol(d) : $jscomp.POLYFILL_PREFIX + d, d = $jscomp.propertyToPolyfillSymbol[d], $jscomp.defineProperty(i, d, { configurable: !0, writable: !0, value: t })));
            }, $jscomp.polyfill("String.prototype.endsWith", function(e) {
              return e || function(t, o) {
                var i = $jscomp.checkStringArgs(this, t, "endsWith");
                t += "", o === void 0 && (o = i.length), o = Math.max(0, Math.min(o | 0, i.length));
                for (var d = t.length; 0 < d && 0 < o; ) if (i[--o] != t[--d]) return !1;
                return 0 >= d;
              };
            }, "es6", "es3"), $jscomp.findInternal = function(e, t, o) {
              e instanceof String && (e = String(e));
              for (var i = e.length, d = 0; d < i; d++) {
                var s = e[d];
                if (t.call(o, s, d, e)) return { i: d, v: s };
              }
              return { i: -1, v: void 0 };
            }, $jscomp.polyfill("Array.prototype.find", function(e) {
              return e || function(t, o) {
                return $jscomp.findInternal(this, t, o).v;
              };
            }, "es6", "es3"), $jscomp.polyfill("String.prototype.startsWith", function(e) {
              return e || function(t, o) {
                var i = $jscomp.checkStringArgs(this, t, "startsWith");
                t += "";
                var d = i.length, s = t.length;
                o = Math.max(0, Math.min(o | 0, i.length));
                for (var n = 0; n < s && o < d; ) if (i[o++] != t[n++]) return !1;
                return n >= s;
              };
            }, "es6", "es3"), $jscomp.polyfill("String.prototype.repeat", function(e) {
              return e || function(t) {
                var o = $jscomp.checkStringArgs(this, null, "repeat");
                if (0 > t || 1342177279 < t) throw new RangeError("Invalid count value");
                t |= 0;
                for (var i = ""; t; ) t & 1 && (i += o), (t >>>= 1) && (o += o);
                return i;
              };
            }, "es6", "es3"), $jscomp.initSymbol = function() {
            }, $jscomp.polyfill("Symbol", function(e) {
              if (e) return e;
              var t = function(d, s) {
                this.$jscomp$symbol$id_ = d, $jscomp.defineProperty(this, "description", { configurable: !0, writable: !0, value: s });
              };
              t.prototype.toString = function() {
                return this.$jscomp$symbol$id_;
              };
              var o = 0, i = function(d) {
                if (this instanceof i) throw new TypeError("Symbol is not a constructor");
                return new t("jscomp_symbol_" + (d || "") + "_" + o++, d);
              };
              return i;
            }, "es6", "es3"), $jscomp.polyfill(
              "Symbol.iterator",
              function(e) {
                if (e) return e;
                e = /* @__PURE__ */ Symbol("Symbol.iterator");
                for (var t = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), o = 0; o < t.length; o++) {
                  var i = $jscomp.global[t[o]];
                  typeof i == "function" && typeof i.prototype[e] != "function" && $jscomp.defineProperty(i.prototype, e, { configurable: !0, writable: !0, value: function() {
                    return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
                  } });
                }
                return e;
              },
              "es6",
              "es3"
            ), $jscomp.iteratorPrototype = function(e) {
              return e = { next: e }, e[Symbol.iterator] = function() {
                return this;
              }, e;
            }, $jscomp.iteratorFromArray = function(e, t) {
              e instanceof String && (e += "");
              var o = 0, i = !1, d = { next: function() {
                if (!i && o < e.length) {
                  var s = o++;
                  return { value: t(s, e[s]), done: !1 };
                }
                return i = !0, { done: !0, value: void 0 };
              } };
              return d[Symbol.iterator] = function() {
                return d;
              }, d;
            }, $jscomp.polyfill("Array.prototype.keys", function(e) {
              return e || function() {
                return $jscomp.iteratorFromArray(this, function(t) {
                  return t;
                });
              };
            }, "es6", "es3"), $jscomp.polyfill("Object.is", function(e) {
              return e || function(t, o) {
                return t === o ? t !== 0 || 1 / t === 1 / o : t !== t && o !== o;
              };
            }, "es6", "es3"), $jscomp.polyfill("Array.prototype.includes", function(e) {
              return e || function(t, o) {
                var i = this;
                i instanceof String && (i = String(i));
                var d = i.length;
                for (o = o || 0, 0 > o && (o = Math.max(o + d, 0)); o < d; o++) {
                  var s = i[o];
                  if (s === t || Object.is(s, t)) return !0;
                }
                return !1;
              };
            }, "es7", "es3"), $jscomp.polyfill("String.prototype.includes", function(e) {
              return e || function(t, o) {
                return $jscomp.checkStringArgs(this, t, "includes").indexOf(t, o || 0) !== -1;
              };
            }, "es6", "es3");
            var goog = goog || {};
            goog.global = this || self, goog.exportPath_ = function(e, t, o, i) {
              e = e.split("."), i = i || goog.global, e[0] in i || typeof i.execScript > "u" || i.execScript("var " + e[0]);
              for (var d; e.length && (d = e.shift()); ) if (e.length || t === void 0) i = i[d] && i[d] !== Object.prototype[d] ? i[d] : i[d] = {};
              else if (!o && goog.isObject(t) && goog.isObject(i[d])) for (var s in t) t.hasOwnProperty(s) && (i[d][s] = t[s]);
              else i[d] = t;
            }, goog.define = function(e, t) {
              return t;
            }, goog.FEATURESET_YEAR = 2012, goog.DEBUG = !0, goog.LOCALE = "en", goog.TRUSTED_SITE = !0, goog.DISALLOW_TEST_ONLY_CODE = !goog.DEBUG, goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1, goog.provide = function(e) {
              if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
              goog.constructNamespace_(e);
            }, goog.constructNamespace_ = function(e, t, o) {
              goog.exportPath_(e, t, o);
            }, goog.getScriptNonce = function(e) {
              return e && e != goog.global ? goog.getScriptNonce_(e.document) : (goog.cspNonce_ === null && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document)), goog.cspNonce_);
            }, goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/, goog.cspNonce_ = null, goog.getScriptNonce_ = function(e) {
              return (e = e.querySelector && e.querySelector("script[nonce]")) && (e = e.nonce || e.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(e) ? e : "";
            }, goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/, goog.module = function(e) {
              if (typeof e != "string" || !e || e.search(goog.VALID_MODULE_RE_) == -1) throw Error("Invalid module identifier");
              if (!goog.isInGoogModuleLoader_()) throw Error("Module " + e + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
              if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
              goog.moduleLoaderState_.moduleName = e;
            }, goog.module.get = function(e) {
              return goog.module.getInternal_(e);
            }, goog.module.getInternal_ = function(e) {
              return null;
            }, goog.ModuleType = { ES6: "es6", GOOG: "goog" }, goog.moduleLoaderState_ = null, goog.isInModuleLoader_ = function() {
              return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
            }, goog.isInGoogModuleLoader_ = function() {
              return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
            }, goog.isInEs6ModuleLoader_ = function() {
              if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
              var e = goog.global.$jscomp;
              return e ? typeof e.getCurrentModulePath != "function" ? !1 : !!e.getCurrentModulePath() : !1;
            }, goog.module.declareLegacyNamespace = function() {
              goog.moduleLoaderState_.declareLegacyNamespace = !0;
            }, goog.declareModuleId = function(e) {
              if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = e;
              else {
                var t = goog.global.$jscomp;
                if (!t || typeof t.getCurrentModulePath != "function") throw Error('Module with namespace "' + e + '" has been loaded incorrectly.');
                t = t.require(t.getCurrentModulePath()), goog.loadedModules_[e] = { exports: t, type: goog.ModuleType.ES6, moduleId: e };
              }
            }, goog.setTestOnly = function(e) {
              if (goog.DISALLOW_TEST_ONLY_CODE) throw e = e || "", Error("Importing test-only code into non-debug environment" + (e ? ": " + e : "."));
            }, goog.forwardDeclare = function(e) {
            }, goog.getObjectByName = function(e, t) {
              e = e.split("."), t = t || goog.global;
              for (var o = 0; o < e.length; o++) if (t = t[e[o]], t == null) return null;
              return t;
            }, goog.addDependency = function(e, t, o, i) {
            }, goog.ENABLE_DEBUG_LOADER = !0, goog.logToConsole_ = function(e) {
              goog.global.console && goog.global.console.error(e);
            }, goog.require = function(e) {
            }, goog.requireType = function(e) {
              return {};
            }, goog.basePath = "", goog.nullFunction = function() {
            }, goog.abstractMethod = function() {
              throw Error("unimplemented abstract method");
            }, goog.addSingletonGetter = function(e) {
              e.instance_ = void 0, e.getInstance = function() {
                return e.instance_ ? e.instance_ : (goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = e), e.instance_ = new e());
              };
            }, goog.instantiatedSingletons_ = [], goog.LOAD_MODULE_USING_EVAL = !0, goog.SEAL_MODULE_EXPORTS = goog.DEBUG, goog.loadedModules_ = {}, goog.DEPENDENCIES_ENABLED = !1, goog.TRANSPILE = "detect", goog.ASSUME_ES_MODULES_TRANSPILED = !1, goog.TRANSPILE_TO_LANGUAGE = "", goog.TRANSPILER = "transpile.js", goog.hasBadLetScoping = null, goog.useSafari10Workaround = function() {
              if (goog.hasBadLetScoping == null) {
                try {
                  var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
                } catch (e) {
                  a = !1;
                }
                goog.hasBadLetScoping = a;
              }
              return goog.hasBadLetScoping;
            }, goog.workaroundSafari10EvalBug = function(e) {
              return "(function(){" + e + `
;})();
`;
            }, goog.loadModule = function(e) {
              var t = goog.moduleLoaderState_;
              try {
                goog.moduleLoaderState_ = { moduleName: "", declareLegacyNamespace: !1, type: goog.ModuleType.GOOG };
                var o = {}, i = o;
                if (typeof e == "function") i = e.call(void 0, i);
                else if (typeof e == "string") goog.useSafari10Workaround() && (e = goog.workaroundSafari10EvalBug(e)), i = goog.loadModuleFromSource_.call(void 0, i, e);
                else throw Error("Invalid module definition");
                var d = goog.moduleLoaderState_.moduleName;
                if (typeof d == "string" && d) goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(d, i, o !== i) : goog.SEAL_MODULE_EXPORTS && Object.seal && typeof i == "object" && i != null && Object.seal(i), goog.loadedModules_[d] = { exports: i, type: goog.ModuleType.GOOG, moduleId: goog.moduleLoaderState_.moduleName };
                else throw Error('Invalid module name "' + d + '"');
              } finally {
                goog.moduleLoaderState_ = t;
              }
            }, goog.loadModuleFromSource_ = function(a, b) {
              return eval(b), a;
            }, goog.normalizePath_ = function(e) {
              e = e.split("/");
              for (var t = 0; t < e.length; ) e[t] == "." ? e.splice(t, 1) : t && e[t] == ".." && e[t - 1] && e[t - 1] != ".." ? e.splice(--t, 2) : t++;
              return e.join("/");
            }, goog.loadFileSync_ = function(e) {
              if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(e);
              try {
                var t = new goog.global.XMLHttpRequest();
                return t.open("get", e, !1), t.send(), t.status == 0 || t.status == 200 ? t.responseText : null;
              } catch {
                return null;
              }
            }, goog.transpile_ = function(e, t, o) {
              var i = goog.global.$jscomp;
              i || (goog.global.$jscomp = i = {});
              var d = i.transpile;
              if (!d) {
                var s = goog.basePath + goog.TRANSPILER, n = goog.loadFileSync_(s);
                if (n) {
                  if ((function() {
                    (0, eval)(n + `
//# sourceURL=` + s);
                  }).call(goog.global), goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
                  goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile, i = goog.global.$jscomp, d = i.transpile;
                }
              }
              return d || (d = i.transpile = function(r, u) {
                return goog.logToConsole_(u + " requires transpilation but no transpiler was found."), r;
              }), d(e, t, o);
            }, goog.typeOf = function(e) {
              var t = typeof e;
              return t != "object" ? t : e ? Array.isArray(e) ? "array" : t : "null";
            }, goog.isArrayLike = function(e) {
              var t = goog.typeOf(e);
              return t == "array" || t == "object" && typeof e.length == "number";
            }, goog.isDateLike = function(e) {
              return goog.isObject(e) && typeof e.getFullYear == "function";
            }, goog.isObject = function(e) {
              var t = typeof e;
              return t == "object" && e != null || t == "function";
            }, goog.getUid = function(e) {
              return Object.prototype.hasOwnProperty.call(e, goog.UID_PROPERTY_) && e[goog.UID_PROPERTY_] || (e[goog.UID_PROPERTY_] = ++goog.uidCounter_);
            }, goog.hasUid = function(e) {
              return !!e[goog.UID_PROPERTY_];
            }, goog.removeUid = function(e) {
              e !== null && "removeAttribute" in e && e.removeAttribute(goog.UID_PROPERTY_);
              try {
                delete e[goog.UID_PROPERTY_];
              } catch {
              }
            }, goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0), goog.uidCounter_ = 0, goog.cloneObject = function(e) {
              var t = goog.typeOf(e);
              if (t == "object" || t == "array") {
                if (typeof e.clone == "function") return e.clone();
                t = t == "array" ? [] : {};
                for (var o in e) t[o] = goog.cloneObject(e[o]);
                return t;
              }
              return e;
            }, goog.bindNative_ = function(e, t, o) {
              return e.call.apply(e.bind, arguments);
            }, goog.bindJs_ = function(e, t, o) {
              if (!e) throw Error();
              if (2 < arguments.length) {
                var i = Array.prototype.slice.call(arguments, 2);
                return function() {
                  var d = Array.prototype.slice.call(arguments);
                  return Array.prototype.unshift.apply(d, i), e.apply(t, d);
                };
              }
              return function() {
                return e.apply(t, arguments);
              };
            }, goog.bind = function(e, t, o) {
              return Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_, goog.bind.apply(null, arguments);
            }, goog.partial = function(e, t) {
              var o = Array.prototype.slice.call(arguments, 1);
              return function() {
                var i = o.slice();
                return i.push.apply(i, arguments), e.apply(this, i);
              };
            }, goog.mixin = function(e, t) {
              for (var o in t) e[o] = t[o];
            }, goog.now = function() {
              return Date.now();
            }, goog.globalEval = function(e) {
              (0, eval)(e);
            }, goog.getCssName = function(e, t) {
              if (String(e).charAt(0) == ".") throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + e);
              var o = function(d) {
                return goog.cssNameMapping_[d] || d;
              }, i = function(d) {
                d = d.split("-");
                for (var s = [], n = 0; n < d.length; n++) s.push(o(d[n]));
                return s.join("-");
              };
              return i = goog.cssNameMapping_ ? goog.cssNameMappingStyle_ == "BY_WHOLE" ? o : i : function(d) {
                return d;
              }, e = t ? e + "-" + i(t) : i(e), goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(e) : e;
            }, goog.setCssNameMapping = function(e, t) {
              goog.cssNameMapping_ = e, goog.cssNameMappingStyle_ = t;
            }, goog.getMsg = function(e, t, o) {
              return o && o.html && (e = e.replace(/</g, "&lt;")), o && o.unescapeHtmlEntities && (e = e.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, "&")), t && (e = e.replace(/\{\$([^}]+)}/g, function(i, d) {
                return t != null && d in t ? t[d] : i;
              })), e;
            }, goog.getMsgWithFallback = function(e, t) {
              return e;
            }, goog.exportSymbol = function(e, t, o) {
              goog.exportPath_(e, t, !0, o);
            }, goog.exportProperty = function(e, t, o) {
              e[t] = o;
            }, goog.inherits = function(e, t) {
              function o() {
              }
              o.prototype = t.prototype, e.superClass_ = t.prototype, e.prototype = new o(), e.prototype.constructor = e, e.base = function(i, d, s) {
                for (var n = Array(arguments.length - 2), r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
                return t.prototype[d].apply(i, n);
              };
            }, goog.scope = function(e) {
              if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
              e.call(goog.global);
            }, goog.defineClass = function(e, t) {
              var o = t.constructor, i = t.statics;
              return o && o != Object.prototype.constructor || (o = function() {
                throw Error("cannot instantiate an interface (no constructor defined).");
              }), o = goog.defineClass.createSealingConstructor_(o, e), e && goog.inherits(o, e), delete t.constructor, delete t.statics, goog.defineClass.applyProperties_(o.prototype, t), i != null && (i instanceof Function ? i(o) : goog.defineClass.applyProperties_(o, i)), o;
            }, goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG, goog.defineClass.createSealingConstructor_ = function(e, t) {
              return goog.defineClass.SEAL_CLASS_INSTANCES ? function() {
                var o = e.apply(this, arguments) || this;
                return o[goog.UID_PROPERTY_] = o[goog.UID_PROPERTY_], o;
              } : e;
            }, goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.defineClass.applyProperties_ = function(e, t) {
              for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              for (var i = 0; i < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; i++) o = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[i], Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }, goog.TRUSTED_TYPES_POLICY_NAME = "goog", goog.identity_ = function(e) {
              return e;
            }, goog.createTrustedTypesPolicy = function(e) {
              var t = null, o = goog.global.trustedTypes;
              if (!o || !o.createPolicy) return t;
              try {
                t = o.createPolicy(e, { createHTML: goog.identity_, createScript: goog.identity_, createScriptURL: goog.identity_ });
              } catch (i) {
                goog.logToConsole_(i.message);
              }
              return t;
            }, goog.debug = {};
            function module$contents$goog$debug$Error_DebugError(e) {
              if (Error.captureStackTrace) Error.captureStackTrace(this, module$contents$goog$debug$Error_DebugError);
              else {
                var t = Error().stack;
                t && (this.stack = t);
              }
              e && (this.message = String(e)), this.reportErrorToServer = !0;
            }
            goog.inherits(module$contents$goog$debug$Error_DebugError, Error), module$contents$goog$debug$Error_DebugError.prototype.name = "CustomError", goog.debug.Error = module$contents$goog$debug$Error_DebugError, goog.dom = {}, goog.dom.NodeType = { ELEMENT: 1, ATTRIBUTE: 2, TEXT: 3, CDATA_SECTION: 4, ENTITY_REFERENCE: 5, ENTITY: 6, PROCESSING_INSTRUCTION: 7, COMMENT: 8, DOCUMENT: 9, DOCUMENT_TYPE: 10, DOCUMENT_FRAGMENT: 11, NOTATION: 12 }, goog.asserts = {}, goog.asserts.ENABLE_ASSERTS = goog.DEBUG, goog.asserts.AssertionError = function(e, t) {
              module$contents$goog$debug$Error_DebugError.call(this, goog.asserts.subs_(e, t)), this.messagePattern = e;
            }, goog.inherits(goog.asserts.AssertionError, module$contents$goog$debug$Error_DebugError), goog.asserts.AssertionError.prototype.name = "AssertionError", goog.asserts.DEFAULT_ERROR_HANDLER = function(e) {
              throw e;
            }, goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER, goog.asserts.subs_ = function(e, t) {
              e = e.split("%s");
              for (var o = "", i = e.length - 1, d = 0; d < i; d++) o += e[d] + (d < t.length ? t[d] : "%s");
              return o + e[i];
            }, goog.asserts.doAssertFailure_ = function(e, t, o, i) {
              var d = "Assertion failed";
              if (o) {
                d += ": " + o;
                var s = i;
              } else e && (d += ": " + e, s = t);
              e = new goog.asserts.AssertionError("" + d, s || []), goog.asserts.errorHandler_(e);
            }, goog.asserts.setErrorHandler = function(e) {
              goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = e);
            }, goog.asserts.assert = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && !e && goog.asserts.doAssertFailure_("", null, t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertExists = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && e == null && goog.asserts.doAssertFailure_("Expected to exist: %s.", [e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.fail = function(e, t) {
              goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (e ? ": " + e : ""), Array.prototype.slice.call(arguments, 1)));
            }, goog.asserts.assertNumber = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && typeof e != "number" && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertString = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && typeof e != "string" && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertFunction = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && typeof e != "function" && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertObject = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && !goog.isObject(e) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertArray = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && !Array.isArray(e) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertBoolean = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && typeof e != "boolean" && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertElement = function(e, t, o) {
              return !goog.asserts.ENABLE_ASSERTS || goog.isObject(e) && e.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertInstanceof = function(e, t, o, i) {
              return !goog.asserts.ENABLE_ASSERTS || e instanceof t || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(t), goog.asserts.getType_(e)], o, Array.prototype.slice.call(arguments, 3)), e;
            }, goog.asserts.assertFinite = function(e, t, o) {
              return !goog.asserts.ENABLE_ASSERTS || typeof e == "number" && isFinite(e) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertObjectPrototypeIsIntact = function() {
              for (var e in Object.prototype) goog.asserts.fail(e + " should not be enumerable in Object.prototype.");
            }, goog.asserts.getType_ = function(e) {
              return e instanceof Function ? e.displayName || e.name || "unknown type name" : e instanceof Object ? e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e) : e === null ? "null" : typeof e;
            }, goog.array = {}, goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
            var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
            goog.array.ASSUME_NATIVE_FUNCTIONS = module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;
            function module$contents$goog$array_peek(e) {
              return e[e.length - 1];
            }
            goog.array.peek = module$contents$goog$array_peek, goog.array.last = module$contents$goog$array_peek;
            var module$contents$goog$array_indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.indexOf.call(e, t, o);
            } : function(e, t, o) {
              if (o = o == null ? 0 : 0 > o ? Math.max(0, e.length + o) : o, typeof e == "string") return typeof t != "string" || t.length != 1 ? -1 : e.indexOf(t, o);
              for (; o < e.length; o++) if (o in e && e[o] === t) return o;
              return -1;
            };
            goog.array.indexOf = module$contents$goog$array_indexOf;
            var module$contents$goog$array_lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.lastIndexOf.call(e, t, o ?? e.length - 1);
            } : function(e, t, o) {
              if (o = o ?? e.length - 1, 0 > o && (o = Math.max(0, e.length + o)), typeof e == "string") return typeof t != "string" || t.length != 1 ? -1 : e.lastIndexOf(t, o);
              for (; 0 <= o; o--) if (o in e && e[o] === t) return o;
              return -1;
            };
            goog.array.lastIndexOf = module$contents$goog$array_lastIndexOf;
            var module$contents$goog$array_forEach = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(e, t, o) {
              goog.asserts.assert(e.length != null), Array.prototype.forEach.call(e, t, o);
            } : function(e, t, o) {
              for (var i = e.length, d = typeof e == "string" ? e.split("") : e, s = 0; s < i; s++) s in d && t.call(o, d[s], s, e);
            };
            goog.array.forEach = module$contents$goog$array_forEach;
            function module$contents$goog$array_forEachRight(e, t, o) {
              var i = e.length, d = typeof e == "string" ? e.split("") : e;
              for (--i; 0 <= i; --i) i in d && t.call(o, d[i], i, e);
            }
            goog.array.forEachRight = module$contents$goog$array_forEachRight;
            var module$contents$goog$array_filter = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.filter.call(e, t, o);
            } : function(e, t, o) {
              for (var i = e.length, d = [], s = 0, n = typeof e == "string" ? e.split("") : e, r = 0; r < i; r++) if (r in n) {
                var u = n[r];
                t.call(o, u, r, e) && (d[s++] = u);
              }
              return d;
            };
            goog.array.filter = module$contents$goog$array_filter;
            var module$contents$goog$array_map = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.map.call(e, t, o);
            } : function(e, t, o) {
              for (var i = e.length, d = Array(i), s = typeof e == "string" ? e.split("") : e, n = 0; n < i; n++) n in s && (d[n] = t.call(o, s[n], n, e));
              return d;
            };
            goog.array.map = module$contents$goog$array_map;
            var module$contents$goog$array_reduce = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(e, t, o, i) {
              return goog.asserts.assert(e.length != null), i && (t = goog.bind(t, i)), Array.prototype.reduce.call(e, t, o);
            } : function(e, t, o, i) {
              var d = o;
              return module$contents$goog$array_forEach(e, function(s, n) {
                d = t.call(i, d, s, n, e);
              }), d;
            };
            goog.array.reduce = module$contents$goog$array_reduce;
            var module$contents$goog$array_reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(e, t, o, i) {
              return goog.asserts.assert(e.length != null), goog.asserts.assert(t != null), i && (t = goog.bind(t, i)), Array.prototype.reduceRight.call(e, t, o);
            } : function(e, t, o, i) {
              var d = o;
              return module$contents$goog$array_forEachRight(e, function(s, n) {
                d = t.call(i, d, s, n, e);
              }), d;
            };
            goog.array.reduceRight = module$contents$goog$array_reduceRight;
            var module$contents$goog$array_some = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.some.call(e, t, o);
            } : function(e, t, o) {
              for (var i = e.length, d = typeof e == "string" ? e.split("") : e, s = 0; s < i; s++) if (s in d && t.call(o, d[s], s, e)) return !0;
              return !1;
            };
            goog.array.some = module$contents$goog$array_some;
            var module$contents$goog$array_every = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.every.call(e, t, o);
            } : function(e, t, o) {
              for (var i = e.length, d = typeof e == "string" ? e.split("") : e, s = 0; s < i; s++) if (s in d && !t.call(o, d[s], s, e)) return !1;
              return !0;
            };
            goog.array.every = module$contents$goog$array_every;
            function module$contents$goog$array_count(e, t, o) {
              var i = 0;
              return module$contents$goog$array_forEach(e, function(d, s, n) {
                t.call(o, d, s, n) && ++i;
              }, o), i;
            }
            goog.array.count = module$contents$goog$array_count;
            function module$contents$goog$array_find(e, t, o) {
              return t = module$contents$goog$array_findIndex(e, t, o), 0 > t ? null : typeof e == "string" ? e.charAt(t) : e[t];
            }
            goog.array.find = module$contents$goog$array_find;
            function module$contents$goog$array_findIndex(e, t, o) {
              for (var i = e.length, d = typeof e == "string" ? e.split("") : e, s = 0; s < i; s++) if (s in d && t.call(o, d[s], s, e)) return s;
              return -1;
            }
            goog.array.findIndex = module$contents$goog$array_findIndex;
            function module$contents$goog$array_findRight(e, t, o) {
              return t = module$contents$goog$array_findIndexRight(e, t, o), 0 > t ? null : typeof e == "string" ? e.charAt(t) : e[t];
            }
            goog.array.findRight = module$contents$goog$array_findRight;
            function module$contents$goog$array_findIndexRight(e, t, o) {
              var i = e.length, d = typeof e == "string" ? e.split("") : e;
              for (--i; 0 <= i; i--) if (i in d && t.call(o, d[i], i, e)) return i;
              return -1;
            }
            goog.array.findIndexRight = module$contents$goog$array_findIndexRight;
            function module$contents$goog$array_contains(e, t) {
              return 0 <= module$contents$goog$array_indexOf(e, t);
            }
            goog.array.contains = module$contents$goog$array_contains;
            function module$contents$goog$array_isEmpty(e) {
              return e.length == 0;
            }
            goog.array.isEmpty = module$contents$goog$array_isEmpty;
            function module$contents$goog$array_clear(e) {
              if (!Array.isArray(e)) for (var t = e.length - 1; 0 <= t; t--) delete e[t];
              e.length = 0;
            }
            goog.array.clear = module$contents$goog$array_clear;
            function module$contents$goog$array_insert(e, t) {
              module$contents$goog$array_contains(e, t) || e.push(t);
            }
            goog.array.insert = module$contents$goog$array_insert;
            function module$contents$goog$array_insertAt(e, t, o) {
              module$contents$goog$array_splice(e, o, 0, t);
            }
            goog.array.insertAt = module$contents$goog$array_insertAt;
            function module$contents$goog$array_insertArrayAt(e, t, o) {
              goog.partial(module$contents$goog$array_splice, e, o, 0).apply(null, t);
            }
            goog.array.insertArrayAt = module$contents$goog$array_insertArrayAt;
            function module$contents$goog$array_insertBefore(e, t, o) {
              var i;
              arguments.length == 2 || 0 > (i = module$contents$goog$array_indexOf(e, o)) ? e.push(t) : module$contents$goog$array_insertAt(e, t, i);
            }
            goog.array.insertBefore = module$contents$goog$array_insertBefore;
            function module$contents$goog$array_remove(e, t) {
              t = module$contents$goog$array_indexOf(e, t);
              var o;
              return (o = 0 <= t) && module$contents$goog$array_removeAt(e, t), o;
            }
            goog.array.remove = module$contents$goog$array_remove;
            function module$contents$goog$array_removeLast(e, t) {
              return t = module$contents$goog$array_lastIndexOf(e, t), 0 <= t ? (module$contents$goog$array_removeAt(e, t), !0) : !1;
            }
            goog.array.removeLast = module$contents$goog$array_removeLast;
            function module$contents$goog$array_removeAt(e, t) {
              return goog.asserts.assert(e.length != null), Array.prototype.splice.call(e, t, 1).length == 1;
            }
            goog.array.removeAt = module$contents$goog$array_removeAt;
            function module$contents$goog$array_removeIf(e, t, o) {
              return t = module$contents$goog$array_findIndex(e, t, o), 0 <= t ? (module$contents$goog$array_removeAt(e, t), !0) : !1;
            }
            goog.array.removeIf = module$contents$goog$array_removeIf;
            function module$contents$goog$array_removeAllIf(e, t, o) {
              var i = 0;
              return module$contents$goog$array_forEachRight(e, function(d, s) {
                t.call(o, d, s, e) && module$contents$goog$array_removeAt(e, s) && i++;
              }), i;
            }
            goog.array.removeAllIf = module$contents$goog$array_removeAllIf;
            function module$contents$goog$array_concat(e) {
              return Array.prototype.concat.apply([], arguments);
            }
            goog.array.concat = module$contents$goog$array_concat;
            function module$contents$goog$array_join(e) {
              return Array.prototype.concat.apply([], arguments);
            }
            goog.array.join = module$contents$goog$array_join;
            function module$contents$goog$array_toArray(e) {
              var t = e.length;
              if (0 < t) {
                for (var o = Array(t), i = 0; i < t; i++) o[i] = e[i];
                return o;
              }
              return [];
            }
            var module$contents$goog$array_clone = goog.array.toArray = module$contents$goog$array_toArray;
            goog.array.clone = module$contents$goog$array_clone;
            function module$contents$goog$array_extend(e, t) {
              for (var o = 1; o < arguments.length; o++) {
                var i = arguments[o];
                if (goog.isArrayLike(i)) {
                  var d = e.length || 0, s = i.length || 0;
                  e.length = d + s;
                  for (var n = 0; n < s; n++) e[d + n] = i[n];
                } else e.push(i);
              }
            }
            goog.array.extend = module$contents$goog$array_extend;
            function module$contents$goog$array_splice(e, t, o, i) {
              return goog.asserts.assert(e.length != null), Array.prototype.splice.apply(e, module$contents$goog$array_slice(arguments, 1));
            }
            goog.array.splice = module$contents$goog$array_splice;
            function module$contents$goog$array_slice(e, t, o) {
              return goog.asserts.assert(e.length != null), 2 >= arguments.length ? Array.prototype.slice.call(e, t) : Array.prototype.slice.call(e, t, o);
            }
            goog.array.slice = module$contents$goog$array_slice;
            function module$contents$goog$array_removeDuplicates(e, t, o) {
              t = t || e;
              var i = function(u) {
                return goog.isObject(u) ? "o" + goog.getUid(u) : (typeof u).charAt(0) + u;
              };
              o = o || i, i = {};
              for (var d = 0, s = 0; s < e.length; ) {
                var n = e[s++], r = o(n);
                Object.prototype.hasOwnProperty.call(i, r) || (i[r] = !0, t[d++] = n);
              }
              t.length = d;
            }
            goog.array.removeDuplicates = module$contents$goog$array_removeDuplicates;
            function module$contents$goog$array_binarySearch(e, t, o) {
              return module$contents$goog$array_binarySearch_(e, o || module$contents$goog$array_defaultCompare, !1, t);
            }
            goog.array.binarySearch = module$contents$goog$array_binarySearch;
            function module$contents$goog$array_binarySelect(e, t, o) {
              return module$contents$goog$array_binarySearch_(e, t, !0, void 0, o);
            }
            goog.array.binarySelect = module$contents$goog$array_binarySelect;
            function module$contents$goog$array_binarySearch_(e, t, o, i, d) {
              for (var s = 0, n = e.length, r; s < n; ) {
                var u = s + (n - s >>> 1), l = o ? t.call(d, e[u], u, e) : t(i, e[u]);
                0 < l ? s = u + 1 : (n = u, r = !l);
              }
              return r ? s : -s - 1;
            }
            function module$contents$goog$array_sort(e, t) {
              e.sort(t || module$contents$goog$array_defaultCompare);
            }
            goog.array.sort = module$contents$goog$array_sort;
            function module$contents$goog$array_stableSort(e, t) {
              for (var o = Array(e.length), i = 0; i < e.length; i++) o[i] = { index: i, value: e[i] };
              var d = t || module$contents$goog$array_defaultCompare;
              for (module$contents$goog$array_sort(o, function(s, n) {
                return d(s.value, n.value) || s.index - n.index;
              }), i = 0; i < e.length; i++) e[i] = o[i].value;
            }
            goog.array.stableSort = module$contents$goog$array_stableSort;
            function module$contents$goog$array_sortByKey(e, t, o) {
              var i = o || module$contents$goog$array_defaultCompare;
              module$contents$goog$array_sort(e, function(d, s) {
                return i(t(d), t(s));
              });
            }
            goog.array.sortByKey = module$contents$goog$array_sortByKey;
            function module$contents$goog$array_sortObjectsByKey(e, t, o) {
              module$contents$goog$array_sortByKey(e, function(i) {
                return i[t];
              }, o);
            }
            goog.array.sortObjectsByKey = module$contents$goog$array_sortObjectsByKey;
            function module$contents$goog$array_isSorted(e, t, o) {
              t = t || module$contents$goog$array_defaultCompare;
              for (var i = 1; i < e.length; i++) {
                var d = t(e[i - 1], e[i]);
                if (0 < d || d == 0 && o) return !1;
              }
              return !0;
            }
            goog.array.isSorted = module$contents$goog$array_isSorted;
            function module$contents$goog$array_equals(e, t, o) {
              if (!goog.isArrayLike(e) || !goog.isArrayLike(t) || e.length != t.length) return !1;
              var i = e.length;
              o = o || module$contents$goog$array_defaultCompareEquality;
              for (var d = 0; d < i; d++) if (!o(e[d], t[d])) return !1;
              return !0;
            }
            goog.array.equals = module$contents$goog$array_equals;
            function module$contents$goog$array_compare3(e, t, o) {
              o = o || module$contents$goog$array_defaultCompare;
              for (var i = Math.min(e.length, t.length), d = 0; d < i; d++) {
                var s = o(e[d], t[d]);
                if (s != 0) return s;
              }
              return module$contents$goog$array_defaultCompare(e.length, t.length);
            }
            goog.array.compare3 = module$contents$goog$array_compare3;
            function module$contents$goog$array_defaultCompare(e, t) {
              return e > t ? 1 : e < t ? -1 : 0;
            }
            goog.array.defaultCompare = module$contents$goog$array_defaultCompare;
            function module$contents$goog$array_inverseDefaultCompare(e, t) {
              return -module$contents$goog$array_defaultCompare(e, t);
            }
            goog.array.inverseDefaultCompare = module$contents$goog$array_inverseDefaultCompare;
            function module$contents$goog$array_defaultCompareEquality(e, t) {
              return e === t;
            }
            goog.array.defaultCompareEquality = module$contents$goog$array_defaultCompareEquality;
            function module$contents$goog$array_binaryInsert(e, t, o) {
              return o = module$contents$goog$array_binarySearch(e, t, o), 0 > o ? (module$contents$goog$array_insertAt(e, t, -(o + 1)), !0) : !1;
            }
            goog.array.binaryInsert = module$contents$goog$array_binaryInsert;
            function module$contents$goog$array_binaryRemove(e, t, o) {
              return t = module$contents$goog$array_binarySearch(e, t, o), 0 <= t ? module$contents$goog$array_removeAt(e, t) : !1;
            }
            goog.array.binaryRemove = module$contents$goog$array_binaryRemove;
            function module$contents$goog$array_bucket(e, t, o) {
              for (var i = {}, d = 0; d < e.length; d++) {
                var s = e[d], n = t.call(o, s, d, e);
                n !== void 0 && (i[n] || (i[n] = [])).push(s);
              }
              return i;
            }
            goog.array.bucket = module$contents$goog$array_bucket;
            function module$contents$goog$array_toObject(e, t, o) {
              var i = {};
              return module$contents$goog$array_forEach(e, function(d, s) {
                i[t.call(o, d, s, e)] = d;
              }), i;
            }
            goog.array.toObject = module$contents$goog$array_toObject;
            function module$contents$goog$array_range(e, t, o) {
              var i = [], d = 0, s = e;
              if (o = o || 1, t !== void 0 && (d = e, s = t), 0 > o * (s - d)) return [];
              if (0 < o) for (e = d; e < s; e += o) i.push(e);
              else for (e = d; e > s; e += o) i.push(e);
              return i;
            }
            goog.array.range = module$contents$goog$array_range;
            function module$contents$goog$array_repeat(e, t) {
              for (var o = [], i = 0; i < t; i++) o[i] = e;
              return o;
            }
            goog.array.repeat = module$contents$goog$array_repeat;
            function module$contents$goog$array_flatten(e) {
              for (var t = [], o = 0; o < arguments.length; o++) {
                var i = arguments[o];
                if (Array.isArray(i)) for (var d = 0; d < i.length; d += 8192) {
                  var s = module$contents$goog$array_slice(i, d, d + 8192);
                  s = module$contents$goog$array_flatten.apply(null, s);
                  for (var n = 0; n < s.length; n++) t.push(s[n]);
                }
                else t.push(i);
              }
              return t;
            }
            goog.array.flatten = module$contents$goog$array_flatten;
            function module$contents$goog$array_rotate(e, t) {
              return goog.asserts.assert(e.length != null), e.length && (t %= e.length, 0 < t ? Array.prototype.unshift.apply(e, e.splice(-t, t)) : 0 > t && Array.prototype.push.apply(e, e.splice(0, -t))), e;
            }
            goog.array.rotate = module$contents$goog$array_rotate;
            function module$contents$goog$array_moveItem(e, t, o) {
              goog.asserts.assert(0 <= t && t < e.length), goog.asserts.assert(0 <= o && o < e.length), t = Array.prototype.splice.call(e, t, 1), Array.prototype.splice.call(e, o, 0, t[0]);
            }
            goog.array.moveItem = module$contents$goog$array_moveItem;
            function module$contents$goog$array_zip(e) {
              if (!arguments.length) return [];
              for (var t = [], o = arguments[0].length, i = 1; i < arguments.length; i++) arguments[i].length < o && (o = arguments[i].length);
              for (i = 0; i < o; i++) {
                for (var d = [], s = 0; s < arguments.length; s++) d.push(arguments[s][i]);
                t.push(d);
              }
              return t;
            }
            goog.array.zip = module$contents$goog$array_zip;
            function module$contents$goog$array_shuffle(e, t) {
              t = t || Math.random;
              for (var o = e.length - 1; 0 < o; o--) {
                var i = Math.floor(t() * (o + 1)), d = e[o];
                e[o] = e[i], e[i] = d;
              }
            }
            goog.array.shuffle = module$contents$goog$array_shuffle;
            function module$contents$goog$array_copyByIndex(e, t) {
              var o = [];
              return module$contents$goog$array_forEach(t, function(i) {
                o.push(e[i]);
              }), o;
            }
            goog.array.copyByIndex = module$contents$goog$array_copyByIndex;
            function module$contents$goog$array_concatMap(e, t, o) {
              return module$contents$goog$array_concat.apply([], module$contents$goog$array_map(e, t, o));
            }
            goog.array.concatMap = module$contents$goog$array_concatMap, goog.dom.asserts = {}, goog.dom.asserts.assertIsLocation = function(e) {
              if (goog.asserts.ENABLE_ASSERTS) {
                var t = goog.dom.asserts.getWindow_(e);
                t && (!e || !(e instanceof t.Location) && e instanceof t.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(e));
              }
              return e;
            }, goog.dom.asserts.assertIsElementType_ = function(e, t) {
              if (goog.asserts.ENABLE_ASSERTS) {
                var o = goog.dom.asserts.getWindow_(e);
                o && typeof o[t] < "u" && (e && (e instanceof o[t] || !(e instanceof o.Location || e instanceof o.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", t, goog.dom.asserts.debugStringForType_(e)));
              }
              return e;
            }, goog.dom.asserts.assertIsHTMLAnchorElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLAnchorElement");
            }, goog.dom.asserts.assertIsHTMLButtonElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLButtonElement");
            }, goog.dom.asserts.assertIsHTMLLinkElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLLinkElement");
            }, goog.dom.asserts.assertIsHTMLImageElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLImageElement");
            }, goog.dom.asserts.assertIsHTMLAudioElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLAudioElement");
            }, goog.dom.asserts.assertIsHTMLVideoElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLVideoElement");
            }, goog.dom.asserts.assertIsHTMLInputElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLInputElement");
            }, goog.dom.asserts.assertIsHTMLTextAreaElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLTextAreaElement");
            }, goog.dom.asserts.assertIsHTMLCanvasElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLCanvasElement");
            }, goog.dom.asserts.assertIsHTMLEmbedElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLEmbedElement");
            }, goog.dom.asserts.assertIsHTMLFormElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLFormElement");
            }, goog.dom.asserts.assertIsHTMLFrameElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLFrameElement");
            }, goog.dom.asserts.assertIsHTMLIFrameElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLIFrameElement");
            }, goog.dom.asserts.assertIsHTMLObjectElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLObjectElement");
            }, goog.dom.asserts.assertIsHTMLScriptElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLScriptElement");
            }, goog.dom.asserts.debugStringForType_ = function(e) {
              if (goog.isObject(e)) try {
                return e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e);
              } catch {
                return "<object could not be stringified>";
              }
              else return e === void 0 ? "undefined" : e === null ? "null" : typeof e;
            }, goog.dom.asserts.getWindow_ = function(e) {
              try {
                var t = e && e.ownerDocument, o = t && (t.defaultView || t.parentWindow);
                if (o = o || goog.global, o.Element && o.Location) return o;
              } catch {
              }
              return null;
            }, goog.dom.HtmlElement = function() {
            }, goog.functions = {}, goog.functions.constant = function(e) {
              return function() {
                return e;
              };
            }, goog.functions.FALSE = function() {
              return !1;
            }, goog.functions.TRUE = function() {
              return !0;
            }, goog.functions.NULL = function() {
              return null;
            }, goog.functions.identity = function(e, t) {
              return e;
            }, goog.functions.error = function(e) {
              return function() {
                throw Error(e);
              };
            }, goog.functions.fail = function(e) {
              return function() {
                throw e;
              };
            }, goog.functions.lock = function(e, t) {
              return t = t || 0, function() {
                return e.apply(this, Array.prototype.slice.call(arguments, 0, t));
              };
            }, goog.functions.nth = function(e) {
              return function() {
                return arguments[e];
              };
            }, goog.functions.partialRight = function(e, t) {
              var o = Array.prototype.slice.call(arguments, 1);
              return function() {
                var i = this;
                i === goog.global && (i = void 0);
                var d = Array.prototype.slice.call(arguments);
                return d.push.apply(d, o), e.apply(i, d);
              };
            }, goog.functions.withReturnValue = function(e, t) {
              return goog.functions.sequence(e, goog.functions.constant(t));
            }, goog.functions.equalTo = function(e, t) {
              return function(o) {
                return t ? e == o : e === o;
              };
            }, goog.functions.compose = function(e, t) {
              var o = arguments, i = o.length;
              return function() {
                var d;
                i && (d = o[i - 1].apply(this, arguments));
                for (var s = i - 2; 0 <= s; s--) d = o[s].call(this, d);
                return d;
              };
            }, goog.functions.sequence = function(e) {
              var t = arguments, o = t.length;
              return function() {
                for (var i, d = 0; d < o; d++) i = t[d].apply(this, arguments);
                return i;
              };
            }, goog.functions.and = function(e) {
              var t = arguments, o = t.length;
              return function() {
                for (var i = 0; i < o; i++) if (!t[i].apply(this, arguments)) return !1;
                return !0;
              };
            }, goog.functions.or = function(e) {
              var t = arguments, o = t.length;
              return function() {
                for (var i = 0; i < o; i++) if (t[i].apply(this, arguments)) return !0;
                return !1;
              };
            }, goog.functions.not = function(e) {
              return function() {
                return !e.apply(this, arguments);
              };
            }, goog.functions.create = function(e, t) {
              var o = function() {
              };
              return o.prototype = e.prototype, o = new o(), e.apply(o, Array.prototype.slice.call(arguments, 1)), o;
            }, goog.functions.CACHE_RETURN_VALUE = !0, goog.functions.cacheReturnValue = function(e) {
              var t = !1, o;
              return function() {
                return goog.functions.CACHE_RETURN_VALUE ? (t || (o = e(), t = !0), o) : e();
              };
            }, goog.functions.once = function(e) {
              var t = e;
              return function() {
                if (t) {
                  var o = t;
                  t = null, o();
                }
              };
            }, goog.functions.debounce = function(e, t, o) {
              var i = 0;
              return function(d) {
                goog.global.clearTimeout(i);
                var s = arguments;
                i = goog.global.setTimeout(function() {
                  e.apply(o, s);
                }, t);
              };
            }, goog.functions.throttle = function(e, t, o) {
              var i = 0, d = !1, s = [], n = function() {
                i = 0, d && (d = !1, r());
              }, r = function() {
                i = goog.global.setTimeout(n, t), e.apply(o, s);
              };
              return function(u) {
                s = arguments, i ? d = !0 : r();
              };
            }, goog.functions.rateLimit = function(e, t, o) {
              var i = 0, d = function() {
                i = 0;
              };
              return function(s) {
                i || (i = goog.global.setTimeout(d, t), e.apply(o, arguments));
              };
            }, goog.functions.isFunction = function(e) {
              return typeof e == "function";
            }, goog.dom.TagName = function() {
            }, goog.dom.TagName.cast = function(e, t) {
              return e;
            }, goog.dom.TagName.prototype.toString = function() {
            }, goog.dom.TagName.A = "A", goog.dom.TagName.ABBR = "ABBR", goog.dom.TagName.ACRONYM = "ACRONYM", goog.dom.TagName.ADDRESS = "ADDRESS", goog.dom.TagName.APPLET = "APPLET", goog.dom.TagName.AREA = "AREA", goog.dom.TagName.ARTICLE = "ARTICLE", goog.dom.TagName.ASIDE = "ASIDE", goog.dom.TagName.AUDIO = "AUDIO", goog.dom.TagName.B = "B", goog.dom.TagName.BASE = "BASE", goog.dom.TagName.BASEFONT = "BASEFONT", goog.dom.TagName.BDI = "BDI", goog.dom.TagName.BDO = "BDO", goog.dom.TagName.BIG = "BIG", goog.dom.TagName.BLOCKQUOTE = "BLOCKQUOTE", goog.dom.TagName.BODY = "BODY", goog.dom.TagName.BR = "BR", goog.dom.TagName.BUTTON = "BUTTON", goog.dom.TagName.CANVAS = "CANVAS", goog.dom.TagName.CAPTION = "CAPTION", goog.dom.TagName.CENTER = "CENTER", goog.dom.TagName.CITE = "CITE", goog.dom.TagName.CODE = "CODE", goog.dom.TagName.COL = "COL", goog.dom.TagName.COLGROUP = "COLGROUP", goog.dom.TagName.COMMAND = "COMMAND", goog.dom.TagName.DATA = "DATA", goog.dom.TagName.DATALIST = "DATALIST", goog.dom.TagName.DD = "DD", goog.dom.TagName.DEL = "DEL", goog.dom.TagName.DETAILS = "DETAILS", goog.dom.TagName.DFN = "DFN", goog.dom.TagName.DIALOG = "DIALOG", goog.dom.TagName.DIR = "DIR", goog.dom.TagName.DIV = "DIV", goog.dom.TagName.DL = "DL", goog.dom.TagName.DT = "DT", goog.dom.TagName.EM = "EM", goog.dom.TagName.EMBED = "EMBED", goog.dom.TagName.FIELDSET = "FIELDSET", goog.dom.TagName.FIGCAPTION = "FIGCAPTION", goog.dom.TagName.FIGURE = "FIGURE", goog.dom.TagName.FONT = "FONT", goog.dom.TagName.FOOTER = "FOOTER", goog.dom.TagName.FORM = "FORM", goog.dom.TagName.FRAME = "FRAME", goog.dom.TagName.FRAMESET = "FRAMESET", goog.dom.TagName.H1 = "H1", goog.dom.TagName.H2 = "H2", goog.dom.TagName.H3 = "H3", goog.dom.TagName.H4 = "H4", goog.dom.TagName.H5 = "H5", goog.dom.TagName.H6 = "H6", goog.dom.TagName.HEAD = "HEAD", goog.dom.TagName.HEADER = "HEADER", goog.dom.TagName.HGROUP = "HGROUP", goog.dom.TagName.HR = "HR", goog.dom.TagName.HTML = "HTML", goog.dom.TagName.I = "I", goog.dom.TagName.IFRAME = "IFRAME", goog.dom.TagName.IMG = "IMG", goog.dom.TagName.INPUT = "INPUT", goog.dom.TagName.INS = "INS", goog.dom.TagName.ISINDEX = "ISINDEX", goog.dom.TagName.KBD = "KBD", goog.dom.TagName.KEYGEN = "KEYGEN", goog.dom.TagName.LABEL = "LABEL", goog.dom.TagName.LEGEND = "LEGEND", goog.dom.TagName.LI = "LI", goog.dom.TagName.LINK = "LINK", goog.dom.TagName.MAIN = "MAIN", goog.dom.TagName.MAP = "MAP", goog.dom.TagName.MARK = "MARK", goog.dom.TagName.MATH = "MATH", goog.dom.TagName.MENU = "MENU", goog.dom.TagName.MENUITEM = "MENUITEM", goog.dom.TagName.META = "META", goog.dom.TagName.METER = "METER", goog.dom.TagName.NAV = "NAV", goog.dom.TagName.NOFRAMES = "NOFRAMES", goog.dom.TagName.NOSCRIPT = "NOSCRIPT", goog.dom.TagName.OBJECT = "OBJECT", goog.dom.TagName.OL = "OL", goog.dom.TagName.OPTGROUP = "OPTGROUP", goog.dom.TagName.OPTION = "OPTION", goog.dom.TagName.OUTPUT = "OUTPUT", goog.dom.TagName.P = "P", goog.dom.TagName.PARAM = "PARAM", goog.dom.TagName.PICTURE = "PICTURE", goog.dom.TagName.PRE = "PRE", goog.dom.TagName.PROGRESS = "PROGRESS", goog.dom.TagName.Q = "Q", goog.dom.TagName.RP = "RP", goog.dom.TagName.RT = "RT", goog.dom.TagName.RTC = "RTC", goog.dom.TagName.RUBY = "RUBY", goog.dom.TagName.S = "S", goog.dom.TagName.SAMP = "SAMP", goog.dom.TagName.SCRIPT = "SCRIPT", goog.dom.TagName.SECTION = "SECTION", goog.dom.TagName.SELECT = "SELECT", goog.dom.TagName.SMALL = "SMALL", goog.dom.TagName.SOURCE = "SOURCE", goog.dom.TagName.SPAN = "SPAN", goog.dom.TagName.STRIKE = "STRIKE", goog.dom.TagName.STRONG = "STRONG", goog.dom.TagName.STYLE = "STYLE", goog.dom.TagName.SUB = "SUB", goog.dom.TagName.SUMMARY = "SUMMARY", goog.dom.TagName.SUP = "SUP", goog.dom.TagName.SVG = "SVG", goog.dom.TagName.TABLE = "TABLE", goog.dom.TagName.TBODY = "TBODY", goog.dom.TagName.TD = "TD", goog.dom.TagName.TEMPLATE = "TEMPLATE", goog.dom.TagName.TEXTAREA = "TEXTAREA", goog.dom.TagName.TFOOT = "TFOOT", goog.dom.TagName.TH = "TH", goog.dom.TagName.THEAD = "THEAD", goog.dom.TagName.TIME = "TIME", goog.dom.TagName.TITLE = "TITLE", goog.dom.TagName.TR = "TR", goog.dom.TagName.TRACK = "TRACK", goog.dom.TagName.TT = "TT", goog.dom.TagName.U = "U", goog.dom.TagName.UL = "UL", goog.dom.TagName.VAR = "VAR", goog.dom.TagName.VIDEO = "VIDEO", goog.dom.TagName.WBR = "WBR", goog.object = {}, goog.object.forEach = function(e, t, o) {
              for (var i in e) t.call(o, e[i], i, e);
            }, goog.object.filter = function(e, t, o) {
              var i = {}, d;
              for (d in e) t.call(o, e[d], d, e) && (i[d] = e[d]);
              return i;
            }, goog.object.map = function(e, t, o) {
              var i = {}, d;
              for (d in e) i[d] = t.call(o, e[d], d, e);
              return i;
            }, goog.object.some = function(e, t, o) {
              for (var i in e) if (t.call(o, e[i], i, e)) return !0;
              return !1;
            }, goog.object.every = function(e, t, o) {
              for (var i in e) if (!t.call(o, e[i], i, e)) return !1;
              return !0;
            }, goog.object.getCount = function(e) {
              var t = 0, o;
              for (o in e) t++;
              return t;
            }, goog.object.getAnyKey = function(e) {
              for (var t in e) return t;
            }, goog.object.getAnyValue = function(e) {
              for (var t in e) return e[t];
            }, goog.object.contains = function(e, t) {
              return goog.object.containsValue(e, t);
            }, goog.object.getValues = function(e) {
              var t = [], o = 0, i;
              for (i in e) t[o++] = e[i];
              return t;
            }, goog.object.getKeys = function(e) {
              var t = [], o = 0, i;
              for (i in e) t[o++] = i;
              return t;
            }, goog.object.getValueByKeys = function(e, t) {
              var o = goog.isArrayLike(t), i = o ? t : arguments;
              for (o = o ? 0 : 1; o < i.length; o++) {
                if (e == null) return;
                e = e[i[o]];
              }
              return e;
            }, goog.object.containsKey = function(e, t) {
              return e !== null && t in e;
            }, goog.object.containsValue = function(e, t) {
              for (var o in e) if (e[o] == t) return !0;
              return !1;
            }, goog.object.findKey = function(e, t, o) {
              for (var i in e) if (t.call(o, e[i], i, e)) return i;
            }, goog.object.findValue = function(e, t, o) {
              return (t = goog.object.findKey(e, t, o)) && e[t];
            }, goog.object.isEmpty = function(e) {
              for (var t in e) return !1;
              return !0;
            }, goog.object.clear = function(e) {
              for (var t in e) delete e[t];
            }, goog.object.remove = function(e, t) {
              var o;
              return (o = t in e) && delete e[t], o;
            }, goog.object.add = function(e, t, o) {
              if (e !== null && t in e) throw Error('The object already contains the key "' + t + '"');
              goog.object.set(e, t, o);
            }, goog.object.get = function(e, t, o) {
              return e !== null && t in e ? e[t] : o;
            }, goog.object.set = function(e, t, o) {
              e[t] = o;
            }, goog.object.setIfUndefined = function(e, t, o) {
              return t in e ? e[t] : e[t] = o;
            }, goog.object.setWithReturnValueIfNotSet = function(e, t, o) {
              return t in e ? e[t] : (o = o(), e[t] = o);
            }, goog.object.equals = function(e, t) {
              for (var o in e) if (!(o in t) || e[o] !== t[o]) return !1;
              for (var i in t) if (!(i in e)) return !1;
              return !0;
            }, goog.object.clone = function(e) {
              var t = {}, o;
              for (o in e) t[o] = e[o];
              return t;
            }, goog.object.unsafeClone = function(e) {
              if (!e || typeof e != "object") return e;
              if (typeof e.clone == "function") return e.clone();
              var t = Array.isArray(e) ? [] : typeof ArrayBuffer != "function" || typeof ArrayBuffer.isView != "function" || !ArrayBuffer.isView(e) || e instanceof DataView ? {} : new e.constructor(e.length), o;
              for (o in e) t[o] = goog.object.unsafeClone(e[o]);
              return t;
            }, goog.object.transpose = function(e) {
              var t = {}, o;
              for (o in e) t[e[o]] = o;
              return t;
            }, goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.object.extend = function(e, t) {
              for (var o, i, d = 1; d < arguments.length; d++) {
                i = arguments[d];
                for (o in i) e[o] = i[o];
                for (var s = 0; s < goog.object.PROTOTYPE_FIELDS_.length; s++) o = goog.object.PROTOTYPE_FIELDS_[s], Object.prototype.hasOwnProperty.call(i, o) && (e[o] = i[o]);
              }
            }, goog.object.create = function(e) {
              var t = arguments.length;
              if (t == 1 && Array.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
              if (t % 2) throw Error("Uneven number of arguments");
              for (var o = {}, i = 0; i < t; i += 2) o[arguments[i]] = arguments[i + 1];
              return o;
            }, goog.object.createSet = function(e) {
              var t = arguments.length;
              if (t == 1 && Array.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
              for (var o = {}, i = 0; i < t; i++) o[arguments[i]] = !0;
              return o;
            }, goog.object.createImmutableView = function(e) {
              var t = e;
              return Object.isFrozen && !Object.isFrozen(e) && (t = Object.create(e), Object.freeze(t)), t;
            }, goog.object.isImmutableView = function(e) {
              return !!Object.isFrozen && Object.isFrozen(e);
            }, goog.object.getAllPropertyNames = function(e, t, o) {
              if (!e) return [];
              if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(e);
              for (var i = {}; e && (e !== Object.prototype || t) && (e !== Function.prototype || o); ) {
                for (var d = Object.getOwnPropertyNames(e), s = 0; s < d.length; s++) i[d[s]] = !0;
                e = Object.getPrototypeOf(e);
              }
              return goog.object.getKeys(i);
            }, goog.object.getSuperClass = function(e) {
              return (e = Object.getPrototypeOf(e.prototype)) && e.constructor;
            }, goog.dom.tags = {}, goog.dom.tags.VOID_TAGS_ = { area: !0, base: !0, br: !0, col: !0, command: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 }, goog.dom.tags.isVoidTag = function(e) {
              return goog.dom.tags.VOID_TAGS_[e] === !0;
            }, goog.string = {}, goog.string.TypedString = function() {
            }, goog.string.Const = function(e, t) {
              this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = e === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && t || "", this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
            }, goog.string.Const.prototype.implementsGoogStringTypedString = !0, goog.string.Const.prototype.getTypedStringValue = function() {
              return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
            }, goog.DEBUG && (goog.string.Const.prototype.toString = function() {
              return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
            }), goog.string.Const.unwrap = function(e) {
              return e instanceof goog.string.Const && e.constructor === goog.string.Const && e.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_ ? e.stringConstValueWithSecurityContract__googStringSecurityPrivate_ : (goog.asserts.fail("expected object of type Const, got '" + e + "'"), "type_error:Const");
            }, goog.string.Const.from = function(e) {
              return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, e);
            }, goog.string.Const.TYPE_MARKER_ = {}, goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.Const.EMPTY = goog.string.Const.from(""), goog.html = {}, goog.html.trustedtypes = {}, goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse = function() {
              return goog.TRUSTED_TYPES_POLICY_NAME ? (goog.html.trustedtypes.cachedPolicy_ === void 0 && (goog.html.trustedtypes.cachedPolicy_ = goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html")), goog.html.trustedtypes.cachedPolicy_) : null;
            };
            var module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeScript_SafeScript = function(e, t) {
              this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = t === module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE ? e : "", this.implementsGoogStringTypedString = !0;
            };
            module$contents$goog$html$SafeScript_SafeScript.fromConstant = function(e) {
              return e = goog.string.Const.unwrap(e), e.length === 0 ? module$contents$goog$html$SafeScript_SafeScript.EMPTY : module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(e);
            }, module$contents$goog$html$SafeScript_SafeScript.fromConstantAndArgs = function(e, t) {
              for (var o = [], i = 1; i < arguments.length; i++) o.push(module$contents$goog$html$SafeScript_SafeScript.stringify_(arguments[i]));
              return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(e) + ")(" + o.join(", ") + ");");
            }, module$contents$goog$html$SafeScript_SafeScript.fromJson = function(e) {
              return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(module$contents$goog$html$SafeScript_SafeScript.stringify_(e));
            }, module$contents$goog$html$SafeScript_SafeScript.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
            }, module$contents$goog$html$SafeScript_SafeScript.unwrap = function(e) {
              return module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(e).toString();
            }, module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript = function(e) {
              return e instanceof module$contents$goog$html$SafeScript_SafeScript && e.constructor === module$contents$goog$html$SafeScript_SafeScript ? e.privateDoNotAccessOrElseSafeScriptWrappedValue_ : ((0, goog.asserts.fail)("expected object of type SafeScript, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeScript");
            }, module$contents$goog$html$SafeScript_SafeScript.stringify_ = function(e) {
              return JSON.stringify(e).replace(/</g, "\\x3c");
            }, module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(e) {
              var t = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
              return e = t ? t.createScript(e) : e, new module$contents$goog$html$SafeScript_SafeScript(e, module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE);
            }, goog.DEBUG && (module$contents$goog$html$SafeScript_SafeScript.prototype.toString = function() {
              return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
            }), module$contents$goog$html$SafeScript_SafeScript.EMPTY = (function() {
              return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");
            })(), goog.html.SafeScript = module$contents$goog$html$SafeScript_SafeScript, goog.fs = {}, goog.fs.url = {}, goog.fs.url.createObjectUrl = function(e) {
              return goog.fs.url.getUrlObject_().createObjectURL(e);
            }, goog.fs.url.revokeObjectUrl = function(e) {
              goog.fs.url.getUrlObject_().revokeObjectURL(e);
            }, goog.fs.url.UrlObject_ = function() {
            }, goog.fs.url.UrlObject_.prototype.createObjectURL = function(e) {
            }, goog.fs.url.UrlObject_.prototype.revokeObjectURL = function(e) {
            }, goog.fs.url.getUrlObject_ = function() {
              var e = goog.fs.url.findUrlObject_();
              if (e != null) return e;
              throw Error("This browser doesn't seem to support blob URLs");
            }, goog.fs.url.findUrlObject_ = function() {
              return goog.global.URL !== void 0 && goog.global.URL.createObjectURL !== void 0 ? goog.global.URL : goog.global.webkitURL !== void 0 && goog.global.webkitURL.createObjectURL !== void 0 ? goog.global.webkitURL : goog.global.createObjectURL !== void 0 ? goog.global : null;
            }, goog.fs.url.browserSupportsObjectUrls = function() {
              return goog.fs.url.findUrlObject_() != null;
            }, goog.fs.blob = {}, goog.fs.blob.getBlob = function(e) {
              var t = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
              if (t !== void 0) {
                t = new t();
                for (var o = 0; o < arguments.length; o++) t.append(arguments[o]);
                return t.getBlob();
              }
              return goog.fs.blob.getBlobWithProperties(module$contents$goog$array_toArray(arguments));
            }, goog.fs.blob.getBlobWithProperties = function(e, t, o) {
              var i = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
              if (i !== void 0) {
                i = new i();
                for (var d = 0; d < e.length; d++) i.append(e[d], o);
                return i.getBlob(t);
              }
              if (goog.global.Blob !== void 0) return i = {}, t && (i.type = t), o && (i.endings = o), new Blob(e, i);
              throw Error("This browser doesn't seem to support creating Blobs");
            }, goog.i18n = {}, goog.i18n.bidi = {}, goog.i18n.bidi.FORCE_RTL = !1, goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || (goog.LOCALE.substring(0, 2).toLowerCase() == "ar" || goog.LOCALE.substring(0, 2).toLowerCase() == "fa" || goog.LOCALE.substring(0, 2).toLowerCase() == "he" || goog.LOCALE.substring(0, 2).toLowerCase() == "iw" || goog.LOCALE.substring(0, 2).toLowerCase() == "ps" || goog.LOCALE.substring(0, 2).toLowerCase() == "sd" || goog.LOCALE.substring(0, 2).toLowerCase() == "ug" || goog.LOCALE.substring(0, 2).toLowerCase() == "ur" || goog.LOCALE.substring(0, 2).toLowerCase() == "yi") && (goog.LOCALE.length == 2 || goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") || 3 <= goog.LOCALE.length && goog.LOCALE.substring(0, 3).toLowerCase() == "ckb" && (goog.LOCALE.length == 3 || goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") || 7 <= goog.LOCALE.length && (goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") && (goog.LOCALE.substring(3, 7).toLowerCase() == "adlm" || goog.LOCALE.substring(3, 7).toLowerCase() == "arab" || goog.LOCALE.substring(3, 7).toLowerCase() == "hebr" || goog.LOCALE.substring(
              3,
              7
            ).toLowerCase() == "nkoo" || goog.LOCALE.substring(3, 7).toLowerCase() == "rohg" || goog.LOCALE.substring(3, 7).toLowerCase() == "thaa") || 8 <= goog.LOCALE.length && (goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") && (goog.LOCALE.substring(4, 8).toLowerCase() == "adlm" || goog.LOCALE.substring(4, 8).toLowerCase() == "arab" || goog.LOCALE.substring(4, 8).toLowerCase() == "hebr" || goog.LOCALE.substring(4, 8).toLowerCase() == "nkoo" || goog.LOCALE.substring(4, 8).toLowerCase() == "rohg" || goog.LOCALE.substring(4, 8).toLowerCase() == "thaa"), goog.i18n.bidi.Format = { LRE: "‪", RLE: "‫", PDF: "‬", LRM: "‎", RLM: "‏" }, goog.i18n.bidi.Dir = { LTR: 1, RTL: -1, NEUTRAL: 0 }, goog.i18n.bidi.RIGHT = "right", goog.i18n.bidi.LEFT = "left", goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT, goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, goog.i18n.bidi.toDir = function(e, t) {
              return typeof e == "number" ? 0 < e ? goog.i18n.bidi.Dir.LTR : 0 > e ? goog.i18n.bidi.Dir.RTL : t ? null : goog.i18n.bidi.Dir.NEUTRAL : e == null ? null : e ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
            }, goog.i18n.bidi.ltrChars_ = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ऀ-῿‎Ⰰ-\uD801\uD804-\uD839\uD83C-\uDBFF豈-﬜︀-﹯﻽-￿", goog.i18n.bidi.rtlChars_ = "֑-ۯۺ-ࣿ‏\uD802-\uD803\uD83A-\uD83Bיִ-﷿ﹰ-ﻼ", goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g, goog.i18n.bidi.stripHtmlIfNeeded_ = function(e, t) {
              return t ? e.replace(goog.i18n.bidi.htmlSkipReg_, "") : e;
            }, goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.hasAnyRtl = function(e, t) {
              return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl, goog.i18n.bidi.hasAnyLtr = function(e, t) {
              return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.isRtlChar = function(e) {
              return goog.i18n.bidi.rtlRe_.test(e);
            }, goog.i18n.bidi.isLtrChar = function(e) {
              return goog.i18n.bidi.ltrRe_.test(e);
            }, goog.i18n.bidi.isNeutralChar = function(e) {
              return !goog.i18n.bidi.isLtrChar(e) && !goog.i18n.bidi.isRtlChar(e);
            }, goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.startsWithRtl = function(e, t) {
              return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl, goog.i18n.bidi.startsWithLtr = function(e, t) {
              return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr, goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/, goog.i18n.bidi.isNeutralText = function(e, t) {
              return e = goog.i18n.bidi.stripHtmlIfNeeded_(e, t), goog.i18n.bidi.isRequiredLtrRe_.test(e) || !goog.i18n.bidi.hasAnyLtr(e) && !goog.i18n.bidi.hasAnyRtl(e);
            }, goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$"), goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$"), goog.i18n.bidi.endsWithLtr = function(e, t) {
              return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr, goog.i18n.bidi.endsWithRtl = function(e, t) {
              return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl, goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i, goog.i18n.bidi.isRtlLanguage = function(e) {
              return goog.i18n.bidi.rtlLocalesRe_.test(e);
            }, goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g, goog.i18n.bidi.guardBracketInText = function(e, t) {
              return t = (t === void 0 ? goog.i18n.bidi.hasAnyRtl(e) : t) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM, e.replace(goog.i18n.bidi.bracketGuardTextRe_, t + "$&" + t);
            }, goog.i18n.bidi.enforceRtlInHtml = function(e) {
              return e.charAt(0) == "<" ? e.replace(/<\w+/, "$& dir=rtl") : `
<span dir=rtl>` + e + "</span>";
            }, goog.i18n.bidi.enforceRtlInText = function(e) {
              return goog.i18n.bidi.Format.RLE + e + goog.i18n.bidi.Format.PDF;
            }, goog.i18n.bidi.enforceLtrInHtml = function(e) {
              return e.charAt(0) == "<" ? e.replace(/<\w+/, "$& dir=ltr") : `
<span dir=ltr>` + e + "</span>";
            }, goog.i18n.bidi.enforceLtrInText = function(e) {
              return goog.i18n.bidi.Format.LRE + e + goog.i18n.bidi.Format.PDF;
            }, goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g, goog.i18n.bidi.leftRe_ = /left/gi, goog.i18n.bidi.rightRe_ = /right/gi, goog.i18n.bidi.tempRe_ = /%%%%/g, goog.i18n.bidi.mirrorCSS = function(e) {
              return e.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
            }, goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g, goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g, goog.i18n.bidi.normalizeHebrewQuote = function(e) {
              return e.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1״").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1׳");
            }, goog.i18n.bidi.wordSeparatorRe_ = /\s+/, goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/, goog.i18n.bidi.rtlDetectionThreshold_ = 0.4, goog.i18n.bidi.estimateDirection = function(e, t) {
              var o = 0, i = 0, d = !1;
              for (e = goog.i18n.bidi.stripHtmlIfNeeded_(e, t).split(goog.i18n.bidi.wordSeparatorRe_), t = 0; t < e.length; t++) {
                var s = e[t];
                goog.i18n.bidi.startsWithRtl(s) ? (o++, i++) : goog.i18n.bidi.isRequiredLtrRe_.test(s) ? d = !0 : goog.i18n.bidi.hasAnyLtr(s) ? i++ : goog.i18n.bidi.hasNumeralsRe_.test(s) && (d = !0);
              }
              return i == 0 ? d ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : o / i > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
            }, goog.i18n.bidi.detectRtlDirectionality = function(e, t) {
              return goog.i18n.bidi.estimateDirection(e, t) == goog.i18n.bidi.Dir.RTL;
            }, goog.i18n.bidi.setElementDirAndAlign = function(e, t) {
              e && (t = goog.i18n.bidi.toDir(t)) && (e.style.textAlign = t == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, e.dir = t == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
            }, goog.i18n.bidi.setElementDirByTextDirectionality = function(e, t) {
              switch (goog.i18n.bidi.estimateDirection(t)) {
                case goog.i18n.bidi.Dir.LTR:
                  e.dir !== "ltr" && (e.dir = "ltr");
                  break;
                case goog.i18n.bidi.Dir.RTL:
                  e.dir !== "rtl" && (e.dir = "rtl");
                  break;
                default:
                  e.removeAttribute("dir");
              }
            }, goog.i18n.bidi.DirectionalString = function() {
            }, goog.html.TrustedResourceUrl = function(e, t) {
              this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = t === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? e : "";
            }, goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0, goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
            }, goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.TrustedResourceUrl.prototype.getDirection = function() {
              return goog.i18n.bidi.Dir.LTR;
            }, goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(e, t) {
              var o = goog.html.TrustedResourceUrl.unwrap(this);
              o = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(o);
              var i = o[3] || "";
              return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(o[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", o[2] || "", e) + goog.html.TrustedResourceUrl.stringifyParams_("#", i, t));
            }, goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
              return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
            }), goog.html.TrustedResourceUrl.unwrap = function(e) {
              return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(e).toString();
            }, goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(e) {
              return e instanceof goog.html.TrustedResourceUrl && e.constructor === goog.html.TrustedResourceUrl ? e.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ : (goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:TrustedResourceUrl");
            }, goog.html.TrustedResourceUrl.format = function(e, t) {
              var o = goog.string.Const.unwrap(e);
              if (!goog.html.TrustedResourceUrl.BASE_URL_.test(o)) throw Error("Invalid TrustedResourceUrl format: " + o);
              return e = o.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(i, d) {
                if (!Object.prototype.hasOwnProperty.call(t, d)) throw Error('Found marker, "' + d + '", in format string, "' + o + '", but no valid label mapping found in args: ' + JSON.stringify(t));
                return i = t[d], i instanceof goog.string.Const ? goog.string.Const.unwrap(i) : encodeURIComponent(String(i));
              }), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g, goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/, goog.html.TrustedResourceUrl.formatWithParams = function(e, t, o, i) {
              return goog.html.TrustedResourceUrl.format(e, t).cloneWithParams(o, i);
            }, goog.html.TrustedResourceUrl.fromConstant = function(e) {
              return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
            }, goog.html.TrustedResourceUrl.fromConstants = function(e) {
              for (var t = "", o = 0; o < e.length; o++) t += goog.string.Const.unwrap(e[o]);
              return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.TrustedResourceUrl.fromSafeScript = function(e) {
              return e = goog.fs.blob.getBlobWithProperties([module$contents$goog$html$SafeScript_SafeScript.unwrap(e)], "text/javascript"), e = goog.fs.url.createObjectUrl(e), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(e) {
              var t = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
              return e = t ? t.createScriptURL(e) : e, new goog.html.TrustedResourceUrl(e, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
            }, goog.html.TrustedResourceUrl.stringifyParams_ = function(e, t, o) {
              if (o == null) return t;
              if (typeof o == "string") return o ? e + encodeURIComponent(o) : "";
              for (var i in o) if (Object.prototype.hasOwnProperty.call(o, i)) {
                var d = o[i];
                d = Array.isArray(d) ? d : [d];
                for (var s = 0; s < d.length; s++) {
                  var n = d[s];
                  n != null && (t || (t = e), t += (t.length > e.length ? "&" : "") + encodeURIComponent(i) + "=" + encodeURIComponent(String(n)));
                }
              }
              return t;
            }, goog.string.internal = {}, goog.string.internal.startsWith = function(e, t) {
              return e.lastIndexOf(t, 0) == 0;
            }, goog.string.internal.endsWith = function(e, t) {
              var o = e.length - t.length;
              return 0 <= o && e.indexOf(t, o) == o;
            }, goog.string.internal.caseInsensitiveStartsWith = function(e, t) {
              return goog.string.internal.caseInsensitiveCompare(t, e.substr(0, t.length)) == 0;
            }, goog.string.internal.caseInsensitiveEndsWith = function(e, t) {
              return goog.string.internal.caseInsensitiveCompare(t, e.substr(e.length - t.length, t.length)) == 0;
            }, goog.string.internal.caseInsensitiveEquals = function(e, t) {
              return e.toLowerCase() == t.toLowerCase();
            }, goog.string.internal.isEmptyOrWhitespace = function(e) {
              return /^[\s\xa0]*$/.test(e);
            }, goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(e) {
              return e.trim();
            } : function(e) {
              return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(e)[1];
            }, goog.string.internal.caseInsensitiveCompare = function(e, t) {
              return e = String(e).toLowerCase(), t = String(t).toLowerCase(), e < t ? -1 : e == t ? 0 : 1;
            }, goog.string.internal.newLineToBr = function(e, t) {
              return e.replace(/(\r\n|\r|\n)/g, t ? "<br />" : "<br>");
            }, goog.string.internal.htmlEscape = function(e, t) {
              if (t) e = e.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
              else {
                if (!goog.string.internal.ALL_RE_.test(e)) return e;
                e.indexOf("&") != -1 && (e = e.replace(goog.string.internal.AMP_RE_, "&amp;")), e.indexOf("<") != -1 && (e = e.replace(
                  goog.string.internal.LT_RE_,
                  "&lt;"
                )), e.indexOf(">") != -1 && (e = e.replace(goog.string.internal.GT_RE_, "&gt;")), e.indexOf('"') != -1 && (e = e.replace(goog.string.internal.QUOT_RE_, "&quot;")), e.indexOf("'") != -1 && (e = e.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;")), e.indexOf("\0") != -1 && (e = e.replace(goog.string.internal.NULL_RE_, "&#0;"));
              }
              return e;
            }, goog.string.internal.AMP_RE_ = /&/g, goog.string.internal.LT_RE_ = /</g, goog.string.internal.GT_RE_ = />/g, goog.string.internal.QUOT_RE_ = /"/g, goog.string.internal.SINGLE_QUOTE_RE_ = /'/g, goog.string.internal.NULL_RE_ = /\x00/g, goog.string.internal.ALL_RE_ = /[\x00&<>"']/, goog.string.internal.whitespaceEscape = function(e, t) {
              return goog.string.internal.newLineToBr(e.replace(/  /g, " &#160;"), t);
            }, goog.string.internal.contains = function(e, t) {
              return e.indexOf(t) != -1;
            }, goog.string.internal.caseInsensitiveContains = function(e, t) {
              return goog.string.internal.contains(e.toLowerCase(), t.toLowerCase());
            }, goog.string.internal.compareVersions = function(e, t) {
              var o = 0;
              e = goog.string.internal.trim(String(e)).split("."), t = goog.string.internal.trim(String(t)).split(".");
              for (var i = Math.max(e.length, t.length), d = 0; o == 0 && d < i; d++) {
                var s = e[d] || "", n = t[d] || "";
                do {
                  if (s = /(\d*)(\D*)(.*)/.exec(s) || ["", "", "", ""], n = /(\d*)(\D*)(.*)/.exec(n) || ["", "", "", ""], s[0].length == 0 && n[0].length == 0) break;
                  o = s[1].length == 0 ? 0 : parseInt(s[1], 10);
                  var r = n[1].length == 0 ? 0 : parseInt(n[1], 10);
                  o = goog.string.internal.compareElements_(o, r) || goog.string.internal.compareElements_(s[2].length == 0, n[2].length == 0) || goog.string.internal.compareElements_(s[2], n[2]), s = s[3], n = n[3];
                } while (o == 0);
              }
              return o;
            }, goog.string.internal.compareElements_ = function(e, t) {
              return e < t ? -1 : e > t ? 1 : 0;
            }, goog.html.SafeUrl = function(e, t) {
              this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = t === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? e : "";
            }, goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez", goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0, goog.html.SafeUrl.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
            }, goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeUrl.prototype.getDirection = function() {
              return goog.i18n.bidi.Dir.LTR;
            }, goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
              return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
            }), goog.html.SafeUrl.unwrap = function(e) {
              return e instanceof goog.html.SafeUrl && e.constructor === goog.html.SafeUrl ? e.privateDoNotAccessOrElseSafeUrlWrappedValue_ : (goog.asserts.fail("expected object of type SafeUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeUrl");
            }, goog.html.SafeUrl.fromConstant = function(e) {
              return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
            }, goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i, goog.html.SafeUrl.isSafeMimeType = function(e) {
              return goog.html.SAFE_MIME_TYPE_PATTERN_.test(e);
            }, goog.html.SafeUrl.fromBlob = function(e) {
              return e = goog.html.SafeUrl.isSafeMimeType(e.type) ? goog.fs.url.createObjectUrl(e) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.revokeObjectUrl = function(e) {
              e = e.getTypedStringValue(), e !== goog.html.SafeUrl.INNOCUOUS_STRING && goog.fs.url.revokeObjectUrl(e);
            }, goog.html.SafeUrl.fromMediaSource = function(e) {
              return goog.asserts.assert("MediaSource" in goog.global, "No support for MediaSource"), e = e instanceof MediaSource ? goog.fs.url.createObjectUrl(e) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.DATA_URL_PATTERN_ = /^data:(.*);base64,[a-z0-9+\/]+=*$/i, goog.html.SafeUrl.tryFromDataUrl = function(e) {
              e = String(e), e = e.replace(/(%0A|%0D)/g, "");
              var t = e.match(goog.html.DATA_URL_PATTERN_);
              return t && goog.html.SafeUrl.isSafeMimeType(t[1]) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e) : null;
            }, goog.html.SafeUrl.fromDataUrl = function(e) {
              return goog.html.SafeUrl.tryFromDataUrl(e) || goog.html.SafeUrl.INNOCUOUS_URL;
            }, goog.html.SafeUrl.fromTelUrl = function(e) {
              return goog.string.internal.caseInsensitiveStartsWith(e, "tel:") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i, goog.html.SafeUrl.fromSipUrl = function(e) {
              return goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(e)) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.fromFacebookMessengerUrl = function(e) {
              return goog.string.internal.caseInsensitiveStartsWith(e, "fb-messenger://share") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.fromWhatsAppUrl = function(e) {
              return goog.string.internal.caseInsensitiveStartsWith(e, "whatsapp://send") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.fromSmsUrl = function(e) {
              return goog.string.internal.caseInsensitiveStartsWith(e, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.isSmsUrlBodyValid_ = function(e) {
              var t = e.indexOf("#");
              if (0 < t && (e = e.substring(0, t)), t = e.match(/[?&]body=/gi), !t) return !0;
              if (1 < t.length) return !1;
              if (e = e.match(/[?&]body=([^&]*)/)[1], !e) return !0;
              try {
                decodeURIComponent(e);
              } catch {
                return !1;
              }
              return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(e);
            }, goog.html.SafeUrl.fromSshUrl = function(e) {
              return goog.string.internal.caseInsensitiveStartsWith(e, "ssh://") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(e, t) {
              return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, e, t);
            }, goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(e, t) {
              return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, e, t);
            }, goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(e, t) {
              return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, e, t);
            }, goog.html.SafeUrl.sanitizeExtensionUrl_ = function(e, t, o) {
              return (e = e.exec(t)) ? (e = e[1], (o instanceof goog.string.Const ? [goog.string.Const.unwrap(o)] : o.map(function(i) {
                return goog.string.Const.unwrap(i);
              })).indexOf(e) == -1 && (t = goog.html.SafeUrl.INNOCUOUS_STRING)) : t = goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.SafeUrl.fromTrustedResourceUrl = function(e) {
              return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(e));
            }, goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i, goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_, goog.html.SafeUrl.trySanitize = function(e) {
              return e instanceof goog.html.SafeUrl ? e : (e = typeof e == "object" && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SAFE_URL_PATTERN_.test(e) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e) : goog.html.SafeUrl.tryFromDataUrl(e));
            }, goog.html.SafeUrl.sanitize = function(e) {
              return goog.html.SafeUrl.trySanitize(e) || goog.html.SafeUrl.INNOCUOUS_URL;
            }, goog.html.SafeUrl.sanitizeAssertUnchanged = function(e, t) {
              return e instanceof goog.html.SafeUrl ? e : (e = typeof e == "object" && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), t && /^data:/i.test(e) && (t = goog.html.SafeUrl.fromDataUrl(e), t.getTypedStringValue() == e) ? t : (goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(e), "%s does not match the safe URL pattern", e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e)));
            }, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(e) {
              return new goog.html.SafeUrl(e, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
            }, goog.html.SafeUrl.INNOCUOUS_URL = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank"), goog.html.SafeStyle = function(e, t) {
              this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = t === goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ ? e : "";
            }, goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyle.fromConstant = function(e) {
              return e = goog.string.Const.unwrap(e), e.length === 0 ? goog.html.SafeStyle.EMPTY : (goog.asserts.assert(goog.string.internal.endsWith(e, ";"), "Last character of style string is not ';': " + e), goog.asserts.assert(goog.string.internal.contains(e, ":"), `Style string must contain at least one ':', to specify a "name: value" pair: ` + e), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(e));
            }, goog.html.SafeStyle.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
            }, goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
              return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
            }), goog.html.SafeStyle.unwrap = function(e) {
              return e instanceof goog.html.SafeStyle && e.constructor === goog.html.SafeStyle ? e.privateDoNotAccessOrElseSafeStyleWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyle, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyle");
            }, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(e) {
              return new goog.html.SafeStyle(e, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_);
            }, goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez", goog.html.SafeStyle.create = function(e) {
              var t = "", o;
              for (o in e) if (Object.prototype.hasOwnProperty.call(e, o)) {
                if (!/^[-_a-zA-Z0-9]+$/.test(o)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + o);
                var i = e[o];
                i != null && (i = Array.isArray(i) ? module$contents$goog$array_map(i, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(i), t += o + ":" + i + ";");
              }
              return t ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t) : goog.html.SafeStyle.EMPTY;
            }, goog.html.SafeStyle.sanitizePropertyValue_ = function(e) {
              if (e instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(e).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
              if (e = e instanceof goog.string.Const ? goog.string.Const.unwrap(e) : goog.html.SafeStyle.sanitizePropertyValueString_(String(e)), /[{;}]/.test(e)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [e]);
              return e;
            }, goog.html.SafeStyle.sanitizePropertyValueString_ = function(e) {
              var t = e.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
              if (goog.html.SafeStyle.VALUE_RE_.test(t)) {
                if (goog.html.SafeStyle.COMMENT_RE_.test(e)) return goog.asserts.fail("String value disallows comments, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
                if (!goog.html.SafeStyle.hasBalancedQuotes_(e)) return goog.asserts.fail("String value requires balanced quotes, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
                if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(e)) return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
              } else return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
              return goog.html.SafeStyle.sanitizeUrl_(e);
            }, goog.html.SafeStyle.hasBalancedQuotes_ = function(e) {
              for (var t = !0, o = !0, i = 0; i < e.length; i++) {
                var d = e.charAt(i);
                d == "'" && o ? t = !t : d == '"' && t && (o = !o);
              }
              return t && o;
            }, goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(e) {
              for (var t = !0, o = /^[-_a-zA-Z0-9]$/, i = 0; i < e.length; i++) {
                var d = e.charAt(i);
                if (d == "]") {
                  if (t) return !1;
                  t = !0;
                } else if (d == "[") {
                  if (!t) return !1;
                  t = !1;
                } else if (!t && !o.test(d)) return !1;
              }
              return t;
            }, goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = `[-,."'%_!# a-zA-Z0-9\\[\\]]`, goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$"), goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g, goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = "calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" "), goog.html.SafeStyle.FUNCTIONS_RE_ = new RegExp("\\b(" + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|") + ")\\([-+*/0-9a-z.%\\[\\], ]+\\)", "g"), goog.html.SafeStyle.COMMENT_RE_ = /\/\*/, goog.html.SafeStyle.sanitizeUrl_ = function(e) {
              return e.replace(goog.html.SafeStyle.URL_RE_, function(t, o, i, d) {
                var s = "";
                return i = i.replace(/^(['"])(.*)\1$/, function(n, r, u) {
                  return s = r, u;
                }), t = goog.html.SafeUrl.sanitize(i).getTypedStringValue(), o + s + t + s + d;
              });
            }, goog.html.SafeStyle.concat = function(e) {
              var t = "", o = function(i) {
                Array.isArray(i) ? module$contents$goog$array_forEach(i, o) : t += goog.html.SafeStyle.unwrap(i);
              };
              return module$contents$goog$array_forEach(arguments, o), t ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t) : goog.html.SafeStyle.EMPTY;
            };
            var module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet = function(e, t) {
              this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = t === module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE ? e : "", this.implementsGoogStringTypedString = !0;
            };
            module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createRule = function(e, t) {
              if ((0, goog.string.internal.contains)(e, "<")) throw Error("Selector does not allow '<', got: " + e);
              var o = e.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
              if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(o)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + e);
              if (!module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_(o)) throw Error("() and [] in selector must be balanced, got: " + e);
              return t instanceof goog.html.SafeStyle || (t = goog.html.SafeStyle.create(t)), e = e + "{" + goog.html.SafeStyle.unwrap(t).replace(/</g, "\\3C ") + "}", module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e);
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_ = function(e) {
              for (var t = { "(": ")", "[": "]" }, o = [], i = 0; i < e.length; i++) {
                var d = e[i];
                if (t[d]) o.push(t[d]);
                else if (goog.object.contains(t, d) && o.pop() != d) return !1;
              }
              return o.length == 0;
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.concat = function(e) {
              var t = "", o = function(i) {
                Array.isArray(i) ? module$contents$goog$array_forEach(i, o) : t += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(i);
              };
              return module$contents$goog$array_forEach(arguments, o), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t);
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.fromConstant = function(e) {
              return e = goog.string.Const.unwrap(e), e.length === 0 ? module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY : ((0, goog.asserts.assert)(!(0, goog.string.internal.contains)(e, "<"), "Forbidden '<' character in style sheet string: " + e), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e));
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap = function(e) {
              return e instanceof module$contents$goog$html$SafeStyleSheet_SafeStyleSheet && e.constructor === module$contents$goog$html$SafeStyleSheet_SafeStyleSheet ? e.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ : ((0, goog.asserts.fail)("expected object of type SafeStyleSheet, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyleSheet");
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(e) {
              return new module$contents$goog$html$SafeStyleSheet_SafeStyleSheet(e, module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE);
            }, goog.DEBUG && (module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.toString = function() {
              return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
            }), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyleSheet = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet, goog.labs = {}, goog.labs.userAgent = {}, goog.labs.userAgent.util = {}, goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
              var e = goog.labs.userAgent.util.getNavigator_();
              return e && (e = e.userAgent) ? e : "";
            }, goog.labs.userAgent.util.getNavigator_ = function() {
              return goog.global.navigator;
            }, goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_(), goog.labs.userAgent.util.setUserAgent = function(e) {
              goog.labs.userAgent.util.userAgent_ = e || goog.labs.userAgent.util.getNativeUserAgentString_();
            }, goog.labs.userAgent.util.getUserAgent = function() {
              return goog.labs.userAgent.util.userAgent_;
            }, goog.labs.userAgent.util.matchUserAgent = function(e) {
              var t = goog.labs.userAgent.util.getUserAgent();
              return goog.string.internal.contains(t, e);
            }, goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(e) {
              var t = goog.labs.userAgent.util.getUserAgent();
              return goog.string.internal.caseInsensitiveContains(t, e);
            }, goog.labs.userAgent.util.extractVersionTuples = function(e) {
              for (var t = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, o = [], i; i = t.exec(e); ) o.push([i[1], i[2], i[3] || void 0]);
              return o;
            }, goog.labs.userAgent.browser = {}, goog.labs.userAgent.browser.matchOpera_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Opera");
            }, goog.labs.userAgent.browser.matchIE_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
            }, goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Edge");
            }, goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Edg/");
            }, goog.labs.userAgent.browser.matchOperaChromium_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("OPR");
            }, goog.labs.userAgent.browser.matchFirefox_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
            }, goog.labs.userAgent.browser.matchSafari_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
            }, goog.labs.userAgent.browser.matchCoast_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Coast");
            }, goog.labs.userAgent.browser.matchIosWebview_ = function() {
              return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
            }, goog.labs.userAgent.browser.matchChrome_ = function() {
              return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
            }, goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
            }, goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_, goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_, goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_, goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_, goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_, goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_, goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_, goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_, goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_, goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_, goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_, goog.labs.userAgent.browser.isSilk = function() {
              return goog.labs.userAgent.util.matchUserAgent("Silk");
            }, goog.labs.userAgent.browser.getVersion = function() {
              function e(d) {
                return d = module$contents$goog$array_find(d, i), o[d] || "";
              }
              var t = goog.labs.userAgent.util.getUserAgent();
              if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(t);
              t = goog.labs.userAgent.util.extractVersionTuples(t);
              var o = {};
              module$contents$goog$array_forEach(t, function(d) {
                o[d[0]] = d[1];
              });
              var i = goog.partial(goog.object.containsKey, o);
              return goog.labs.userAgent.browser.isOpera() ? e(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? e(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? e(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? e(["Chrome", "CriOS", "HeadlessChrome"]) : (t = t[2]) && t[1] || "";
            }, goog.labs.userAgent.browser.isVersionOrHigher = function(e) {
              return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), e);
            }, goog.labs.userAgent.browser.getIEVersion_ = function(e) {
              var t = /rv: *([\d\.]*)/.exec(e);
              if (t && t[1]) return t[1];
              t = "";
              var o = /MSIE +([\d\.]+)/.exec(e);
              if (o && o[1]) if (e = /Trident\/(\d.\d)/.exec(e), o[1] == "7.0") if (e && e[1]) switch (e[1]) {
                case "4.0":
                  t = "8.0";
                  break;
                case "5.0":
                  t = "9.0";
                  break;
                case "6.0":
                  t = "10.0";
                  break;
                case "7.0":
                  t = "11.0";
              }
              else t = "7.0";
              else t = o[1];
              return t;
            }, goog.html.SafeHtml = function(e, t, o) {
              this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = o === goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ ? e : "", this.dir_ = t;
            }, goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG, goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = !0, goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeHtml.prototype.getDirection = function() {
              return this.dir_;
            }, goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0, goog.html.SafeHtml.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
            }, goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
              return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
            }), goog.html.SafeHtml.unwrap = function(e) {
              return goog.html.SafeHtml.unwrapTrustedHTML(e).toString();
            }, goog.html.SafeHtml.unwrapTrustedHTML = function(e) {
              return e instanceof goog.html.SafeHtml && e.constructor === goog.html.SafeHtml ? e.privateDoNotAccessOrElseSafeHtmlWrappedValue_ : (goog.asserts.fail("expected object of type SafeHtml, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeHtml");
            }, goog.html.SafeHtml.htmlEscape = function(e) {
              if (e instanceof goog.html.SafeHtml) return e;
              var t = typeof e == "object", o = null;
              return t && e.implementsGoogI18nBidiDirectionalString && (o = e.getDirection()), e = t && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(e), o);
            }, goog.html.SafeHtml.htmlEscapePreservingNewlines = function(e) {
              return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
            }, goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(e) {
              return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
            }, goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape, goog.html.SafeHtml.comment = function(e) {
              return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!--" + goog.string.internal.htmlEscape(e) + "-->", null);
            }, goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/, goog.html.SafeHtml.URL_ATTRIBUTES_ = { action: !0, cite: !0, data: !0, formaction: !0, href: !0, manifest: !0, poster: !0, src: !0 }, goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = goog.object.createSet(goog.dom.TagName.APPLET, goog.dom.TagName.BASE, goog.dom.TagName.EMBED, goog.dom.TagName.IFRAME, goog.dom.TagName.LINK, goog.dom.TagName.MATH, goog.dom.TagName.META, goog.dom.TagName.OBJECT, goog.dom.TagName.SCRIPT, goog.dom.TagName.STYLE, goog.dom.TagName.SVG, goog.dom.TagName.TEMPLATE), goog.html.SafeHtml.create = function(e, t, o) {
              return goog.html.SafeHtml.verifyTagName(String(e)), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(e), t, o);
            }, goog.html.SafeHtml.verifyTagName = function(e) {
              if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(e)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Invalid tag name <" + e + ">." : "");
              if (e.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Tag name <" + e + "> is not allowed for SafeHtml." : "");
            }, goog.html.SafeHtml.createIframe = function(e, t, o, i) {
              e && goog.html.TrustedResourceUrl.unwrap(e);
              var d = {};
              return d.src = e || null, d.srcdoc = t && goog.html.SafeHtml.unwrap(t), e = goog.html.SafeHtml.combineAttributes(d, { sandbox: "" }, o), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, i);
            }, goog.html.SafeHtml.createSandboxIframe = function(e, t, o, i) {
              if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "The browser does not support sandboxed iframes." : "");
              var d = {};
              return d.src = e ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)) : null, d.srcdoc = t || null, d.sandbox = "", e = goog.html.SafeHtml.combineAttributes(d, {}, o), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, i);
            }, goog.html.SafeHtml.canUseSandboxIframe = function() {
              return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
            }, goog.html.SafeHtml.createScriptSrc = function(e, t) {
              return goog.html.TrustedResourceUrl.unwrap(e), e = goog.html.SafeHtml.combineAttributes({ src: e }, {}, t), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", e);
            }, goog.html.SafeHtml.createScript = function(e, t) {
              for (var o in t) if (Object.prototype.hasOwnProperty.call(t, o)) {
                var i = o.toLowerCase();
                if (i == "language" || i == "src" || i == "text" || i == "type") throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot set "' + i + '" attribute' : "");
              }
              for (o = "", e = module$contents$goog$array_concat(e), i = 0; i < e.length; i++) o += module$contents$goog$html$SafeScript_SafeScript.unwrap(e[i]);
              return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(
                "script",
                t,
                e
              );
            }, goog.html.SafeHtml.createStyle = function(e, t) {
              t = goog.html.SafeHtml.combineAttributes({ type: "text/css" }, {}, t);
              var o = "";
              e = module$contents$goog$array_concat(e);
              for (var i = 0; i < e.length; i++) o += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(e[i]);
              return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", t, e);
            }, goog.html.SafeHtml.createMetaRefresh = function(e, t) {
              return e = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)), (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(e, ";") && (e = "'" + e.replace(/'/g, "%27") + "'"), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", { "http-equiv": "refresh", content: (t || 0) + "; url=" + e });
            }, goog.html.SafeHtml.getAttrNameAndValue_ = function(e, t, o) {
              if (o instanceof goog.string.Const) o = goog.string.Const.unwrap(o);
              else if (t.toLowerCase() == "style") if (goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE) o = goog.html.SafeHtml.getStyleValue_(o);
              else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "style" not supported.' : "");
              else {
                if (/^on/i.test(t)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + t + '" requires goog.string.Const value, "' + o + '" given.' : "");
                if (t.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) if (o instanceof goog.html.TrustedResourceUrl) o = goog.html.TrustedResourceUrl.unwrap(o);
                else if (o instanceof goog.html.SafeUrl) o = goog.html.SafeUrl.unwrap(o);
                else if (typeof o == "string") o = goog.html.SafeUrl.sanitize(o).getTypedStringValue();
                else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + t + '" on tag "' + e + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + o + '" given.' : "");
              }
              return o.implementsGoogStringTypedString && (o = o.getTypedStringValue()), goog.asserts.assert(typeof o == "string" || typeof o == "number", "String or number value expected, got " + typeof o + " with value: " + o), t + '="' + goog.string.internal.htmlEscape(String(o)) + '"';
            }, goog.html.SafeHtml.getStyleValue_ = function(e) {
              if (!goog.isObject(e)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof e + " given: " + e : "");
              return e instanceof goog.html.SafeStyle || (e = goog.html.SafeStyle.create(e)), goog.html.SafeStyle.unwrap(e);
            }, goog.html.SafeHtml.createWithDir = function(e, t, o, i) {
              return t = goog.html.SafeHtml.create(t, o, i), t.dir_ = e, t;
            }, goog.html.SafeHtml.join = function(e, t) {
              e = goog.html.SafeHtml.htmlEscape(e);
              var o = e.getDirection(), i = [], d = function(s) {
                Array.isArray(s) ? module$contents$goog$array_forEach(s, d) : (s = goog.html.SafeHtml.htmlEscape(s), i.push(goog.html.SafeHtml.unwrap(s)), s = s.getDirection(), o == goog.i18n.bidi.Dir.NEUTRAL ? o = s : s != goog.i18n.bidi.Dir.NEUTRAL && o != s && (o = null));
              };
              return module$contents$goog$array_forEach(t, d), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(i.join(goog.html.SafeHtml.unwrap(e)), o);
            }, goog.html.SafeHtml.concat = function(e) {
              return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
            }, goog.html.SafeHtml.concatWithDir = function(e, t) {
              var o = goog.html.SafeHtml.concat(module$contents$goog$array_slice(arguments, 1));
              return o.dir_ = e, o;
            }, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(e, t) {
              var o = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
              return e = o ? o.createHTML(e) : e, new goog.html.SafeHtml(e, t, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
            }, goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(e, t, o) {
              var i = null, d = "<" + e + goog.html.SafeHtml.stringifyAttributes(e, t);
              return o == null ? o = [] : Array.isArray(o) || (o = [o]), goog.dom.tags.isVoidTag(e.toLowerCase()) ? (goog.asserts.assert(!o.length, "Void tag <" + e + "> does not allow content."), d += ">") : (i = goog.html.SafeHtml.concat(o), d += ">" + goog.html.SafeHtml.unwrap(i) + "</" + e + ">", i = i.getDirection()), (e = t && t.dir) && (i = /^(ltr|rtl|auto)$/i.test(e) ? goog.i18n.bidi.Dir.NEUTRAL : null), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(
                d,
                i
              );
            }, goog.html.SafeHtml.stringifyAttributes = function(e, t) {
              var o = "";
              if (t) {
                for (var i in t) if (Object.prototype.hasOwnProperty.call(t, i)) {
                  if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(i)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid attribute name "' + i + '".' : "");
                  var d = t[i];
                  d != null && (o += " " + goog.html.SafeHtml.getAttrNameAndValue_(e, i, d));
                }
              }
              return o;
            }, goog.html.SafeHtml.combineAttributes = function(e, t, o) {
              var i = {}, d;
              for (d in e) Object.prototype.hasOwnProperty.call(e, d) && (goog.asserts.assert(d.toLowerCase() == d, "Must be lower case"), i[d] = e[d]);
              for (d in t) Object.prototype.hasOwnProperty.call(t, d) && (goog.asserts.assert(d.toLowerCase() == d, "Must be lower case"), i[d] = t[d]);
              if (o) {
                for (d in o) if (Object.prototype.hasOwnProperty.call(o, d)) {
                  var s = d.toLowerCase();
                  if (s in e) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot override "' + s + '" attribute, got "' + d + '" with value "' + o[d] + '"' : "");
                  s in t && delete i[s], i[d] = o[d];
                }
              }
              return i;
            }, goog.html.SafeHtml.DOCTYPE_HTML = (function() {
              return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL);
            })(), goog.html.SafeHtml.EMPTY = new goog.html.SafeHtml(goog.global.trustedTypes && goog.global.trustedTypes.emptyHTML || "", goog.i18n.bidi.Dir.NEUTRAL, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_), goog.html.SafeHtml.BR = (function() {
              return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL);
            })(), goog.html.uncheckedconversions = {}, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(e, t, o) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(t, o || null);
            }, goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(e, t) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(e, t) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(e, t) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(e, t) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(e, t) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t);
            }, goog.dom.safe = {}, goog.dom.safe.InsertAdjacentHtmlPosition = { AFTERBEGIN: "afterbegin", AFTEREND: "afterend", BEFOREBEGIN: "beforebegin", BEFOREEND: "beforeend" }, goog.dom.safe.insertAdjacentHtml = function(e, t, o) {
              e.insertAdjacentHTML(t, goog.html.SafeHtml.unwrapTrustedHTML(o));
            }, goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = { MATH: !0, SCRIPT: !0, STYLE: !0, SVG: !0, TEMPLATE: !0 }, goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
              if (goog.DEBUG && typeof document > "u") return !1;
              var e = document.createElement("div"), t = document.createElement("div");
              return t.appendChild(document.createElement("div")), e.appendChild(t), goog.DEBUG && !e.firstChild ? !1 : (t = e.firstChild.firstChild, e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY), !t.parentElement);
            }), goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(e, t) {
              if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for (; e.lastChild; ) e.removeChild(e.lastChild);
              e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t);
            }, goog.dom.safe.setInnerHtml = function(e, t) {
              if (goog.asserts.ENABLE_ASSERTS && e.tagName) {
                var o = e.tagName.toUpperCase();
                if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[o]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + e.tagName + ".");
              }
              goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(e, t);
            }, goog.dom.safe.setInnerHtmlFromConstant = function(e, t) {
              goog.dom.safe.setInnerHtml(e, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Constant HTML to be immediatelly used."), goog.string.Const.unwrap(t)));
            }, goog.dom.safe.setOuterHtml = function(e, t) {
              e.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t);
            }, goog.dom.safe.setFormElementAction = function(e, t) {
              t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLFormElement(e).action = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setButtonFormAction = function(e, t) {
              t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLButtonElement(e).formAction = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setInputFormAction = function(e, t) {
              t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLInputElement(e).formAction = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setStyle = function(e, t) {
              e.style.cssText = goog.html.SafeStyle.unwrap(t);
            }, goog.dom.safe.documentWrite = function(e, t) {
              e.write(goog.html.SafeHtml.unwrapTrustedHTML(t));
            }, goog.dom.safe.setAnchorHref = function(e, t) {
              goog.dom.asserts.assertIsHTMLAnchorElement(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.href = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setImageSrc = function(e, t) {
              if (goog.dom.asserts.assertIsHTMLImageElement(e), !(t instanceof goog.html.SafeUrl)) {
                var o = /^data:image\//i.test(t);
                t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, o);
              }
              e.src = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setAudioSrc = function(e, t) {
              if (goog.dom.asserts.assertIsHTMLAudioElement(e), !(t instanceof goog.html.SafeUrl)) {
                var o = /^data:audio\//i.test(t);
                t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, o);
              }
              e.src = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setVideoSrc = function(e, t) {
              if (goog.dom.asserts.assertIsHTMLVideoElement(e), !(t instanceof goog.html.SafeUrl)) {
                var o = /^data:video\//i.test(t);
                t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, o);
              }
              e.src = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setEmbedSrc = function(e, t) {
              goog.dom.asserts.assertIsHTMLEmbedElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t);
            }, goog.dom.safe.setFrameSrc = function(e, t) {
              goog.dom.asserts.assertIsHTMLFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrap(t);
            }, goog.dom.safe.setIframeSrc = function(e, t) {
              goog.dom.asserts.assertIsHTMLIFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrap(t);
            }, goog.dom.safe.setIframeSrcdoc = function(e, t) {
              goog.dom.asserts.assertIsHTMLIFrameElement(e), e.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(t);
            }, goog.dom.safe.setLinkHrefAndRel = function(e, t, o) {
              goog.dom.asserts.assertIsHTMLLinkElement(e), e.rel = o, goog.string.internal.caseInsensitiveContains(o, "stylesheet") ? (goog.asserts.assert(t instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), e.href = goog.html.TrustedResourceUrl.unwrap(t)) : e.href = t instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrap(t) : t instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrap(t) : goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(t));
            }, goog.dom.safe.setObjectData = function(e, t) {
              goog.dom.asserts.assertIsHTMLObjectElement(e), e.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t);
            }, goog.dom.safe.setScriptSrc = function(e, t) {
              goog.dom.asserts.assertIsHTMLScriptElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t), goog.dom.safe.setNonceForScriptElement_(e);
            }, goog.dom.safe.setScriptContent = function(e, t) {
              goog.dom.asserts.assertIsHTMLScriptElement(e), e.textContent = module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(t), goog.dom.safe.setNonceForScriptElement_(e);
            }, goog.dom.safe.setNonceForScriptElement_ = function(e) {
              var t = goog.getScriptNonce(e.ownerDocument && e.ownerDocument.defaultView);
              t && e.setAttribute("nonce", t);
            }, goog.dom.safe.setLocationHref = function(e, t) {
              goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.href = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.assignLocation = function(e, t) {
              goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.assign(goog.html.SafeUrl.unwrap(t));
            }, goog.dom.safe.replaceLocation = function(e, t) {
              t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.replace(goog.html.SafeUrl.unwrap(t));
            }, goog.dom.safe.openInWindow = function(e, t, o, i, d) {
              return e = e instanceof goog.html.SafeUrl ? e : goog.html.SafeUrl.sanitizeAssertUnchanged(e), t = t || goog.global, o = o instanceof goog.string.Const ? goog.string.Const.unwrap(o) : o || "", t.open(goog.html.SafeUrl.unwrap(e), o, i, d);
            }, goog.dom.safe.parseFromStringHtml = function(e, t) {
              return goog.dom.safe.parseFromString(e, t, "text/html");
            }, goog.dom.safe.parseFromString = function(e, t, o) {
              return e.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(t), o);
            }, goog.dom.safe.createImageFromBlob = function(e) {
              if (!/^image\/.*/g.test(e.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
              var t = goog.global.URL.createObjectURL(e);
              return e = new goog.global.Image(), e.onload = function() {
                goog.global.URL.revokeObjectURL(t);
              }, goog.dom.safe.setImageSrc(e, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), t)), e;
            }, goog.string.DETECT_DOUBLE_ESCAPING = !1, goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1, goog.string.Unicode = { NBSP: " " }, goog.string.startsWith = goog.string.internal.startsWith, goog.string.endsWith = goog.string.internal.endsWith, goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith, goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith, goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals, goog.string.subs = function(e, t) {
              for (var o = e.split("%s"), i = "", d = Array.prototype.slice.call(arguments, 1); d.length && 1 < o.length; ) i += o.shift() + d.shift();
              return i + o.join("%s");
            }, goog.string.collapseWhitespace = function(e) {
              return e.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
            }, goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace, goog.string.isEmptyString = function(e) {
              return e.length == 0;
            }, goog.string.isEmpty = goog.string.isEmptyOrWhitespace, goog.string.isEmptyOrWhitespaceSafe = function(e) {
              return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(e));
            }, goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe, goog.string.isBreakingWhitespace = function(e) {
              return !/[^\t\n\r ]/.test(e);
            }, goog.string.isAlpha = function(e) {
              return !/[^a-zA-Z]/.test(e);
            }, goog.string.isNumeric = function(e) {
              return !/[^0-9]/.test(e);
            }, goog.string.isAlphaNumeric = function(e) {
              return !/[^a-zA-Z0-9]/.test(e);
            }, goog.string.isSpace = function(e) {
              return e == " ";
            }, goog.string.isUnicodeChar = function(e) {
              return e.length == 1 && " " <= e && "~" >= e || "" <= e && "�" >= e;
            }, goog.string.stripNewlines = function(e) {
              return e.replace(/(\r\n|\r|\n)+/g, " ");
            }, goog.string.canonicalizeNewlines = function(e) {
              return e.replace(/(\r\n|\r|\n)/g, `
`);
            }, goog.string.normalizeWhitespace = function(e) {
              return e.replace(/\xa0|\s/g, " ");
            }, goog.string.normalizeSpaces = function(e) {
              return e.replace(/\xa0|[ \t]+/g, " ");
            }, goog.string.collapseBreakingSpaces = function(e) {
              return e.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
            }, goog.string.trim = goog.string.internal.trim, goog.string.trimLeft = function(e) {
              return e.replace(/^[\s\xa0]+/, "");
            }, goog.string.trimRight = function(e) {
              return e.replace(/[\s\xa0]+$/, "");
            }, goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare, goog.string.numberAwareCompare_ = function(e, t, o) {
              if (e == t) return 0;
              if (!e) return -1;
              if (!t) return 1;
              for (var i = e.toLowerCase().match(o), d = t.toLowerCase().match(o), s = Math.min(i.length, d.length), n = 0; n < s; n++) {
                o = i[n];
                var r = d[n];
                if (o != r) return e = parseInt(o, 10), !isNaN(e) && (t = parseInt(r, 10), !isNaN(t) && e - t) ? e - t : o < r ? -1 : 1;
              }
              return i.length != d.length ? i.length - d.length : e < t ? -1 : 1;
            }, goog.string.intAwareCompare = function(e, t) {
              return goog.string.numberAwareCompare_(e, t, /\d+|\D+/g);
            }, goog.string.floatAwareCompare = function(e, t) {
              return goog.string.numberAwareCompare_(e, t, /\d+|\.\d+|\D+/g);
            }, goog.string.numerateCompare = goog.string.floatAwareCompare, goog.string.urlEncode = function(e) {
              return encodeURIComponent(String(e));
            }, goog.string.urlDecode = function(e) {
              return decodeURIComponent(e.replace(/\+/g, " "));
            }, goog.string.newLineToBr = goog.string.internal.newLineToBr, goog.string.htmlEscape = function(e, t) {
              return e = goog.string.internal.htmlEscape(e, t), goog.string.DETECT_DOUBLE_ESCAPING && (e = e.replace(goog.string.E_RE_, "&#101;")), e;
            }, goog.string.E_RE_ = /e/g, goog.string.unescapeEntities = function(e) {
              return goog.string.contains(e, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(e) : goog.string.unescapePureXmlEntities_(e) : e;
            }, goog.string.unescapeEntitiesWithDocument = function(e, t) {
              return goog.string.contains(e, "&") ? goog.string.unescapeEntitiesUsingDom_(e, t) : e;
            }, goog.string.unescapeEntitiesUsingDom_ = function(e, t) {
              var o = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"' }, i = t ? t.createElement("div") : goog.global.document.createElement("div");
              return e.replace(goog.string.HTML_ENTITY_PATTERN_, function(d, s) {
                var n = o[d];
                return n || (s.charAt(0) == "#" && (s = +("0" + s.substr(1)), isNaN(s) || (n = String.fromCharCode(s))), n || (goog.dom.safe.setInnerHtml(i, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(
                  goog.string.Const.from("Single HTML entity."),
                  d + " "
                )), n = i.firstChild.nodeValue.slice(0, -1)), o[d] = n);
              });
            }, goog.string.unescapePureXmlEntities_ = function(e) {
              return e.replace(/&([^;]+);/g, function(t, o) {
                switch (o) {
                  case "amp":
                    return "&";
                  case "lt":
                    return "<";
                  case "gt":
                    return ">";
                  case "quot":
                    return '"';
                  default:
                    return o.charAt(0) != "#" || (o = +("0" + o.substr(1)), isNaN(o)) ? t : String.fromCharCode(o);
                }
              });
            }, goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g, goog.string.whitespaceEscape = function(e, t) {
              return goog.string.newLineToBr(e.replace(/  /g, " &#160;"), t);
            }, goog.string.preserveSpaces = function(e) {
              return e.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
            }, goog.string.stripQuotes = function(e, t) {
              for (var o = t.length, i = 0; i < o; i++) {
                var d = o == 1 ? t : t.charAt(i);
                if (e.charAt(0) == d && e.charAt(e.length - 1) == d) return e.substring(1, e.length - 1);
              }
              return e;
            }, goog.string.truncate = function(e, t, o) {
              return o && (e = goog.string.unescapeEntities(e)), e.length > t && (e = e.substring(0, t - 3) + "..."), o && (e = goog.string.htmlEscape(e)), e;
            }, goog.string.truncateMiddle = function(e, t, o, i) {
              if (o && (e = goog.string.unescapeEntities(e)), i && e.length > t) {
                i > t && (i = t);
                var d = e.length - i;
                e = e.substring(0, t - i) + "..." + e.substring(d);
              } else e.length > t && (i = Math.floor(t / 2), d = e.length - i, e = e.substring(0, i + t % 2) + "..." + e.substring(d));
              return o && (e = goog.string.htmlEscape(e)), e;
            }, goog.string.specialEscapeChars_ = { "\0": "\\0", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t", "\v": "\\x0B", '"': '\\"', "\\": "\\\\", "<": "\\u003C" }, goog.string.jsEscapeCache_ = { "'": "\\'" }, goog.string.quote = function(e) {
              e = String(e);
              for (var t = ['"'], o = 0; o < e.length; o++) {
                var i = e.charAt(o), d = i.charCodeAt(0);
                t[o + 1] = goog.string.specialEscapeChars_[i] || (31 < d && 127 > d ? i : goog.string.escapeChar(i));
              }
              return t.push('"'), t.join("");
            }, goog.string.escapeString = function(e) {
              for (var t = [], o = 0; o < e.length; o++) t[o] = goog.string.escapeChar(e.charAt(o));
              return t.join("");
            }, goog.string.escapeChar = function(e) {
              if (e in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[e];
              if (e in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[e] = goog.string.specialEscapeChars_[e];
              var t = e.charCodeAt(0);
              if (31 < t && 127 > t) var o = e;
              else
                256 > t ? (o = "\\x", (16 > t || 256 < t) && (o += "0")) : (o = "\\u", 4096 > t && (o += "0")), o += t.toString(16).toUpperCase();
              return goog.string.jsEscapeCache_[e] = o;
            }, goog.string.contains = goog.string.internal.contains, goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains, goog.string.countOf = function(e, t) {
              return e && t ? e.split(t).length - 1 : 0;
            }, goog.string.removeAt = function(e, t, o) {
              var i = e;
              return 0 <= t && t < e.length && 0 < o && (i = e.substr(0, t) + e.substr(t + o, e.length - t - o)), i;
            }, goog.string.remove = function(e, t) {
              return e.replace(t, "");
            }, goog.string.removeAll = function(e, t) {
              return t = new RegExp(goog.string.regExpEscape(t), "g"), e.replace(t, "");
            }, goog.string.replaceAll = function(e, t, o) {
              return t = new RegExp(goog.string.regExpEscape(t), "g"), e.replace(t, o.replace(/\$/g, "$$$$"));
            }, goog.string.regExpEscape = function(e) {
              return String(e).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
            }, goog.string.repeat = String.prototype.repeat ? function(e, t) {
              return e.repeat(t);
            } : function(e, t) {
              return Array(t + 1).join(e);
            }, goog.string.padNumber = function(e, t, o) {
              return e = o !== void 0 ? e.toFixed(o) : String(e), o = e.indexOf("."), o == -1 && (o = e.length), goog.string.repeat("0", Math.max(0, t - o)) + e;
            }, goog.string.makeSafe = function(e) {
              return e == null ? "" : String(e);
            }, goog.string.buildString = function(e) {
              return Array.prototype.join.call(arguments, "");
            }, goog.string.getRandomString = function() {
              return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
            }, goog.string.compareVersions = goog.string.internal.compareVersions, goog.string.hashCode = function(e) {
              for (var t = 0, o = 0; o < e.length; ++o) t = 31 * t + e.charCodeAt(o) >>> 0;
              return t;
            }, goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0, goog.string.createUniqueString = function() {
              return "goog_" + goog.string.uniqueStringCounter_++;
            }, goog.string.toNumber = function(e) {
              var t = Number(e);
              return t == 0 && goog.string.isEmptyOrWhitespace(e) ? NaN : t;
            }, goog.string.isLowerCamelCase = function(e) {
              return /^[a-z]+([A-Z][a-z]*)*$/.test(e);
            }, goog.string.isUpperCamelCase = function(e) {
              return /^([A-Z][a-z]*)+$/.test(e);
            }, goog.string.toCamelCase = function(e) {
              return String(e).replace(/\-([a-z])/g, function(t, o) {
                return o.toUpperCase();
              });
            }, goog.string.toSelectorCase = function(e) {
              return String(e).replace(/([A-Z])/g, "-$1").toLowerCase();
            }, goog.string.toTitleCase = function(e, t) {
              return t = typeof t == "string" ? goog.string.regExpEscape(t) : "\\s", e.replace(new RegExp("(^" + (t ? "|[" + t + "]+" : "") + ")([a-z])", "g"), function(o, i, d) {
                return i + d.toUpperCase();
              });
            }, goog.string.capitalize = function(e) {
              return String(e.charAt(0)).toUpperCase() + String(e.substr(1)).toLowerCase();
            }, goog.string.parseInt = function(e) {
              return isFinite(e) && (e = String(e)), typeof e == "string" ? /^\s*-?0x/i.test(e) ? parseInt(e, 16) : parseInt(e, 10) : NaN;
            }, goog.string.splitLimit = function(e, t, o) {
              e = e.split(t);
              for (var i = []; 0 < o && e.length; ) i.push(e.shift()), o--;
              return e.length && i.push(e.join(t)), i;
            }, goog.string.lastComponent = function(e, t) {
              if (t) typeof t == "string" && (t = [t]);
              else return e;
              for (var o = -1, i = 0; i < t.length; i++) if (t[i] != "") {
                var d = e.lastIndexOf(t[i]);
                d > o && (o = d);
              }
              return o == -1 ? e : e.slice(o + 1);
            }, goog.string.editDistance = function(e, t) {
              var o = [], i = [];
              if (e == t) return 0;
              if (!e.length || !t.length) return Math.max(e.length, t.length);
              for (var d = 0; d < t.length + 1; d++) o[d] = d;
              for (d = 0; d < e.length; d++) {
                i[0] = d + 1;
                for (var s = 0; s < t.length; s++) i[s + 1] = Math.min(i[s] + 1, o[s + 1] + 1, o[s] + +(e[d] != t[s]));
                for (s = 0; s < o.length; s++) o[s] = i[s];
              }
              return i[t.length];
            }, goog.proto2 = {}, goog.proto2.Descriptor = function(e, t, o) {
              for (this.messageType_ = e, this.name_ = t.name || null, this.fullName_ = t.fullName || null, this.containingType_ = t.containingType, this.fields_ = {}, e = 0; e < o.length; e++) t = o[e], this.fields_[t.getTag()] = t;
            }, goog.proto2.Descriptor.prototype.getName = function() {
              return this.name_;
            }, goog.proto2.Descriptor.prototype.getFullName = function() {
              return this.fullName_;
            }, goog.proto2.Descriptor.prototype.getContainingType = function() {
              return this.containingType_ ? this.containingType_.getDescriptor() : null;
            }, goog.proto2.Descriptor.prototype.getFields = function() {
              var e = goog.object.getValues(this.fields_);
              return module$contents$goog$array_sort(e, function(t, o) {
                return t.getTag() - o.getTag();
              }), e;
            }, goog.proto2.Descriptor.prototype.getFieldsMap = function() {
              return this.fields_;
            }, goog.proto2.Descriptor.prototype.findFieldByName = function(e) {
              return goog.object.findValue(this.fields_, function(t, o, i) {
                return t.getName() == e;
              }) || null;
            }, goog.proto2.Descriptor.prototype.findFieldByTag = function(e) {
              return goog.asserts.assert(goog.string.isNumeric(e)), this.fields_[parseInt(e, 10)] || null;
            }, goog.proto2.Descriptor.prototype.createMessageInstance = function() {
              return new this.messageType_();
            }, goog.proto2.FieldDescriptor = function(e, t, o) {
              switch (this.parent_ = e, goog.asserts.assert(goog.string.isNumeric(t)), this.tag_ = t, this.name_ = o.name, this.isPacked_ = !!o.packed, this.isRepeated_ = !!o.repeated, this.isRequired_ = !!o.required, this.fieldType_ = o.fieldType, this.nativeType_ = o.type, this.deserializationConversionPermitted_ = !1, this.fieldType_) {
                case goog.proto2.FieldDescriptor.FieldType.INT64:
                case goog.proto2.FieldDescriptor.FieldType.UINT64:
                case goog.proto2.FieldDescriptor.FieldType.FIXED64:
                case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
                case goog.proto2.FieldDescriptor.FieldType.SINT64:
                case goog.proto2.FieldDescriptor.FieldType.FLOAT:
                case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
                  this.deserializationConversionPermitted_ = !0;
              }
              this.defaultValue_ = o.defaultValue;
            }, goog.proto2.FieldDescriptor.FieldType = { DOUBLE: 1, FLOAT: 2, INT64: 3, UINT64: 4, INT32: 5, FIXED64: 6, FIXED32: 7, BOOL: 8, STRING: 9, GROUP: 10, MESSAGE: 11, BYTES: 12, UINT32: 13, ENUM: 14, SFIXED32: 15, SFIXED64: 16, SINT32: 17, SINT64: 18 }, goog.proto2.FieldDescriptor.prototype.getTag = function() {
              return this.tag_;
            }, goog.proto2.FieldDescriptor.prototype.getContainingType = function() {
              return this.parent_.prototype.getDescriptor();
            }, goog.proto2.FieldDescriptor.prototype.getName = function() {
              return this.name_;
            }, goog.proto2.FieldDescriptor.prototype.getDefaultValue = function() {
              if (this.defaultValue_ === void 0) {
                var e = this.nativeType_;
                if (e === Boolean) this.defaultValue_ = !1;
                else if (e === Number) this.defaultValue_ = 0;
                else if (e === String) this.defaultValue_ = this.deserializationConversionPermitted_ ? "0" : "";
                else return new e();
              }
              return this.defaultValue_;
            }, goog.proto2.FieldDescriptor.prototype.getFieldType = function() {
              return this.fieldType_;
            }, goog.proto2.FieldDescriptor.prototype.getNativeType = function() {
              return this.nativeType_;
            }, goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function() {
              return this.deserializationConversionPermitted_;
            }, goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function() {
              return this.nativeType_.prototype.getDescriptor();
            }, goog.proto2.FieldDescriptor.prototype.isCompositeType = function() {
              return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
            }, goog.proto2.FieldDescriptor.prototype.isPacked = function() {
              return this.isPacked_;
            }, goog.proto2.FieldDescriptor.prototype.isRepeated = function() {
              return this.isRepeated_;
            }, goog.proto2.FieldDescriptor.prototype.isRequired = function() {
              return this.isRequired_;
            }, goog.proto2.FieldDescriptor.prototype.isOptional = function() {
              return !this.isRepeated_ && !this.isRequired_;
            }, goog.proto2.Message = function() {
              this.values_ = {}, this.fields_ = this.getDescriptor().getFieldsMap(), this.deserializedFields_ = this.lazyDeserializer_ = null;
            }, goog.proto2.Message.FieldType = { DOUBLE: 1, FLOAT: 2, INT64: 3, UINT64: 4, INT32: 5, FIXED64: 6, FIXED32: 7, BOOL: 8, STRING: 9, GROUP: 10, MESSAGE: 11, BYTES: 12, UINT32: 13, ENUM: 14, SFIXED32: 15, SFIXED64: 16, SINT32: 17, SINT64: 18 }, goog.proto2.Message.prototype.initializeForLazyDeserializer = function(e, t) {
              this.lazyDeserializer_ = e, this.values_ = t, this.deserializedFields_ = {};
            }, goog.proto2.Message.prototype.setUnknown = function(e, t) {
              goog.asserts.assert(!this.fields_[e], "Field is not unknown in this message"), goog.asserts.assert(1 <= e, "Tag " + e + ' has value "' + t + '" in descriptor ' + this.getDescriptor().getName()), goog.asserts.assert(t !== null, "Value cannot be null"), this.values_[e] = t, this.deserializedFields_ && delete this.deserializedFields_[e];
            }, goog.proto2.Message.prototype.forEachUnknown = function(e, t) {
              t = t || this;
              for (var o in this.values_) {
                var i = Number(o);
                this.fields_[i] || e.call(t, i, this.values_[o]);
              }
            }, goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod, goog.proto2.Message.prototype.has = function(e) {
              return goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.has$Value(e.getTag());
            }, goog.proto2.Message.prototype.arrayOf = function(e) {
              return goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.array$Values(e.getTag());
            }, goog.proto2.Message.prototype.countOf = function(e) {
              return goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.count$Values(e.getTag());
            }, goog.proto2.Message.prototype.get = function(e, t) {
              return goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.get$Value(e.getTag(), t);
            }, goog.proto2.Message.prototype.getOrDefault = function(e, t) {
              return goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.get$ValueOrDefault(e.getTag(), t);
            }, goog.proto2.Message.prototype.set = function(e, t) {
              goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.set$Value(e.getTag(), t);
            }, goog.proto2.Message.prototype.add = function(e, t) {
              goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.add$Value(e.getTag(), t);
            }, goog.proto2.Message.prototype.clear = function(e) {
              goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.clear$Field(e.getTag());
            }, goog.proto2.Message.prototype.equals = function(e) {
              if (!e || this.constructor != e.constructor) return !1;
              for (var t = this.getDescriptor().getFields(), o = 0; o < t.length; o++) {
                var i = t[o], d = i.getTag();
                if (this.has$Value(d) != e.has$Value(d)) return !1;
                if (this.has$Value(d)) {
                  var s = i.isCompositeType(), n = this.getValueForTag_(d);
                  if (d = e.getValueForTag_(d), i.isRepeated()) {
                    if (n.length != d.length) return !1;
                    for (i = 0; i < n.length; i++) {
                      var r = n[i], u = d[i];
                      if (s ? !r.equals(u) : r != u) return !1;
                    }
                  } else if (s ? !n.equals(d) : n != d) return !1;
                }
              }
              return !0;
            }, goog.proto2.Message.prototype.copyFrom = function(e) {
              goog.asserts.assert(this.constructor == e.constructor, "The source message must have the same type."), this != e && (this.values_ = {}, this.deserializedFields_ && (this.deserializedFields_ = {}), this.mergeFrom(e));
            }, goog.proto2.Message.prototype.mergeFrom = function(e) {
              goog.asserts.assert(this.constructor == e.constructor, "The source message must have the same type.");
              for (var t = this.getDescriptor().getFields(), o = 0; o < t.length; o++) {
                var i = t[o], d = i.getTag();
                if (e.has$Value(d)) {
                  this.deserializedFields_ && delete this.deserializedFields_[i.getTag()];
                  var s = i.isCompositeType();
                  if (i.isRepeated()) {
                    i = e.array$Values(d);
                    for (var n = 0; n < i.length; n++) this.add$Value(d, s ? i[n].clone() : i[n]);
                  } else i = e.getValueForTag_(d), s ? (s = this.getValueForTag_(d)) ? s.mergeFrom(i) : this.set$Value(d, i.clone()) : this.set$Value(d, i);
                }
              }
            }, goog.proto2.Message.prototype.clone = function() {
              var e = new this.constructor();
              return e.copyFrom(this), e;
            }, goog.proto2.Message.prototype.initDefaults = function(e) {
              for (var t = this.getDescriptor().getFields(), o = 0; o < t.length; o++) {
                var i = t[o], d = i.getTag(), s = i.isCompositeType();
                if (this.has$Value(d) || i.isRepeated() || (s ? this.values_[d] = new (i.getNativeType())() : e && (this.values_[d] = i.getDefaultValue())), s) if (i.isRepeated()) for (i = this.array$Values(d), d = 0; d < i.length; d++) i[d].initDefaults(e);
                else this.get$Value(d).initDefaults(e);
              }
            }, goog.proto2.Message.prototype.has$Value = function(e) {
              return this.values_[e] != null;
            }, goog.proto2.Message.prototype.getValueForTag_ = function(e) {
              var t = this.values_[e];
              return t == null ? null : this.lazyDeserializer_ ? e in this.deserializedFields_ ? this.deserializedFields_[e] : (t = this.lazyDeserializer_.deserializeField(this, this.fields_[e], t), this.deserializedFields_[e] = t) : t;
            }, goog.proto2.Message.prototype.get$Value = function(e, t) {
              var o = this.getValueForTag_(e);
              return this.fields_[e].isRepeated() ? (e = t || 0, goog.asserts.assert(0 <= e && e < o.length, "Given index %s is out of bounds.  Repeated field length: %s", e, o.length), o[e]) : o;
            }, goog.proto2.Message.prototype.get$ValueOrDefault = function(e, t) {
              return this.has$Value(e) ? this.get$Value(e, t) : this.fields_[e].getDefaultValue();
            }, goog.proto2.Message.prototype.array$Values = function(e) {
              return this.getValueForTag_(e) || [];
            }, goog.proto2.Message.prototype.count$Values = function(e) {
              return this.fields_[e].isRepeated() ? this.has$Value(e) ? this.values_[e].length : 0 : this.has$Value(e) ? 1 : 0;
            }, goog.proto2.Message.prototype.set$Value = function(e, t) {
              goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[e], t), this.values_[e] = t, this.deserializedFields_ && (this.deserializedFields_[e] = t);
            }, goog.proto2.Message.prototype.add$Value = function(e, t) {
              goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[e], t), this.values_[e] || (this.values_[e] = []), this.values_[e].push(t), this.deserializedFields_ && delete this.deserializedFields_[e];
            }, goog.proto2.Message.prototype.checkFieldType_ = function(e, t) {
              e.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(t) : goog.asserts.assert(Object(t).constructor == e.getNativeType());
            }, goog.proto2.Message.prototype.clear$Field = function(e) {
              delete this.values_[e], this.deserializedFields_ && delete this.deserializedFields_[e];
            }, goog.proto2.Message.createDescriptor = function(e, t) {
              var o = [], i = t[0], d;
              for (d in t) d != 0 && o.push(new goog.proto2.FieldDescriptor(e, d, t[d]));
              return new goog.proto2.Descriptor(e, i, o);
            }, goog.proto2.Serializer = function() {
            }, goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = !1, goog.proto2.Serializer.prototype.serialize = goog.abstractMethod, goog.proto2.Serializer.prototype.getSerializedValue = function(e, t) {
              return e.isCompositeType() ? this.serialize(t) : typeof t != "number" || isFinite(t) ? t : t.toString();
            }, goog.proto2.Serializer.prototype.deserialize = function(e, t) {
              return e = e.createMessageInstance(), this.deserializeTo(e, t), goog.asserts.assert(e instanceof goog.proto2.Message), e;
            }, goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod, goog.proto2.Serializer.prototype.getDeserializedValue = function(e, t) {
              if (e.isCompositeType()) return t instanceof goog.proto2.Message ? t : this.deserialize(e.getFieldMessageType(), t);
              if (e.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM) return goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && typeof t == "string" && (e = e.getNativeType(), e.hasOwnProperty(t)) ? e[t] : typeof t == "string" && goog.proto2.Serializer.INTEGER_REGEX.test(t) && (e = Number(t), 0 < e) ? e : t;
              if (!e.deserializationConversionPermitted()) return t;
              if (e = e.getNativeType(), e === String) {
                if (typeof t == "number") return String(t);
              } else if (e === Number && typeof t == "string" && (t === "Infinity" || t === "-Infinity" || t === "NaN" || goog.proto2.Serializer.INTEGER_REGEX.test(t))) return Number(t);
              return t;
            }, goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/, goog.proto2.LazyDeserializer = function() {
            }, goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer), goog.proto2.LazyDeserializer.prototype.deserialize = function(e, t) {
              return e = e.createMessageInstance(), e.initializeForLazyDeserializer(this, t), goog.asserts.assert(e instanceof goog.proto2.Message), e;
            }, goog.proto2.LazyDeserializer.prototype.deserializeTo = function(e, t) {
              throw Error("Unimplemented");
            }, goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod, goog.proto2.PbLiteSerializer = function() {
            }, goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer), goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = !1, goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function(e) {
              this.zeroIndexing_ = e;
            }, goog.proto2.PbLiteSerializer.prototype.serialize = function(e) {
              for (var t = e.getDescriptor().getFields(), o = [], i = this.zeroIndexing_, d = 0; d < t.length; d++) {
                var s = t[d];
                if (e.has(s)) {
                  var n = s.getTag();
                  if (n = i ? n - 1 : n, s.isRepeated()) {
                    o[n] = [];
                    for (var r = 0; r < e.countOf(s); r++) o[n][r] = this.getSerializedValue(s, e.get(s, r));
                  } else o[n] = this.getSerializedValue(s, e.get(s));
                }
              }
              return e.forEachUnknown(function(u, l) {
                o[i ? u - 1 : u] = l;
              }), o;
            }, goog.proto2.PbLiteSerializer.prototype.deserializeField = function(e, t, o) {
              if (o == null) return o;
              if (t.isRepeated()) {
                e = [], goog.asserts.assert(Array.isArray(o), "Value must be array: %s", o);
                for (var i = 0; i < o.length; i++) e[i] = this.getDeserializedValue(t, o[i]);
                return e;
              }
              return this.getDeserializedValue(t, o);
            }, goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function(e, t) {
              return e.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? t ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
            }, goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function(e, t) {
              return e.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert(typeof t == "number" || typeof t == "boolean", "Value is expected to be a number or boolean"), !!t) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
            }, goog.proto2.PbLiteSerializer.prototype.deserialize = function(e, t) {
              var o = t;
              if (this.zeroIndexing_) {
                o = [];
                for (var i in t) o[parseInt(i, 10) + 1] = t[i];
              }
              return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, e, o);
            }, goog.string.StringBuffer = function(e, t) {
              e != null && this.append.apply(this, arguments);
            }, goog.string.StringBuffer.prototype.buffer_ = "", goog.string.StringBuffer.prototype.set = function(e) {
              this.buffer_ = "" + e;
            }, goog.string.StringBuffer.prototype.append = function(e, t, o) {
              if (this.buffer_ += String(e), t != null) for (var i = 1; i < arguments.length; i++) this.buffer_ += arguments[i];
              return this;
            }, goog.string.StringBuffer.prototype.clear = function() {
              this.buffer_ = "";
            }, goog.string.StringBuffer.prototype.getLength = function() {
              return this.buffer_.length;
            }, goog.string.StringBuffer.prototype.toString = function() {
              return this.buffer_;
            };
            var i18n = { phonenumbers: {} };
            i18n.phonenumbers.NumberFormat = function() {
              goog.proto2.Message.call(this);
            }, goog.inherits(i18n.phonenumbers.NumberFormat, goog.proto2.Message), i18n.phonenumbers.NumberFormat.descriptor_ = null, i18n.phonenumbers.NumberFormat.prototype.getPattern = function() {
              return this.get$Value(1);
            }, i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function() {
              return this.get$ValueOrDefault(1);
            }, i18n.phonenumbers.NumberFormat.prototype.setPattern = function(e) {
              this.set$Value(1, e);
            }, i18n.phonenumbers.NumberFormat.prototype.hasPattern = function() {
              return this.has$Value(1);
            }, i18n.phonenumbers.NumberFormat.prototype.patternCount = function() {
              return this.count$Values(1);
            }, i18n.phonenumbers.NumberFormat.prototype.clearPattern = function() {
              this.clear$Field(1);
            }, i18n.phonenumbers.NumberFormat.prototype.getFormat = function() {
              return this.get$Value(2);
            }, i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function() {
              return this.get$ValueOrDefault(2);
            }, i18n.phonenumbers.NumberFormat.prototype.setFormat = function(e) {
              this.set$Value(2, e);
            }, i18n.phonenumbers.NumberFormat.prototype.hasFormat = function() {
              return this.has$Value(2);
            }, i18n.phonenumbers.NumberFormat.prototype.formatCount = function() {
              return this.count$Values(2);
            }, i18n.phonenumbers.NumberFormat.prototype.clearFormat = function() {
              this.clear$Field(2);
            }, i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function(e) {
              return this.get$Value(3, e);
            }, i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function(e) {
              return this.get$ValueOrDefault(3, e);
            }, i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function(e) {
              this.add$Value(3, e);
            }, i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function() {
              return this.array$Values(3);
            }, i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function() {
              return this.has$Value(3);
            }, i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function() {
              return this.count$Values(3);
            }, i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function() {
              this.clear$Field(3);
            }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function() {
              return this.get$Value(4);
            }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function() {
              return this.get$ValueOrDefault(4);
            }, i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function(e) {
              this.set$Value(4, e);
            }, i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function() {
              return this.has$Value(4);
            }, i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function() {
              return this.count$Values(4);
            }, i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function() {
              this.clear$Field(4);
            }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function() {
              return this.get$Value(6);
            }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function() {
              return this.get$ValueOrDefault(6);
            }, i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function(e) {
              this.set$Value(6, e);
            }, i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function() {
              return this.has$Value(6);
            }, i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function() {
              return this.count$Values(6);
            }, i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function() {
              this.clear$Field(6);
            }, i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function() {
              return this.get$Value(5);
            }, i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function() {
              return this.get$ValueOrDefault(5);
            }, i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function(e) {
              this.set$Value(5, e);
            }, i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function() {
              return this.has$Value(5);
            }, i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function() {
              return this.count$Values(5);
            }, i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function() {
              this.clear$Field(5);
            }, i18n.phonenumbers.PhoneNumberDesc = function() {
              goog.proto2.Message.call(this);
            }, goog.inherits(i18n.phonenumbers.PhoneNumberDesc, goog.proto2.Message), i18n.phonenumbers.PhoneNumberDesc.descriptor_ = null, i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function() {
              return this.get$Value(2);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function() {
              return this.get$ValueOrDefault(2);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function(e) {
              this.set$Value(2, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function() {
              return this.has$Value(2);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function() {
              return this.count$Values(2);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function() {
              this.clear$Field(2);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function(e) {
              return this.get$Value(9, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function(e) {
              return this.get$ValueOrDefault(9, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function(e) {
              this.add$Value(9, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function() {
              return this.array$Values(9);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function() {
              return this.has$Value(9);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function() {
              return this.count$Values(9);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function() {
              this.clear$Field(9);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function(e) {
              return this.get$Value(10, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function(e) {
              return this.get$ValueOrDefault(10, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function(e) {
              this.add$Value(10, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function() {
              return this.array$Values(10);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function() {
              return this.has$Value(10);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function() {
              return this.count$Values(10);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function() {
              this.clear$Field(10);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function() {
              return this.get$Value(6);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function() {
              return this.get$ValueOrDefault(6);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function(e) {
              this.set$Value(6, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function() {
              return this.has$Value(6);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function() {
              return this.count$Values(6);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function() {
              this.clear$Field(6);
            }, i18n.phonenumbers.PhoneMetadata = function() {
              goog.proto2.Message.call(this);
            }, goog.inherits(i18n.phonenumbers.PhoneMetadata, goog.proto2.Message), i18n.phonenumbers.PhoneMetadata.descriptor_ = null, i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function() {
              return this.get$Value(1);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function() {
              return this.get$ValueOrDefault(1);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function(e) {
              this.set$Value(1, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function() {
              return this.has$Value(1);
            }, i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount = function() {
              return this.count$Values(1);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function() {
              this.clear$Field(1);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine = function() {
              return this.get$Value(2);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function() {
              return this.get$ValueOrDefault(2);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine = function(e) {
              this.set$Value(2, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function() {
              return this.has$Value(2);
            }, i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function() {
              return this.count$Values(2);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function() {
              this.clear$Field(2);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getMobile = function() {
              return this.get$Value(3);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function() {
              return this.get$ValueOrDefault(3);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setMobile = function(e) {
              this.set$Value(3, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasMobile = function() {
              return this.has$Value(3);
            }, i18n.phonenumbers.PhoneMetadata.prototype.mobileCount = function() {
              return this.count$Values(3);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearMobile = function() {
              this.clear$Field(3);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getTollFree = function() {
              return this.get$Value(4);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function() {
              return this.get$ValueOrDefault(4);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setTollFree = function(e) {
              this.set$Value(4, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree = function() {
              return this.has$Value(4);
            }, i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function() {
              return this.count$Values(4);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree = function() {
              this.clear$Field(4);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function() {
              return this.get$Value(5);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function() {
              return this.get$ValueOrDefault(5);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function(e) {
              this.set$Value(5, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function() {
              return this.has$Value(5);
            }, i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function() {
              return this.count$Values(5);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function() {
              this.clear$Field(5);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost = function() {
              return this.get$Value(6);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function() {
              return this.get$ValueOrDefault(6);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost = function(e) {
              this.set$Value(6, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function() {
              return this.has$Value(6);
            }, i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function() {
              return this.count$Values(6);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function() {
              this.clear$Field(6);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function() {
              return this.get$Value(7);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function() {
              return this.get$ValueOrDefault(7);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function(e) {
              this.set$Value(7, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function() {
              return this.has$Value(7);
            }, i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function() {
              return this.count$Values(7);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function() {
              this.clear$Field(7);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getVoip = function() {
              return this.get$Value(8);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function() {
              return this.get$ValueOrDefault(8);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setVoip = function(e) {
              this.set$Value(8, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasVoip = function() {
              return this.has$Value(8);
            }, i18n.phonenumbers.PhoneMetadata.prototype.voipCount = function() {
              return this.count$Values(8);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearVoip = function() {
              this.clear$Field(8);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPager = function() {
              return this.get$Value(21);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function() {
              return this.get$ValueOrDefault(21);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setPager = function(e) {
              this.set$Value(21, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasPager = function() {
              return this.has$Value(21);
            }, i18n.phonenumbers.PhoneMetadata.prototype.pagerCount = function() {
              return this.count$Values(21);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearPager = function() {
              this.clear$Field(21);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getUan = function() {
              return this.get$Value(25);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function() {
              return this.get$ValueOrDefault(25);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setUan = function(e) {
              this.set$Value(25, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasUan = function() {
              return this.has$Value(25);
            }, i18n.phonenumbers.PhoneMetadata.prototype.uanCount = function() {
              return this.count$Values(25);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearUan = function() {
              this.clear$Field(25);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getEmergency = function() {
              return this.get$Value(27);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function() {
              return this.get$ValueOrDefault(27);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setEmergency = function(e) {
              this.set$Value(27, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency = function() {
              return this.has$Value(27);
            }, i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount = function() {
              return this.count$Values(27);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency = function() {
              this.clear$Field(27);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail = function() {
              return this.get$Value(28);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function() {
              return this.get$ValueOrDefault(28);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail = function(e) {
              this.set$Value(28, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function() {
              return this.has$Value(28);
            }, i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount = function() {
              return this.count$Values(28);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function() {
              this.clear$Field(28);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getShortCode = function() {
              return this.get$Value(29);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault = function() {
              return this.get$ValueOrDefault(29);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setShortCode = function(e) {
              this.set$Value(29, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode = function() {
              return this.has$Value(29);
            }, i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount = function() {
              return this.count$Values(29);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode = function() {
              this.clear$Field(29);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate = function() {
              return this.get$Value(30);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault = function() {
              return this.get$ValueOrDefault(30);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate = function(e) {
              this.set$Value(30, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate = function() {
              return this.has$Value(30);
            }, i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount = function() {
              return this.count$Values(30);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate = function() {
              this.clear$Field(30);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific = function() {
              return this.get$Value(31);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault = function() {
              return this.get$ValueOrDefault(31);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific = function(e) {
              this.set$Value(31, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific = function() {
              return this.has$Value(31);
            }, i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount = function() {
              return this.count$Values(31);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific = function() {
              this.clear$Field(31);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices = function() {
              return this.get$Value(33);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault = function() {
              return this.get$ValueOrDefault(33);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices = function(e) {
              this.set$Value(33, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices = function() {
              return this.has$Value(33);
            }, i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount = function() {
              return this.count$Values(33);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices = function() {
              this.clear$Field(33);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function() {
              return this.get$Value(24);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function() {
              return this.get$ValueOrDefault(24);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function(e) {
              this.set$Value(24, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function() {
              return this.has$Value(24);
            }, i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function() {
              return this.count$Values(24);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function() {
              this.clear$Field(24);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getId = function() {
              return this.get$Value(9);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function() {
              return this.get$ValueOrDefault(9);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setId = function(e) {
              this.set$Value(9, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasId = function() {
              return this.has$Value(9);
            }, i18n.phonenumbers.PhoneMetadata.prototype.idCount = function() {
              return this.count$Values(9);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearId = function() {
              this.clear$Field(9);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode = function() {
              return this.get$Value(10);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function() {
              return this.get$ValueOrDefault(10);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode = function(e) {
              this.set$Value(10, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function() {
              return this.has$Value(10);
            }, i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function() {
              return this.count$Values(10);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function() {
              this.clear$Field(10);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function() {
              return this.get$Value(11);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function() {
              return this.get$ValueOrDefault(11);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function(e) {
              this.set$Value(11, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function() {
              return this.has$Value(11);
            }, i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function() {
              return this.count$Values(11);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function() {
              this.clear$Field(11);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function() {
              return this.get$Value(17);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function() {
              return this.get$ValueOrDefault(17);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function(e) {
              this.set$Value(17, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function() {
              return this.has$Value(17);
            }, i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function() {
              return this.count$Values(17);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function() {
              this.clear$Field(17);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function() {
              return this.get$Value(12);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function() {
              return this.get$ValueOrDefault(12);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function(e) {
              this.set$Value(12, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function() {
              return this.has$Value(12);
            }, i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function() {
              return this.count$Values(12);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function() {
              this.clear$Field(12);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function() {
              return this.get$Value(13);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function() {
              return this.get$ValueOrDefault(13);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function(e) {
              this.set$Value(13, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function() {
              return this.has$Value(13);
            }, i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function() {
              return this.count$Values(13);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function() {
              this.clear$Field(13);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function() {
              return this.get$Value(15);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function() {
              return this.get$ValueOrDefault(15);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function(e) {
              this.set$Value(15, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function() {
              return this.has$Value(15);
            }, i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function() {
              return this.count$Values(15);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function() {
              this.clear$Field(15);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function() {
              return this.get$Value(16);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function() {
              return this.get$ValueOrDefault(16);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function(e) {
              this.set$Value(16, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function() {
              return this.has$Value(16);
            }, i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function() {
              return this.count$Values(16);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function() {
              this.clear$Field(16);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function() {
              return this.get$Value(18);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function() {
              return this.get$ValueOrDefault(18);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function(e) {
              this.set$Value(18, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function() {
              return this.has$Value(18);
            }, i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function() {
              return this.count$Values(18);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function() {
              this.clear$Field(18);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function(e) {
              return this.get$Value(19, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function(e) {
              return this.get$ValueOrDefault(19, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function(e) {
              this.add$Value(19, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function() {
              return this.array$Values(19);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function() {
              return this.has$Value(19);
            }, i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function() {
              return this.count$Values(19);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function() {
              this.clear$Field(19);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function(e) {
              return this.get$Value(20, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function(e) {
              return this.get$ValueOrDefault(20, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function(e) {
              this.add$Value(20, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function() {
              return this.array$Values(20);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function() {
              return this.has$Value(20);
            }, i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function() {
              return this.count$Values(20);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function() {
              this.clear$Field(20);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function() {
              return this.get$Value(22);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function() {
              return this.get$ValueOrDefault(22);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function(e) {
              this.set$Value(22, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function() {
              return this.has$Value(22);
            }, i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function() {
              return this.count$Values(22);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function() {
              this.clear$Field(22);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function() {
              return this.get$Value(23);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function() {
              return this.get$ValueOrDefault(23);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function(e) {
              this.set$Value(23, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function() {
              return this.has$Value(23);
            }, i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function() {
              return this.count$Values(23);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function() {
              this.clear$Field(23);
            }, i18n.phonenumbers.PhoneMetadataCollection = function() {
              goog.proto2.Message.call(this);
            }, goog.inherits(i18n.phonenumbers.PhoneMetadataCollection, goog.proto2.Message), i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = null, i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function(e) {
              return this.get$Value(1, e);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function(e) {
              return this.get$ValueOrDefault(1, e);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function(e) {
              this.add$Value(1, e);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function() {
              return this.array$Values(1);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function() {
              return this.has$Value(1);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function() {
              return this.count$Values(1);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function() {
              this.clear$Field(1);
            }, i18n.phonenumbers.NumberFormat.prototype.getDescriptor = function() {
              var e = i18n.phonenumbers.NumberFormat.descriptor_;
              return e || (i18n.phonenumbers.NumberFormat.descriptor_ = e = goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat, { 0: { name: "NumberFormat", fullName: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: !0, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 2: { name: "format", required: !0, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 3: {
                name: "leading_digits_pattern",
                repeated: !0,
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              }, 4: { name: "national_prefix_formatting_rule", fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 6: { name: "national_prefix_optional_when_formatting", fieldType: goog.proto2.Message.FieldType.BOOL, defaultValue: !1, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", fieldType: goog.proto2.Message.FieldType.STRING, type: String } })), e;
            }, i18n.phonenumbers.NumberFormat.getDescriptor = i18n.phonenumbers.NumberFormat.prototype.getDescriptor, i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function() {
              var e = i18n.phonenumbers.PhoneNumberDesc.descriptor_;
              return e || (i18n.phonenumbers.PhoneNumberDesc.descriptor_ = e = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc, {
                0: { name: "PhoneNumberDesc", fullName: "i18n.phonenumbers.PhoneNumberDesc" },
                2: { name: "national_number_pattern", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                9: { name: "possible_length", repeated: !0, fieldType: goog.proto2.Message.FieldType.INT32, type: Number },
                10: { name: "possible_length_local_only", repeated: !0, fieldType: goog.proto2.Message.FieldType.INT32, type: Number },
                6: { name: "example_number", fieldType: goog.proto2.Message.FieldType.STRING, type: String }
              })), e;
            }, i18n.phonenumbers.PhoneNumberDesc.getDescriptor = i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor, i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor = function() {
              var e = i18n.phonenumbers.PhoneMetadata.descriptor_;
              return e || (i18n.phonenumbers.PhoneMetadata.descriptor_ = e = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata, {
                0: { name: "PhoneMetadata", fullName: "i18n.phonenumbers.PhoneMetadata" },
                1: { name: "general_desc", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                2: { name: "fixed_line", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                3: { name: "mobile", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                4: { name: "toll_free", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                5: { name: "premium_rate", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                6: { name: "shared_cost", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                7: {
                  name: "personal_number",
                  fieldType: goog.proto2.Message.FieldType.MESSAGE,
                  type: i18n.phonenumbers.PhoneNumberDesc
                },
                8: { name: "voip", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                21: { name: "pager", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                25: { name: "uan", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                27: { name: "emergency", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                28: {
                  name: "voicemail",
                  fieldType: goog.proto2.Message.FieldType.MESSAGE,
                  type: i18n.phonenumbers.PhoneNumberDesc
                },
                29: { name: "short_code", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                30: { name: "standard_rate", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                31: { name: "carrier_specific", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                33: { name: "sms_services", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                24: {
                  name: "no_international_dialling",
                  fieldType: goog.proto2.Message.FieldType.MESSAGE,
                  type: i18n.phonenumbers.PhoneNumberDesc
                },
                9: { name: "id", required: !0, fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                10: { name: "country_code", fieldType: goog.proto2.Message.FieldType.INT32, type: Number },
                11: { name: "international_prefix", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                17: { name: "preferred_international_prefix", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                12: {
                  name: "national_prefix",
                  fieldType: goog.proto2.Message.FieldType.STRING,
                  type: String
                },
                13: { name: "preferred_extn_prefix", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                15: { name: "national_prefix_for_parsing", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                16: { name: "national_prefix_transform_rule", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                18: { name: "same_mobile_and_fixed_line_pattern", fieldType: goog.proto2.Message.FieldType.BOOL, defaultValue: !1, type: Boolean },
                19: {
                  name: "number_format",
                  repeated: !0,
                  fieldType: goog.proto2.Message.FieldType.MESSAGE,
                  type: i18n.phonenumbers.NumberFormat
                },
                20: { name: "intl_number_format", repeated: !0, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.NumberFormat },
                22: { name: "main_country_for_code", fieldType: goog.proto2.Message.FieldType.BOOL, defaultValue: !1, type: Boolean },
                23: { name: "leading_digits", fieldType: goog.proto2.Message.FieldType.STRING, type: String }
              })), e;
            }, i18n.phonenumbers.PhoneMetadata.getDescriptor = i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor, i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function() {
              var e = i18n.phonenumbers.PhoneMetadataCollection.descriptor_;
              return e || (i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = e = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection, { 0: { name: "PhoneMetadataCollection", fullName: "i18n.phonenumbers.PhoneMetadataCollection" }, 1: { name: "metadata", repeated: !0, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneMetadata } })), e;
            }, i18n.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor, i18n.phonenumbers.PhoneNumber = function() {
              goog.proto2.Message.call(this);
            }, goog.inherits(i18n.phonenumbers.PhoneNumber, goog.proto2.Message), i18n.phonenumbers.PhoneNumber.descriptor_ = null, i18n.phonenumbers.PhoneNumber.prototype.getCountryCode = function() {
              return this.get$Value(1);
            }, i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function() {
              return this.get$ValueOrDefault(1);
            }, i18n.phonenumbers.PhoneNumber.prototype.setCountryCode = function(e) {
              this.set$Value(1, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode = function() {
              return this.has$Value(1);
            }, i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount = function() {
              return this.count$Values(1);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode = function() {
              this.clear$Field(1);
            }, i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber = function() {
              return this.get$Value(2);
            }, i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function() {
              return this.get$ValueOrDefault(2);
            }, i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber = function(e) {
              this.set$Value(2, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function() {
              return this.has$Value(2);
            }, i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function() {
              return this.count$Values(2);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function() {
              this.clear$Field(2);
            }, i18n.phonenumbers.PhoneNumber.prototype.getExtension = function() {
              return this.get$Value(3);
            }, i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function() {
              return this.get$ValueOrDefault(3);
            }, i18n.phonenumbers.PhoneNumber.prototype.setExtension = function(e) {
              this.set$Value(3, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasExtension = function() {
              return this.has$Value(3);
            }, i18n.phonenumbers.PhoneNumber.prototype.extensionCount = function() {
              return this.count$Values(3);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearExtension = function() {
              this.clear$Field(3);
            }, i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function() {
              return this.get$Value(4);
            }, i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function() {
              return this.get$ValueOrDefault(4);
            }, i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function(e) {
              this.set$Value(4, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function() {
              return this.has$Value(4);
            }, i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function() {
              return this.count$Values(4);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function() {
              this.clear$Field(4);
            }, i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function() {
              return this.get$Value(8);
            }, i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function() {
              return this.get$ValueOrDefault(8);
            }, i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function(e) {
              this.set$Value(8, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function() {
              return this.has$Value(8);
            }, i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function() {
              return this.count$Values(8);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function() {
              this.clear$Field(8);
            }, i18n.phonenumbers.PhoneNumber.prototype.getRawInput = function() {
              return this.get$Value(5);
            }, i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function() {
              return this.get$ValueOrDefault(5);
            }, i18n.phonenumbers.PhoneNumber.prototype.setRawInput = function(e) {
              this.set$Value(5, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasRawInput = function() {
              return this.has$Value(5);
            }, i18n.phonenumbers.PhoneNumber.prototype.rawInputCount = function() {
              return this.count$Values(5);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearRawInput = function() {
              this.clear$Field(5);
            }, i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function() {
              return this.get$Value(6);
            }, i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function() {
              return this.get$ValueOrDefault(6);
            }, i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function(e) {
              this.set$Value(6, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function() {
              return this.has$Value(6);
            }, i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function() {
              return this.count$Values(6);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function() {
              this.clear$Field(6);
            }, i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function() {
              return this.get$Value(7);
            }, i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function() {
              return this.get$ValueOrDefault(7);
            }, i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function(e) {
              this.set$Value(7, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function() {
              return this.has$Value(7);
            }, i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function() {
              return this.count$Values(7);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function() {
              this.clear$Field(7);
            }, i18n.phonenumbers.PhoneNumber.CountryCodeSource = { UNSPECIFIED: 0, FROM_NUMBER_WITH_PLUS_SIGN: 1, FROM_NUMBER_WITH_IDD: 5, FROM_NUMBER_WITHOUT_PLUS_SIGN: 10, FROM_DEFAULT_COUNTRY: 20 }, i18n.phonenumbers.PhoneNumber.prototype.getDescriptor = function() {
              var e = i18n.phonenumbers.PhoneNumber.descriptor_;
              return e || (i18n.phonenumbers.PhoneNumber.descriptor_ = e = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber, {
                0: { name: "PhoneNumber", fullName: "i18n.phonenumbers.PhoneNumber" },
                1: { name: "country_code", required: !0, fieldType: goog.proto2.Message.FieldType.INT32, type: Number },
                2: { name: "national_number", required: !0, fieldType: goog.proto2.Message.FieldType.UINT64, type: Number },
                3: {
                  name: "extension",
                  fieldType: goog.proto2.Message.FieldType.STRING,
                  type: String
                },
                4: { name: "italian_leading_zero", fieldType: goog.proto2.Message.FieldType.BOOL, type: Boolean },
                8: { name: "number_of_leading_zeros", fieldType: goog.proto2.Message.FieldType.INT32, defaultValue: 1, type: Number },
                5: { name: "raw_input", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                6: { name: "country_code_source", fieldType: goog.proto2.Message.FieldType.ENUM, defaultValue: i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED, type: i18n.phonenumbers.PhoneNumber.CountryCodeSource },
                7: { name: "preferred_domestic_carrier_code", fieldType: goog.proto2.Message.FieldType.STRING, type: String }
              })), e;
            }, i18n.phonenumbers.PhoneNumber.ctor = i18n.phonenumbers.PhoneNumber, i18n.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n.phonenumbers.PhoneNumber.prototype.getDescriptor, i18n.phonenumbers.metadata = {}, i18n.phonenumbers.metadata.countryCodeToRegionCodeMap = {
              1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
              7: ["RU", "KZ"],
              20: ["EG"],
              27: ["ZA"],
              30: ["GR"],
              31: ["NL"],
              32: ["BE"],
              33: ["FR"],
              34: ["ES"],
              36: ["HU"],
              39: ["IT", "VA"],
              40: ["RO"],
              41: ["CH"],
              43: ["AT"],
              44: ["GB", "GG", "IM", "JE"],
              45: ["DK"],
              46: ["SE"],
              47: ["NO", "SJ"],
              48: ["PL"],
              49: ["DE"],
              51: ["PE"],
              52: ["MX"],
              53: ["CU"],
              54: ["AR"],
              55: ["BR"],
              56: ["CL"],
              57: ["CO"],
              58: ["VE"],
              60: ["MY"],
              61: ["AU", "CC", "CX"],
              62: ["ID"],
              63: ["PH"],
              64: ["NZ"],
              65: ["SG"],
              66: ["TH"],
              81: ["JP"],
              82: ["KR"],
              84: ["VN"],
              86: ["CN"],
              90: ["TR"],
              91: ["IN"],
              92: ["PK"],
              93: ["AF"],
              94: ["LK"],
              95: ["MM"],
              98: ["IR"],
              211: ["SS"],
              212: ["MA", "EH"],
              213: ["DZ"],
              216: ["TN"],
              218: ["LY"],
              220: ["GM"],
              221: ["SN"],
              222: ["MR"],
              223: ["ML"],
              224: ["GN"],
              225: ["CI"],
              226: ["BF"],
              227: ["NE"],
              228: ["TG"],
              229: ["BJ"],
              230: ["MU"],
              231: ["LR"],
              232: ["SL"],
              233: ["GH"],
              234: ["NG"],
              235: ["TD"],
              236: ["CF"],
              237: ["CM"],
              238: ["CV"],
              239: ["ST"],
              240: ["GQ"],
              241: ["GA"],
              242: ["CG"],
              243: ["CD"],
              244: ["AO"],
              245: ["GW"],
              246: ["IO"],
              247: ["AC"],
              248: ["SC"],
              249: ["SD"],
              250: ["RW"],
              251: ["ET"],
              252: ["SO"],
              253: ["DJ"],
              254: ["KE"],
              255: ["TZ"],
              256: ["UG"],
              257: ["BI"],
              258: ["MZ"],
              260: ["ZM"],
              261: ["MG"],
              262: ["RE", "YT"],
              263: ["ZW"],
              264: ["NA"],
              265: ["MW"],
              266: ["LS"],
              267: ["BW"],
              268: ["SZ"],
              269: ["KM"],
              290: ["SH", "TA"],
              291: ["ER"],
              297: ["AW"],
              298: ["FO"],
              299: ["GL"],
              350: ["GI"],
              351: ["PT"],
              352: ["LU"],
              353: ["IE"],
              354: ["IS"],
              355: ["AL"],
              356: ["MT"],
              357: ["CY"],
              358: ["FI", "AX"],
              359: ["BG"],
              370: ["LT"],
              371: ["LV"],
              372: ["EE"],
              373: ["MD"],
              374: ["AM"],
              375: ["BY"],
              376: ["AD"],
              377: ["MC"],
              378: ["SM"],
              380: ["UA"],
              381: ["RS"],
              382: ["ME"],
              383: ["XK"],
              385: ["HR"],
              386: ["SI"],
              387: ["BA"],
              389: ["MK"],
              420: ["CZ"],
              421: ["SK"],
              423: ["LI"],
              500: ["FK"],
              501: ["BZ"],
              502: ["GT"],
              503: ["SV"],
              504: ["HN"],
              505: ["NI"],
              506: ["CR"],
              507: ["PA"],
              508: ["PM"],
              509: ["HT"],
              590: ["GP", "BL", "MF"],
              591: ["BO"],
              592: ["GY"],
              593: ["EC"],
              594: ["GF"],
              595: ["PY"],
              596: ["MQ"],
              597: ["SR"],
              598: ["UY"],
              599: ["CW", "BQ"],
              670: ["TL"],
              672: ["NF"],
              673: ["BN"],
              674: ["NR"],
              675: ["PG"],
              676: ["TO"],
              677: ["SB"],
              678: ["VU"],
              679: ["FJ"],
              680: ["PW"],
              681: ["WF"],
              682: ["CK"],
              683: ["NU"],
              685: ["WS"],
              686: ["KI"],
              687: ["NC"],
              688: ["TV"],
              689: ["PF"],
              690: ["TK"],
              691: ["FM"],
              692: ["MH"],
              800: ["001"],
              808: ["001"],
              850: ["KP"],
              852: ["HK"],
              853: ["MO"],
              855: ["KH"],
              856: ["LA"],
              870: ["001"],
              878: ["001"],
              880: ["BD"],
              881: ["001"],
              882: ["001"],
              883: ["001"],
              886: ["TW"],
              888: ["001"],
              960: ["MV"],
              961: ["LB"],
              962: ["JO"],
              963: ["SY"],
              964: ["IQ"],
              965: ["KW"],
              966: ["SA"],
              967: ["YE"],
              968: ["OM"],
              970: ["PS"],
              971: ["AE"],
              972: ["IL"],
              973: ["BH"],
              974: ["QA"],
              975: ["BT"],
              976: ["MN"],
              977: ["NP"],
              979: ["001"],
              992: ["TJ"],
              993: ["TM"],
              994: ["AZ"],
              995: ["GE"],
              996: ["KG"],
              998: ["UZ"]
            }, i18n.phonenumbers.metadata.countryToMetadata = {
              AC: [, [, , "(?:[01589]\\d|[46])\\d{4}", , , , , , , [5, 6]], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:0[1-9]|[1589]\\d)\\d{4}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]],
              AD: [, [, , "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", , , , , , , [6, 8, 9]], [, , "[78]\\d{5}", , , , "712345", , , [6]], [
                ,
                ,
                "690\\d{6}|[356]\\d{5}",
                ,
                ,
                ,
                "312345",
                ,
                ,
                [6, 9]
              ], [, , "180[02]\\d{4}", , , , "18001234", , , [8]], [, , "[19]\\d{5}", , , , "912345", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AD", 376, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], , [, , , , , , , , , [-1]], , , [, , "1800\\d{4}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AE: [
                ,
                [, , "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
                [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]],
                [, , "5[02-68]\\d{7}", , , , "501234567", , , [9]],
                [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"],
                [, , "900[02]\\d{5}", , , , "900234567", , , [9]],
                [, , "700[05]\\d{5}", , , , "700012345", , , [9]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "AE",
                971,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [
                  ,
                  ,
                  "600[25]\\d{5}",
                  ,
                  ,
                  ,
                  "600212345",
                  ,
                  ,
                  [9]
                ],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              AF: [, [, , "[2-7]\\d{8}", , , , , , , [9], [7]], [, , "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}", , , , "234567890", , , , [7]], [, , "7\\d{8}", , , , "701234567", , , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AG: [, [, , "(?:268|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}", , , , "2684601234", , , , [7]], [, , "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}", , , , "2684641234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]], "AG", 1, "011", "1", , , "([457]\\d{6})$|1", "268$1", , , , , [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]], , "268", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AI: [, [, , "(?:264|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "264(?:292|4(?:6[12]|9[78]))\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "([2457]\\d{6})$|1", "264$1", , , , , [, , "264724\\d{4}", , , , "2647241234", , , , [7]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AL: [, [
                ,
                ,
                "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6, 7, 8, 9],
                [5]
              ], [, , "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[78][2-9]|9\\d)\\d{6}", , , , "672123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "900[1-9]\\d\\d", , , , "900123", , , [6]], [, , "808[1-9]\\d\\d", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [
                ,
                "(\\d)(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["4[2-6]"],
                "0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AM: [
                ,
                [, , "(?:[1-489]\\d|55|60|77)\\d{6}", , , , , , , [8], [5, 6]],
                [, , "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}", , , , "10123456", , , , [5, 6]],
                [, , "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}", , , , "77123456"],
                [, , "800\\d{5}", , , , "80012345"],
                [, , "90[016]\\d{5}", , , , "90012345"],
                [, , "80[1-4]\\d{5}", , , , "80112345"],
                [, , , , , , , , , [-1]],
                [, , "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}", , , , "60271234"],
                "AM",
                374,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              AO: [, [, , "[29]\\d{8}", , , , , , , [9]], [
                ,
                ,
                "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
                ,
                ,
                ,
                "222123456"
              ], [, , "9[1-79]\\d{7}", , , , "923123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AO", 244, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AR: [
                ,
                [, , "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", , , , , , , [10, 11], [6, 7, 8]],
                [
                  ,
                  ,
                  "3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                  ,
                  ,
                  ,
                  "1123456789",
                  ,
                  ,
                  [10],
                  [6, 7, 8]
                ],
                [
                  ,
                  ,
                  "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                  ,
                  ,
                  ,
                  "91123456789",
                  ,
                  ,
                  ,
                  [6, 7, 8]
                ],
                [, , "800\\d{7,8}", , , , "8001234567"],
                [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "AR",
                54,
                "00",
                "0",
                ,
                ,
                "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
                "9$1",
                ,
                ,
                [[, "(\\d{3})", "$1", ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[1-9]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[1-8]"]], [
                  ,
                  "(\\d{4})(\\d{2})(\\d{4})",
                  "$1 $2-$3",
                  [
                    "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                    "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                    "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                    "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                  ],
                  "0$1",
                  ,
                  1
                ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [
                  ,
                  "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                  "$2 15-$3-$4",
                  [
                    "9(?:2[2-469]|3[3-578])",
                    "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                    "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                  ],
                  "0$1"
                ], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]],
                [
                  [
                    ,
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                      "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                      "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                      "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                      "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    ,
                    1
                  ],
                  [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
                  [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
                  [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1],
                  [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", [
                    "9(?:2[2-469]|3[3-578])",
                    "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                    "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                  ]],
                  [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]],
                  [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"],
                  [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9"]]
                ],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , "810\\d{7}", , , , , , , [10]],
                [, , "810\\d{7}", , , , "8101234567", , , [10]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              AS: [, [, , "(?:[58]\\d\\d|684|900)\\d{7}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}", , , , "6847331234", , , , [7]], [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "([267]\\d{6})$|1", "684$1", , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AT: [, [
                ,
                ,
                "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
                ,
                ,
                ,
                ,
                ,
                ,
                [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
                [3]
              ], [, , "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}", , , , "1234567890", , , , [3]], [
                ,
                ,
                "6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}",
                ,
                ,
                ,
                "664123456",
                ,
                ,
                [7, 8, 9, 10, 11, 12, 13]
              ], [, , "800\\d{6,10}", , , , "800123456", , , [9, 10, 11, 12, 13]], [, , "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10|2[018])\\d{6,10}|828\\d{5}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", , , , "780123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["14"]], [, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [
                ,
                "(\\d{2})(\\d{3,5})",
                "$1 $2",
                ["5[079]"],
                "0$1"
              ], [, "(\\d{6})", "$1", ["[18]"]], [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [
                ,
                "(\\d{2})(\\d{3,5})",
                "$1 $2",
                ["5[079]"],
                "0$1"
              ], [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AU: [, [
                ,
                ,
                "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5, 6, 7, 8, 9, 10, 12]
              ], [, , "(?:(?:241|349)0\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|91(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79]))))\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:55|6[0-8]|[78]\\d|9[02-9]))\\d{6}", , , , "212345678", , , [9], [8]], [
                ,
                ,
                "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [9]
              ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "AU", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "(183[12])|0", , "0011", , [[
                ,
                "(\\d{2})(\\d{3,4})",
                "$1 $2",
                ["16"],
                "0$1"
              ], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["130"]]], [[
                ,
                "(\\d{2})(\\d{3,4})",
                "$1 $2",
                ["16"],
                "0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], [, , "163\\d{2,6}", , , , "1631234", , , [5, 6, 7, 8, 9]], 1, , [, , "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}", , , , , , , [6, 7, 8, 10, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AW: [, [, , "(?:[25-79]\\d\\d|800)\\d{4}", , , , , , , [7]], [
                ,
                ,
                "5(?:2\\d|8[1-9])\\d{4}",
                ,
                ,
                ,
                "5212345"
              ], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:28\\d|501)\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AX: [, [, , "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", , , , , , , [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
              ]], [, , "18[1-8]\\d{3,6}", , , , "181234567", , , [6, 7, 8, 9]], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , "18", [, , , , , , , , , [-1]], [
                ,
                ,
                "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                ,
                ,
                ,
                "10112345"
              ], , , [, , , , , , , , , [-1]]],
              AZ: [, [, , "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", , , , , , , [9], [7]], [, , "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}", , , , "123123456", , , , [7]], [, , "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["90"],
                "0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [
                ,
                "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[13-9]"],
                "0$1"
              ]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BA: [
                ,
                [, , "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", , , , , , , [8, 9], [6]],
                [, , "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", , , , "30212345", , , [8], [6]],
                [, , "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}", , , , "61123456"],
                [, , "8[08]\\d{6}", , , , "80123456", , , [8]],
                [, , "9[0246]\\d{6}", , , , "90123456", , , [8]],
                [, , "8[12]\\d{6}", , , , "82123456", , , [8]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "BA",
                387,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
                [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              BB: [, [, , "(?:246|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}", , , , "2462501234", , , , [7]], [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ], [, , "(?:246976|900[2-9]\\d\\d)\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "([2-9]\\d{6})$|1", "246$1", , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [
                ,
                ,
                "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
                ,
                ,
                ,
                "2464301234",
                ,
                ,
                ,
                [7]
              ], , , [, , , , , , , , , [-1]]],
              BD: [, [, , "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [
                ,
                ,
                "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
                ,
                ,
                ,
                "27111234"
              ], [, , "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], [
                ,
                "(\\d{3})(\\d{3,7})",
                "$1-$2",
                ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
                "0$1"
              ], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BE: [, [, , "4\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9]], [, , "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", , , , "12345678", , , [8]], [, , "4[5-9]\\d{7}", , , , "470123456", , , [9]], [, , "800[1-9]\\d{4}", , , , "80012345", , , [8]], [, , "(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}", , , , "90012345", , , [8]], [
                ,
                ,
                "7879\\d{4}",
                ,
                ,
                ,
                "78791234",
                ,
                ,
                [8]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}", , , , "78102345", , , [8]], , , [, , , , , , , , , [-1]]],
              BF: [, [
                ,
                ,
                "(?:[025-7]\\d|44)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ], [, , "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:0[1-7]|44|5[0-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BG: [, [
                ,
                ,
                "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6, 7, 8, 9, 12],
                [4, 5]
              ], [, , "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", , , , "2123456", , , [6, 7, 8], [4, 5]], [, , "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", , , , "43012345", , , [8, 9]], [, , "(?:00800\\d\\d|800)\\d{5}", , , , "80012345", , , [8, 12]], [, , "90\\d{6}", , , , "90123456", , , [8]], [, , "700\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BG", 359, "00", "0", , , "0", , , , [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["43[1-6]|70[1-9]"],
                "0$1"
              ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["43[1-6]|70[1-9]"],
                "0$1"
              ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BH: [
                ,
                [
                  ,
                  ,
                  "[136-9]\\d{7}",
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  [8]
                ],
                [, , "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}", , , , "17001234"],
                [, , "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}", , , , "36001234"],
                [, , "8[02369]\\d{6}", , , , "80123456"],
                [, , "(?:87|9[0-8])\\d{6}", , , , "90123456"],
                [, , "84\\d{6}", , , , "84123456"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "BH",
                973,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              BI: [, [, , "(?:[267]\\d|31)\\d{6}", , , , , , , [8]], [, , "(?:22|31)\\d{6}", , , , "22201234"], [, , "(?:29|6[124-9]|7[125-9])\\d{6}", , , , "79561234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BJ: [, [, , "(?:01\\d|8)\\d{7}", , , , , , , [8, 10]], [, , "012\\d{7}", , , , "0120211234", , , [10]], [
                ,
                ,
                "01(?:2[5-9]|[4-69]\\d)\\d{6}",
                ,
                ,
                ,
                "0195123456",
                ,
                ,
                [10]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "857[58]\\d{4}", , , , "85751234", , , [8]], "BJ", 229, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "81\\d{6}", , , , "81123456", , , [8]], , , [, , , , , , , , , [-1]]],
              BL: [, [, , "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [
                ,
                ,
                "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}",
                ,
                ,
                ,
                "590271234"
              ], [, , "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}", , , , "976012345"], "BL", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BM: [
                ,
                [, , "(?:441|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
                [
                  ,
                  ,
                  "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",
                  ,
                  ,
                  ,
                  "4414123456",
                  ,
                  ,
                  ,
                  [7]
                ],
                [, , "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}", , , , "4413701234", , , , [7]],
                [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
                [, , "900[2-9]\\d{6}", , , , "9002123456"],
                [, , , , , , , , , [-1]],
                [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
                [, , , , , , , , , [-1]],
                "BM",
                1,
                "011",
                "1",
                ,
                ,
                "([2-9]\\d{6})$|1",
                "441$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "441",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              BN: [, [, , "[2-578]\\d{6}", , , , , , , [7]], [, , "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}", , , , "2345678"], [, , "(?:22[89]|[78]\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[34]\\d{5}", , , , "5345678"], "BN", 673, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BO: [, [
                ,
                ,
                "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9],
                [7]
              ], [, , "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , [8], [7]], [, , "[67]\\d{7}", , , , "71234567", , , [8]], [, , "8001[07]\\d{4}", , , , "800171234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "50\\d{6}", , , , "50123456", , , [8], [7]], "BO", 591, "00(?:1\\d)?", "0", , , "0(1\\d)?", , , , [[
                ,
                "(\\d)(\\d{7})",
                "$1 $2",
                ["[235]|4[46]"],
                ,
                "0$CC $1"
              ], [, "(\\d{8})", "$1", ["[67]"], , "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], , "0$CC $1"]], , [, , , , , , , , , [-1]], , , [, , "8001[07]\\d{4}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BQ: [
                ,
                [, , "(?:[34]1|7\\d)\\d{5}", , , , , , , [7]],
                [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}", , , , "7151234"],
                [, , "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "BQ",
                599,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "[347]",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              BR: [, [, , "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", , , , "11961234567", , , [10, 11], [8, 9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "[59]00\\d{6,7}", , , , "500123456", , , [9, 10]], [
                ,
                ,
                "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370|864))\\d{4}|300\\d{5}",
                ,
                ,
                ,
                "40041234",
                ,
                ,
                [8, 10]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [[, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]], [
                ,
                "(\\d{3})(\\d{2,3})(\\d{4})",
                "$1 $2 $3",
                ["(?:[358]|90)0"],
                "0$1"
              ], [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], [
                ,
                "(\\d{2})(\\d{4})(\\d{4})",
                "$1 $2-$3",
                ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],
                "($1)",
                "0 $CC ($1)"
              ], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|864))\\d{4}|800\\d{6,7}|300\\d{5}", , , , , , , [8, 9, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BS: [
                ,
                [, , "(?:242|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
                [, , "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}", , , , "2423456789", , , , [7]],
                [
                  ,
                  ,
                  "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}",
                  ,
                  ,
                  ,
                  "2423591234",
                  ,
                  ,
                  ,
                  [7]
                ],
                [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]],
                [, , "900[2-9]\\d{6}", , , , "9002123456"],
                [, , , , , , , , , [-1]],
                [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
                [, , , , , , , , , [-1]],
                "BS",
                1,
                "011",
                "1",
                ,
                ,
                "([3-8]\\d{6})$|1",
                "242$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "242",
                [, , , , , , , , , [-1]],
                [, , "242225\\d{4}", , , , "2422250123"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              BT: [, [, , "[178]\\d{7}|[2-8]\\d{6}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|[78]7)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], [
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["1[67]|[78]"]
              ]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|[78]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BW: [, [, , "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [, , "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", , , , "2401234", , , [7]], [
                ,
                ,
                "(?:321|7[1-8]\\d)\\d{5}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [8]
              ], [, , "(?:0800|800\\d)\\d{6}", , , , "0800012345", , , [10]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79(?:1(?:[0-2]\\d|3[0-8])|2[0-7]\\d)\\d{3}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              BY: [, [, , "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , "152450911", , , [9], [5, 6, 7]], [, , "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", , , , "294911911", , , [9]], [
                ,
                ,
                "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",
                ,
                ,
                ,
                "8011234567"
              ], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "0|80?", , "8~10", , [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [, "(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2-$3-$4",
                ["1(?:[56]|7[467])|2[1-3]"],
                "8 0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BZ: [, [, , "(?:0800\\d|[2-8])\\d{6}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", , , , "2221234", , , [7]], [, , "6[0-35-7]\\d{5}", , , , "6221234", , , [7]], [
                ,
                ,
                "0800\\d{7}",
                ,
                ,
                ,
                "08001234123",
                ,
                ,
                [11]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CA: [, [, , "[2-9]\\d{9}|3\\d{6}", , , , , , , [7, 10]], [
                ,
                ,
                "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                ,
                ,
                ,
                "5062345678",
                ,
                ,
                [10],
                [7]
              ], [, , "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", , , , "5062345678", , , [10], [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , [10]], [, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|3[23]|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                ,
                ,
                ,
                "5219023456",
                ,
                ,
                [10]
              ], [, , "600[2-9]\\d{6}", , , , "6002012345", , , [10]], "CA", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "310\\d{4}", , , , "3101234", , , [7]], , , [, , , , , , , , , [-1]]],
              CC: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [
                ,
                ,
                "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [9]
              ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CD: [, [
                ,
                ,
                "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8, 9, 10]
              ], [, , "(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}", , , , "1234567"], [, , "88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", , , , "991234567", , , [7, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[89]"],
                "0$1"
              ], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CF: [, [, , "(?:[27]\\d{3}|8776)\\d{4}", , , , , , , [8]], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[02-7]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CG: [, [, , "222\\d{6}|(?:0\\d|80)\\d{7}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [, , "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}", , , , "061234567"], [, , , , , , , , , [-1]], [, , "80[0-2]\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CH: [, [
                ,
                ,
                "8\\d{11}|[2-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 12]
              ], [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]], [, , "(?:6[89]|7[235-9])\\d{7}", , , , "781234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[016]\\d{6}", , , , "900123456", , , [9]], [, , "84[0248]\\d{6}", , , , "840123456", , , [9]], [, , "878\\d{6}", , , , "878123456", , , [9]], [, , , , , , , , , [-1]], "CH", 41, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [
                ,
                "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4 $5",
                ["8"],
                "0$1"
              ]], , [, , "74[0248]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "5[18]\\d{7}", , , , "581234567", , , [9]], , , [, , "860\\d{9}", , , , "860123456789", , , [12]]],
              CI: [, [, , "[02]\\d{9}", , , , , , , [10]], [, , "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}", , , , "2123456789"], [, , "0[157]\\d{8}", , , , "0123456789"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[
                ,
                "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                "$1 $2 $3 $4",
                ["2"]
              ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CK: [, [, , "[2-578]\\d{4}", , , , , , , [5]], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[578]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CL: [, [
                ,
                ,
                "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 10, 11]
              ], [, , "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:(?:2\\d|50)\\d|3(?:[034679]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389])|600)|646[59])|(?:600|80[1-9])\\d\\d|9(?:(?:10[0-2]|7[1-9]\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", , , , "600123456", , , [9]], [
                ,
                ,
                "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:(?:2\\d|50)\\d|3(?:[034679]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389])|600)|646[59])|80[1-8]\\d\\d|9(?:(?:10[0-2]|7[1-9]\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                ,
                ,
                ,
                "221234567",
                ,
                ,
                [9]
              ], [, , "(?:123|8)00\\d{6}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [, , "600\\d{7,8}", , , , "6001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , , [[, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [
                ,
                "(\\d)(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["2[1-36]"],
                "($1)"
              ], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [[, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [
                ,
                "(\\d)(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["2[1-36]"],
                "($1)"
              ], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CM: [, [, , "[26]\\d{8}|88\\d{6,7}", , , , , , , [8, 9]], [
                ,
                ,
                "2(?:22|33)\\d{6}",
                ,
                ,
                ,
                "222123456",
                ,
                ,
                [9]
              ], [, , "(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", , , , "671234567", , , [9]], [, , "88\\d{6,7}", , , , "88012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CN: [, [
                ,
                ,
                "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8, 9, 10, 11, 12],
                [5, 6]
              ], [
                ,
                ,
                "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
                ,
                ,
                ,
                "1012345678",
                ,
                ,
                [7, 8, 9, 10, 11],
                [5, 6]
              ], [, , "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:(?:10|21)8|8)00\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [
                ,
                ,
                "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
                ,
                ,
                ,
                "4001234567",
                ,
                ,
                [7, 8, 9, 10, 11],
                [5, 6]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "00|1(?:[12]\\d|79)\\d\\d00", "0", , , "(1(?:[12]\\d|79)\\d\\d)|0", , "00", , [
                [, "(\\d{5,6})", "$1", ["1(?:00|2[13])|9[56]", "1(?:00|2(?:1|39))|9[56]", "1(?:00|2(?:1|395))|9[56]"]],
                [, "(\\d{5,6})", "$1", ["1(?:0|23)|781|[1-9]12", "1(?:0|23)|7812|[1-9]123", "1(?:0|23(?:[0-8]|9[0-46-9]))|78123|[1-9]123"]],
                [
                  ,
                  "(\\d{2})(\\d{5,6})",
                  "$1 $2",
                  [
                    "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                    "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                  ],
                  "0$1",
                  "$CC $1"
                ],
                [, "(\\d{3})(\\d{4})", "$1 $2", [
                  "[1-9]",
                  "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
                  "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|[3-9]",
                  "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))",
                  "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:0(?:[0-689]|7[0-79])|1[01459]|2[0-489]|[46]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))"
                ]],
                [, "(\\d{4})(\\d{4})", "$1 $2", ["16[08]"]],
                [
                  ,
                  "(\\d{3})(\\d{5,6})",
                  "$1 $2",
                  [
                    "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                    "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                    "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                    "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                  ],
                  "0$1",
                  "$CC $1"
                ],
                [, "(\\d{4})(\\d{4})", "$1 $2", [
                  "[1-9]",
                  "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
                  "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
                  "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
                ]],
                [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
                [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1],
                [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
                [
                  ,
                  "(\\d{3})(\\d{7,8})",
                  "$1 $2",
                  ["9"]
                ],
                [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
                [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
                [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
                [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
              ], [[
                ,
                "(\\d{2})(\\d{5,6})",
                "$1 $2",
                [
                  "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                  "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                  "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                  "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                  "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                ],
                "0$1",
                "$CC $1"
              ], [
                ,
                "(\\d{3})(\\d{5,6})",
                "$1 $2",
                [
                  "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                  "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                  "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                  "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                ],
                "0$1",
                "$CC $1"
              ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1], [
                ,
                "(\\d{3})(\\d{7,8})",
                "$1 $2",
                ["9"]
              ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}", , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CO: [, [, , "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", , , , , , , [8, 10, 11], [4, 7]], [
                ,
                ,
                "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[18][1-9]|[24-7][2-9]))\\d{6}",
                ,
                ,
                ,
                "6012345678",
                ,
                ,
                [8, 10],
                [4, 7]
              ], [, , "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:(?:0[0-5]|1\\d|5[01]|70)\\d|2(?:[0-3]\\d|4[1-9])|3(?:00|3[0-24-9]))|9(?:101|408))\\d{6}", , , , "3211234567", , , [10]], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "(?:19(?:0[01]|4[78])|901)\\d{7}", , , , "19001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0([3579]|4(?:[14]4|56))?", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["46"]], [
                ,
                "(\\d{3})(\\d{7})",
                "$1 $2",
                ["6|90"],
                "($1)",
                "0$CC $1"
              ], [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1"]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["46"]], [, "(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CR: [, [, , "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", , , , , , , [8, 10]], [
                ,
                ,
                "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [8]
              ], [, , "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", , , , "83123456", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:210[0-6]|4\\d{3}|5100)\\d{4}", , , , "40001234", , , [8]], "CR", 506, "00", , , , "(19(?:0[0-2468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              CU: [, [, , "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", , , , , , , [6, 7, 8, 10], [4, 5]], [, , "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}", , , , "71234567", , , , [4, 5]], [, , "(?:5\\d|6[2-4])\\d{6}", , , , "51234567", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , "807\\d{7}", , , , "8071234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [
                ,
                "(\\d)(\\d{6,7})",
                "$1 $2",
                ["7"],
                "(0$1)"
              ], [, "(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CV: [, [, , "(?:[2-59]\\d\\d|800)\\d{4}", , , , , , , [7]], [, , "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}", , , , "2211234"], [, , "(?:36|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , "800\\d{4}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[3-5]|4[356])\\d{5}", , , , "3401234"], "CV", 238, "0", , , , , , , , [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3",
                ["[2-589]"]
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CW: [, [, , "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", , , , , , , [7, 8]], [, , "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}", , , , "94351234"], [, , "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}", , , , "95181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[3467]"]
              ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], , [, , "955\\d{5}", , , , "95581234", , , [8]], 1, "[69]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CX: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", , , , "891641234", , , [9], [8]], [
                ,
                ,
                "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [9]
              ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CX", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CY: [, [
                ,
                ,
                "(?:[279]\\d|[58]0)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ], [, , "2[2-6]\\d{6}", , , , "22345678"], [, , "9(?:10|[4-79]\\d)\\d{5}", , , , "96123456"], [, , "800\\d{5}", , , , "80001234"], [, , "90[09]\\d{5}", , , , "90012345"], [, , "80[1-9]\\d{5}", , , , "80112345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "CY", 357, "00", , , , , , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:50|77)\\d{6}", , , , "77123456"], , , [, , , , , , , , , [-1]]],
              CZ: [, [, , "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]], [
                ,
                ,
                "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [9]
              ], [, , "7(?:060\\d|19(?:[0-5]\\d|6[0-6]))\\d{4}|(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]], [, , "8[134]\\d{7}", , , , "811234567", , , [9]], [, , "70[01]\\d{6}", , , , "700123456", , , [9]], [, , "9[17]0\\d{6}", , , , "910123456", , , [9]], "CZ", 420, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], [
                ,
                "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3 $4",
                ["9"]
              ], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "9(?:5\\d|7[2-4])\\d{6}", , , , "972123456", , , [9]], , , [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]],
              DE: [, [, , "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [2, 3]], [
                ,
                ,
                "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
                ,
                ,
                ,
                "30123456",
                ,
                ,
                [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                [2, 3, 4]
              ], [, , "1(?:(?:5(?:[0-25-9]\\d\\d|3(?:10|33))|7[26-9]\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", , , , "9001234567", , , [10, 11]], [, , "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, "00", "0", , , "0", , , , [
                [
                  ,
                  "(\\d{2})(\\d{3,13})",
                  "$1 $2",
                  ["3[02]|40|[68]9"],
                  "0$1"
                ],
                [, "(\\d{6})", "$1", ["227", "2277"]],
                [, "(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"],
                [
                  ,
                  "(\\d{4})(\\d{2,11})",
                  "$1 $2",
                  ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
                  "0$1"
                ],
                [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
                [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
                [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
                [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
                [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
                [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
                [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
                [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
                [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
                [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
                [, "(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"],
                [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
                [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
                [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
                [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
              ], [
                [, "(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"],
                [
                  ,
                  "(\\d{3})(\\d{3,12})",
                  "$1 $2",
                  ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{2,11})",
                  "$1 $2",
                  ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
                  "0$1"
                ],
                [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
                [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
                [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
                [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
                [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
                [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
                [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
                [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
                [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
                [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
                [, "(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"],
                [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
                [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
                [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
                [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
              ], [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [
                ,
                ,
                "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
                ,
                ,
                ,
                "177991234567",
                ,
                ,
                [12, 13]
              ]],
              DJ: [, [, , "(?:2\\d|77)\\d{6}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              DK: [, [, , "[2-9]\\d{7}", , , , , , , [8]], [
                ,
                ,
                "(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}",
                ,
                ,
                ,
                "32123456"
              ], [, , "(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}", , , , "34412345"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              DM: [
                ,
                [, , "(?:[58]\\d\\d|767|900)\\d{7}", , , , , , , [10], [7]],
                [
                  ,
                  ,
                  "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",
                  ,
                  ,
                  ,
                  "7674201234",
                  ,
                  ,
                  ,
                  [7]
                ],
                [, , "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}", , , , "7672251234", , , , [7]],
                [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
                [, , "900[2-9]\\d{6}", , , , "9002123456"],
                [, , , , , , , , , [-1]],
                [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
                [, , , , , , , , , [-1]],
                "DM",
                1,
                "011",
                "1",
                ,
                ,
                "([2-7]\\d{6})$|1",
                "767$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "767",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              DO: [
                ,
                [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
                [
                  ,
                  ,
                  "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",
                  ,
                  ,
                  ,
                  "8092345678",
                  ,
                  ,
                  ,
                  [7]
                ],
                [, , "8[024]9[2-9]\\d{6}", , , , "8092345678", , , , [7]],
                [, , "800(?:14|[2-9]\\d)\\d{5}|8[024]9[01]\\d{6}|8(?:33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
                [, , "900[2-9]\\d{6}", , , , "9002123456"],
                [, , , , , , , , , [-1]],
                [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
                [, , , , , , , , , [-1]],
                "DO",
                1,
                "011",
                "1",
                ,
                ,
                "1",
                ,
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "8001|8[024]9",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              DZ: [
                ,
                [, , "(?:[1-4]|[5-79]\\d|80)\\d{7}", , , , , , , [8, 9]],
                [, , "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}", , , , "12345678"],
                [, , "(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", , , , "551234567", , , [9]],
                [, , "800\\d{6}", , , , "800123456", , , [9]],
                [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]],
                [, , "80[12]1\\d{5}", , , , "801123456", , , [9]],
                [, , , , , , , , , [-1]],
                [, , "98[23]\\d{6}", , , , "983123456", , , [9]],
                "DZ",
                213,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              EC: [, [, , "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", , , , , , , [8, 9, 10, 11], [7]], [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]], [, , "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", , , , "991234567", , , [9]], [
                ,
                ,
                "1800\\d{7}|1[78]00\\d{6}",
                ,
                ,
                ,
                "18001234567",
                ,
                ,
                [10, 11]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]], "EC", 593, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              EE: [, [, , "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [, , "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", , , , "3212345", , , [7]], [
                ,
                ,
                "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|[2-79]\\d\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[013-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                ,
                ,
                ,
                "51234567",
                ,
                ,
                [7, 8]
              ], [, , "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}", , , , "80012345"], [, , "(?:40\\d\\d|900)\\d{4}", , , , "9001234", , , [7, 8]], [, , , , , , , , , [-1]], [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], "EE", 372, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], [
                ,
                "(\\d{2})(\\d{2})(\\d{4})",
                "$1 $2 $3",
                ["7"]
              ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , "800[2-9]\\d{3}", , , , , , , [7]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              EG: [
                ,
                [, , "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", , , , , , , [8, 9, 10], [6, 7]],
                [, , "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", , , , "234567890", , , [8, 9], [6, 7]],
                [, , "1[0-25]\\d{8}", , , , "1001234567", , , [10]],
                [, , "800\\d{7}", , , , "8001234567", , , [10]],
                [, , "900\\d{7}", , , , "9001234567", , , [10]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "EG",
                20,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              EH: [
                ,
                [, , "[5-8]\\d{8}", , , , , , , [9]],
                [, , "528[89]\\d{5}", , , , "528812345"],
                [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}", , , , "650123456"],
                [, , "80[0-7]\\d{6}", , , , "801234567"],
                [, , "89\\d{7}", , , , "891234567"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}", , , , "592401234"],
                "EH",
                212,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "528[89]",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              ER: [, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", , , , "8370362", , , , [6]], [, , "(?:17[1-3]|7\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[
                ,
                "(\\d)(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[178]"],
                "0$1"
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              ES: [
                ,
                [, , "[5-9]\\d{8}", , , , , , , [9]],
                [, , "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}", , , , "810123456"],
                [, , "96906(?:09|10)\\d\\d|(?:590(?:10[0-2]|600)|97390\\d)\\d{3}|(?:6\\d|7[1-48])\\d{7}", , , , "612345678"],
                [, , "[89]00\\d{6}", , , , "800123456"],
                [, , "80[367]\\d{6}", , , , "803123456"],
                [, , "90[12]\\d{6}", , , , "901123456"],
                [, , "70\\d{7}", , , , "701234567"],
                [, , , , , , , , , [-1]],
                "ES",
                34,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]],
                [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "51\\d{7}", , , , "511234567"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              ET: [, [
                ,
                ,
                "(?:11|[2-579]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [7]
              ], [
                ,
                ,
                "(?:11(?:[124]\\d\\d|3(?:[0-79]\\d|8[0-7])|5(?:[02-9]\\d|1[0-57-9])|6(?:[02-79]\\d|1[0-57-9]|8[0-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
                ,
                ,
                ,
                "111112345",
                ,
                ,
                ,
                [7]
              ], [, , "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|2[1-35-79]|3\\d|77|86|99)|9\\d\\d)\\d{6}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              FI: [
                ,
                [, , "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
                [
                  ,
                  ,
                  "1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
                  ,
                  ,
                  ,
                  "131234567",
                  ,
                  ,
                  [5, 6, 7, 8, 9]
                ],
                [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]],
                [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]],
                [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "FI",
                358,
                "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
                "0",
                ,
                ,
                "0",
                ,
                "00",
                ,
                [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], [, "(\\d{5})", "$1", ["20[2-59]"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{4,8})",
                  "$1 $2",
                  ["[14]|2[09]|50|7[135]"],
                  "0$1"
                ], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]],
                [[, "(\\d{5})", "$1", ["20[2-59]"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]],
                [, , , , , , , , , [-1]],
                1,
                "1[03-79]|[2-9]",
                [, , "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"],
                [, , "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}", , , , "10112345"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              FJ: [
                ,
                [, , "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", , , , , , , [7, 11]],
                [, , "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]],
                [, , "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", , , , "7012345", , , [7]],
                [, , "0800\\d{7}", , , , "08001234567", , , [11]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "FJ",
                679,
                "0(?:0|52)",
                ,
                ,
                ,
                ,
                ,
                "00",
                ,
                [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              FK: [, [, , "[2-7]\\d{4}", , , , , , , [5]], [, , "[2-47]\\d{4}", , , , "31234"], [, , "[56]\\d{4}", , , , "51234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FK", 500, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              FM: [, [, , "(?:[39]\\d\\d|820)\\d{4}", , , , , , , [7]], [
                ,
                ,
                "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
                ,
                ,
                ,
                "3201234"
              ], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              FO: [, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[34]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d|9[16])\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [
                ,
                ,
                "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
                ,
                ,
                ,
                "901123"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", ["[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              FR: [, [, , "[1-9]\\d{8}", , , , , , , [9]], [, , "(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}", , , , "123456789"], [, , "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [
                ,
                ,
                "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
                ,
                ,
                ,
                "891123456"
              ], [, , "8(?:1[01]|2[0156]|4[024]|84)\\d{6}", , , , "884012345"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["10"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]],
              GA: [, [, , "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", , , , , , , [7, 8]], [, , "[01]1\\d{6}", , , , "01441234", , , [8]], [, , "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}", , , , "06031234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["0"]
              ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GB: [, [, , "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", , , , , , , [7, 9, 10], [4, 5, 6, 8]], [
                ,
                ,
                "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                ,
                ,
                ,
                "1212345678",
                ,
                ,
                [9, 10],
                [4, 5, 6, 7, 8]
              ], [, , "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", , , , "7400123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [
                ,
                ,
                "56\\d{8}",
                ,
                ,
                ,
                "5612345678",
                ,
                ,
                [10]
              ], "GB", 44, "00", "0", " x", , "0|180020", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [
                ,
                "(\\d{2})(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"],
                "0$1"
              ], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
              GD: [, [, , "(?:473|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
                ,
                ,
                "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
                ,
                ,
                ,
                "4732691234",
                ,
                ,
                ,
                [7]
              ], [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], "GD", 1, "011", "1", , , "([2-9]\\d{6})$|1", "473$1", , , , , [, , , , , , , , , [-1]], , "473", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GE: [, [, , "(?:[3-57]\\d\\d|800)\\d{6}", , , , , , , [9], [6, 7]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6, 7]], [
                ,
                ,
                "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0(?:1[09]|70)|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|1[12]|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-6])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:(?:[0147-9]\\d|22)\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}",
                ,
                ,
                ,
                "555123456"
              ], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70[67]\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "70[67]\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GF: [, [
                ,
                ,
                "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ], [, , "594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}", , , , "594101234"], [, , "(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}", , , , "694201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}", , , , "976012345"], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              GG: [
                ,
                [, , "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", , , , , , , [7, 9, 10], [6]],
                [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]],
                [, , "7(?:(?:781|839)\\d|911[17])\\d{5}", , , , "7781123456", , , [10]],
                [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"],
                [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]],
                [, , , , , , , , , [-1]],
                [, , "70\\d{8}", , , , "7012345678", , , [10]],
                [, , "56\\d{8}", , , , "5612345678", , , [10]],
                "GG",
                44,
                "00",
                "0",
                ,
                ,
                "([25-9]\\d{5})$|0|180020",
                "1481$1",
                ,
                ,
                ,
                ,
                [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              GH: [, [, , "(?:[235]\\d{3}|800)\\d{5}", , , , , , , [8, 9], [7]], [, , "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", , , , "302345678", , , [9], [7]], [
                ,
                ,
                "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
                ,
                ,
                ,
                "231234567",
                ,
                ,
                [9]
              ], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|8[0-2]"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GI: [, [
                ,
                ,
                "(?:[25]\\d|60)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ], [, , "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}", , , , "20012345"], [, , "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GL: [, [, , "(?:19|[2-689]\\d|70)\\d{4}", , , , , , , [6]], [, , "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}", , , , "321000"], [
                ,
                ,
                "[245]\\d{5}",
                ,
                ,
                ,
                "221234"
              ], [, , "80\\d{4}", , , , "801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3[89]\\d{4}", , , , "381234"], "GL", 299, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GM: [, [, , "[2-9]\\d{6}", , , , , , , [7]], [, , "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8[0-589]\\d\\d)\\d{3}", , , , "5661234"], [
                ,
                ,
                "556\\d{4}|(?:[23679]\\d|4[015]|5[0-489]|8[67])\\d{5}",
                ,
                ,
                ,
                "3012345"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GM", 220, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GN: [, [, , "722\\d{6}|(?:3|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", , , , "30241234", , , [8]], [, , "6[0-356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "722\\d{6}",
                ,
                ,
                ,
                "722123456",
                ,
                ,
                [9]
              ], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GP: [
                ,
                [, , "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
                [, , "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}", , , , "590201234"],
                [, , "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}", , , , "690001234"],
                [, , "80[0-5]\\d{6}", , , , "800012345"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}", , , , "976012345"],
                "GP",
                590,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                1,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              GQ: [
                ,
                [, , "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", , , , , , , [9]],
                [, , "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}", , , , "333091234"],
                [, , "(?:222|55\\d)\\d{6}", , , , "222123456"],
                [, , "80\\d[1-9]\\d{5}", , , , "800123456"],
                [, , "90\\d[1-9]\\d{5}", , , , "900123456"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "GQ",
                240,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              GR: [, [, , "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", , , , , , , [10, 11, 12]], [
                ,
                ,
                "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
                ,
                ,
                ,
                "2123456789",
                ,
                ,
                [10]
              ], [, , "68[57-9]\\d{7}|(?:69|94)\\d{8}", , , , "6912345678", , , [10]], [, , "800\\d{7,9}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567", , , [10]], [, , "8(?:0[16]|12|[27]5|50)\\d{7}", , , , "8011234567", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], [
                ,
                "(\\d{3})(\\d{3,4})(\\d{5})",
                "$1 $2 $3",
                ["8"]
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5005000\\d{3}", , , , "5005000123", , , [10]], , , [, , , , , , , , , [-1]]],
              GT: [, [, , "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", , , , , , , [8, 11]], [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]], [, , "(?:[3-5]\\d\\d|80[0-4])\\d{5}", , , , "51234567", , , [8]], [, , "18[01]\\d{8}", , , , "18001112222", , , [11]], [, , "19\\d{9}", , , , "19001112222", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GT", 502, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], [
                ,
                "(\\d{4})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["1"]
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GU: [, [, , "(?:[58]\\d\\d|671|900)\\d{7}", , , , , , , [10], [7]], [, , "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [
                ,
                ,
                "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
                ,
                ,
                ,
                "6713001234",
                ,
                ,
                ,
                [7]
              ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "([2-9]\\d{6})$|1", "671$1", , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              GW: [, [, , "[49]\\d{8}|4\\d{6}", , , , , , , [7, 9]], [, , "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GY: [, [, , "(?:[2-8]\\d{3}|9008)\\d{3}", , , , , , , [7]], [
                ,
                ,
                "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
                ,
                ,
                ,
                "2201234"
              ], [, , "(?:51[01]|6\\d\\d|7(?:[0-5]\\d|6[0-59]|70))\\d{4}", , , , "6091234"], [, , "(?:289|8(?:00|6[28]|88|99))\\d{4}", , , , "2891234"], [, , "9008\\d{3}", , , , "9008123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "515\\d{4}", , , , "5151234"], "GY", 592, "001", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              HK: [, [, , "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", , , , , , , [5, 6, 7, 8, 9, 11]], [
                ,
                ,
                "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-5]))|58(?:0[1-9]|1[2-9]))\\d{4}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [8]
              ], [, , "(?:4(?:09[3-6]|44[0-35-9]|6(?:4[0-57-9]|6[0-6])|7(?:4[0-48]|6[0-5]))|5(?:25[3-7]|35[4-8]|73[0-6]|95[0-8])|6(?:26[013-8]|(?:66|78)[0-5])|70(?:7[1-8]|8[0-8])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-467]|899))\\d{4}|(?:4(?:4[0-35-9]|6[0-357-9]|7[0-35])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", , , , "51234567", , , [8]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
                ,
                ,
                "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
                ,
                ,
                ,
                "90012345678",
                ,
                ,
                [5, 6, 7, 8, 11]
              ], [, , , , , , , , , [-1]], [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", , , , "81123456", , , [8]], [, , , , , , , , , [-1]], "HK", 852, "00(?:30|5[09]|[126-9]?)", , , , , , "00", , [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], , [
                ,
                ,
                "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [8]
              ], , , [, , , , , , , , , [-1]], [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]], , , [, , , , , , , , , [-1]]],
              HN: [, [, , "8\\d{10}|[237-9]\\d{7}", , , , , , , [8, 11]], [
                ,
                ,
                "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [8]
              ], [, , "[37-9]\\d{7}", , , , "91234567", , , [8]], [, , "8002\\d{7}", , , , "80021234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [, , , , , , , , , [-1]], , , [, , "8002\\d{7}", , , , , , , [11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              HR: [, [, , "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", , , , , , , [7, 8, 9], [6]], [
                ,
                ,
                "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [8, 9],
                [6, 7]
              ], [, , "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}", , , , "921234567", , , [8, 9]], [, , "80\\d{5,7}", , , , "800123456"], [, , "6[01459]\\d{6}|6[01]\\d{5}", , , , "6001234", , , [7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], [
                ,
                "(\\d{2})(\\d{3})(\\d{3,4})",
                "$1 $2 $3",
                ["6|7[245]"],
                "0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "62\\d{6,7}|72\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]],
              HT: [, [, , "[2-589]\\d{7}", , , , , , , [8]], [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"], [, , "(?:[34]\\d|5[56])\\d{6}", , , , "34101234"], [, , "8\\d{7}", , , , "80012345"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}", , , , "98901234"], "HT", 509, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              HU: [, [, , "[235-7]\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6, 7]], [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]], [, , "(?:[48]0\\d|680[29])\\d{5}", , , , "80123456"], [
                ,
                ,
                "9[01]\\d{6}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [8]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "21\\d{7}", , , , "211234567", , , [9]], "HU", 36, "00", "06", , , "06", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], , [, , , , , , , , , [-1]], , , [, , "(?:[48]0\\d|680[29])\\d{5}"], [, , "38\\d{7}", , , , "381234567", , , [9]], , , [, , , , , , , , , [-1]]],
              ID: [, [
                ,
                ,
                "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
                [5, 6]
              ], [
                ,
                ,
                "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
                ,
                ,
                ,
                "218350123",
                ,
                ,
                [7, 8, 9, 10, 11],
                [5, 6]
              ], [, , "8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", , , , "8001234567", , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "00[89]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [
                ,
                "(\\d{3})(\\d{5,8})",
                "$1 $2",
                ["[2-79]"],
                "(0$1)"
              ], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3 $4", ["001"]], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [
                ,
                "(\\d{2})(\\d{5,9})",
                "$1 $2",
                ["2[124]|[36]1"],
                "(0$1)"
              ], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "001803\\d{5,11}|(?:007803\\d|8071)\\d{6}", , , , , , , [10, 11, 12, 13, 14, 15, 16, 17]], [
                ,
                ,
                "(?:1500|8071\\d{3})\\d{3}",
                ,
                ,
                ,
                "8071123456",
                ,
                ,
                [7, 10]
              ], , , [, , , , , , , , , [-1]]],
              IE: [, [, , "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", , , , , , , [7, 8, 9, 10], [5, 6]], [, , "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}", , , , "2212345", , , , [5, 6]], [, , "8(?:22|[35-9]\\d)\\d{6}", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [
                ,
                ,
                "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
                ,
                ,
                ,
                "1520123456",
                ,
                ,
                [10]
              ], [, , "18[59]0\\d{6}", , , , "1850123456", , , [10]], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["81"],
                "(0$1)"
              ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , , , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", , , , "8551234567", , , [10]]],
              IL: [, [, , "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", , , , , , , [
                7,
                8,
                9,
                10,
                11,
                12
              ]], [, , "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", , , , "21234567", , , [8, 11, 12], [7]], [, , "55(?:4(?:0[0-2]|[16]0)|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[3-5]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", , , , "502345678", , , [9]], [, , "1(?:255|80[019]\\d{3})\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", , , , "1919123456", , , [8, 10]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [
                ,
                ,
                "7(?:38(?:[05]\\d|8[0138])|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
                ,
                ,
                ,
                "771234567",
                ,
                ,
                [9]
              ], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "(\\d{4})(\\d{3})", "$1-$2", ["125"]], [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], , [, , , , , , , , , [-1]], , , [
                ,
                ,
                "1700\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10]
              ], [, , "1599\\d{6}", , , , "1599123456", , , [10]], , , [, , "151\\d{8,9}", , , , "15112340000", , , [11, 12]]],
              IM: [
                ,
                [, , "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]],
                [, , "1624(?:230|[5-8]\\d\\d)\\d{3}", , , , "1624756789", , , , [6]],
                [, , "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"],
                [, , "808162\\d{4}", , , , "8081624567"],
                [, , "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}", , , , "9016247890"],
                [, , , , , , , , , [-1]],
                [, , "70\\d{8}", , , , "7012345678"],
                [, , "56\\d{8}", , , , "5612345678"],
                "IM",
                44,
                "00",
                "0",
                ,
                ,
                "([25-8]\\d{5})$|0|180020",
                "1624$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "74576|(?:16|7[56])24",
                [, , , , , , , , , [-1]],
                [, , "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}", , , , "5512345678"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              IN: [, [, , "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [
                ,
                ,
                "(?:2717(?:[2-7]\\d|95)|6828[235-7]\\d)\\d{4}|(?:170[24]|280[13468]|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:271[0-689]|682[0-79]|782[0-6])[2-7]\\d{5}|(?:2(?:[02][2-79]|90)|3(?:23|80)|683|79[1-7])\\d{7}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[14-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
                ,
                ,
                ,
                "7410410123",
                ,
                ,
                [10],
                [6, 7, 8]
              ], [
                ,
                ,
                "(?:6(?:1279|828[01489])|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:160[01]|6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578])\\d|7(?:[235689]\\d|4[0189])|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
                ,
                ,
                ,
                "8123456789",
                ,
                ,
                [10]
              ], [, , "000800\\d{7}|180(?:0\\d{4,9}|3\\d{9})", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [
                ,
                "(\\d{3})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["140"],
                ,
                ,
                1
              ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [
                ,
                "(\\d{3})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                [
                  "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                  "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                  "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                ],
                "0$1",
                ,
                1
              ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689])\\d|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
              ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["16|[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", [
                "18[06]",
                "18[06]0"
              ], , , 1], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", [
                "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
              ], "0$1", , 1], [
                ,
                "(\\d{3})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                [
                  "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                  "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                  "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                ],
                "0$1",
                ,
                1
              ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689])\\d|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
              ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["16|[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", [
                "18[06]",
                "18[06]0"
              ], , , 1], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [, , , , , , , , , [-1]], , , [, , "1800\\d{4,9}|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]],
              IO: [
                ,
                [, , "3\\d{6}", , , , , , , [7]],
                [, , "37\\d{5}", , , , "3709100"],
                [, , "38\\d{5}", , , , "3801234"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "IO",
                246,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              IQ: [
                ,
                [, , "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]],
                [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]],
                [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "IQ",
                964,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              IR: [, [, , "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", , , , , , , [4, 5, 6, 7, 10], [8]], [, , "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", , , , "2123456789", , , [6, 7, 10], [4, 5, 8]], [
                ,
                ,
                "9(?:(?:0[0-5]|[13]\\d|2[0-3])\\d\\d|9(?:[0-46]\\d\\d|5(?:10|5\\d)|8(?:[12]\\d|88)|9(?:[0159]\\d|21|69|77|8[7-9])))\\d{5}",
                ,
                ,
                ,
                "9123456789",
                ,
                ,
                [10]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IR", 98, "00", "0", , , "0", , , , [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], , [, , , , , , , , , [-1]], , , [
                ,
                ,
                "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",
                ,
                ,
                ,
                ,
                ,
                ,
                [4, 5, 10]
              ], [, , "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", , , , "9601", , , [4, 5]], , , [, , , , , , , , , [-1]]],
              IS: [, [, , "(?:38\\d|[4-9])\\d{6}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", , , , "4101234", , , [7]], [
                ,
                ,
                "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",
                ,
                ,
                ,
                "6111234"
              ], [, , "80[0-8]\\d{4}", , , , "8001234", , , [7]], [, , "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49[0-24-79]\\d{4}", , , , "4921234", , , [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:689|8(?:7[18]|80)|95[48])\\d{4}", , , , "6891234", , , [7]]],
              IT: [, [, , "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [
                ,
                ,
                "0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                ,
                ,
                ,
                "0212345678"
              ], [, , "3[2-9]\\d{7,8}|(?:31|43)\\d{8}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "IT", 39, "00", , , , , , , , [
                [, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]],
                [, "(\\d{6})", "$1", ["1(?:1|92)"]],
                [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
                [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],
                [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
                [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]],
                [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
                [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]],
                [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]],
                [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]],
                [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
                [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]
              ], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [
                ,
                "(\\d{3})(\\d{3})(\\d{3,4})",
                "$1 $2 $3",
                ["1(?:44|[679])|[378]|43"]
              ], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]], [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
              JE: [, [, , "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [
                ,
                ,
                "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
                ,
                ,
                ,
                "7797712345"
              ], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , , , , , , , , [-1]], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "([0-24-8]\\d{5})$|0|180020", "1534$1", , , , , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [
                ,
                ,
                "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
                ,
                ,
                ,
                "5512345678"
              ], , , [, , , , , , , , , [-1]]],
              JM: [, [, , "(?:[58]\\d\\d|658|900)\\d{7}", , , , , , , [10], [7]], [, , "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", , , , "8765230123", , , , [7]], [
                ,
                ,
                "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
                ,
                ,
                ,
                "8762101234",
                ,
                ,
                ,
                [7]
              ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "658|876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              JO: [, [, , "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}", , , , , , , [8, 9]], [
                ,
                ,
                "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
                ,
                ,
                ,
                "62001234",
                ,
                ,
                [8]
              ], [, , "(?:427|7(?:[78][0-25-9]|9\\d))\\d{6}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "9\\d{7}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[47]"], "0$1"]], , [
                ,
                ,
                "74(?:66|77)\\d{5}",
                ,
                ,
                ,
                "746612345",
                ,
                ,
                [9]
              ], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]],
              JP: [
                ,
                [, , "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]],
                [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", , , , "312345678", , , [9]],
                [
                  ,
                  ,
                  "(?:601[0-4]0|[7-9]0[1-9]\\d\\d)\\d{5}",
                  ,
                  ,
                  ,
                  "9012345678",
                  ,
                  ,
                  [10]
                ],
                [, , "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}", , , , "120123456"],
                [, , "990\\d{6}", , , , "990123456", , , [9]],
                [, , , , , , , , , [-1]],
                [, , "60\\d{7}", , , , "601234567", , , [9]],
                [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]],
                "JP",
                81,
                "010",
                "0",
                ,
                ,
                "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0",
                "$1",
                ,
                ,
                [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{8,10})", "$1", ["000"]], [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1-$2-$3",
                  ["(?:12|57|99)0"],
                  "0$1"
                ], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["60"],
                  "0$1"
                ], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  [
                    "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                  ],
                  "0$1"
                ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{6})(\\d{6,7})", "$1-$2-$3", ["0"]]],
                [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
                  ,
                  "(\\d{4})(\\d)(\\d{4})",
                  "$1-$2-$3",
                  ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
                  "0$1"
                ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  [
                    "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                  ],
                  "0$1"
                ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]],
                [, , "20\\d{8}", , , , "2012345678", , , [10]],
                ,
                ,
                [, , "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"],
                [, , "570\\d{6}", , , , "570123456", , , [9]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              KE: [, [, , "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", , , , , , , [7, 8, 9, 10]], [
                ,
                ,
                "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
                ,
                ,
                ,
                "202012345",
                ,
                ,
                [7, 8, 9]
              ], [, , "(?:1(?:0[0-8]|1\\d|2[014]|[34]0)|7\\d\\d)\\d{6}", , , , "712123456", , , [9]], [, , "800[02-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KG: [, [
                ,
                ,
                "8\\d{9}|[235-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 10],
                [5, 6]
              ], [, , "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", , , , "312123456", , , [9], [5, 6]], [, , "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KH: [
                ,
                [, , "1\\d{9}|[1-9]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]],
                [
                  ,
                  ,
                  "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
                  ,
                  ,
                  ,
                  "23756789",
                  ,
                  ,
                  [8, 9],
                  [6, 7]
                ],
                [, , "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", , , , "91234567", , , [8, 9]],
                [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]],
                [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "KH",
                855,
                "00[14-9]",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              KI: [, [, , "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", , , , "31234"], [
                ,
                ,
                "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
                ,
                ,
                ,
                "72001234",
                ,
                ,
                [8]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", , , , "30010000", , , [8]], "KI", 686, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KM: [, [, , "[3478]\\d{6}", , , , , , , [7], [4]], [, , "7[4-7]\\d{5}", , , , "7712345", , , , [4]], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3",
                ["[3478]"]
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KN: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "([2-7]\\d{6})$|1", "869$1", , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KP: [, [, , "85\\d{6}|(?:19\\d|[2-7])\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}", , , , "21234567", , , , [6, 7]], [, , "19[1-3]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[
                ,
                "(\\d{2})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["8"],
                "0$1"
              ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KR: [, [, , "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [
                ,
                ,
                "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [5, 6, 8, 9, 10],
                [3, 4, 7]
              ], [, , "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", , , , "1020000000", , , [9, 10]], [, , "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8,9}", , , , "5012345678", , , [10, 11]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0", , , "0(8(?:[1-46-8]|5\\d\\d))?", , , , [[
                ,
                "(\\d{5})",
                "$1",
                ["1[016-9]1", "1[016-9]11", "1[016-9]114"],
                "0$1"
              ], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [
                ,
                "(\\d{2})(\\d{5})(\\d{4})",
                "$1-$2-$3",
                ["5"],
                "0$1",
                "0$CC-$1"
              ], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [
                [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"],
                [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]],
                [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"],
                [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1", "0$CC-$1"],
                [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"],
                [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"],
                [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]
              ], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})", , , , , , , [11, 12, 13, 14]], [, , "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]],
              KW: [, [, , "18\\d{5}|(?:[2569]\\d|41)\\d{6}", , , , , , , [7, 8]], [, , "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", , , , "22345678", , , [8]], [
                ,
                ,
                "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:00|1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
                ,
                ,
                ,
                "50012345",
                ,
                ,
                [8]
              ], [, , "18\\d{5}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KY: [, [, , "(?:345|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
                ,
                ,
                "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}",
                ,
                ,
                ,
                "3452221234",
                ,
                ,
                ,
                [7]
              ], [, , "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "(?:345976|900[2-9]\\d\\d)\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "([2-9]\\d{6})$|1", "345$1", , , , , [, , , , , , , , , [-1]], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KZ: [, [, , "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", , , , , , , [10, 14], [5, 6, 7]], [
                ,
                ,
                "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
                ,
                ,
                ,
                "7123456789",
                ,
                ,
                [10],
                [5, 6, 7]
              ], [, , "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", , , , "7710009998", , , [10]], [, , "8(?:00|108\\d{3})\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , "751\\d{7}", , , , "7511234567", , , [10]], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , "33622|7", [, , "751\\d{7}", , , , , , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LA: [, [, , "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", , , , , , , [8, 9, 10], [6]], [
                ,
                ,
                "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
                ,
                ,
                ,
                "21212862",
                ,
                ,
                [8],
                [6]
              ], [, , "(?:20(?:[23579]\\d|8[78])|30[24]\\d)\\d{6}|30\\d{7}", , , , "2023123456", , , [9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LB: [, [
                ,
                ,
                "[27-9]\\d{7}|[13-9]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8]
              ], [, , "7(?:62|8[0-6]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}", , , , "1123456"], [, , "(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[7-9]|9[0-4]))\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LC: [, [, , "(?:[58]\\d\\d|758|900)\\d{7}", , , , , , , [10], [7]], [, , "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}", , , , "7584305678", , , , [7]], [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}", , , , "7582845678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "LC", 1, "011", "1", , , "([2-8]\\d{6})$|1", "758$1", , , , , [, , , , , , , , , [-1]], , "758", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LI: [, [, , "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", , , , , , , [7, 9]], [, , "(?:2(?:01|1[27]|2[024]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", , , , "2345678", , , [7]], [, , "(?:6(?:(?:4[5-9]|5\\d)\\d|6(?:[024-68]\\d|1[01]|3[7-9]|70))\\d|7(?:[37-9]\\d|42|56))\\d{4}", , , , "660234567"], [, , "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}", , , , "8002222"], [
                ,
                ,
                "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",
                ,
                ,
                ,
                "9002222",
                ,
                ,
                [7]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "(1001)|0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d\\d", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]],
              LK: [
                ,
                [, , "[1-9]\\d{8}", , , , , , , [9], [7]],
                [, , "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", , , , "112345678", , , , [7]],
                [, , "7(?:[0-25-8]\\d|4[0-4])\\d{6}", , , , "712345678"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "LK",
                94,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "1973\\d{5}", , , , "197312345"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              LR: [, [, , "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", , , , , , , [7, 8, 9]], [, , "2\\d{7}", , , , "21234567", , , [8]], [, , "(?:(?:(?:22|33)0|555|7(?:6[01]|7\\d)|88\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "332(?:02|[34]\\d)\\d{4}", , , , "332021234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[2-578]"],
                "0$1"
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LS: [, [, , "(?:[256]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[1256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LT: [
                ,
                [, , "(?:[3469]\\d|52|[78]0)\\d{6}", , , , , , , [8]],
                [
                  ,
                  ,
                  "(?:3[1478]|4[124-6]|52)\\d{6}",
                  ,
                  ,
                  ,
                  "31234567"
                ],
                [, , "6\\d{7}", , , , "61234567"],
                [, , "80[02]\\d{5}", , , , "80012345"],
                [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"],
                [, , "808\\d{5}", , , , "80812345"],
                [, , "70[05]\\d{5}", , , , "70012345"],
                [, , "[89]01\\d{5}", , , , "80123456"],
                "LT",
                370,
                "00",
                "0",
                ,
                ,
                "[08]",
                ,
                ,
                ,
                [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", , 1], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", , 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", , 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", , 1]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "70[67]\\d{5}", , , , "70712345"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              LU: [, [, , "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [, , "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}", , , , "27123456"], [, , "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [
                ,
                ,
                "20(?:1\\d{5}|[2-689]\\d{1,7})",
                ,
                ,
                ,
                "20201234",
                ,
                ,
                [4, 5, 6, 7, 8, 9, 10]
              ], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [
                ,
                "(\\d{3})(\\d{2})(\\d{3})",
                "$1 $2 $3",
                ["80[01]|90[015]"],
                ,
                "$CC $1"
              ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LV: [, [, , "(?:[268]\\d|78|90)\\d{6}", , , , , , , [8]], [
                ,
                ,
                "6\\d{7}",
                ,
                ,
                ,
                "63123456"
              ], [, , "2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2679]|8[01]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LY: [, [, , "[2-9]\\d{8}", , , , , , , [9], [7]], [
                ,
                ,
                "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                ,
                [7]
              ], [, , "9[1-6]\\d{7}", , , , "912345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LY", 218, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MA: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "5(?:(?:18|4[0679]|5[03])\\d|2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9]))\\d{5}", , , , "520123456"], [
                ,
                ,
                "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}",
                ,
                ,
                ,
                "650123456"
              ], [, , "80[0-7]\\d{6}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}", , , , "592401234"], "MA", 212, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1-$2", ["892"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8(?:0[0-7]|9)"], "0$1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[5-8]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MC: [, [, , "(?:[3489]|[67]\\d)\\d{7}", , , , , , , [8, 9]], [
                ,
                ,
                "(?:870|9[2-47-9]\\d)\\d{5}",
                ,
                ,
                ,
                "99123456",
                ,
                ,
                [8]
              ], [, , "4(?:[469]\\d|5[1-9])\\d{5}|(?:3|[67]\\d)\\d{7}", , , , "612345678"], [, , "(?:800|90\\d)\\d{5}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MC", 377, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["87"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[67]"], "0$1"]], [[
                ,
                "(\\d{2})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["4"],
                "0$1"
              ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[67]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "8[07]0\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MD: [, [, , "(?:[235-7]\\d|[89]0)\\d{6}", , , , , , , [8]], [, , "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"], [, , "562\\d{5}|(?:6\\d|7[16-9])\\d{6}", , , , "62112345"], [, , "800\\d{5}", , , , "80012345"], [, , "90[056]\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , "3[08]\\d{6}", , , , "30123456"], "MD", 373, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "803\\d{5}", , , , "80312345"], , , [, , , , , , , , , [-1]]],
              ME: [, [, , "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", , , , , , , [8, 9], [6]], [, , "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", , , , "30234567", , , [8], [6]], [
                ,
                ,
                "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
                ,
                ,
                ,
                "60123456",
                ,
                ,
                [8]
              ], [, , "80(?:[0-2578]|9\\d)\\d{5}", , , , "80080002"], [, , "9(?:4[1568]|5[178])\\d{5}", , , , "94515151", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780", , , [8]], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012", , , [8]], , , [, , , , , , , , , [-1]]],
              MF: [, [, , "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [
                ,
                ,
                "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}",
                ,
                ,
                ,
                "590271234"
              ], [, , "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}", , , , "976012345"], "MF", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MG: [, [, , "[23]\\d{8}", , , , , , , [9], [7]], [
                ,
                ,
                "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}",
                ,
                ,
                ,
                "202123456",
                ,
                ,
                ,
                [7]
              ], [, , "3[2-9]\\d{7}", , , , "321234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "22\\d{7}", , , , "221234567"], "MG", 261, "00", "0", , , "([24-9]\\d{6})$|0", "20$1", , , [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MH: [
                ,
                [, , "329\\d{4}|(?:[256]\\d|45)\\d{5}", , , , , , , [7]],
                [, , "(?:247|528|625)\\d{4}", , , , "2471234"],
                [, , "(?:(?:23|54)5|329|45[35-8])\\d{4}", , , , "2351234"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "635\\d{4}", , , , "6351234"],
                "MH",
                692,
                "011",
                "1",
                ,
                ,
                "1",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              MK: [, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]], [
                ,
                ,
                "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
                ,
                ,
                ,
                "72345678"
              ], [, , "800\\d{5}", , , , "80012345"], [, , "5\\d{7}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MK", 389, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              ML: [, [, , "[24-9]\\d{7}", , , , , , , [8]], [
                ,
                ,
                "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}",
                ,
                ,
                ,
                "20212345"
              ], [, , "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[0-3]|[679]\\d|8[2-59])\\d{6}", , , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MM: [
                ,
                [, , "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", , , , , , , [6, 7, 8, 9, 10], [5]],
                [
                  ,
                  ,
                  "(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
                  ,
                  ,
                  ,
                  "1234567",
                  ,
                  ,
                  [6, 7, 8, 9],
                  [5]
                ],
                [, , "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", , , , "92123456", , , [7, 8, 9, 10]],
                [, , "80080(?:0[1-9]|2\\d)\\d{3}", , , , "8008001234", , , [10]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "1333\\d{4}", , , , "13331234", , , [8]],
                "MM",
                95,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],
                  "0$1"
                ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [
                  ,
                  "(\\d)(\\d{5})(\\d{4})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              MN: [, [, , "[12]\\d{7,9}|[5-9]\\d{7}", , , , , , , [8, 9, 10], [4, 5, 6]], [, , "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}", , , , "53123456", , , , [4, 5, 6]], [, , "92[0139]\\d{5}|(?:5[05]|6[069]|7[28]|8[0135689]|9[013-9])\\d{6}", , , , "88123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "712[0-79]\\d{4}|7(?:1[013-9]|[5-79]\\d)\\d{5}",
                ,
                ,
                ,
                "75123456",
                ,
                ,
                [8]
              ], "MN", 976, "001", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MO: [, [, , "0800\\d{3}|(?:28|[68]\\d)\\d{6}", , , , , , , [7, 8]], [
                ,
                ,
                "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
                ,
                ,
                ,
                "28212345",
                ,
                ,
                [8]
              ], [, , "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", , , , "66123456", , , [8]], [, , "0800\\d{3}", , , , "0800501", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MP: [, [, , "[58]\\d{9}|(?:67|90)0\\d{7}", , , , , , , [10], [7]], [
                ,
                ,
                "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                ,
                ,
                ,
                "6702345678",
                ,
                ,
                ,
                [7]
              ], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "([2-9]\\d{6})$|1", "670$1", , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MQ: [, [, , "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", , , , , , , [9]], [, , "(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}", , , , "596301234"], [, , "(?:69[67]\\d\\d|7091[0-3])\\d{4}", , , , "696201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , "8[129]\\d{7}", , , , "810123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}",
                ,
                ,
                ,
                "976612345"
              ], "MQ", 596, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MR: [
                ,
                [, , "(?:[2-4]\\d\\d|800)\\d{5}", , , , , , , [8]],
                [, , "(?:25[08]|35\\d|45[1-7])\\d{5}", , , , "35123456"],
                [, , "[2-4][0-46-9]\\d{6}", , , , "22123456"],
                [, , "800\\d{5}", , , , "80012345"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "MR",
                222,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              MS: [, [, , "(?:[58]\\d\\d|664|900)\\d{7}", , , , , , , [10], [7]], [, , "6644(?:1[0-3]|91)\\d{4}", , , , "6644912345", , , , [7]], [, , "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "([34]\\d{6})$|1", "664$1", , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MT: [, [, , "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}", , , , "96961234"], [, , "800(?:02|[3467]\\d)\\d{3}", , , , "80071234"], [
                ,
                ,
                "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
                ,
                ,
                ,
                "50037123"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]],
              MU: [, [, , "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", , , , , , , [7, 8, 10]], [, , "(?:2(?:[0346-8]\\d|1[0-8])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", , , , "54480123", , , [7, 8]], [
                ,
                ,
                "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-7]|3[013]))\\d{5}",
                ,
                ,
                ,
                "52512345",
                ,
                ,
                [8]
              ], [, , "802\\d{7}|80[0-2]\\d{4}", , , , "8001234", , , [7, 10]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", , , , , , "020", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], [, "(\\d{5})(\\d{5})", "$1 $2", ["8"]]], , [, , "219\\d{4}", , , , "2190123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MV: [, [, , "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", , , , , , , [
                7,
                10
              ]], [, , "(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", , , , "6701234", , , [7]], [, , "(?:46[46]|[79]\\d\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "4(?:0[01]|50)\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]],
              MW: [
                ,
                [, , "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", , , , , , , [7, 9]],
                [, , "(?:1[2-9]|2[12]\\d\\d)\\d{5}", , , , "1234567"],
                [, , "111\\d{6}|(?:31|77|[89][89])\\d{7}", , , , "991234567", , , [9]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "MW",
                265,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              MX: [
                ,
                [, , "[2-9]\\d{9}", , , , , , , [10], [7, 8]],
                [
                  ,
                  ,
                  "(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                  ,
                  ,
                  ,
                  "2001234567",
                  ,
                  ,
                  ,
                  [7, 8]
                ],
                [, , "(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}", , , , "2221234567", , , , [7, 8]],
                [, , "8(?:00|88)\\d{7}", , , , "8001234567"],
                [, , "900\\d{7}", , , , "9001234567"],
                [, , "300\\d{7}", , , , "3001234567"],
                [, , "500\\d{7}", , , , "5001234567"],
                [, , , , , , , , , [-1]],
                "MX",
                52,
                "0[09]",
                ,
                ,
                ,
                ,
                ,
                "00",
                ,
                [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]],
                [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              MY: [, [
                ,
                ,
                "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9, 10],
                [6, 7]
              ], [, , "427[01]\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", , , , "323856789", , , [8, 9], [6, 7]], [
                ,
                ,
                "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
                ,
                ,
                ,
                "123456789",
                ,
                ,
                [9, 10]
              ], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", , , , "1546012345", , , [10]], "MY", 60, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], [
                ,
                "(\\d)(\\d{4})(\\d{4})",
                "$1-$2 $3",
                ["3"],
                "0$1"
              ], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MZ: [
                ,
                [, , "(?:2|8\\d)\\d{7}", , , , , , , [8, 9]],
                [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]],
                [, , "8[2-79]\\d{7}", , , , "821234567", , , [9]],
                [, , "800\\d{6}", , , , "800123456", , , [9]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "MZ",
                258,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              NA: [, [, , "[68]\\d{7,8}", , , , , , , [8, 9]], [
                ,
                ,
                "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
                ,
                ,
                ,
                "61221234"
              ], [, , "(?:60|8[1245])\\d{7}", , , , "811234567", , , [9]], [, , "80\\d{7}", , , , "800123456", , , [9]], [, , "8701\\d{5}", , , , "870123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d\\d|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              NC: [, [, , "(?:050|[2-57-9]\\d\\d)\\d{3}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [, , "(?:[579]\\d|8[0-79])\\d{4}", , , , "751234"], [, , "050\\d{3}", , , , "050012"], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{3})", "$1", ["5[6-8]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              NE: [, [, , "[027-9]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}", , , , "20201234"], [, , "(?:23|7[0467]|[89]\\d)\\d{6}", , , , "93123456"], [, , "08\\d{6}", , , , "08123456"], [, , "09\\d{6}", , , , "09123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NE", 227, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              NF: [, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", , , , "106609", , , , [5]], [, , "(?:14|3[58])\\d{4}", , , , "381234", , , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , "([0-258]\\d{4})$", "3$1", , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], [, "(\\d)(\\d{5})", "$1 $2", ["[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              NG: [, [, , "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", , , , , , , [
                10,
                11,
                12,
                13,
                14
              ], [6, 7]], [, , "20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])\\d{6}", , , , "2033123456", , , [10], [6, 7]], [, , "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", , , , "8021234567", , , [10]], [, , "800\\d{7,11}", , , , "80017591759"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], [
                ,
                "(\\d{4})(\\d{2})(\\d{4})",
                "$1 $2 $3",
                ["2"],
                "0$1"
              ], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , , , "7001234567"], , , [, , , , , , , , , [-1]]],
              NI: [, [, , "(?:1800|[25-8]\\d{3})\\d{4}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [, , "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}", , , , "81234567"], [, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              NL: [, [, , "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", , , , , , , [5, 6, 7, 8, 9, 10, 11]], [
                ,
                ,
                "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
                ,
                ,
                ,
                "101234567",
                ,
                ,
                [9]
              ], [, , "(?:6[1-58]|970\\d)\\d{7}", , , , "612345678", , , [9, 11]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:85|91)\\d{7}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
                "0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [
                ,
                "(\\d{3})(\\d{3})(\\d{5})",
                "$1 $2 $3",
                ["9"],
                "0$1"
              ]], [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d", , , , , , , [5, 6]], [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", , , , "14020", , , [5, 6, 9]], , , [, , , , , , , , , [-1]]],
              NO: [, [, , "(?:0|[2-9]\\d{3})\\d{4}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [
                ,
                ,
                "(?:4[015-8]|9\\d)\\d{6}",
                ,
                ,
                ,
                "40612345",
                ,
                ,
                [8]
              ], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], , [, , , , , , , , , [-1]], 1, "[02-689]|7[0-8]", [, , , , , , , , , [-1]], [, , "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
                ,
                ,
                "81[23]\\d{5}",
                ,
                ,
                ,
                "81212345",
                ,
                ,
                [8]
              ]],
              NP: [, [, , "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", , , , , , , [8, 10, 11], [6, 7]], [, , "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", , , , "14567890", , , [8], [6, 7]], [, , "9(?:00|6[0-3]|7[0-24-6]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , "1(?:66001|800\\d\\d)\\d{5}", , , , "16600101234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [
                ,
                "(\\d{2})(\\d{6})",
                "$1-$2",
                ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
                "0$1"
              ], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]], [, "(\\d{4})(\\d{2})(\\d{5})", "$1-$2-$3", ["1"]]], [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              NR: [, [, , "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", , , , , , , [7]], [, , "444\\d{4}", , , , "4441234"], [
                ,
                ,
                "(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}",
                ,
                ,
                ,
                "5551234"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              NU: [
                ,
                [, , "(?:[4-7]|888\\d)\\d{3}", , , , , , , [4, 7]],
                [, , "[47]\\d{3}", , , , "7012", , , [4]],
                [, , "(?:[56]|888[1-9])\\d{3}", , , , "8884012"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "NU",
                683,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              NZ: [
                ,
                [, , "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", , , , , , , [5, 6, 7, 8, 9, 10]],
                [, , "240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", , , , "32345678", , , [8], [7]],
                [, , "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", , , , "211234567", , , [8, 9, 10]],
                [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456", , , [8, 9, 10]],
                [, , "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", , , , "900123456", , , [7, 8, 9, 10]],
                [, , , , , , , , , [-1]],
                [, , "70\\d{7}", , , , "701234567", , , [9]],
                [, , , , , , , , , [-1]],
                "NZ",
                64,
                "0(?:0|161)",
                "0",
                ,
                ,
                "0",
                ,
                "00",
                ,
                [[, "(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,5})",
                  "$1 $2 $3",
                  ["2(?:[169]|7[0-35-9])|7"],
                  "0$1"
                ]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}", , , , "83012378"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              OM: [, [, , "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", , , , , , , [7, 8, 9]], [, , "2[1-6]\\d{6}", , , , "23123456", , , [8]], [, , "(?:1505|90[1-9]\\d)\\d{4}|(?:7[124-9]|9[1-9])\\d{6}", , , , "92123456", , , [8]], [, , "8007\\d{4,5}|(?:500|800[05])\\d{4}", , , , "80071234"], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "OM", 968, "00", , , , , , , , [[
                ,
                "(\\d{3})(\\d{4,6})",
                "$1 $2",
                ["[58]"]
              ], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PA: [, [, , "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", , , , , , , [7, 8, 10, 11]], [
                ,
                ,
                "(?:1(?:0\\d|1[0479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[047-9]\\d|1[0-8]|2[0-5]|33|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[4-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
                ,
                ,
                ,
                "2001234",
                ,
                ,
                [7]
              ], [, , "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", , , , "61234567", , , [7, 8]], [, , "800\\d{4,5}|(?:00800|800\\d)\\d{6}", , , , "8001234"], [, , "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PE: [, [
                ,
                ,
                "(?:[14-8]|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9],
                [6, 7]
              ], [, , "(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "00|19(?:1[124]|77|90)00", "0", " Anexo ", , "0", , "00", , [[
                ,
                "(\\d{3})(\\d{5})",
                "$1 $2",
                ["80"],
                "(0$1)"
              ], [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PF: [
                ,
                [, , "4\\d{5}(?:\\d{2})?|8\\d{7,8}", , , , , , , [6, 8, 9]],
                [, , "4(?:0[4-689]|9[4-68])\\d{5}", , , , "40412345", , , [8]],
                [, , "8[7-9]\\d{6}", , , , "87123456", , , [8]],
                [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "499\\d{5}", , , , "49901234", , , [8]],
                "PF",
                689,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , "44\\d{4}", , , , , , , [6]],
                [, , "44\\d{4}", , , , "440123", , , [6]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              PG: [, [, , "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", , , , , , , [7, 8]], [, , "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", , , , "3123456", , , [7]], [, , "(?:7\\d|8[1-48])\\d{6}", , , , "70123456", , , [8]], [
                ,
                ,
                "180\\d{4}",
                ,
                ,
                ,
                "1801234",
                ,
                ,
                [7]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-57]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "00|140[1-3]", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], , [, , "27[01]\\d{4}", , , , "2700123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PH: [, [, , "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [
                ,
                ,
                "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
                ,
                ,
                ,
                "232345678",
                ,
                ,
                [6, 8, 9, 10],
                [4, 5, 7]
              ], [, , "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [
                ,
                "(\\d{4})(\\d{4,6})",
                "$1 $2",
                ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
                "(0$1)"
              ], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PK: [, [
                ,
                ,
                "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9, 10, 11, 12],
                [5, 6, 7]
              ], [, , "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", , , , "2123456789", , , [9, 10], [5, 6, 7, 8]], [, , "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}(?:\\d{3})?", , , , "80012345", , , [8, 11]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [
                ,
                ,
                "122\\d{6}",
                ,
                ,
                ,
                "122044444",
                ,
                ,
                [9]
              ], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [
                ,
                "(\\d{3})(\\d{6,7})",
                "$1 $2",
                ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
                "(0$1)"
              ], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
                ,
                ,
                ,
                "21111825888",
                ,
                ,
                [11, 12]
              ], , , [, , , , , , , , , [-1]]],
              PL: [, [, , "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [, , "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", , , , "123456789", , , [7, 9]], [, , "2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [
                ,
                ,
                "801\\d{6}",
                ,
                ,
                ,
                "801234567",
                ,
                ,
                [9]
              ], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [
                [, "(\\d{5})", "$1", ["19"]],
                [, "(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]],
                [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],
                [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]],
                [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],
                [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]],
                [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]
              ], , [, , "64\\d{4,7}", , , , "641234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]],
              PM: [, [, , "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", , , , , , , [6, 9]], [, , "(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}", , , , "430123"], [, , "(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}", , , , "551234"], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [
                ,
                ,
                "8[129]\\d{7}",
                ,
                ,
                ,
                "810123456",
                ,
                ,
                [9]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PM", 508, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PR: [, [, , "(?:[589]\\d\\d|787)\\d{7}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
              ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PS: [, [, , "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", , , , , , , [
                8,
                9,
                10
              ], [7]], [, , "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", , , , "22234567", , , [8], [7]], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              PT: [
                ,
                [, , "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", , , , , , , [9]],
                [, , "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}", , , , "212345678"],
                [, , "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}", , , , "912345678"],
                [, , "80[02]\\d{6}", , , , "800123456"],
                [, , "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}", , , , "760123456"],
                [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"],
                [, , "884[0-4689]\\d{5}", , , , "884123456"],
                [, , "30\\d{7}", , , , "301234567"],
                "PT",
                351,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]],
                ,
                [, , "6(?:222\\d|89(?:00|88|99))\\d{4}", , , , "622212345"],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}", , , , "707123456"],
                ,
                ,
                [, , "600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}", , , , "600110000"]
              ],
              PW: [, [, , "(?:[24-8]\\d\\d|345|900)\\d{4}", , , , , , , [7]], [, , "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}", , , , "2771234"], [
                ,
                ,
                "(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}",
                ,
                ,
                ,
                "6201234"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PW", 680, "01[12]", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PY: [, [, , "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [
                ,
                ,
                "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [7, 8, 9],
                [5, 6]
              ], [, , "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , "9800\\d{5,7}", , , , "98000123456", , , [9, 10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{7})", "$1", ["[15]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [
                ,
                "(\\d{3})(\\d{4,5})",
                "$1 $2",
                ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],
                "(0$1)"
              ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [
                ,
                "(\\d{3})(\\d{4,5})",
                "$1 $2",
                ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],
                "(0$1)"
              ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]]],
              QA: [
                ,
                [, , "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", , , , , , , [7, 8, 9, 11]],
                [, , "4(?:(?:[014]\\d\\d|999)\\d|2022)\\d{3}", , , , "44123456", , , [8]],
                [, , "[35-7]\\d{7}", , , , "33123456", , , [8]],
                [, , "800\\d{4}|(?:0080[01]|800)\\d{6}", , , , "8001234", , , [7, 9, 11]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "QA",
                974,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]],
                ,
                [, , "2[136]\\d{5}", , , , "2123456", , , [7]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              RE: [
                ,
                [, , "709\\d{6}|(?:26|[689]\\d)\\d{7}", , , , , , , [9]],
                [
                  ,
                  ,
                  "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}",
                  ,
                  ,
                  ,
                  "262161234"
                ],
                [, , "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}", , , , "692123456"],
                [, , "80\\d{7}", , , , "801234567"],
                [, , "89[1-37-9]\\d{6}", , , , "891123456"],
                [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"],
                [, , , , , , , , , [-1]],
                [, , "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}", , , , "939901234"],
                "RE",
                262,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                1,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              RO: [, [, , "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", , , , , , , [6, 9]], [, , "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d", , , , "211234567"], [, , "(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", , , , "712034567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[0136]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[
                ,
                "(\\d{3})(\\d{3})",
                "$1 $2",
                ["2[3-6]", "2[3-6]\\d9"],
                "0$1"
              ], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:37\\d|80[578])\\d{6}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]],
              RS: [, [, , "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", , , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [
                ,
                ,
                "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",
                ,
                ,
                ,
                "10234567",
                ,
                ,
                [7, 8, 9, 10, 11, 12],
                [4, 5, 6]
              ], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [, , "800\\d{3,9}", , , , "80012345"], [, , "(?:78\\d|90[0169])\\d{3,7}", , , , "90012345", , , [6, 7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]],
              RU: [, [
                ,
                ,
                "8\\d{13}|[347-9]\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10, 14],
                [7]
              ], [, , "336(?:[013-9]\\d|2[013-9])\\d{5}|(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}", , , , "3011234567", , , [10], [7]], [, , "9\\d{9}", , , , "9123456789", , , [10]], [, , "8(?:0[04]|108\\d{3})\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})",
                "$1-$2-$3",
                ["[0-79]"]
              ], [, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
                ,
                "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
                "8 ($1)",
                ,
                1
              ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", [
                "7(?:1[0-68]|2[1-9])",
                "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
              ], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              RW: [, [, , "(?:06|[27]\\d\\d|[89]00)\\d{6}", , , , , , , [8, 9]], [, , "(?:06|2[23568]\\d)\\d{6}", , , , "250123456"], [, , "7[237-9]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "900\\d{6}", , , , "900123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[7-9]"],
                "0$1"
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SA: [, [, , "(?:[15]\\d|800|92)\\d{7}", , , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [9], [7]], [, , "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", , , , "512345678", , , [9]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "925\\d{6}", , , , "925012345", , , [9]], [, , "920\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[
                ,
                "(\\d{4})(\\d{5})",
                "$1 $2",
                ["9"]
              ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SB: [, [, , "[6-9]\\d{6}|[1-6]\\d{4}", , , , , , , [5, 7]], [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]], [, , "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}", , , , "7421234"], [
                ,
                ,
                "1[38]\\d{3}",
                ,
                ,
                ,
                "18123",
                ,
                ,
                [5]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[12]\\d{3}", , , , "51123", , , [5]], "SB", 677, "0[01]", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SC: [, [, , "(?:[2489]\\d|64)\\d{5}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[125-8]\\d{5}", , , , "2510123"], [, , "800[08]\\d{3}", , , , "8000000"], [, , "85\\d{5}", , , , "8512345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "971\\d{4}|(?:64|95)\\d{5}",
                ,
                ,
                ,
                "6412345"
              ], "SC", 248, "010|0[0-2]", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SD: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1(?:5\\d|8[35-7])\\d{6}", , , , "153123456"], [, , "(?:1[0-2]|9[0-3569])\\d{7}", , , , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              SE: [, [, , "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", , , , , , , [6, 7, 8, 9, 10, 12]], [
                ,
                ,
                "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
                ,
                ,
                ,
                "8123456",
                ,
                ,
                [7, 8, 9]
              ], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77[0-7]\\d{6}", , , , "771234567", , , [9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1"], [
                ,
                "(\\d{2})(\\d{3})(\\d{2})",
                "$1-$2 $3",
                ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
                "0$1"
              ], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1"], [
                ,
                "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                "$1-$2 $3 $4",
                ["8"],
                "0$1"
              ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44|9)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [
                ,
                "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["8"]
              ], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["10|7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
              ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "10[1-8]\\d{6}", , , , "102345678", , , [9]], , , [, , "(?:25[245]|67[3-68])\\d{9}", , , , "254123456789", , , [12]]],
              SG: [, [, , "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", , , , , , , [8, 10, 11]], [
                ,
                ,
                "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
                ,
                ,
                ,
                "61234567",
                ,
                ,
                [8]
              ], [, , "89(?:8[02-9]|9[0-5])\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-7])|9[0-8]\\d)\\d{5}", , , , "81234567", , , [8]], [, , "(?:18|8)00\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[12]\\d|666)\\d{5}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [[, "(\\d{4,5})", "$1", ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [
                ,
                "(\\d{4})(\\d{4})(\\d{3})",
                "$1 $2 $3",
                ["7"]
              ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]],
              SH: [, [, , "(?:[256]\\d|8)\\d{3}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d\\d", , , , "22158"], [
                ,
                ,
                "[56]\\d{4}",
                ,
                ,
                ,
                "51234",
                ,
                ,
                [5]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "262\\d\\d", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, "[256]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SI: [
                ,
                [, , "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", , , , , , , [5, 6, 7, 8]],
                [, , "(?:[1-357][2-8]|4[24-8])\\d{6}", , , , "12345678", , , [8], [7]],
                [, , "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", , , , "31234567", , , [8]],
                [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]],
                [, , "89[1-3]\\d{2,5}|90\\d{4,6}", , , , "90123456"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", , , , "59012345", , , [8]],
                "SI",
                386,
                "00|10(?:22|66|88|99)",
                "0",
                ,
                ,
                "0",
                ,
                "00",
                ,
                [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              SJ: [, [, , "0\\d{4}|(?:[489]\\d|79)\\d{6}", , , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "79", [, , , , , , , , , [-1]], [, , "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
                ,
                ,
                "81[23]\\d{5}",
                ,
                ,
                ,
                "81212345",
                ,
                ,
                [8]
              ]],
              SK: [
                ,
                [, , "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", , , , , , , [6, 7, 9]],
                [, , "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", , , , "221234567"],
                [, , "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", , , , "912123456", , , [9]],
                [, , "800\\d{6}", , , , "800123456", , , [9]],
                [, , "9(?:00|[78]\\d)\\d{6}", , , , "900123456", , , [9]],
                [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]],
                [, , , , , , , , , [-1]],
                [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]],
                "SK",
                421,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
                [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", [
                  "[3-5][1-8]1",
                  "[3-5][1-8]1[67]"
                ], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
                [, , "9090\\d{3}", , , , "9090123", , , [7]],
                ,
                ,
                [, , "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}", , , , , , , [7, 9]],
                [, , "96\\d{7}", , , , "961234567", , , [9]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              SL: [, [, , "(?:[237-9]\\d|66)\\d{6}", , , , , , , [8], [6]], [, , "22[2-4][2-9]\\d{4}", , , , "22221234", , , , [6]], [
                ,
                ,
                "(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}",
                ,
                ,
                ,
                "25123456"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SM: [, [, , "(?:0549|[5-7]\\d)\\d{6}", , , , , , , [8, 10], [6]], [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , "66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "5[158]\\d{6}",
                ,
                ,
                ,
                "58001110",
                ,
                ,
                [8]
              ], "SM", 378, "00", , , , "([89]\\d{5})$", "0549$1", , , [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SN: [, [, , "(?:[378]\\d|93)\\d{7}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [
                ,
                ,
                "7(?:[015-8]\\d|21|90)\\d{6}",
                ,
                ,
                ,
                "701234567"
              ], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SO: [, [, , "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", , , , , , , [6, 7, 8, 9]], [
                ,
                ,
                "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
                ,
                ,
                ,
                "4012345",
                ,
                ,
                [6, 7]
              ], [, , "(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], [
                ,
                "(\\d)(\\d{7})",
                "$1 $2",
                ["(?:2|90)4|[67]"]
              ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SR: [, [, , "(?:[2-5]|[6-8]\\d|90)\\d{5}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|4\\d|5[2-58])\\d{4}", , , , "211234", , , [6]], [, , "(?:6[08]|7[124-7]|8[1-9])\\d{5}", , , , "7412345", , , [7]], [, , "80\\d{5}", , , , "8012345", , , [7]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "56\\d{4}",
                ,
                ,
                ,
                "561234",
                ,
                ,
                [6]
              ], "SR", 597, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SS: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1[89]\\d{7}", , , , "181234567"], [, , "(?:12|9[1257-9])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[19]"],
                "0$1"
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              ST: [, [, , "(?:22|9\\d)\\d{5}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SV: [, [, , "[25-7]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", , , , , , , [7, 8, 11]], [
                ,
                ,
                "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [8]
              ], [, , "[5-7]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{8}|80[01]\\d{4}", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[25-7]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SX: [
                ,
                [, , "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
                [
                  ,
                  ,
                  "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
                  ,
                  ,
                  ,
                  "7215425678",
                  ,
                  ,
                  ,
                  [7]
                ],
                [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]],
                [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
                [, , "900[2-9]\\d{6}", , , , "9002123456"],
                [, , , , , , , , , [-1]],
                [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
                [, , , , , , , , , [-1]],
                "SX",
                1,
                "011",
                "1",
                ,
                ,
                "(5\\d{6})$|1",
                "721$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "721",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              SY: [, [, , "[1-359]\\d{8}|[1-5]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "(?:50|9[1-9])\\d{7}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", , 1], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[59]"],
                "0$1",
                ,
                1
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SZ: [, [, , "0800\\d{4}|(?:[237]\\d|900)\\d{6}", , , , , , , [8, 9]], [, , "[23][2-5]\\d{6}", , , , "22171234", , , [8]], [, , "7[5-9]\\d{6}", , , , "76123456", , , [8]], [, , "0800\\d{4}", , , , "08001234", , , [8]], [, , "900\\d{6}", , , , "900012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{6}", , , , "70012345", , , [8]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["9"]]], , [, , , , , , , , , [-1]], , , [
                ,
                ,
                "0800\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TA: [, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TC: [
                ,
                [, , "(?:[58]\\d\\d|649|900)\\d{7}", , , , , , , [10], [7]],
                [, , "649(?:266|712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]],
                [, , "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]],
                [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
                [, , "900[2-9]\\d{6}", , , , "9002345678"],
                [, , , , , , , , , [-1]],
                [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
                [, , "649(?:71[01]|966)\\d{4}", , , , "6497101234", , , , [7]],
                "TC",
                1,
                "011",
                "1",
                ,
                ,
                "([2-479]\\d{6})$|1",
                "649$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "649",
                [
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  [-1]
                ],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              TD: [, [, , "(?:22|30|[689]\\d|77)\\d{6}", , , , , , , [8]], [, , "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:30|[69]\\d|77|8[5-7])\\d{6}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", , , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TG: [, [, , "[279]\\d{7}", , , , , , , [8]], [
                ,
                ,
                "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
                ,
                ,
                ,
                "22212345"
              ], [, , "(?:7[0-29]|9[0-36-9])\\d{6}", , , , "90112345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TH: [, [, , "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", , , , , , , [8, 9, 10, 13]], [, , "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [
                ,
                ,
                "67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
                ,
                ,
                ,
                "812345678",
                ,
                ,
                [9]
              ], [, , "(?:001800\\d|1800)\\d{6}", , , , "1800123456", , , [10, 13]], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00[1-9]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TJ: [, [, , "(?:[0-57-9]\\d|66)\\d{7}", , , , , , , [9], [
                3,
                5,
                6,
                7
              ]], [, , "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}", , , , "372123456", , , , [3, 5, 6, 7]], [, , "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|3[08]|40|5[05]|66|7[01578]|8[078])\\d{7}", , , , "917123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TJ", 992, "810", , , , , , "8~10", , [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], [
                ,
                "(\\d{4})(\\d)(\\d{4})",
                "$1 $2 $3",
                ["3(?:[1245]|3[12])"]
              ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["\\d"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TK: [, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TL: [, [, , "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", , , , , , , [7, 8]], [
                ,
                ,
                "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",
                ,
                ,
                ,
                "2112345",
                ,
                ,
                [7]
              ], [, , "7[2-8]\\d{6}", , , , "77212345", , , [8]], [, , "80\\d{5}", , , , "8012345", , , [7]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , "70\\d{5}", , , , "7012345", , , [7]], [, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TM: [, [, , "(?:[1-6]\\d|71)\\d{6}", , , , , , , [8]], [
                ,
                ,
                "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",
                ,
                ,
                ,
                "12345678"
              ], [, , "(?:6\\d|71)\\d{6}", , , , "66123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TM", 993, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TN: [
                ,
                [, , "[2-57-9]\\d{7}", , , , , , , [8]],
                [, , "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}", , , , "30010123"],
                [, , "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}", , , , "20123456"],
                [, , "8010\\d{4}", , , , "80101234"],
                [, , "88\\d{6}", , , , "88123456"],
                [, , "8[12]10\\d{4}", , , , "81101234"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "TN",
                216,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              TO: [, [, , "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", , , , , , , [5, 7]], [
                ,
                ,
                "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",
                ,
                ,
                ,
                "20123",
                ,
                ,
                [5]
              ], [, , "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", , , , "7715123", , , [7]], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "55[0-37-9]\\d{4}", , , , "5510123", , , [7]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TR: [, [
                ,
                ,
                "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 10, 12, 13]
              ], [, , "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", , , , "2123456789", , , [10]], [, , "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", , , , "5012345678", , , [10]], [, , "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", , , , "8001234567", , , [10, 12, 13]], [, , "(?:8[89]8|900)\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , "592(?:21[12]|461)\\d{4}", , , , "5922121234", , , [10]], [
                ,
                ,
                "850\\d{7}",
                ,
                ,
                ,
                "8500123456",
                ,
                ,
                [10]
              ], "TR", 90, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [
                ,
                "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"],
                "0$1",
                ,
                1
              ], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]], [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "(?:444|811\\d{3})\\d{4}", , , , , , , [7, 10]], [, , "444\\d{4}", , , , "4441444", , , [7]], , , [, , , , , , , , , [-1]]],
              TT: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
                ,
                ,
                "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",
                ,
                ,
                ,
                "8682211234",
                ,
                ,
                ,
                [7]
              ], [, , "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}", , , , "8682911234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "([2-46-8]\\d{6})$|1", "868$1", , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]],
              TV: [, [, , "(?:2|7\\d\\d|90)\\d{4}", , , , , , , [5, 6, 7]], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:7[01]\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["90"]], [
                ,
                "(\\d{2})(\\d{5})",
                "$1 $2",
                ["7"]
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TW: [, [, , "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", , , , , , , [7, 8, 9, 10, 11]], [
                ,
                ,
                "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
                ,
                ,
                ,
                "221234567",
                ,
                ,
                [8, 9]
              ], [, , "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}|800\\d{5}", , , , "800123456", , , [8, 9]], [, , "20(?:[013-9]\\d\\d|2)\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", , , , "7012345678", , , [10, 11]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", , "0", , , , [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], [
                ,
                "(\\d)(\\d{3,4})(\\d{4})",
                "$1 $2 $3",
                ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],
                "0$1"
              ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]],
              TZ: [
                ,
                [, , "(?:[25-8]\\d|41|90)\\d{7}", , , , , , , [9]],
                [, , "2[2-8]\\d{7}", , , , "222345678"],
                [, , "(?:6[1-35-9]|7[13-9])\\d{7}", , , , "621234567"],
                [, , "80[08]\\d{6}", , , , "800123456"],
                [, , "90\\d{7}", , , , "900123456"],
                [, , "8(?:40|6[01])\\d{6}", , , , "840123456"],
                [, , , , , , , , , [-1]],
                [, , "41\\d{7}", , , , "412345678"],
                "TZ",
                255,
                "00[056]",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["5"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              UA: [, [, , "[89]\\d{9}|[3-9]\\d{8}", , , , , , , [9, 10], [5, 6, 7]], [
                ,
                ,
                "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
                ,
                ,
                ,
                "311234567",
                ,
                ,
                [9],
                [5, 6, 7]
              ], [, , "790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", , , , "501234567", , , [9]], [, , "800[1-8]\\d{5,6}", , , , "800123456"], [, , "900[239]\\d{5,6}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567", , , [9]], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [
                ,
                "(\\d{4})(\\d{5})",
                "$1 $2",
                ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
                "0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              UG: [, [, , "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", , , , , , , [9], [5, 6, 7]], [
                ,
                ,
                "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
                ,
                ,
                ,
                "312345678",
                ,
                ,
                ,
                [5, 6, 7]
              ], [, , "72[48]0\\d{5}|7(?:[014-8]\\d|2[0167]|3[06]|9[0-3589])\\d{6}", , , , "712345678"], [, , "800[1-3]\\d{5}", , , , "800123456"], [, , "90[1-3]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              US: [, [
                ,
                ,
                "[2-9]\\d{9}|3\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ], [
                ,
                ,
                "(?:2742|(?:472|983)[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
                ,
                ,
                ,
                "2015550123",
                ,
                ,
                ,
                [7]
              ], [
                ,
                ,
                "(?:2742|(?:472|983)[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
                ,
                ,
                ,
                "2015550123",
                ,
                ,
                ,
                [7]
              ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "US", 1, "011", "1", , , "1", , , 1, [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [
                ,
                "(\\d{3})(\\d{4})",
                "$1-$2",
                ["[24-9]|3(?:[02-9]|1[1-9])"]
              ], [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], , , 1]], [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              UY: [, [, , "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13]], [, , "(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [
                ,
                ,
                "0004\\d{2,9}|(?:405|80[05])\\d{4}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [6, 7, 8, 9, 10, 11, 12, 13]
              ], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", , "0", , "00", , [[, "(\\d{4,5})", "$1", ["21"]], [, "(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], [, "(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]], [, , "21\\d{2,3}", , , , "21123", , , [4, 5]], , , [, , , , , , , , , [-1]]],
              UZ: [, [, , "(?:20|33|[5-9]\\d)\\d{7}", , , , , , , [9]], [, , "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}", , , , "669050123"], [
                ,
                ,
                "(?:(?:[25]0|33|8[078]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
                ,
                ,
                ,
                "912345678"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              VA: [, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , "06698\\d{1,6}", , , , "0669812345", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [
                ,
                ,
                "80(?:0\\d{3}|3)\\d{3}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [6, 9]
              ], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "06698", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
              VC: [
                ,
                [, , "(?:[58]\\d\\d|784|900)\\d{7}", , , , , , , [10], [7]],
                [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]],
                [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}", , , , "7844301234", , , , [7]],
                [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
                [, , "900[2-9]\\d{6}", , , , "9002345678"],
                [, , , , , , , , , [-1]],
                [
                  ,
                  ,
                  "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                  ,
                  ,
                  ,
                  "5002345678"
                ],
                [, , "78451[0-2]\\d{4}", , , , "7845101234", , , , [7]],
                "VC",
                1,
                "011",
                "1",
                ,
                ,
                "([2-7]\\d{6})$|1",
                "784$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "784",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              VE: [
                ,
                [, , "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", , , , , , , [10], [7]],
                [, , "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}", , , , "2121234567", , , , [7]],
                [, , "4(?:1[24-8]|2[246])\\d{7}", , , , "4121234567"],
                [, , "800\\d{7}", , , , "8001234567"],
                [, , "90[01]\\d{7}", , , , "9001234567"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "VE",
                58,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1", "$CC $1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "501\\d{7}", , , , "5010123456", , , , [7]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              VG: [, [, , "(?:284|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}", , , , "2842291234", , , , [7]], [, , "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
              ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "([2-578]\\d{6})$|1", "284$1", , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              VI: [, [, , "[58]\\d{9}|(?:34|90)0\\d{7}", , , , , , , [10], [7]], [
                ,
                ,
                "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                ,
                ,
                ,
                "3406421234",
                ,
                ,
                ,
                [7]
              ], [, , "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "([2-9]\\d{6})$|1", "340$1", , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              VN: [, [, , "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", , , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", , , , "912345678", , , [9]], [
                ,
                ,
                "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [8, 9, 10]
              ], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "672\\d{6}", , , , "672012345", , , [9]], "VN", 84, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [
                ,
                "(\\d{2})(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["2[48]"],
                "0$1",
                ,
                1
              ], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , , , , [7, 8]], [
                ,
                ,
                "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
                ,
                ,
                ,
                "1992000",
                ,
                ,
                [7, 8]
              ], , , [, , , , , , , , , [-1]]],
              VU: [
                ,
                [, , "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", , , , , , , [5, 7]],
                [, , "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", , , , "22123", , , [5]],
                [, , "(?:[58]\\d|7[013-7])\\d{5}", , , , "5912345", , , [7]],
                [, , "81[18]\\d\\d", , , , "81123", , , [5]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "9(?:0[1-9]|1[01])\\d{4}", , , , "9010123", , , [7]],
                "VU",
                678,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "(?:3[03]|900\\d)\\d{3}", , , , "30123"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              WF: [, [, , "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", , , , , , , [6, 9]], [, , "72\\d{4}", , , , "721234", , , [6]], [, , "(?:72|8[23])\\d{4}", , , , "821234", , , [6]], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9[23]\\d{4}", , , , "921234", , , [6]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234", , , [6]]],
              WS: [
                ,
                [, , "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", , , , , , , [5, 6, 7, 10]],
                [, , "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", , , , "22123", , , [5, 6]],
                [, , "(?:7[1-35-8]|8(?:[3-7]|9\\d{3}))\\d{5}", , , , "7212345", , , [7, 10]],
                [, , "800\\d{3}", , , , "800123", , , [6]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "WS",
                685,
                "0",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{5})", "$1", ["[2-5]|6[1-9]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              XK: [
                ,
                [, , "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", , , , , , , [8, 9, 10, 11, 12]],
                [, , "38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})", , , , "28012345"],
                [, , "4[3-9]\\d{6}", , , , "43201234", , , [8]],
                [, , "800\\d{5}", , , , "80001234", , , [8]],
                [, , "900\\d{5}", , , , "90001234", , , [8]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "XK",
                383,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{7,10})",
                  "$1 $2",
                  ["3"],
                  "0$1"
                ]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              YE: [, [, , "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", , , , , , , [7, 8, 9], [6]], [, , "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", , , , "1234567", , , [7, 8], [6]], [, , "7[01378]\\d{7}", , , , "712345678", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YE", 967, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["7"],
                "0$1"
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              YT: [
                ,
                [, , "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", , , , , , , [9]],
                [, , "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}", , , , "269601234"],
                [, , "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}", , , , "639012345"],
                [, , "80\\d{7}", , , , "801234567"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "9(?:(?:39|47)8[01]|769\\d)\\d{4}", , , , "939801234"],
                "YT",
                262,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              ZA: [, [, , "[1-79]\\d{8}|8\\d{4,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", , , , "101234567", , , [9]], [
                ,
                ,
                "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|[67]\\d\\d)\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                ,
                ,
                ,
                "711234567",
                ,
                ,
                [5, 6, 7, 8, 9]
              ], [, , "80\\d{7}", , , , "801234567", , , [9]], [, , "(?:86[2-9]|9[0-2]\\d)\\d{6}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [, , "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", , , , "871234567", , , [9]], "ZA", 27, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[1-9]"],
                "0$1"
              ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6,7}", , , , "861123456", , , [9, 10]], , , [, , , , , , , , , [-1]]],
              ZM: [, [, , "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", , , , , , , [9], [6]], [, , "21[1-8]\\d{6}", , , , "211234567", , , , [6]], [, , "(?:[59][5-8]|7[5-9])\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "63\\d{7}", , , , "630123456"], "ZM", 260, "00", "0", , , "0", , , , [
                [, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]],
                [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"],
                [, "(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]
              ], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              ZW: [, [, , "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [
                ,
                ,
                "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
                ,
                ,
                ,
                "1312345",
                ,
                ,
                ,
                [3, 4]
              ], [, , "7(?:[1278]\\d|3[1-9])\\d{6}", , , , "712345678", , , [9]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [
                [, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"],
                [, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
                [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
                [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"],
                [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
                [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"],
                [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
                [
                  ,
                  "(\\d{2})(\\d{3,5})",
                  "$1 $2",
                  ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
                  "0$1"
                ],
                [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"],
                [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]
              ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              800: [
                ,
                [, , "(?:00|[1-9]\\d)\\d{6}", , , , , , , [8]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "(?:00|[1-9]\\d)\\d{6}", , , , "12345678"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "001",
                800,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                1,
                [[, "(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              808: [, [, , "[1-9]\\d{7}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1-9]\\d{7}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              870: [, [, , "7\\d{11}|[235-7]\\d{8}", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "2\\d{8}",
                ,
                ,
                ,
                "201234567",
                ,
                ,
                [9]
              ], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              878: [, [, , "10\\d{10}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              881: [, [
                ,
                ,
                "6\\d{9}|[0-36-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 10]
              ], [, , , , , , , , , [-1]], [, , "6\\d{9}|[0-36-9]\\d{8}", , , , "612345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 881, , , , , , , , , [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], [, "(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              882: [, [, , "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [
                ,
                ,
                "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                ,
                ,
                ,
                "3421234",
                ,
                ,
                [7, 8, 9, 10, 12]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["49"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [
                ,
                "(\\d{2})(\\d{3,4})(\\d{4})",
                "$1 $2 $3",
                ["16"]
              ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]],
              883: [, [, , "(?:[1-4]\\d|51)\\d{6,10}", , , , , , , [8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
                ,
                ,
                ,
                "510012345"
              ], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              888: [, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]],
              979: [, [, , "[1359]\\d{8}", , , , , , , [9], [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1359]\\d{8}", , , , "123456789", , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]
            }, i18n.phonenumbers.PhoneNumberUtil = function() {
              this.regionToMetadataMap = {};
            }, goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil), i18n.phonenumbers.Error = { INVALID_COUNTRY_CODE: "Invalid country calling code", NOT_A_NUMBER: "The string supplied did not seem to be a phone number", TOO_SHORT_AFTER_IDD: "Phone number too short after IDD", TOO_SHORT_NSN: "The string supplied is too short to be a phone number", TOO_LONG: "The string supplied is too long to be a phone number" }, i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1, i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2, i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17, i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3, i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = "ZZ", i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = { 54: "9" }, i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [52, 54, 55], i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN = "+", i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = "*", i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = ";ext=", i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = "tel:", i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = ";phone-context=", i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = ";isub=", i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "０": "0", "１": "1", "２": "2", "３": "3", "４": "4", "５": "5", "６": "6", "７": "7", "８": "8", "９": "9", "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4", "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9", "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4", "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9" }, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "+": i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN, "*": "*", "#": "#" }, i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = { A: "2", B: "2", C: "2", D: "3", E: "3", F: "3", G: "4", H: "4", I: "4", J: "5", K: "5", L: "5", M: "6", N: "6", O: "6", P: "7", Q: "7", R: "7", S: "7", T: "8", U: "8", V: "8", W: "9", X: "9", Y: "9", Z: "9" }, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = {
              0: "0",
              1: "1",
              2: "2",
              3: "3",
              4: "4",
              5: "5",
              6: "6",
              7: "7",
              8: "8",
              9: "9",
              "０": "0",
              "１": "1",
              "２": "2",
              "３": "3",
              "４": "4",
              "５": "5",
              "６": "6",
              "７": "7",
              "８": "8",
              "９": "9",
              "٠": "0",
              "١": "1",
              "٢": "2",
              "٣": "3",
              "٤": "4",
              "٥": "5",
              "٦": "6",
              "٧": "7",
              "٨": "8",
              "٩": "9",
              "۰": "0",
              "۱": "1",
              "۲": "2",
              "۳": "3",
              "۴": "4",
              "۵": "5",
              "۶": "6",
              "۷": "7",
              "۸": "8",
              "۹": "9",
              A: "2",
              B: "2",
              C: "2",
              D: "3",
              E: "3",
              F: "3",
              G: "4",
              H: "4",
              I: "4",
              J: "5",
              K: "5",
              L: "5",
              M: "6",
              N: "6",
              O: "6",
              P: "7",
              Q: "7",
              R: "7",
              S: "7",
              T: "8",
              U: "8",
              V: "8",
              W: "9",
              X: "9",
              Y: "9",
              Z: "9"
            }, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = {
              0: "0",
              1: "1",
              2: "2",
              3: "3",
              4: "4",
              5: "5",
              6: "6",
              7: "7",
              8: "8",
              9: "9",
              A: "A",
              B: "B",
              C: "C",
              D: "D",
              E: "E",
              F: "F",
              G: "G",
              H: "H",
              I: "I",
              J: "J",
              K: "K",
              L: "L",
              M: "M",
              N: "N",
              O: "O",
              P: "P",
              Q: "Q",
              R: "R",
              S: "S",
              T: "T",
              U: "U",
              V: "V",
              W: "W",
              X: "X",
              Y: "Y",
              Z: "Z",
              a: "A",
              b: "B",
              c: "C",
              d: "D",
              e: "E",
              f: "F",
              g: "G",
              h: "H",
              i: "I",
              j: "J",
              k: "K",
              l: "L",
              m: "M",
              n: "N",
              o: "O",
              p: "P",
              q: "Q",
              r: "R",
              s: "S",
              t: "T",
              u: "U",
              v: "V",
              w: "W",
              x: "X",
              y: "Y",
              z: "Z",
              "-": "-",
              "－": "-",
              "‐": "-",
              "‑": "-",
              "‒": "-",
              "–": "-",
              "—": "-",
              "―": "-",
              "−": "-",
              "/": "/",
              "／": "/",
              " ": " ",
              "　": " ",
              "⁠": " ",
              ".": ".",
              "．": "."
            }, i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/, i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = "-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～", i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = "0-9０-９٠-٩۰-۹", i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = "A-Za-z", i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = "+＋", i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+"), i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+"), i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]+", i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = new RegExp("([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "])"), i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]"), i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/, i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = new RegExp("[^" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "#]+$"), i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/, i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + "}", i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = "[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]*(?:[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + "]*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]){3,}[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]*", i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = " ext. ", i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?", i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ = "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]|" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ + ")", i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*$", i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_), i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ = i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_, i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*", i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*", i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_ = "^(" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ + "\\.)*" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ + "\\.?$", i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_), i18n.phonenumbers.PhoneNumberUtil.extnDigits_ = function(e) {
              return "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1," + e + "})";
            }, i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_ = function() {
              var e = i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20"), t = "[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20") + "#?", o = "[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?", i = "[- ]+" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("6") + "#", d = "[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("15") + "#?", s = "[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?";
              return e + "|" + t + "|" + o + "|" + i + "|" + d + "|" + s;
            }, i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = new RegExp("(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")$", "i"), i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + "$|^" + i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + "(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")?$", "i"), i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/, i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/, i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/, i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/, i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/, i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/, i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = "001", i18n.phonenumbers.PhoneNumberFormat = { E164: 0, INTERNATIONAL: 1, NATIONAL: 2, RFC3966: 3 }, i18n.phonenumbers.PhoneNumberType = { FIXED_LINE: 0, MOBILE: 1, FIXED_LINE_OR_MOBILE: 2, TOLL_FREE: 3, PREMIUM_RATE: 4, SHARED_COST: 5, VOIP: 6, PERSONAL_NUMBER: 7, PAGER: 8, UAN: 9, VOICEMAIL: 10, UNKNOWN: -1 }, i18n.phonenumbers.PhoneNumberUtil.MatchType = { NOT_A_NUMBER: 0, NO_MATCH: 1, SHORT_NSN_MATCH: 2, NSN_MATCH: 3, EXACT_MATCH: 4 }, i18n.phonenumbers.PhoneNumberUtil.ValidationResult = { IS_POSSIBLE: 0, IS_POSSIBLE_LOCAL_ONLY: 4, INVALID_COUNTRY_CODE: 1, TOO_SHORT: 2, INVALID_LENGTH: 5, TOO_LONG: 3 }, i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function(e) {
              var t = e.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
              return 0 <= t ? (e = e.substring(t), e = e.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ""), t = e.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= t && (e = e.substring(0, t))) : e = "", e;
            }, i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function(e) {
              return e.length < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, e);
            }, i18n.phonenumbers.PhoneNumberUtil.normalize = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, e) ? i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(e, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !0) : i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e);
            }, i18n.phonenumbers.PhoneNumberUtil.normalizeSB_ = function(e) {
              var t = i18n.phonenumbers.PhoneNumberUtil.normalize(e.toString());
              e.clear(), e.append(t);
            }, i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(e, i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, !0);
            }, i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(e, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, !0);
            }, i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(e, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !1);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function(e) {
              var t = this.getMetadataForRegion(this.getRegionCodeForNumber(e));
              return t != null && (t.hasNationalPrefix() || e.hasItalianLeadingZero()) && this.isNumberGeographical(e) ? this.getLengthOfNationalDestinationCode(e) : 0;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function(e) {
              if (e.hasExtension()) {
                var t = e.clone();
                t.clearExtension();
              } else t = e;
              return t = this.format(t, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_), t[0].length == 0 && t.shift(), 2 >= t.length ? 0 : this.getNumberType(e) == i18n.phonenumbers.PhoneNumberType.MOBILE && (e = i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(e.getCountryCodeOrDefault()), e != "") ? t[2].length + e.length : t[1].length;
            }, i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[e] || "";
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function() {
              return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(e) {
                return isNaN(e);
              });
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function() {
              return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(e) {
                return !isNaN(e);
              }).map(function(e) {
                return parseInt(e, 10);
              });
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes = function() {
              var e = Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);
              return [].concat($jscomp.arrayFromIterable(this.getSupportedGlobalNetworkCallingCodes()), $jscomp.arrayFromIterable(e.map(function(t) {
                return parseInt(t, 10);
              })));
            }, i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function(e) {
              return e != null && (e.possibleLengthCount() != 1 || e.possibleLengthArray()[0] != -1);
            }, i18n.phonenumbers.PhoneNumberUtil.descHasData_ = function(e) {
              return e != null && (e.hasExampleNumber() || i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(e) || e.hasNationalNumberPattern());
            }, i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function(e) {
              var t = [];
              return goog.object.forEach(i18n.phonenumbers.PhoneNumberType, function(o) {
                if (o != i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && o != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
                  var i = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(e, o);
                  i18n.phonenumbers.PhoneNumberUtil.descHasData_(i) && t.push(o);
                }
              }), t;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function(e) {
              return this.isValidRegionCode_(e) ? i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(e)) : [];
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function(e) {
              return e = this.getMetadataForNonGeographicalRegion(e), e == null ? [] : i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(e);
            }, i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function(e, t, o) {
              for (var i = new goog.string.StringBuffer(), d, s, n = e.length, r = 0; r < n; ++r) d = e.charAt(r), s = t[d.toUpperCase()], s != null ? i.append(s) : o || i.append(d);
              return i.toString();
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function(e) {
              return e.length == 0 || i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function(e) {
              var t = this.getNumberType(e);
              return t == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || t == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_.includes(e.getCountryCodeOrDefault()) && t == i18n.phonenumbers.PhoneNumberType.MOBILE;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function(e) {
              return e != null && isNaN(e) && e.toUpperCase() in i18n.phonenumbers.metadata.countryToMetadata;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function(e) {
              return e in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.format = function(e, t) {
              if (e.getNationalNumber() == 0 && e.hasRawInput()) {
                var o = e.getRawInputOrDefault();
                if (0 < o.length) return o;
              }
              o = e.getCountryCodeOrDefault();
              var i = this.getNationalSignificantNumber(e);
              if (t == i18n.phonenumbers.PhoneNumberFormat.E164) return this.prefixNumberWithCountryCallingCode_(o, i18n.phonenumbers.PhoneNumberFormat.E164, i, "");
              if (!this.hasValidCountryCallingCode_(o)) return i;
              var d = this.getRegionCodeForCountryCode(o);
              return d = this.getMetadataForRegionOrCallingCode_(
                o,
                d
              ), e = this.maybeGetFormattedExtension_(e, d, t), i = this.formatNsn_(i, d, t), this.prefixNumberWithCountryCallingCode_(o, t, i, e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function(e, t, o) {
              var i = e.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(e);
              if (!this.hasValidCountryCallingCode_(i)) return d;
              var s = this.getRegionCodeForCountryCode(i);
              s = this.getMetadataForRegionOrCallingCode_(i, s);
              var n = this.chooseFormattingPatternForNumber_(o, d);
              if (n != null) {
                if (o = n.clone(), n = n.getNationalPrefixFormattingRuleOrDefault(), 0 < n.length) {
                  var r = s.getNationalPrefixOrDefault();
                  0 < r.length ? (n = n.replace(
                    i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_,
                    r
                  ).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_, "$1"), o.setNationalPrefixFormattingRule(n)) : o.clearNationalPrefixFormattingRule();
                }
                d = this.formatNsnUsingPattern_(d, o, t);
              }
              return e = this.maybeGetFormattedExtension_(e, s, t), this.prefixNumberWithCountryCallingCode_(i, t, d, e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function(e, t) {
              var o = e.getCountryCodeOrDefault(), i = this.getNationalSignificantNumber(e);
              if (!this.hasValidCountryCallingCode_(o)) return i;
              var d = this.getRegionCodeForCountryCode(o);
              return d = this.getMetadataForRegionOrCallingCode_(o, d), e = this.maybeGetFormattedExtension_(e, d, i18n.phonenumbers.PhoneNumberFormat.NATIONAL), t = this.formatNsn_(i, d, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, t), this.prefixNumberWithCountryCallingCode_(
                o,
                i18n.phonenumbers.PhoneNumberFormat.NATIONAL,
                t,
                e
              );
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function(e, t) {
              return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == t ? this.getMetadataForNonGeographicalRegion(e) : this.getMetadataForRegion(t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function(e, t) {
              return this.formatNationalNumberWithCarrierCode(e, 0 < e.getPreferredDomesticCarrierCodeOrDefault().length ? e.getPreferredDomesticCarrierCodeOrDefault() : t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function(e, t, o) {
              var i = e.getCountryCodeOrDefault();
              if (!this.hasValidCountryCallingCode_(i)) return e.hasRawInput() ? e.getRawInputOrDefault() : "";
              var d = "";
              e = e.clone(), e.clearExtension();
              var s = this.getRegionCodeForCountryCode(i), n = this.getNumberType(e), r = n != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
              if (t == s) d = n == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || n == i18n.phonenumbers.PhoneNumberType.MOBILE || n == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, s == "BR" && d ? d = 0 < e.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(e, "") : "" : i == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (t = this.getMetadataForRegion(t), d = this.canBeInternationallyDialled(e) && this.testNumberLength_(this.getNationalSignificantNumber(e), t) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL)) : d = (s == i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || (s == "MX" || s == "CL" || s == "UZ") && d) && this.canBeInternationallyDialled(e) ? this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
              else if (r && this.canBeInternationallyDialled(e)) return o ? this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(e, i18n.phonenumbers.PhoneNumberFormat.E164);
              return o ? d : i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function(e, t) {
              if (!this.isValidRegionCode_(t)) return this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
              var o = e.getCountryCodeOrDefault(), i = this.getNationalSignificantNumber(e);
              if (!this.hasValidCountryCallingCode_(o)) return i;
              if (o == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                if (this.isNANPACountry(t)) return o + " " + this.format(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
              } else if (o == this.getCountryCodeForValidRegion_(t)) return this.format(
                e,
                i18n.phonenumbers.PhoneNumberFormat.NATIONAL
              );
              var d = this.getMetadataForRegion(t), s = d.getInternationalPrefixOrDefault();
              return t = "", d.hasPreferredInternationalPrefix() ? t = d.getPreferredInternationalPrefixOrDefault() : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, s) && (t = s), d = this.getRegionCodeForCountryCode(o), d = this.getMetadataForRegionOrCallingCode_(o, d), i = this.formatNsn_(i, d, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL), e = this.maybeGetFormattedExtension_(
                e,
                d,
                i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL
              ), 0 < t.length ? t + " " + o + " " + i + e : this.prefixNumberWithCountryCallingCode_(o, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, i, e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function(e, t) {
              if (e.hasRawInput() && !this.hasFormattingPatternForNumber_(e)) return e.getRawInputOrDefault();
              if (!e.hasCountryCodeSource()) return this.format(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
              switch (e.getCountryCodeSource()) {
                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
                  t = this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                  break;
                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
                  t = this.formatOutOfCountryCallingNumber(e, t);
                  break;
                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
                  t = this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
                  break;
                default:
                  var o = this.getRegionCodeForCountryCode(e.getCountryCodeOrDefault()), i = this.getNddPrefixForRegion(o, !0);
                  if (t = this.format(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL), i != null && i.length != 0 && !this.rawInputContainsNationalPrefix_(e.getRawInputOrDefault(), i, o) && (o = this.getMetadataForRegion(o), i = this.getNationalSignificantNumber(e), o = this.chooseFormattingPatternForNumber_(o.numberFormatArray(), i), o != null)) {
                    i = o.getNationalPrefixFormattingRuleOrDefault();
                    var d = i.indexOf("$1");
                    0 >= d || (i = i.substring(0, d), i = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(i), i.length != 0 && (t = o.clone(), t.clearNationalPrefixFormattingRule(), t = this.formatByPattern(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, [t])));
                  }
              }
              return e = e.getRawInputOrDefault(), t != null && 0 < e.length && (o = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(t), i = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e), o != i && (t = e)), t;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function(e, t, o) {
              if (e = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e), goog.string.startsWith(e, t)) try {
                return this.isValidNumber(this.parse(e.substring(t.length), o));
              } catch {
              }
              return !1;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function(e) {
              var t = e.getCountryCodeOrDefault(), o = this.getRegionCodeForCountryCode(t);
              return t = this.getMetadataForRegionOrCallingCode_(t, o), t == null ? !1 : (e = this.getNationalSignificantNumber(e), this.chooseFormattingPatternForNumber_(t.numberFormatArray(), e) != null);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function(e, t) {
              var o = e.getRawInputOrDefault();
              if (o.length == 0) return this.formatOutOfCountryCallingNumber(e, t);
              var i = e.getCountryCodeOrDefault();
              if (!this.hasValidCountryCallingCode_(i)) return o;
              o = i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(o, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, !0);
              var d = this.getNationalSignificantNumber(e);
              if (3 < d.length) {
                var s = o.indexOf(d.substring(0, 3));
                s != -1 && (o = o.substring(s));
              }
              if (s = this.getMetadataForRegion(t), i == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                if (this.isNANPACountry(t)) return i + " " + o;
              } else if (s != null && i == this.getCountryCodeForValidRegion_(t))
                return i = this.chooseFormattingPatternForNumber_(s.numberFormatArray(), d), i == null ? o : (i = i.clone(), i.setPattern("(\\d+)(.*)"), i.setFormat("$1$2"), this.formatNsnUsingPattern_(o, i, i18n.phonenumbers.PhoneNumberFormat.NATIONAL));
              return t = "", s != null && (t = s.getInternationalPrefixOrDefault(), t = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(
                i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_,
                t
              ) ? t : s.getPreferredInternationalPrefixOrDefault()), s = this.getRegionCodeForCountryCode(i), s = this.getMetadataForRegionOrCallingCode_(i, s), e = this.maybeGetFormattedExtension_(e, s, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL), 0 < t.length ? t + " " + i + " " + o + e : this.prefixNumberWithCountryCallingCode_(i, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, o, e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function(e) {
              if (!e.hasNationalNumber()) return "";
              var t = "" + e.getNationalNumber();
              return e.hasItalianLeadingZero() && e.getItalianLeadingZero() && 0 < e.getNumberOfLeadingZerosOrDefault() ? Array(e.getNumberOfLeadingZerosOrDefault() + 1).join("0") + t : t;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function(e, t, o, i) {
              switch (t) {
                case i18n.phonenumbers.PhoneNumberFormat.E164:
                  return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + e + o + i;
                case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
                  return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + e + " " + o + i;
                case i18n.phonenumbers.PhoneNumberFormat.RFC3966:
                  return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + e + "-" + o + i;
                default:
                  return o + i;
              }
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function(e, t, o, i) {
              return t = t.intlNumberFormatArray().length == 0 || o == i18n.phonenumbers.PhoneNumberFormat.NATIONAL ? t.numberFormatArray() : t.intlNumberFormatArray(), t = this.chooseFormattingPatternForNumber_(t, e), t == null ? e : this.formatNsnUsingPattern_(e, t, o, i);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function(e, t) {
              for (var o, i = e.length, d = 0; d < i; ++d) {
                o = e[d];
                var s = o.leadingDigitsPatternCount();
                if ((s == 0 || t.search(o.getLeadingDigitsPattern(s - 1)) == 0) && (s = new RegExp(o.getPattern()), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(s, t))) return o;
              }
              return null;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function(e, t, o, i) {
              var d = t.getFormatOrDefault(), s = new RegExp(t.getPattern()), n = t.getDomesticCarrierCodeFormattingRuleOrDefault();
              return o == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && i != null && 0 < i.length && 0 < n.length ? (t = n.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_, i), d = d.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, t), e = e.replace(s, d)) : (t = t.getNationalPrefixFormattingRuleOrDefault(), e = o == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && t != null && 0 < t.length ? e.replace(s, d.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, t)) : e.replace(s, d)), o == i18n.phonenumbers.PhoneNumberFormat.RFC3966 && (e = e.replace(new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ""), e = e.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, "g"), "-")), e;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function(e) {
              return this.getExampleNumberForType(e, i18n.phonenumbers.PhoneNumberType.FIXED_LINE);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function(e, t) {
              if (!this.isValidRegionCode_(e)) return null;
              t = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(e), t);
              try {
                if (t.hasExampleNumber()) return this.parse(t.getExampleNumber(), e);
              } catch {
              }
              return null;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function(e) {
              var t = this.getMetadataForNonGeographicalRegion(e);
              if (t != null && (t = [t.getMobile(), t.getTollFree(), t.getSharedCost(), t.getVoip(), t.getVoicemail(), t.getUan(), t.getPremiumRate()].find(function(o, i) {
                return o.hasExampleNumber();
              }), t !== void 0)) try {
                return this.parse("+" + e + t.getExampleNumber(), "ZZ");
              } catch {
              }
              return null;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function(e, t, o) {
              return e.hasExtension() && e.getExtension().length != 0 ? o == i18n.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + e.getExtension() : t.hasPreferredExtnPrefix() ? t.getPreferredExtnPrefix() + e.getExtensionOrDefault() : i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + e.getExtensionOrDefault() : "";
            }, i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function(e, t) {
              switch (t) {
                case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:
                  return e.getPremiumRate();
                case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:
                  return e.getTollFree();
                case i18n.phonenumbers.PhoneNumberType.MOBILE:
                  return e.getMobile();
                case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:
                case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
                  return e.getFixedLine();
                case i18n.phonenumbers.PhoneNumberType.SHARED_COST:
                  return e.getSharedCost();
                case i18n.phonenumbers.PhoneNumberType.VOIP:
                  return e.getVoip();
                case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
                  return e.getPersonalNumber();
                case i18n.phonenumbers.PhoneNumberType.PAGER:
                  return e.getPager();
                case i18n.phonenumbers.PhoneNumberType.UAN:
                  return e.getUan();
                case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:
                  return e.getVoicemail();
                default:
                  return e.getGeneralDesc();
              }
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function(e) {
              var t = this.getRegionCodeForNumber(e);
              return t = this.getMetadataForRegionOrCallingCode_(e.getCountryCodeOrDefault(), t), t == null ? i18n.phonenumbers.PhoneNumberType.UNKNOWN : (e = this.getNationalSignificantNumber(e), this.getNumberTypeHelper_(e, t));
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function(e, t) {
              return this.isNumberMatchingDesc_(e, t.getGeneralDesc()) ? this.isNumberMatchingDesc_(e, t.getPremiumRate()) ? i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(e, t.getTollFree()) ? i18n.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(e, t.getSharedCost()) ? i18n.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(e, t.getVoip()) ? i18n.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(
                e,
                t.getPersonalNumber()
              ) ? i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : this.isNumberMatchingDesc_(e, t.getPager()) ? i18n.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(e, t.getUan()) ? i18n.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(e, t.getVoicemail()) ? i18n.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(e, t.getFixedLine()) ? t.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(e, t.getMobile()) ? i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n.phonenumbers.PhoneNumberType.FIXED_LINE : !t.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(e, t.getMobile()) ? i18n.phonenumbers.PhoneNumberType.MOBILE : i18n.phonenumbers.PhoneNumberType.UNKNOWN : i18n.phonenumbers.PhoneNumberType.UNKNOWN;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function(e) {
              if (e == null) return null;
              e = e.toUpperCase();
              var t = this.regionToMetadataMap[e];
              if (t == null) {
                t = new goog.proto2.PbLiteSerializer();
                var o = i18n.phonenumbers.metadata.countryToMetadata[e];
                if (o == null) return null;
                t = t.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), o), this.regionToMetadataMap[e] = t;
              }
              return t;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function(e) {
              return this.getMetadataForRegion("" + e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function(e, t) {
              var o = e.length;
              return 0 < t.possibleLengthCount() && t.possibleLengthArray().indexOf(o) == -1 ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(t.getNationalNumberPatternOrDefault(), e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function(e) {
              var t = this.getRegionCodeForNumber(e);
              return this.isValidNumberForRegion(e, t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function(e, t) {
              var o = e.getCountryCodeOrDefault(), i = this.getMetadataForRegionOrCallingCode_(o, t);
              return i == null || i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != t && o != this.getCountryCodeForValidRegion_(t) ? !1 : (e = this.getNationalSignificantNumber(e), this.getNumberTypeHelper_(e, i) != i18n.phonenumbers.PhoneNumberType.UNKNOWN);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function(e) {
              if (e == null) return null;
              var t = e.getCountryCodeOrDefault();
              return t = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[t], t == null ? null : t.length == 1 ? t[0] : this.getRegionCodeForNumberFromRegionList_(e, t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function(e, t) {
              e = this.getNationalSignificantNumber(e);
              for (var o, i = t.length, d = 0; d < i; d++) {
                o = t[d];
                var s = this.getMetadataForRegion(o);
                if (s.hasLeadingDigits()) {
                  if (e.search(s.getLeadingDigits()) == 0) return o;
                } else if (this.getNumberTypeHelper_(e, s) != i18n.phonenumbers.PhoneNumberType.UNKNOWN) return o;
              }
              return null;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function(e) {
              return e = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[e], e == null ? i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : e[0];
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function(e) {
              return e = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[e], e ?? [];
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function(e) {
              return this.isValidRegionCode_(e) ? this.getCountryCodeForValidRegion_(e) : 0;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function(e) {
              var t = this.getMetadataForRegion(e);
              if (t == null) throw Error("Invalid region code: " + e);
              return t.getCountryCodeOrDefault();
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function(e, t) {
              return e = this.getMetadataForRegion(e), e == null || (e = e.getNationalPrefixOrDefault(), e.length == 0) ? null : (t && (e = e.replace("~", "")), e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function(e) {
              return e != null && i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_].includes(e.toUpperCase());
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e) ? (e = new goog.string.StringBuffer(e), this.maybeStripExtension(e), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, e.toString())) : !1;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function(e) {
              return e = this.isPossibleNumberWithReason(e), e == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || e == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function(e, t) {
              return e = this.isPossibleNumberForTypeWithReason(e, t), e == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || e == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function(e, t) {
              return this.testNumberLengthForType_(e, t, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function(e, t, o) {
              var i = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(t, o), d = i.possibleLengthCount() == 0 ? t.getGeneralDesc().possibleLengthArray() : i.possibleLengthArray();
              if (i = i.possibleLengthLocalOnlyArray(), o == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE) if (i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(t, i18n.phonenumbers.PhoneNumberType.FIXED_LINE))) o = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(t, i18n.phonenumbers.PhoneNumberType.MOBILE), i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(o) && (d = d.concat(o.possibleLengthCount() == 0 ? t.getGeneralDesc().possibleLengthArray() : o.possibleLengthArray()), d.sort(), i.length == 0 ? i = o.possibleLengthLocalOnlyArray() : (i = i.concat(o.possibleLengthLocalOnlyArray()), i.sort()));
              else return this.testNumberLengthForType_(e, t, i18n.phonenumbers.PhoneNumberType.MOBILE);
              return d[0] == -1 ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH : (e = e.length, -1 < i.indexOf(e) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY : (t = d[0], t == e ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : t > e ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : d[d.length - 1] < e ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < d.indexOf(e, 1) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH));
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function(e) {
              return this.isPossibleNumberForTypeWithReason(e, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function(e, t) {
              var o = this.getNationalSignificantNumber(e);
              if (e = e.getCountryCodeOrDefault(), !this.hasValidCountryCallingCode_(e)) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
              var i = this.getRegionCodeForCountryCode(e);
              return e = this.getMetadataForRegionOrCallingCode_(e, i), this.testNumberLengthForType_(o, e, t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function(e, t) {
              try {
                return this.isPossibleNumber(this.parse(e, t));
              } catch {
                return !1;
              }
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function(e) {
              if (this.isValidNumber(e)) return !0;
              var t = e.clone(), o = e.getNationalNumberOrDefault();
              do
                if (o = Math.floor(o / 10), t.setNationalNumber(o), o == 0 || this.isPossibleNumberWithReason(t) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT) return !1;
              while (!this.isValidNumber(t));
              return e.setNationalNumber(o), !0;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function(e, t) {
              if (e = e.toString(), e.length == 0 || e.charAt(0) == "0") return 0;
              for (var o, i = e.length, d = 1; d <= i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && d <= i; ++d) if (o = parseInt(e.substring(0, d), 10), o in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap) return t.append(e.substring(d)), o;
              return 0;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function(e, t, o, i, d) {
              if (e.length == 0) return 0;
              e = new goog.string.StringBuffer(e);
              var s;
              if (t != null && (s = t.getInternationalPrefix()), s == null && (s = "NonMatch"), s = this.maybeStripInternationalPrefixAndNormalize(e, s), i && d.setCountryCodeSource(s), s != i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
                if (e.getLength() <= i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
                if (t = this.extractCountryCode(e, o), t != 0) return d.setCountryCode(t), t;
                throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
              }
              if (t != null) {
                s = t.getCountryCodeOrDefault();
                var n = "" + s, r = e.toString();
                if (goog.string.startsWith(r, n) && (n = new goog.string.StringBuffer(r.substring(n.length)), r = t.getGeneralDesc(), r = new RegExp(r.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(n, t, null), n = n.toString(), !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(r, e.toString()) && i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(
                  r,
                  n
                ) || this.testNumberLength_(e.toString(), t) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG)) return o.append(n), i && d.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), d.setCountryCode(s), s;
              }
              return d.setCountryCode(0), 0;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function(e, t) {
              var o = t.toString();
              if (o.search(e) == 0) {
                e = o.match(e)[0].length;
                var i = o.substring(e).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
                return i && i[1] != null && 0 < i[1].length && i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(i[1]) == "0" ? !1 : (t.clear(), t.append(o.substring(e)), !0);
              }
              return !1;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function(e, t) {
              var o = e.toString();
              return o.length == 0 ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY : i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(o) ? (o = o.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), e.clear(), e.append(i18n.phonenumbers.PhoneNumberUtil.normalize(o)), i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN) : (t = new RegExp(t), i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e), this.parsePrefixAsIdd_(t, e) ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function(e, t, o) {
              var i = e.toString(), d = i.length, s = t.getNationalPrefixForParsing();
              if (d == 0 || s == null || s.length == 0) return !1;
              var n = new RegExp("^(?:" + s + ")");
              if (d = n.exec(i)) {
                s = new RegExp(t.getGeneralDesc().getNationalNumberPatternOrDefault());
                var r = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(s, i), u = d.length - 1;
                if (t = t.getNationalPrefixTransformRule(), t == null || t.length == 0 || d[u] == null || d[u].length == 0) {
                  if (r && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(
                    s,
                    i.substring(d[0].length)
                  )) return !1;
                  o != null && 0 < u && d[u] != null && o.append(d[1]), e.set(i.substring(d[0].length));
                } else {
                  if (i = i.replace(n, t), r && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(s, i)) return !1;
                  o != null && 0 < u && o.append(d[1]), e.set(i);
                }
                return !0;
              }
              return !1;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function(e) {
              var t = e.toString(), o = t.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
              if (0 <= o && i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(t.substring(0, o))) {
                for (var i = t.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), d = i.length, s = 1; s < d; ++s) if (i[s] != null && 0 < i[s].length) return e.clear(), e.append(t.substring(0, o)), i[s];
              }
              return "";
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function(e, t) {
              return this.isValidRegionCode_(t) || e != null && 0 < e.length && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.parse = function(e, t) {
              return this.parseHelper_(e, t, !1, !0);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function(e, t) {
              if (!this.isValidRegionCode_(t) && 0 < e.length && e.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
              return this.parseHelper_(e, t, !0, !0);
            }, i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function(e, t) {
              if (1 < e.length && e.charAt(0) == "0") {
                t.setItalianLeadingZero(!0);
                for (var o = 1; o < e.length - 1 && e.charAt(o) == "0"; ) o++;
                o != 1 && t.setNumberOfLeadingZeros(o);
              }
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function(e, t, o, i) {
              if (e == null) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
              if (e.length > i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
              var d = new goog.string.StringBuffer();
              if (this.buildNationalNumberForParsing_(e, d), !i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(d.toString())) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
              if (i && !this.checkRegionForParsing_(d.toString(), t)) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
              i = new i18n.phonenumbers.PhoneNumber(), o && i.setRawInput(e), e = this.maybeStripExtension(d), 0 < e.length && i.setExtension(e);
              var s = this.getMetadataForRegion(t);
              e = new goog.string.StringBuffer();
              var n = 0, r = d.toString();
              try {
                n = this.maybeExtractCountryCode(r, s, e, o, i);
              } catch (u) {
                if (u.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(r)) {
                  if (r = r.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), n = this.maybeExtractCountryCode(
                    r,
                    s,
                    e,
                    o,
                    i
                  ), n == 0) throw u;
                } else throw u;
              }
              if (n != 0 ? (d = this.getRegionCodeForCountryCode(n), d != t && (s = this.getMetadataForRegionOrCallingCode_(n, d))) : (i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(d), e.append(d.toString()), t != null ? (n = s.getCountryCodeOrDefault(), i.setCountryCode(n)) : o && i.clearCountryCodeSource()), e.getLength() < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ || (s != null && (t = new goog.string.StringBuffer(), d = new goog.string.StringBuffer(e.toString()), this.maybeStripNationalPrefixAndCarrierCode(d, s, t), s = this.testNumberLength_(d.toString(), s), n = i18n.phonenumbers.PhoneNumberUtil.ValidationResult, s != n.TOO_SHORT && s != n.IS_POSSIBLE_LOCAL_ONLY && s != n.INVALID_LENGTH && (e = d, o && 0 < t.toString().length && i.setPreferredDomesticCarrierCode(t.toString()))), o = e.toString(), e = o.length, e < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)) throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
              if (e > i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
              return i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(o, i), i.setNationalNumber(parseInt(o, 10)), i;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_ = function(e) {
              var t = e.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
              if (t === -1) return null;
              if (t += i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length, t >= e.length) return "";
              var o = e.indexOf(";", t);
              return o !== -1 ? e.substring(t, o) : e.substring(t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_ = function(e) {
              if (e == null) return !0;
              if (e.length === 0) return !1;
              var t = i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.exec(e);
              return e = i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_.exec(e), t !== null || e !== null;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function(e, t) {
              var o = i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_(e);
              if (!i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_(o)) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
              if (o != null) {
                o.charAt(0) === i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && t.append(o), o = e.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_), o = 0 <= o ? o + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0;
                var i = e.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
                t.append(e.substring(o, i));
              } else t.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(e ?? ""));
              e = t.toString(), o = e.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_), 0 < o && (t.clear(), t.append(e.substring(0, o)));
            }, i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function(e) {
              var t = new i18n.phonenumbers.PhoneNumber();
              return t.setCountryCode(e.getCountryCodeOrDefault()), t.setNationalNumber(e.getNationalNumberOrDefault()), 0 < e.getExtensionOrDefault().length && t.setExtension(e.getExtensionOrDefault()), e.getItalianLeadingZero() && (t.setItalianLeadingZero(!0), t.setNumberOfLeadingZeros(e.getNumberOfLeadingZerosOrDefault())), t;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function(e, t) {
              if (typeof e == "string") try {
                var o = this.parse(e, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
              } catch (s) {
                if (s.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE) return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                if (typeof t != "string") {
                  var i = this.getRegionCodeForCountryCode(t.getCountryCodeOrDefault());
                  if (i != i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
                    try {
                      o = this.parse(e, i);
                    } catch {
                      return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                    }
                    var d = this.isNumberMatch(o, t);
                    return d == i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : d;
                  }
                }
                try {
                  o = this.parseHelper_(e, null, !1, !1);
                } catch {
                  return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                }
              }
              else o = e.clone();
              if (typeof t == "string") try {
                return d = this.parse(t, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_), this.isNumberMatch(e, d);
              } catch (s) {
                return s.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER : this.isNumberMatch(t, o);
              }
              else d = t.clone();
              return e = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(o), d = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(d), e.hasExtension() && d.hasExtension() && e.getExtension() != d.getExtension() ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH : (t = e.getCountryCodeOrDefault(), o = d.getCountryCodeOrDefault(), t != 0 && o != 0 ? e.equals(d) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : t == o && this.isNationalNumberSuffixOfTheOther_(e, d) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH : (e.setCountryCode(0), d.setCountryCode(0), e.equals(d) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(e, d) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH));
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function(e, t) {
              return e = "" + e.getNationalNumber(), t = "" + t.getNationalNumber(), goog.string.endsWith(e, t) || goog.string.endsWith(t, e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function(e) {
              var t = this.getMetadataForRegion(this.getRegionCodeForNumber(e));
              return t == null ? !0 : (e = this.getNationalSignificantNumber(e), !this.isNumberMatchingDesc_(e, t.getNoInternationalDialling()));
            }, i18n.phonenumbers.PhoneNumberUtil.matchesEntirely = function(e, t) {
              return !!((e = t.match(new RegExp("^(?:" + (typeof e == "string" ? e : e.source) + ")$", "i"))) && e[0].length == t.length);
            }, i18n.phonenumbers.PhoneNumberUtil.matchesPrefix = function(e, t) {
              return !!((e = typeof e == "string" ? t.match("^(?:" + e + ")") : t.match(e)) && goog.string.startsWith(t, e[0]));
            }, i18n.phonenumbers.shortnumbermetadata = {}, i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap = { 0: "AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ") }, i18n.phonenumbers.shortnumbermetadata.countryToMetadata = {
              AC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "AC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              AD: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[0268]", , , , "110"], [, , , , , , , , , [-1]], , , , "AD", , , , , , , , , , , , , , , , , , [, , "11[0268]", , , , "110"], , [, , "11[0268]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              AE: [, [, , "[149]\\d{2,3}", , , , , , , [3, 4]], , , [
                ,
                ,
                "112|99[7-9]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], [, , , , , , , , , [-1]], , , , "AE", , , , , , , , , , , , , , , , , , [, , "112|99[7-9]", , , , "112", , , [3]], , [, , "112|445[16]|99[7-9]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "445\\d", , , , "4450", , , [4]]],
              AF: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:0[02]|19)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "AF", , , , , , , , , , , , , , , , , , [, , "1(?:0[02]|19)", , , , "100", , , [3]], , [, , "1(?:0[02]|19)|40404", , , , "100"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              AG: [
                ,
                [, , "[19]\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "9(?:11|88|99)", , , , "911"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "AG",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "9(?:11|99)", , , , "911"],
                ,
                [, , "176|9(?:11|88|99)", , , , "176"],
                [, , , , , , , , , [-1]],
                [, , "176", , , , "176"],
                ,
                [, , "176", , , , "176"]
              ],
              AI: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "AI", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              AL: [, [, , "[15]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)", , , , "112", , , [3, 6]], [
                ,
                ,
                "5\\d{4}",
                ,
                ,
                ,
                "50000",
                ,
                ,
                [5]
              ], , , , "AL", , , , , , , , , , , , , , , , , , [, , "1(?:12|2[7-9])", , , , "112", , , [3]], , [, , "1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])", , , , "110"], [, , , , , , , , , [-1]], [, , "123", , , , "123", , , [3]], , [, , "131|5\\d{4}", , , , "131", , , [3, 5]]],
              AM: [, [, , "[148]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10[1-3]", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "AM", , , , , , , , , , , , , , , , , , [, , "10[1-3]", , , , "101", , , [3]], , [, , "(?:1|8[1-7])\\d\\d|40404", , , , "100"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]],
              AO: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[235]", , , , "112"], [, , , , , , , , , [-1]], , , , "AO", , , , , , , , , , , , , , , , , , [, , "11[235]", , , , "112"], , [, , "11[235]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              AR: [, [, , "[01389]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911", , , , "19", , , [2, 3]], [, , , , , , , , , [-1]], , , , "AR", , , , , , , , , , , , , , , , , , [, , "10[017]|911", , , , "100", , , [3]], , [, , "000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911", , , , "19"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , "893\\d\\d", , , , "89300", , , [5]], , [, , "(?:337|893\\d)\\d", , , , "3370", , , [4, 5]]],
              AS: [, [, , "[49]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "9(?:11|88)", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "AS", , , , , , , , , , , , , , , , , , [, , "911", , , , "911", , , [3]], , [, , "40404|9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              AT: [, [, , "[1268]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:12|2[0238]|3[03]|4[0-247])|1(?:16\\d\\d|4[58])\\d", , , , "112", , , [3, 4, 6]], [, , , , , , , , , [-1]], , , , "AT", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "1(?:[12]2|33|44)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], , [, , "1(?:1(?:2|6(?:00[06]|1(?:17|23)))|2[0238]|3[03]|4(?:[0-247]|5[05]|84))|(?:2(?:066|20)|61|8108[1-3])0", , , , "112"], [, , , , , , , , , [-1]], [, , "220\\d|610|(?:206|810\\d)\\d\\d", , , , "610"], , [, , "206\\d\\d", , , , "20600", , , [5]]],
              AU: [, [, , "[0-27]\\d{2,7}", , , , , , , [3, 4, 5, 6, 7, 8]], , , [, , "000|1(?:06|12|258885|55\\d)|733", , , , "000", , , [3, 4, 7]], [, , "1(?:2(?:34|456)|9\\d{4,6})", , , , "1234", , , [4, 5, 6, 7, 8]], , , , "AU", , , , , , , , , , , , , , , , , , [, , "000|1(?:06|12)", , , , "000", , , [3]], , [
                ,
                ,
                "000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)",
                ,
                ,
                ,
                "000"
              ], [, , "1(?:1[09]\\d|24733)|225|767", , , , "225", , , [3, 4, 6]], [, , "1(?:258885|55\\d)", , , , "1550", , , [4, 7]], , [, , "19\\d{4,6}", , , , "190000", , , [6, 7, 8]]],
              AW: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "100|911", , , , "100"], [, , , , , , , , , [-1]], , , , "AW", , , , , , , , , , , , , , , , , , [, , "100|911", , , , "100"], , [, , "1(?:00|18|76)|91[13]", , , , "100"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              AX: [, [, , "[17]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "AX", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [
                ,
                ,
                "112|75[12]\\d\\d",
                ,
                ,
                ,
                "112"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              AZ: [, [, , "[148]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "AZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], , [, , "1(?:0[1-3]|12)|(?:404|880)0", , , , "101"], [, , , , , , , , , [-1]], [, , "(?:404|880)\\d", , , , "4040", , , [4]], , [, , "(?:404|880)\\d", , , , "4040", , , [4]]],
              BA: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:16\\d{3}|2[2-4])", , , , "122", , , [3, 6]], [, , , , , , , , , [-1]], , , , "BA", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "12[2-4]",
                ,
                ,
                ,
                "122",
                ,
                ,
                [3]
              ], , [, , "1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?", , , , "122"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              BB: [, [, , "[2-689]\\d\\d", , , , , , , [3]], , , [, , "988|[2359]11", , , , "211"], [, , , , , , , , , [-1]], , , , "BB", , , , , , , , , , , , , , , , , , [, , "[2359]11", , , , "211"], , [, , "988|[2-689]11", , , , "211"], [, , , , , , , , , [-1]], [, , "[468]11", , , , "411"], , [, , , , , , , , , [-1]]],
              BD: [
                ,
                [, , "[1579]\\d{2,4}", , , , , , , [3, 4, 5]],
                ,
                ,
                [, , "10[0-26]|[19]99", , , , "100", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "BD",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "10[0-2]|[19]99", , , , "100", , , [3]],
                ,
                [, , "1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d", , , , "100"],
                [, , , , , , , , , [-1]],
                [, , "1(?:11|2[13])|(?:501|959)\\d|786", , , , "111", , , [3, 4]],
                ,
                [, , "959\\d", , , , "9590", , , [4]]
              ],
              BE: [, [, , "[1-9]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:0[0-35-8]|1[0269]|7(?:12|77)|813)|(?:116|8)\\d{3}", , , , "100"], [
                ,
                ,
                "1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d",
                ,
                ,
                ,
                "1204",
                ,
                ,
                [4]
              ], , , , "BE", , , , , , , , , , , , , , , , , , [, , "1(?:0[01]|12)", , , , "100", , , [3]], , [, , "1(?:0[0-8]|16117|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|11[02679]|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "[2-9]\\d{3}", , , , "2000", , , [4]]],
              BF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "BF", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , [, , , , , , , , , [-1]]],
              BG: [, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:1(?:2|6\\d{3})|50|6[06])", , , , "112"], [, , , , , , , , , [-1]], , , , "BG", , , , , , , , , , , , , , , , , , [, , "1(?:12|50|6[06])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|50|6[06])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              BH: [, [, , "[0189]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "(?:0[167]|81)\\d{3}|[19]99", , , , "199"], [, , "9[148]\\d{3}", , , , "91000", , , [5]], , , , "BH", , , , , , , , , , , , , , , , , , [, , "[19]99", , , , "199", , , [3]], , [
                ,
                ,
                "1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}",
                ,
                ,
                ,
                "100"
              ], [, , , , , , , , , [-1]], [, , "0[67]\\d{3}|88000|98555", , , , "06000", , , [5]], , [, , "88000|98555", , , , "88000", , , [5]]],
              BI: [, [, , "[16-9]\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[237]|611", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "BI", , , , , , , , , , , , , , , , , , [, , "11[237]", , , , "112", , , [3]], , [, , "1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900", , , , "110"], [, , , , , , , , , [-1]], [, , "611|7(?:10|77)|888|900", , , , "611", , , [3]], , [, , "(?:71|90)0", , , , "710", , , [3]]],
              BJ: [, [, , "[17]\\d{2,3}", , , , , , , [3, 4]], , , [
                ,
                ,
                "1(?:1[246-8]|3[68]|6[06])|7[3-5]\\d\\d",
                ,
                ,
                ,
                "112"
              ], [, , , , , , , , , [-1]], , , , "BJ", , , , , , , , , , , , , , , , , , [, , "11[246-8]", , , , "112", , , [3]], , [, , "1(?:05|1[24-8]|2[02-5]|3[126-8]|5[05]|6[06]|89)|7[0-5]\\d\\d", , , , "105"], [, , , , , , , , , [-1]], [, , "12[02-5]", , , , "120", , , [3]], , [, , , , , , , , , [-1]]],
              BL: [, [, , "1\\d", , , , , , , [2]], , , [, , "18", , , , "18"], [, , , , , , , , , [-1]], , , , "BL", , , , , , , , , , , , , , , , , , [, , "18", , , , "18"], , [, , "18", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              BM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "BM", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              BN: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "99[135]", , , , "991"], [, , , , , , , , , [-1]], , , , "BN", , , , , , , , , , , , , , , , , , [, , "99[135]", , , , "991"], , [, , "99[135]", , , , "991"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              BO: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[089]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "BO", , , , , , , , , , , , , , , , , , [, , "11[089]", , , , "110", , , [3]], , [, , "11[089]|40404", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]],
              BQ: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], , , , "BQ", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              BR: [, [, , "[1-69]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911", , , , "100", , , [3, 4]], [, , , , , , , , , [-1]], , , , "BR", , , , , , , , , , , , , , , , , , [, , "1(?:12|28|9[023])|911", , , , "112", , , [3]], , [
                ,
                ,
                "1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]",
                ,
                ,
                ,
                "100"
              ], [, , "102|273\\d\\d|321", , , , "102", , , [3, 5]], [, , "151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)", , , , "151", , , [3, 4, 5]], , [, , "285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}", , , , "321"]],
              BS: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:1[19]|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "BS", , , , , , , , , , , , , , , , , , [, , "91[19]", , , , "911"], , [, , "9(?:1[19]|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              BT: [
                ,
                [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]],
                ,
                ,
                [, , "11[023]", , , , "110", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "BT",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[023]", , , , "110", , , [3]],
                ,
                [, , "11[0-6]|40404", , , , "110"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , "404\\d\\d", , , , "40400", , , [5]]
              ],
              BW: [, [, , "[19]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "9(?:11|9[7-9])", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "BW", , , , , , , , , , , , , , , , , , [, , "9(?:11|9[7-9])", , , , "911", , , [3]], , [, , "1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])", , , , "112"], [, , , , , , , , , [-1]], [, , "131\\d\\d", , , , "13100", , , [5]], , [, , "131\\d\\d", , , , "13100", , , [5]]],
              BY: [
                ,
                [, , "1\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "1(?:0[1-3]|12)", , , , "101"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "BY",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:0[1-3]|12)", , , , "101"],
                ,
                [, , "1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])", , , , "101"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              BZ: [, [, , "9\\d\\d?", , , , , , , [2, 3]], , , [, , "9(?:0|11|22|66|77|9[09])", , , , "90"], [, , , , , , , , , [-1]], , , , "BZ", , , , , , , , , , , , , , , , , , [, , "9(?:0|11|90)", , , , "90"], , [, , "9(?:0|11|22|66|77|9[09])", , , , "90"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CA: [, [, , "[1-9]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [
                ,
                ,
                "112|988|[29]11",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], [, , , , , , , , , [-1]], , , , "CA", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "[1-35-9]\\d{4,5}|112|[2-8]11|9(?:11|88)", , , , "112"], [, , , , , , , , , [-1]], [, , "[235-7]11", , , , "211", , , [3]], , [, , "[1-35-9]\\d{4,5}", , , , "10000", , , [5, 6]]],
              CC: [, [, , "[01]\\d\\d", , , , , , , [3]], , , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], , , , "CC", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "000"], , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CD: [
                ,
                [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]],
                ,
                ,
                [, , "1(?:1[348]|77|88)", , , , "113", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "CD",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:1[348]|77|88)", , , , "113", , , [3]],
                ,
                [, , "1(?:1[348]|23|77|88)|40404", , , , "113"],
                [, , , , , , , , , [-1]],
                [, , "404\\d\\d", , , , "40400", , , [5]],
                ,
                [, , "404\\d\\d", , , , "40400", , , [5]]
              ],
              CF: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[78]|22\\d)", , , , "117"], [, , , , , , , , , [-1]], , , , "CF", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|220)", , , , "117"], , [, , "1(?:1[478]|220)", , , , "114"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CG: [
                ,
                [, , "1\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "11[178]", , , , "111"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "CG",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[78]", , , , "117"],
                ,
                [, , "11[126-8]", , , , "111"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              CH: [, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:[278]|6\\d{3})|4[47])|5200", , , , "112", , , [3, 4, 6]], [, , "1(?:14|8[0-2589])\\d|543|83111", , , , "543", , , [3, 4, 5]], , , , "CH", , , , , , , , , , , , , , , , , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], , [, , "1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[0145])|6(?:00|[1-46])|8(?:02|1[189]|[25]0|7|8[08]|99))|[2-9]\\d{2,4}", , , , "112"], [
                ,
                ,
                "1(?:4[035]|6[1-46])|1(?:41|60)\\d",
                ,
                ,
                ,
                "140",
                ,
                ,
                [3, 4]
              ], [, , "5(?:200|35)", , , , "535", , , [3, 4]], , [, , "[2-9]\\d{2,4}", , , , "200", , , [3, 4, 5]]],
              CI: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[01]|[78]0)", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "CI", , , , , , , , , , , , , , , , , , [, , "1(?:1[01]|[78]0)", , , , "110", , , [3]], , [, , "1(?:1[01]|[78]0)|4443", , , , "110"], [, , , , , , , , , [-1]], [, , "444\\d", , , , "4440", , , [4]], , [, , "444\\d", , , , "4440", , , [4]]],
              CK: [
                ,
                [, , "9\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "99[689]", , , , "996"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "CK",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "99[689]", , , , "996"],
                ,
                [, , "99[689]", , , , "996"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              CL: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:213|3[1-3])|434\\d|911", , , , "131", , , [3, 4]], [, , "1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d", , , , "1060", , , [4, 5]], , , , "CL", , , , , , , , , , , , , , , , , , [, , "13[1-3]|911", , , , "131", , , [3]], , [
                ,
                ,
                "1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0",
                ,
                ,
                ,
                "100"
              ], [, , "(?:200|333)\\d", , , , "2000", , , [4]], [, , , , , , , , , [-1]], , [, , "13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d", , , , "1060", , , [4, 5]]],
              CM: [, [, , "[18]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:1[37]|[37])", , , , "13", , , [2, 3]], [, , , , , , , , , [-1]], , , , "CM", , , , , , , , , , , , , , , , , , [, , "1(?:1[37]|[37])", , , , "13", , , [2, 3]], , [
                ,
                ,
                "1(?:1[37]|[37])|8711",
                ,
                ,
                ,
                "13"
              ], [, , , , , , , , , [-1]], [, , "871\\d", , , , "8710", , , [4]], , [, , "871\\d", , , , "8710", , , [4]]],
              CN: [, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1[09]|2(?:[02]|1\\d\\d|395))", , , , "110", , , [3, 5]], [, , , , , , , , , [-1]], , , , "CN", , , , , , , , , , , , , , , , , , [, , "1(?:1[09]|20)", , , , "110", , , [3]], , [, , "1(?:00|1[0249]|2395|6[08])|9[56]\\d{3,4}|12[023]|1(?:0(?:[0-26]\\d|8)|21\\d)\\d", , , , "100"], [, , "1(?:0(?:[0-26]\\d|8)\\d|1[24]|23|6[08])|9[56]\\d{3,4}|100", , , , "100"], [, , , , , , , , , [-1]], , [, , "12110", , , , "12110", , , [5]]],
              CO: [, [
                ,
                ,
                "[1-589]\\d\\d(?:\\d{2,3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5, 6]
              ], , , [, , "1(?:1[29]|23|32|56)", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "CO", , , , , , , , , , , , , , , , , , [, , "1(?:1[29]|23|32|56)", , , , "112", , , [3]], , [, , "1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|(?:29002|39003)9|40404|5930\\d\\d|85432|(?:[2359][57]|8(?:7|9\\d))\\d{3}", , , , "106"], [, , , , , , , , , [-1]], [, , "(?:40|85)4\\d\\d", , , , "40400", , , [5]], , [, , "(?:40|85)4\\d\\d", , , , "40400", , , [5]]],
              CR: [, [, , "[1359]\\d{2,3}", , , , , , , [3, 4]], , , [, , "112|911", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "CR", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], , [, , "1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "(?:385|5(?:0[34]|51))\\d", , , , "3850", , , [4]]],
              CU: [, [, , "[12]\\d\\d(?:\\d{3,4})?", , , , , , , [3, 6, 7]], , , [, , "10[4-7]|(?:116|204\\d)\\d{3}", , , , "104"], [, , , , , , , , , [-1]], , , , "CU", , , , , , , , , , , , , , , , , , [, , "10[4-6]", , , , "104", , , [3]], , [
                ,
                ,
                "1(?:0[4-7]|1(?:6111|8)|40)|2045252",
                ,
                ,
                ,
                "104"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CV: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "13[0-2]", , , , "130"], [, , , , , , , , , [-1]], , , , "CV", , , , , , , , , , , , , , , , , , [, , "13[0-2]", , , , "130"], , [, , "13[0-2]", , , , "130"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CW: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], , , , "CW", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              CX: [, [, , "[01]\\d\\d", , , , , , , [3]], , , [
                ,
                ,
                "000|112",
                ,
                ,
                ,
                "000"
              ], [, , , , , , , , , [-1]], , , , "CX", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "000"], , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CY: [, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:1(?:2|6\\d{3})|99)", , , , "112"], [, , , , , , , , , [-1]], , , , "CY", , , , , , , , , , , , , , , , , , [, , "1(?:12|99)", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|99)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CZ: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5\\d)", , , , "112", , , [3, 6]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , , "CZ", , , , , , , , , , , , , , , , , , [, , "1(?:12|5\\d)", , , , "112", , , [3]], , [, , "1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5\\d|99)|1(?:16|4)\\d{3}", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              DE: [, [, , "[1-46-8]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[02]|6\\d{3})", , , , "110", , , [3, 6]], [, , , , , , , , , [-1]], , , , "DE", , , , , , , , , , , , , , , , , , [, , "11[02]", , , , "110", , , [3]], , [
                ,
                ,
                "11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|22(?:044|5(?:43|80)|7700|922)|33(?:11|3[34])|44844|600\\d\\d|7(?:0\\d{3}|464)|80808|118\\d\\d",
                ,
                ,
                ,
                "110"
              ], [, , , , , , , , , [-1]], [, , "(?:33[13]|746)\\d|(?:22(?:[059]|7\\d)|(?:44|80)8|600|70\\d)\\d\\d", , , , "3310", , , [4, 5, 6]], , [, , "(?:333|746)\\d|(?:22(?:[059]|7\\d)|(?:44|80)8|600|70\\d)\\d\\d", , , , "3330", , , [4, 5, 6]]],
              DJ: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "DJ", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              DK: [
                ,
                [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]],
                ,
                ,
                [, , "11(?:[24]|6\\d{3})", , , , "112", , , [3, 6]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "DK",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[24]", , , , "112", , , [3]],
                ,
                [, , "1(?:1(?:[248]|6(?:00[06]|111))|619[0-2]|8(?:01|1[0238]|28|30|5[13]|8[18]))", , , , "112"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              DM: [, [, , "[39]\\d\\d", , , , , , , [3]], , , [, , "333|9(?:11|88|99)", , , , "333"], [, , , , , , , , , [-1]], , , , "DM", , , , , , , , , , , , , , , , , , [, , "333|9(?:11|99)", , , , "333"], , [, , "333|9(?:11|88|99)", , , , "333"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              DO: [
                ,
                [, , "[19]\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "112|9(?:11|88)", , , , "112"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "DO",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112|911", , , , "112"],
                ,
                [, , "112|9(?:11|88)", , , , "112"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              DZ: [, [, , "[17]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:12|[47]|54\\d)", , , , "14"], [, , , , , , , , , [-1]], , , , "DZ", , , , , , , , , , , , , , , , , , [, , "1(?:12|[47])", , , , "14", , , [2, 3]], , [, , "1(?:055|12|[47]|548)|730", , , , "14"], [, , , , , , , , , [-1]], [, , "730", , , , "730", , , [3]], , [, , "730", , , , "730", , , [3]]],
              EC: [
                ,
                [, , "[19]\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "1(?:0[12]|12)|911", , , , "101"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "EC",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:0[12]|12)|911", , , , "101"],
                ,
                [, , "1(?:0[12]|12)|911", , , , "101"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              EE: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))", , , , "110"], [
                ,
                ,
                "1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))",
                ,
                ,
                ,
                "123",
                ,
                ,
                [3, 4, 5]
              ], , , , "EE", , , , , , , , , , , , , , , , , , [, , "11[02]", , , , "110", , , [3]], , [, , "1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
                ,
                ,
                "1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))",
                ,
                ,
                ,
                "126",
                ,
                ,
                [3, 4, 5]
              ]],
              EG: [, [, , "[13]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:2[23]|80)", , , , "122", , , [3]], [, , , , , , , , , [-1]], , , , "EG", , , , , , , , , , , , , , , , , , [, , "1(?:2[23]|80)", , , , "122", , , [3]], , [, , "1(?:2[23]|[679]\\d{3}|80)|34400", , , , "122"], [, , , , , , , , , [-1]], [, , "344\\d\\d", , , , "34400", , , [5]], , [, , "344\\d\\d", , , , "34400", , , [5]]],
              EH: [
                ,
                [, , "1\\d\\d?", , , , , , , [2, 3]],
                ,
                ,
                [, , "1(?:[59]|77)", , , , "15"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "EH",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:[59]|77)", , , , "15"],
                ,
                [, , "1(?:[59]|77)", , , , "15"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              ER: [, [, , "[12]\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "11[2-46]|(?:12[47]|20[12])\\d{3}", , , , "112"], [, , , , , , , , , [-1]], , , , "ER", , , , , , , , , , , , , , , , , , [, , "1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99", , , , "112"], , [, , "1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              ES: [, [, , "[0-379]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "0(?:16|20|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}", , , , "016", , , [3, 4, 6]], [
                ,
                ,
                "[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}",
                ,
                ,
                ,
                "120"
              ], , , , "ES", , , , , , , , , , , , , , , , , , [, , "08[58]|112", , , , "085", , , [3]], , [, , "0(?:1[0-267]|2[0148]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}", , , , "010"], [, , "0(?:1[0-27]|2[148]|6[0-2]|80|9[12])|21\\d{4}", , , , "010", , , [3, 6]], [, , "1(?:3[34]|77)|[12]2\\d{1,4}", , , , "120"], , [, , "(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d", , , , "22000", , , [5, 6]]],
              ET: [
                ,
                [, , "9\\d\\d?", , , , , , , [2, 3]],
                ,
                ,
                [, , "9(?:07|11?|2|39?|9[17])", , , , "91"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "ET",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "9(?:11?|2|39?|9[17])", , , , "91"],
                ,
                [, , "9(?:07|11?|2|39?|45|9[17])", , , , "91"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              FI: [
                ,
                [, , "[17]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]],
                ,
                ,
                [, , "11(?:2|6\\d{3})", , , , "112", , , [3, 6]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "FI",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112", , , , "112", , , [3]],
                ,
                [, , "11(?:2|6(?:00[06]|1(?:1[17]|23)))|(?:1[2-8]\\d|75[12])\\d\\d", , , , "112"],
                [, , "1[2-8]\\d{3}", , , , "12000", , , [5]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              FJ: [, [, , "[0-579]\\d(?:\\d(?:\\d{2})?)?", , , , , , , [2, 3, 5]], , , [, , "91[17]", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "FJ", , , , , , , , , , , , , , , , , , [, , "91[17]", , , , "911", , , [3]], , [, , "0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75", , , , "22"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              FK: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "FK", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "1\\d\\d|999", , , , "100"], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , [, , , , , , , , , [-1]]],
              FM: [, [, , "[39]\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "320\\d{3}|911", , , , "911"], [, , , , , , , , , [-1]], , , , "FM", , , , , , , , , , , , , , , , , , [, , "(?:32022|91)1", , , , "911"], , [, , "(?:32022|91)1", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              FO: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[24]|81\\d)", , , , "112"], [, , , , , , , , , [-1]], , , , "FO", , , , , , , , , , , , , , , , , , [, , "11[24]", , , , "112", , , [3]], , [, , "1(?:1[248]|819)|1(?:4[124]|71|8[7-9])\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              FR: [
                ,
                [, , "[1-8]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]],
                ,
                ,
                [, , "1(?:1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d", , , , "15"],
                [, , "(?:1(?:0|18\\d)|366|[4-8]\\d\\d)\\d\\d|3[2-9]\\d\\d", , , , "1000", , , [4, 5, 6]],
                ,
                ,
                ,
                "FR",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:12|[578])", , , , "15", , , [2, 3]],
                ,
                [, , "1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)", , , , "15"],
                [, , "202\\d|6(?:1[14]|34)|70[06]", , , , "611", , , [3, 4]],
                [
                  ,
                  ,
                  "118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d",
                  ,
                  ,
                  ,
                  "224",
                  ,
                  ,
                  [3, 4, 5, 6]
                ],
                ,
                [, , "114|[3-8]\\d{4}", , , , "114", , , [3, 5]]
              ],
              GA: [, [, , "1\\d(?:\\d{2})?", , , , , , , [2, 4]], , , [, , "18|1(?:3\\d|73)\\d", , , , "18"], [, , , , , , , , , [-1]], , , , "GA", , , , , , , , , , , , , , , , , , [, , "1(?:3\\d\\d|730|8)", , , , "18"], , [, , "1(?:3\\d\\d|730|8)", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GB: [, [, , "[1-46-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999", , , , "105"], [, , , , , , , , , [-1]], , , , "GB", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [
                ,
                ,
                "1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)",
                ,
                ,
                ,
                "100"
              ], [, , , , , , , , , [-1]], [, , "1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901", , , , "202", , , [3, 4, 5]], , [, , "(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d", , , , "1250", , , [4, 5]]],
              GD: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "GD", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              GE: [, [, , "[014]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "0(?:11|33)|11[1-3]|[01]22", , , , "011", , , [3]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , , "GE", , , , , , , , , , , , , , , , , , [, , "0(?:11|33)|11[1-3]|[01]22", , , , "011", , , [3]], , [, , "0(?:11|33)|11[1-3]|40404|[01]22", , , , "011"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              GF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "GF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GG: [
                ,
                [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
                ,
                ,
                [, , "112|999", , , , "112", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "GG",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112|999", , , , "112", , , [3]],
                ,
                [, , "1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d", , , , "100"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              GH: [, [, , "[14589]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "19[1-3]|999", , , , "191", , , [3]], [, , , , , , , , , [-1]], , , , "GH", , , , , , , , , , , , , , , , , , [, , "19[1-3]|999", , , , "191", , , [3]], , [, , "19[1-3]|40404|(?:54|83)00|999", , , , "191"], [, , , , , , , , , [-1]], [, , "404\\d\\d|(?:54|83)0\\d", , , , "5400", , , [4, 5]], , [, , "404\\d\\d|(?:54|83)0\\d", , , , "5400", , , [4, 5]]],
              GI: [, [
                ,
                ,
                "[158]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4, 5, 6]
              ], , , [, , "1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d", , , , "100", , , [3, 4, 6]], [, , "8[1-69]\\d\\d", , , , "8100", , , [4]], , , , "GI", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[09])", , , , "112", , , [3]], , [, , "1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])", , , , "100"], [, , "150|87\\d\\d", , , , "150", , , [3, 4]], [, , "1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])", , , , "100", , , [3, 5]], , [, , , , , , , , , [-1]]],
              GL: [, [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "GL", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "1[1-8]\\d", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GM: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:1[6-8]|[6-8])", , , , "16"], [, , , , , , , , , [-1]], , , , "GM", , , , , , , , , , , , , , , , , , [, , "1(?:1[6-8]|[6-8])", , , , "16"], , [, , "1(?:1[6-8]|[6-8])", , , , "16"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GN: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GN", , , , , , , , , , , , , , , , , , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , [, , "12\\d|40404", , , , "120"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              GP: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "GP", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GR: [, [, , "1\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "1(?:0[089]|1(?:2|6\\d{3})|66|99)", , , , "100", , , [3, 6]], [, , , , , , , , , [-1]], , , , "GR", , , , , , , , , , , , , , , , , , [, , "1(?:00|12|66|99)", , , , "100", , , [3]], , [
                ,
                ,
                "1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)",
                ,
                ,
                ,
                "100"
              ], [, , "113\\d\\d", , , , "11300", , , [5]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GT: [, [, , "[14]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:10|2[03])", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "GT", , , , , , , , , , , , , , , , , , [, , "1(?:10|2[03])", , , , "110", , , [3]], , [, , "110|40404|1(?:2|[57]\\d)\\d", , , , "110"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              GU: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "GU", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GW: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[378]", , , , "113"], [, , , , , , , , , [-1]], , , , "GW", , , , , , , , , , , , , , , , , , [, , "11[378]", , , , "113"], , [, , "11[378]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GY: [, [, , "[019]\\d{2,3}", , , , , , , [3, 4]], , , [, , "91[1-3]", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "GY", , , , , , , , , , , , , , , , , , [, , "91[1-3]", , , , "911", , , [3]], , [, , "0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]", , , , "002"], [, , , , , , , , , [-1]], [
                ,
                ,
                "144\\d",
                ,
                ,
                ,
                "1440",
                ,
                ,
                [4]
              ], , [, , "144\\d", , , , "1440", , , [4]]],
              HK: [
                ,
                [, , "[19]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]],
                ,
                ,
                [, , "112|99[29]", , , , "112", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "HK",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112|99[29]", , , , "112", , , [3]],
                ,
                [, , "1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]", , , , "100"],
                [, , , , , , , , , [-1]],
                [, , "109|1(?:08|85\\d)\\d", , , , "109", , , [3, 4, 5]],
                ,
                [, , "992", , , , "992", , , [3]]
              ],
              HN: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "199", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "HN", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40404", , , , "199"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              HR: [, [, , "[016-9]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d", , , , "93", , , [2, 3, 5, 6]], [, , "06\\d|(?:118|[6-8]\\d{3})\\d\\d", , , , "060", , , [
                3,
                5,
                6
              ]], , , , "HR", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])|9[34]", , , , "93", , , [2, 3]], , [, , "(?:06|[6-8]\\d{4})\\d|1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]", , , , "93"], [, , , , , , , , , [-1]], [, , "139\\d\\d", , , , "13900", , , [5]], , [, , "139\\d\\d", , , , "13900", , , [5]]],
              HT: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[48]", , , , "114", , , [3]], [, , , , , , , , , [-1]], , , , "HT", , , , , , , , , , , , , , , , , , [, , "11[48]", , , , "114", , , [3]], , [, , "11[48]|40404", , , , "114"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]],
              HU: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:0[457]|12|4[0-4]\\d)|1(?:16\\d|37|45)\\d\\d", , , , "104"], [, , , , , , , , , [-1]], , , , "HU", , , , , , , , , , , , , , , , , , [, , "1(?:0[457]|12)", , , , "104", , , [3]], , [, , "1(?:0[457]|1(?:2|6(?:000|1(?:11|23))|800)|2(?:0[0-4]|1[013489]|2[0-5]|3[0-46]|4[0-24-68]|5[0-2568]|6[06]|7[0-25-7]|8[028]|9[08])|37(?:00|37|7[07])|4(?:0[0-5]|1[013-8]|2[034]|3[23]|4[02-9]|5(?:00|41|67))|777|8(?:1[27-9]|2[04]|40|[589]))", , , , "104"], [, , , , , , , , , [-1]], [
                ,
                ,
                "1(?:4[0-4]|77)\\d|1(?:18|2|45)\\d\\d",
                ,
                ,
                ,
                "1200",
                ,
                ,
                [4, 5]
              ], , [, , "184\\d", , , , "1840", , , [4]]],
              ID: [, [, , "[178]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "11[02389]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "ID", , , , , , , , , , , , , , , , , , [, , "11[02389]", , , , "110", , , [3]], , [, , "1(?:1[02389]|40\\d\\d|50264)|71400|89887", , , , "110"], [, , , , , , , , , [-1]], [, , "(?:714|898)\\d\\d", , , , "71400", , , [5]], , [, , "714\\d\\d", , , , "71400", , , [5]]],
              IE: [, [, , "[159]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6\\d{3})|999", , , , "112", , , [3, 6]], [, , "5[37]\\d{3}", , , , "53000", , , [5]], , , , "IE", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "112|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], , [, , "11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d", , , , "112"], [, , "51\\d{3}", , , , "51000", , , [5]], [, , "51210", , , , "51210", , , [5]], , [, , "51210|(?:118|5[037]\\d)\\d\\d", , , , "11800", , , [5]]],
              IL: [, [, , "[12]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[0-2]|12)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "IL", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-2]|12)", , , , "100", , , [3]], , [, , "1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00", , , , "100"], [, , , , , , , , , [-1]], [
                ,
                ,
                "104\\d\\d",
                ,
                ,
                ,
                "10400",
                ,
                ,
                [5]
              ], , [, , "104\\d\\d", , , , "10400", , , [5]]],
              IM: [, [, , "[189]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "999", , , , "999", , , [3]], [, , , , , , , , , [-1]], , , , "IM", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "8(?:64|98)\\d\\d", , , , "86400", , , [5]]],
              IN: [, [, , "[12578]\\d{2,8}", , , , , , , [3, 4, 5, 6, 7, 8, 9]], , , [
                ,
                ,
                "1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3, 4, 5, 6]
              ], [, , "11[67]\\d{4}|56161561", , , , "1160000", , , [7, 8]], , , , "IN", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-28]|12|298)|2611", , , , "100", , , [3, 4]], , [
                ,
                ,
                "1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d",
                ,
                ,
                ,
                "100"
              ], [, , "5(?:14(?:2[5-9]|[34]\\d)|757555)", , , , "51425", , , [5, 7]], [, , "1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])", , , , "118", , , [3, 4, 5, 6, 7, 8]], , [, , "1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)", , , , "139", , , [3, 4, 5, 7, 8]]],
              IQ: [, [, , "[1479]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[04]|15|22)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "IQ", , , , , , , , , , , , , , , , , , [, , "1(?:0[04]|15|22)", , , , "100", , , [3]], , [, , "1(?:0[04]|15|22)|4432|71117|9988", , , , "100"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , "(?:443|711\\d|998)\\d", , , , "4430", , , [4, 5]], , [, , "(?:443|711\\d|998)\\d", , , , "4430", , , [4, 5]]],
              IR: [, [, , "[129]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1[0-68]|2[0-59]|9[0-579])|911", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "IR", , , , , , , , , , , , , , , , , , [, , "1(?:1[025]|25)|911", , , , "110", , , [3]], , [
                ,
                ,
                "1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))",
                ,
                ,
                ,
                "110"
              ], [, , "1(?:5[0-469]|8[0-489])\\d", , , , "1500", , , [4]], [, , "(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d", , , , "1500", , , [4, 6]], , [, , "990\\d{3}", , , , "990000", , , [6]]],
              IS: [, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:12|71\\d)", , , , "112", , , [3, 4]], [, , , , , , , , , [-1]], , , , "IS", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)", , , , "112"], [, , , , , , , , , [-1]], [, , "14(?:0\\d|41)", , , , "1400", , , [4]], , [
                ,
                ,
                "1(?:415|90\\d)",
                ,
                ,
                ,
                "1415",
                ,
                ,
                [4]
              ]],
              IT: [
                ,
                [, , "[14]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]],
                ,
                ,
                [, , "1(?:1(?:[2358]|6\\d{3})|87)", , , , "112", , , [3, 6]],
                [, , "(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d", , , , "1200", , , [4, 5, 7]],
                ,
                ,
                ,
                "IT",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[2358]", , , , "112", , , [3]],
                ,
                [, , "1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d", , , , "112"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , "4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d", , , , "43000", , , [5, 7]]
              ],
              JE: [, [, , "[129]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "112|999", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "JE", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [, , "1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              JM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "11[029]|9(?:11|88)", , , , "110"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , , "JM", , , , , , , , , , , , , , , , , , [, , "11[029]|911", , , , "110"], , [, , "1(?:1[029]|76)|9(?:11|88)", , , , "110"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              JO: [, [, , "[19]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:0[235]|1[2-6]|9[127])|911", , , , "102", , , [3]], [, , "9[0-4689]\\d{3}", , , , "90000", , , [5]], , , , "JO", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[127])|911", , , , "112", , , [3]], , [, , "1(?:0[2359]|1[0-68]|9[0-24-79])|9[0-4689]\\d{3}|911", , , , "102"], [, , , , , , , , , [-1]], [, , "9[0-4689]\\d{3}", , , , "90000", , , [5]], , [
                ,
                ,
                "9[0-4689]\\d{3}",
                ,
                ,
                ,
                "90000",
                ,
                ,
                [5]
              ]],
              JP: [, [, , "[01]\\d\\d(?:\\d{5,7})?", , , , , , , [3, 8, 9, 10]], , , [, , "11[089]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "JP", , , , , , , , , , , , , , , , , , [, , "11[09]", , , , "110", , , [3]], , [, , "000[2569]\\d{4,6}|1(?:0[24]|1[089]|44|89)", , , , "102"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "000[2569]\\d{4,6}", , , , "00020000", , , [8, 9, 10]]],
              KE: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999", , , , "112"], [, , "909\\d\\d", , , , "90900", , , [5]], , , , "KE", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "11[24]|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], , [, , "1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988", , , , "100"], [, , , , , , , , , [-1]], [, , "1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d", , , , "130"], , [
                ,
                ,
                "1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d",
                ,
                ,
                ,
                "141"
              ]],
              KG: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "10[1-3]", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "KG", , , , , , , , , , , , , , , , , , [, , "10[1-3]", , , , "101", , , [3]], , [, , "10[1-3]|4040", , , , "101"], [, , , , , , , , , [-1]], [, , "404\\d", , , , "4040", , , [4]], , [, , "404\\d", , , , "4040", , , [4]]],
              KH: [, [, , "[146]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[7-9]|666", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "KH", , , , , , , , , , , , , , , , , , [, , "11[7-9]|666", , , , "117", , , [3]], , [, , "11[7-9]|40404|666", , , , "117"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]],
              KI: [, [, , "[179]\\d{2,3}", , , , , , , [3, 4]], , , [, , "19[2-5]|99[2-4]", , , , "192", , , [3]], [, , , , , , , , , [-1]], , , , "KI", , , , , , , , , , , , , , , , , , [, , "19[2-5]|99[2-4]", , , , "192", , , [3]], , [, , "1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]", , , , "100"], [, , "103", , , , "103", , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              KM: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "KM", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              KN: [
                ,
                [, , "[39]\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "333|9(?:11|88|99)", , , , "333"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "KN",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "333|9(?:11|99)", , , , "333"],
                ,
                [, , "333|9(?:11|88|99)", , , , "333"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              KP: [, [, , "[18]\\d\\d", , , , , , , [3]], , , [, , "11[29]|819", , , , "112"], [, , , , , , , , , [-1]], , , , "KP", , , , , , , , , , , , , , , , , , [, , "11[29]|819", , , , "112"], , [, , "11[29]|819", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              KR: [
                ,
                [, , "1\\d{2,4}", , , , , , , [3, 4, 5]],
                ,
                ,
                [, , "1(?:1[27-9]|28|330|82)", , , , "112", , , [3, 4]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "KR",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[29]", , , , "112", , , [3]],
                ,
                [, , "1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])", , , , "100"],
                [, , , , , , , , , [-1]],
                [, , "1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d", , , , "100", , , [3, 5]],
                ,
                [, , , , , , , , , [-1]]
              ],
              KW: [, [, , "[18]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "KW", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1[0-7]\\d|89887", , , , "100"], [, , , , , , , , , [-1]], [, , "898\\d\\d", , , , "89800", , , [5]], , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              KY: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "KY", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              KZ: [, [, , "[1-4]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[1-3]|12)|212\\d", , , , "101", , , [3, 4]], [, , , , , , , , , [-1]], , , , "KZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], , [, , "1(?:0[1-4]|12)|2121|(?:3040|404)0", , , , "101"], [, , , , , , , , , [-1]], [, , "(?:304\\d|404)\\d", , , , "4040", , , [4, 5]], , [
                ,
                ,
                "(?:304\\d|404)\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4, 5]
              ]],
              LA: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[015]", , , , "190"], [, , , , , , , , , [-1]], , , , "LA", , , , , , , , , , , , , , , , , , [, , "19[015]", , , , "190"], , [, , "19[015]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LB: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "1(?:12|40|75)|999", , , , "112"], [, , , , , , , , , [-1]], , , , "LB", , , , , , , , , , , , , , , , , , [, , "1(?:12|40|75)|999", , , , "112"], , [, , "1(?:12|40|75)|999", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , , "LC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LI: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "LI", , , , , , , , , , , , , , , , , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], , [, , "1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LK: [
                ,
                [, , "1\\d{2,3}", , , , , , , [3, 4]],
                ,
                ,
                [, , "11[02689]", , , , "110", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "LK",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[02689]", , , , "110", , , [3]],
                ,
                [, , "1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))", , , , "110"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              LR: [, [, , "[3489]\\d{2,3}", , , , , , , [3, 4]], , , [, , "355|911", , , , "355", , , [3]], [, , , , , , , , , [-1]], , , , "LR", , , , , , , , , , , , , , , , , , [, , "355|911", , , , "355", , , [3]], , [, , "355|4040|8(?:400|933)|911", , , , "355"], [, , , , , , , , , [-1]], [
                ,
                ,
                "(?:404|8(?:40|93))\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4]
              ], , [, , "(?:404|8(?:40|93))\\d", , , , "4040", , , [4]]],
              LS: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[257]", , , , "112"], [, , , , , , , , , [-1]], , , , "LS", , , , , , , , , , , , , , , , , , [, , "11[257]", , , , "112"], , [, , "11[257]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LT: [, [, , "[01]\\d(?:\\d(?:\\d{3})?)?", , , , , , , [2, 3, 6]], , , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d", , , , "01"], [, , , , , , , , , [-1]], , , , "LT", , , , , , , , , , , , , , , , , , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|12)", , , , "01", , , [2, 3]], , [
                ,
                ,
                "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))",
                ,
                ,
                ,
                "01"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LU: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[23]|6\\d{3})", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "LU", , , , , , , , , , , , , , , , , , [, , "11[23]", , , , "112", , , [3]], , [, , "11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LV: [, [, , "[018]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "0[1-3]|11(?:[023]|6\\d{3})", , , , "01", , , [2, 3, 6]], [, , "1180|821\\d\\d", , , , "1180", , , [4, 5]], , , , "LV", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "0[1-3]|11[023]",
                ,
                ,
                ,
                "01",
                ,
                ,
                [2, 3]
              ], , [, , "0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4", , , , "01"], [, , "1181", , , , "1181", , , [4]], [, , "165\\d", , , , "1650", , , [4]], , [, , , , , , , , , [-1]]],
              LY: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[013]", , , , "190"], [, , , , , , , , , [-1]], , , , "LY", , , , , , , , , , , , , , , , , , [, , "19[013]", , , , "190"], , [, , "19[013]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MA: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:[59]|77)", , , , "15"], [, , , , , , , , , [-1]], , , , "MA", , , , , , , , , , , , , , , , , , [, , "1(?:[59]|77)", , , , "15"], , [
                ,
                ,
                "1(?:[59]|77)",
                ,
                ,
                ,
                "15"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MC: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "MC", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [, , "1(?:12|41|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MD: [, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "MD", , , , , , , , , , , , , , , , , , [, , "112|90[1-3]", , , , "112", , , [3]], , [
                ,
                ,
                "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d",
                ,
                ,
                ,
                "112"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              ME: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:12|2[2-4])", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "ME", , , , , , , , , , , , , , , , , , [, , "1(?:12|2[2-4])", , , , "112", , , [3]], , [, , "1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MF: [
                ,
                [, , "1\\d", , , , , , , [2]],
                ,
                ,
                [, , "1[578]", , , , "15"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "MF",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1[578]", , , , "15"],
                ,
                [, , "1[578]", , , , "15"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              MG: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:1[78]|[78])", , , , "17"], [, , , , , , , , , [-1]], , , , "MG", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|[78])", , , , "17"], , [, , "1(?:1[78]|[78])", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MH: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "MH", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MK: [, [
                ,
                ,
                "1\\d\\d(?:\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4, 6]
              ], , , [, , "1(?:1(?:2|6\\d{3})|9[2-4])", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "MK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])", , , , "112", , , [3]], , [, , "1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              ML: [, [, , "[136-8]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d", , , , "15", , , [2, 4, 5]], [, , "(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)", , , , "1220", , , [4, 5]], , , , "ML", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15", , , [2]], , [
                ,
                ,
                "1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d",
                ,
                ,
                ,
                "15"
              ], [, , "37(?:433|575)|7400|8001\\d", , , , "7400", , , [4, 5]], [, , "3503\\d|(?:3[67]\\d|800)\\d\\d", , , , "35030", , , [5]], , [, , "374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d", , , , "7400", , , [4, 5]]],
              MM: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "199", , , , "199"], [, , , , , , , , , [-1]], , , , "MM", , , , , , , , , , , , , , , , , , [, , "199", , , , "199"], , [, , "199", , , , "199"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              MN: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "10[0-35]", , , , "100"], [, , , , , , , , , [-1]], , , , "MN", , , , , , , , , , , , , , , , , , [, , "10[0-35]", , , , "100"], , [, , "10[0-35]", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MO: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "MO", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MP: [
                ,
                [, , "9\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "9(?:11|88)", , , , "911"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "MP",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "911", , , , "911"],
                ,
                [, , "9(?:11|88)", , , , "911"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              MQ: [, [, , "[13]\\d(?:\\d(?:\\d(?:\\d{2})?)?)?", , , , , , , [2, 3, 4, 6]], , , [, , "1(?:12|[578])|3[01]\\d\\d", , , , "15", , , [2, 3, 4]], [, , "3[2469]\\d\\d", , , , "3200", , , [4]], , , , "MQ", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15", , , [2, 3]], , [, , "1(?:12|[578])|(?:118[02-9]|3[0-2469])\\d\\d", , , , "15"], [, , "118\\d{3}", , , , "118000", , , [6]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MR: [
                ,
                [, , "1\\d", , , , , , , [2]],
                ,
                ,
                [, , "1[78]", , , , "17"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "MR",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1[78]", , , , "17"],
                ,
                [, , "1[78]", , , , "17"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              MS: [, [, , "[29]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "MS", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "211|9(?:11|88|99)", , , , "211"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MT: [, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "11(?:2|6\\d{3})", , , , "112"], [, , , , , , , , , [-1]], , , , "MT", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "11(?:2|6(?:000|1(?:11|23)))", , , , "112"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MU: [, [, , "[189]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "11[45]|99[59]", , , , "114", , , [3]], [, , , , , , , , , [-1]], , , , "MU", , , , , , , , , , , , , , , , , , [, , "11[45]|99[59]", , , , "114", , , [3]], , [, , "1\\d{2,4}|(?:8\\d\\d|99)\\d", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MV: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:02|1[89])", , , , "102", , , [3]], [, , , , , , , , , [-1]], , , , "MV", , , , , , , , , , , , , , , , , , [, , "1(?:02|1[89])", , , , "102", , , [3]], , [, , "1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1", , , , "100"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , "1[45]1", , , , "141", , , [3]], , [, , , , , , , , , [-1]]],
              MW: [, [, , "[189]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "199|99[7-9]", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "MW", , , , , , , , , , , , , , , , , , [, , "199|99[7-9]", , , , "199", , , [3]], , [, , "199|80400|99[7-9]", , , , "199"], [, , , , , , , , , [-1]], [, , "804\\d\\d", , , , "80400", , , [5]], , [, , "804\\d\\d", , , , "80400", , , [5]]],
              MX: [, [, , "[0579]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "0(?:6[0568]|80)|911", , , , "060", , , [3]], [, , "(?:530\\d|776)\\d", , , , "7760", , , [4, 5]], , , , "MX", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "0(?:6[0568]|80)|911",
                ,
                ,
                ,
                "060",
                ,
                ,
                [3]
              ], , [, , "0[1-9]\\d|53053|7766|911", , , , "010"], [, , , , , , , , , [-1]], [, , "0(?:[249]0|[35][01])", , , , "020", , , [3]], , [, , , , , , , , , [-1]]],
              MY: [, [, , "[1369]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "112|999", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "MY", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [
                ,
                ,
                "1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d",
                ,
                ,
                ,
                "100"
              ], [, , "666\\d\\d", , , , "66600", , , [5]], [, , , , , , , , , [-1]], , [, , "(?:3[23679]\\d|666)\\d\\d", , , , "32000", , , [5]]],
              MZ: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[79]|9[78])", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "MZ", , , , , , , , , , , , , , , , , , [, , "1(?:1[79]|9[78])", , , , "117", , , [3]], , [, , "1(?:[02-5]\\d\\d|1[79]|9[78])", , , , "117"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NA: [, [, , "[19]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10111", , , , "10111", , , [5]], [, , , , , , , , , [-1]], , , , "NA", , , , , , , , , , , , , , , , , , [, , "10111", , , , "10111", , , [5]], , [
                ,
                ,
                "(?:10|93)111|(?:1\\d|9)\\d\\d",
                ,
                ,
                ,
                "900"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NC: [, [, , "[135]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577", , , , "15"], [, , , , , , , , , [-1]], , , , "NC", , , , , , , , , , , , , , , , , , [, , "1[5-8]", , , , "15", , , [2]], , [, , "1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d", , , , "15"], [, , "5(?:67|88)", , , , "567", , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NE: [, [, , "[1-3578]\\d(?:\\d(?:\\d{3})?)?", , , , , , , [2, 3, 6]], , , [
                ,
                ,
                "1(?:18|[578])|723\\d{3}",
                ,
                ,
                ,
                "15"
              ], [, , , , , , , , , [-1]], , , , "NE", , , , , , , , , , , , , , , , , , [, , "1(?:18|[578])|723141", , , , "15"], , [, , "1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888", , , , "15"], [, , , , , , , , , [-1]], [, , "1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888", , , , "100", , , [3]], , [, , , , , , , , , [-1]]],
              NF: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|55|77)", , , , "911"], [, , , , , , , , , [-1]], , , , "NF", , , , , , , , , , , , , , , , , , [, , "9(?:11|55|77)", , , , "911"], , [, , "9(?:11|55|77)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NG: [, [
                ,
                ,
                "[14]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ], , , [, , "199", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "NG", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40700", , , , "199"], [, , , , , , , , , [-1]], [, , "407\\d\\d", , , , "40700", , , [5]], , [, , "407\\d\\d", , , , "40700", , , [5]]],
              NI: [, [, , "[12467]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[58]|2[08])|737\\d", , , , "115"], [, , , , , , , , , [-1]], , , , "NI", , , , , , , , , , , , , , , , , , [, , "1(?:1[58]|2[08])", , , , "115", , , [3]], , [, , "1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00", , , , "115"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NL: [
                ,
                [, , "[1349]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]],
                ,
                ,
                [, , "11(?:2|6\\d{3})|911", , , , "112", , , [3, 6]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "NL",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112|911", , , , "112", , , [3]],
                ,
                [, , "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911", , , , "112"],
                [, , , , , , , , , [-1]],
                [, , "120\\d", , , , "1200", , , [4]],
                ,
                [, , "[34]00\\d", , , , "3000", , , [4]]
              ],
              NO: [, [, , "[01]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[023]|6\\d{3})", , , , "110", , , [3, 6]], [, , , , , , , , , [-1]], , , , "NO", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "11[023]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ], , [, , "04\\d{3}|1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8\\d\\d|90)", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "04\\d{3}", , , , "04000", , , [5]]],
              NP: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:0[0-36]|12)|1(?:09|11)\\d", , , , "100"], [, , , , , , , , , [-1]], , , , "NP", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-3]|12)", , , , "100", , , [3]], , [, , "1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NR: [
                ,
                [, , "1\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "11[0-2]", , , , "110"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "NR",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[0-2]", , , , "110"],
                ,
                [, , "1(?:1[0-2]|23|92)", , , , "110"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              NU: [, [, , "[019]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "NU", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "01[05]|101|999", , , , "010"], [, , , , , , , , , [-1]], [, , "010", , , , "010"], , [, , , , , , , , , [-1]]],
              NZ: [, [, , "\\d{3,4}", , , , , , , [3, 4]], , , [, , "111", , , , "111", , , [3]], [, , "018", , , , "018", , , [3]], , , , "NZ", , , , , , , , , , , , , , , , , , [, , "111", , , , "111", , , [3]], , [
                ,
                ,
                "018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)",
                ,
                ,
                ,
                "018"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}", , , , "018"]],
              OM: [, [, , "[19]\\d{3}", , , , , , , [4]], , , [, , "1444|999\\d", , , , "1444"], [, , , , , , , , , [-1]], , , , "OM", , , , , , , , , , , , , , , , , , [, , "1444|9999", , , , "1444"], , [, , "1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d", , , , "1111"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PA: [
                ,
                [, , "[19]\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "911", , , , "911"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "PA",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "911", , , , "911"],
                ,
                [, , "10[2-4]|911", , , , "102"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              PE: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:05|1[67])", , , , "105"], [, , , , , , , , , [-1]], , , , "PE", , , , , , , , , , , , , , , , , , [, , "1(?:05|1[67])", , , , "105"], , [, , "1(?:05|1[67])", , , , "105"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "PF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PG: [, [, , "[01]\\d{2,6}", , , , , , , [
                3,
                4,
                5,
                6,
                7
              ]], , , [, , "000|11[01]", , , , "000", , , [3]], [, , , , , , , , , [-1]], , , , "PG", , , , , , , , , , , , , , , , , , [, , "000|11[01]", , , , "000", , , [3]], , [, , "000|1(?:1[01]|5\\d\\d|6\\d{2,5})", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "16\\d{2,5}", , , , "1600", , , [4, 5, 6, 7]]],
              PH: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "11[27]|911", , , , "112"], [, , , , , , , , , [-1]], , , , "PH", , , , , , , , , , , , , , , , , , [, , "11[27]|911", , , , "112"], , [, , "11[27]|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PK: [, [, , "1\\d{1,3}", , , , , , , [2, 3, 4]], , , [
                ,
                ,
                "1(?:1(?:2\\d?|5)|[56])",
                ,
                ,
                ,
                "15"
              ], [, , , , , , , , , [-1]], , , , "PK", , , , , , , , , , , , , , , , , , [, , "1(?:1(?:22?|5)|[56])", , , , "15"], , [, , "1(?:122|3[014]|[56])|11[2457-9]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PL: [, [, , "[19]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "11(?:2|6\\d{3})|99[7-9]", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "PL", , , , , , , , , , , , , , , , , , [, , "112|99[7-9]", , , , "112", , , [3]], , [, , "1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PM: [, [
                ,
                ,
                "[13]\\d(?:\\d\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 4, 6]
              ], , , [, , "1[578]|3(?:0\\d|1[689])\\d", , , , "15", , , [2, 4]], [, , "3[2469]\\d\\d", , , , "3200", , , [4]], , , , "PM", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15", , , [2]], , [, , "1[578]|31(?:03|[689]\\d)|(?:118[02-9]|3[02469])\\d\\d", , , , "15"], [, , "118\\d{3}", , , , "118000", , , [6]], [, , "310\\d", , , , "3100", , , [4]], , [, , , , , , , , , [-1]]],
              PR: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "PR", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PS: [
                ,
                [, , "1\\d{2,3}", , , , , , , [3, 4]],
                ,
                ,
                [, , "1(?:0[0-2]|66)", , , , "100", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "PS",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "10[0-2]", , , , "100", , , [3]],
                ,
                [, , "1(?:0[0-2]|122|44|66|99)", , , , "100"],
                [, , , , , , , , , [-1]],
                [, , "112\\d", , , , "1120", , , [4]],
                ,
                [, , , , , , , , , [-1]]
              ],
              PT: [, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "11[257]|1(?:16\\d\\d|5[1589]|8[279])\\d", , , , "112"], [, , , , , , , , , [-1]], , , , "PT", , , , , , , , , , , , , , , , , , [, , "11[25]", , , , "112", , , [3]], , [
                ,
                ,
                "1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0",
                ,
                ,
                ,
                "112"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PW: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "PW", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PY: [, [, , "[159]\\d\\d(?:\\d{4})?", , , , , , , [3, 7]], , , [, , "128|911", , , , "128", , , [3]], [, , , , , , , , , [-1]], , , , "PY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "128", , , [3]], , [, , "(?:1[01]|51)\\d{5}|911|1[1-9]\\d", , , , "110"], [, , , , , , , , , [-1]], [, , "(?:1[01]|51)\\d{5}", , , , "1000000", , , [7]], , [
                ,
                ,
                "(?:1[01]|51)\\d{5}",
                ,
                ,
                ,
                "1000000",
                ,
                ,
                [7]
              ]],
              QA: [, [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "99\\d", , , , "990", , , [3]], [, , "900", , , , "900", , , [3]], , , , "QA", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "9(?:00|[19]\\d)|(?:1|20|9[27]\\d)\\d\\d", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              RE: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "RE", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              RO: [, [
                ,
                ,
                "[18]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4, 5, 6]
              ], , , [, , "11(?:[23]|6\\d{3})", , , , "112", , , [3, 6]], [, , "(?:1(?:18[39]|[24])|8[48])\\d\\d", , , , "1200", , , [4, 6]], , , , "RO", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1(?:1(?:[23]|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "113|(?:1[24]|8[48])\\d\\d", , , , "113", , , [3, 4]]],
              RS: [
                ,
                [, , "[19]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]],
                ,
                ,
                [, , "112|9[2-4]", , , , "92", , , [2, 3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "RS",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112|9[2-4]", , , , "92", , , [2, 3]],
                ,
                [, , "1[189]\\d{1,4}|9[2-4]", , , , "92"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              RU: [, [, , "[01]\\d\\d?", , , , , , , [2, 3]], , , [, , "112|(?:0|10)[1-3]", , , , "01"], [, , , , , , , , , [-1]], , , , "RU", , , , , , , , , , , , , , , , , , [, , "112|(?:0|10)[1-3]", , , , "01"], , [, , "112|(?:0|10)[1-4]", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              RW: [, [, , "[14]\\d\\d", , , , , , , [3]], , , [, , "11[1245]", , , , "111"], [, , , , , , , , , [-1]], , , , "RW", , , , , , , , , , , , , , , , , , [, , "11[12]", , , , "111"], , [
                ,
                ,
                "1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456",
                ,
                ,
                ,
                "100"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SA: [, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6\\d{3})|9(?:11|37|9[7-9])", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "SA", , , , , , , , , , , , , , , , , , [, , "112|9(?:11|9[79])", , , , "112", , , [3]], , [, , "1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])", , , , "112"], [, , "141\\d", , , , "1410", , , [4]], [, , "1(?:10|41)\\d|90[24679]", , , , "902", , , [3, 4]], , [, , , , , , , , , [-1]]],
              SB: [
                ,
                [, , "[127-9]\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "999", , , , "999"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "SB",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "999", , , , "999"],
                ,
                [, , "1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)", , , , "100"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              SC: [, [, , "[19]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[1468]|60)|999", , , , "111", , , [3]], [, , , , , , , , , [-1]], , , , "SC", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "1(?:[06]\\d|1[0-246-8]|2[0-8]|3[13]|4[0-2]|5[15]|7[124-6]|8[158]|9[015])|9(?:6\\d\\d|99)", , , , "100"], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , [, , , , , , , , , [-1]]],
              SD: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SD", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SE: [, [, , "[1-37-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|(?:3|6\\d)\\d\\d|414|77)|900\\d\\d", , , , "112"], [, , "11811[89]|72\\d{3}", , , , "72000", , , [5, 6]], , , , "SE", , , , , , , , , , , , , , , , , , [, , "112|90000", , , , "112", , , [3, 5]], , [
                ,
                ,
                "11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])",
                ,
                ,
                ,
                "112"
              ], [, , , , , , , , , [-1]], [, , "2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912", , , , "220", , , [3]], , [, , "7\\d{4}", , , , "70000", , , [5]]],
              SG: [, [, , "[179]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "99[359]", , , , "993", , , [3]], [, , , , , , , , , [-1]], , , , "SG", , , , , , , , , , , , , , , , , , [, , "99[359]", , , , "993", , , [3]], , [, , "1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "772\\d\\d", , , , "77200", , , [5]]],
              SH: [, [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]], , , [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ], [, , , , , , , , , [-1]], , , , "SH", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911", , , [3]], , [, , "1\\d{2,3}|26[01]\\d\\d|9(?:11|99)", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SI: [
                ,
                [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]],
                ,
                ,
                [, , "11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)", , , , "112"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "SI",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[23]", , , , "112", , , [3]],
                ,
                [, , "1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]", , , , "112"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              SJ: [, [, , "[01]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[023]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "SJ", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110", , , [3]], , [, , "04\\d{3}|11[023]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "04\\d{3}", , , , "04000", , , [5]]],
              SK: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6\\d{3})|5[058])", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "SK", , , , , , , , , , , , , , , , , , [, , "1(?:12|5[058])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])", , , , "112"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SL: [, [, , "[069]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "(?:01|99)9", , , , "019", , , [3]], [, , , , , , , , , [-1]], , , , "SL", , , , , , , , , , , , , , , , , , [, , "(?:01|99)9", , , , "019", , , [3]], , [, , "(?:01|99)9|60400", , , , "019"], [, , , , , , , , , [-1]], [, , "604\\d\\d", , , , "60400", , , [5]], , [, , "604\\d\\d", , , , "60400", , , [5]]],
              SM: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[358]", , , , "113"], [, , , , , , , , , [-1]], , , , "SM", , , , , , , , , , , , , , , , , , [, , "11[358]", , , , "113"], , [, , "11[358]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              SN: [, [, , "[12]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "1(?:515|[78])|2(?:00|1)\\d{3}", , , , "17", , , [2, 4, 5, 6]], [, , "2(?:0[246]|[468])\\d{3}", , , , "24000", , , [5, 6]], , , , "SN", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17", , , [2]], , [, , "1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]", , , , "12"], [, , "2(?:01|2)\\d{3}", , , , "22000", , , [5, 6]], [, , "1[46]\\d\\d", , , , "1400", , , [4]], , [, , "2[468]\\d{3}", , , , "24000", , , [5]]],
              SO: [
                ,
                [, , "[57-9]\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "555|888|999", , , , "555"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "SO",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "555|888|999", , , , "555"],
                ,
                [, , "555|777|888|999", , , , "555"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              SR: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "115", , , , "115", , , [3]], [, , , , , , , , , [-1]], , , , "SR", , , , , , , , , , , , , , , , , , [, , "115", , , , "115", , , [3]], , [, , "1\\d{2,3}", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SS: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SS", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              ST: [, [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "ST", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SV: [, [, , "[149]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "116\\d{3}|911", , , , "911", , , [3, 6]], [, , , , , , , , , [-1]], , , , "SV", , , , , , , , , , , , , , , , , , [, , "91[13]", , , , "911", , , [3]], , [, , "1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)", , , , "112"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              SX: [, [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ], , , [, , "9(?:19|88)", , , , "919"], [, , , , , , , , , [-1]], , , , "SX", , , , , , , , , , , , , , , , , , [, , "919", , , , "919"], , [, , "9(?:19|88)", , , , "919"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SY: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[023]", , , , "110"], [, , , , , , , , , [-1]], , , , "SY", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110"], , [, , "11[023]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SZ: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SZ", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "TC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TD: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "TD", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TG: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [
                ,
                ,
                "1(?:1[78]|7[127])",
                ,
                ,
                ,
                "117",
                ,
                ,
                [3]
              ], [, , , , , , , , , [-1]], , , , "TG", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|7[127])", , , , "117", , , [3]], , [, , "1(?:011|1[078]|7[127])", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TH: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55", , , , "191"], [, , "1(?:113|2[23]\\d|5(?:09|56))", , , , "1113", , , [4]], , , , "TH", , , , , , , , , , , , , , , , , , [, , "1(?:669|9[19])", , , , "191"], , [
                ,
                ,
                "1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])",
                ,
                ,
                ,
                "100"
              ], [, , "1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d", , , , "1103", , , [4]], [, , "114[89]", , , , "1148", , , [4]], , [, , , , , , , , , [-1]]],
              TJ: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:0[1-3]|12)", , , , "101"], [, , , , , , , , , [-1]], , , , "TJ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101"], , [, , "1(?:0[1-3]|12)", , , , "101"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TL: [, [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ], , , [, , "11[25]", , , , "112"], [, , , , , , , , , [-1]], , , , "TL", , , , , , , , , , , , , , , , , , [, , "11[25]", , , , "112"], , [, , "1(?:0[02]|1[25]|2[0138]|72|9[07])", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TM: [, [, , "0\\d", , , , , , , [2]], , , [, , "0[1-49]", , , , "01"], [, , , , , , , , , [-1]], , , , "TM", , , , , , , , , , , , , , , , , , [, , "0[1-3]", , , , "01"], , [, , "0[1-49]", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TN: [
                ,
                [, , "1\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "19[078]", , , , "190"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "TN",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "19[078]", , , , "190"],
                ,
                [, , "19[078]", , , , "190"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              TO: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|22|33|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "TO", , , , , , , , , , , , , , , , , , [, , "9(?:11|22|33|99)", , , , "911"], , [, , "9(?:11|22|33|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TR: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "TR", , , , , , , , , , , , , , , , , , [, , "1(?:1[02]|55)", , , , "110", , , [3]], , [
                ,
                ,
                "1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d",
                ,
                ,
                ,
                "110"
              ], [, , "(?:285|542)0", , , , "2850", , , [4]], [, , , , , , , , , [-1]], , [, , "1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d", , , , "144", , , [3, 4]]],
              TT: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:88|9[09])", , , , "988"], [, , , , , , , , , [-1]], , , , "TT", , , , , , , , , , , , , , , , , , [, , "99[09]", , , , "990"], , [
                ,
                ,
                "9(?:88|9[09])",
                ,
                ,
                ,
                "988"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TV: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "TV", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "1\\d\\d|911", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TW: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[0289]|1(?:81|92)\\d", , , , "110"], [, , "10[56]", , , , "105", , , [3]], , , , "TW", , , , , , , , , , , , , , , , , , [, , "11[029]", , , , "110", , , [3]], , [
                ,
                ,
                "1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))",
                ,
                ,
                ,
                "100"
              ], [, , "1(?:65|9(?:1\\d|50|85|98))", , , , "165"], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TZ: [, [, , "[149]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:1[0-79]|9[09])|999", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "TZ", , , , , , , , , , , , , , , , , , [, , "11[0-245]|999", , , , "110", , , [3]], , [, , "1(?:1\\d|9[09])|46400|999", , , , "110"], [, , , , , , , , , [-1]], [, , "464\\d\\d", , , , "46400", , , [5]], , [, , "464\\d\\d", , , , "46400", , , [5]]],
              UA: [
                ,
                [, , "[189]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
                ,
                ,
                [, , "1(?:0[1-3]|1(?:2|6\\d{3}))", , , , "101", , , [3, 6]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "UA",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:0[1-3]|12)", , , , "101", , , [3]],
                ,
                [, , "1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d", , , , "101"],
                [, , , , , , , , , [-1]],
                [, , "(?:118|[89]00)\\d\\d?", , , , "1180", , , [4, 5]],
                ,
                [, , , , , , , , , [-1]]
              ],
              UG: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "UG", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              US: [, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [
                ,
                ,
                "112|611|9(?:11|33|88)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], [, , "24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7", , , , "24280", , , [5]], , , , "US", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-8]11|9(?:11|33|88)", , , , "112"], [
                ,
                ,
                "2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099",
                ,
                ,
                ,
                "23333",
                ,
                ,
                [5, 6]
              ], [, , "336\\d\\d|[2-9]\\d{3}|[2356]11", , , , "211", , , [3, 4, 5]], , [, , "[2-9]\\d{4,5}", , , , "20000", , , [5, 6]]],
              UY: [, [, , "[19]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "128|911", , , , "128", , , [3]], [, , , , , , , , , [-1]], , , , "UY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "128", , , [3]], , [, , "1(?:0[4-9]|1[2368]|2[0-3568]|787|997\\d?)|911", , , , "104"], [, , "178\\d", , , , "1780", , , [4]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              UZ: [
                ,
                [, , "[04]\\d(?:\\d(?:\\d{2})?)?", , , , , , , [2, 3, 5]],
                ,
                ,
                [, , "0(?:0[1-3]|[1-3]|50)", , , , "01", , , [2, 3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "UZ",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "0(?:0[1-3]|[1-3]|50)", , , , "01", , , [2, 3]],
                ,
                [, , "0(?:0[1-3]|[1-3]|50)|45400", , , , "01"],
                [, , , , , , , , , [-1]],
                [, , "454\\d\\d", , , , "45400", , , [5]],
                ,
                [, , "454\\d\\d", , , , "45400", , , [5]]
              ],
              VA: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[2358]", , , , "112"], [, , , , , , , , , [-1]], , , , "VA", , , , , , , , , , , , , , , , , , [, , "11[2358]", , , , "112"], , [, , "11[2358]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              VC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "VC", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911"
              ], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              VE: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "1(?:12|71)|911", , , , "112"], [, , , , , , , , , [-1]], , , , "VE", , , , , , , , , , , , , , , , , , [, , "1(?:12|71)|911", , , , "112"], , [, , "1(?:12|71)|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              VG: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "VG", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              VI: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "VI", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              VN: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[3-5]", , , , "113"], [, , , , , , , , , [-1]], , , , "VN", , , , , , , , , , , , , , , , , , [, , "11[3-5]", , , , "113"], , [, , "11[3-5]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              VU: [
                ,
                [, , "1\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "112", , , , "112"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "VU",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112", , , , "112"],
                ,
                [, , "112", , , , "112"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              WF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "WF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              WS: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|9[4-69])", , , , "911"], [, , , , , , , , , [-1]], , , , "WS", , , , , , , , , , , , , , , , , , [, , "9(?:11|9[4-69])", , , , "911"], , [, , "1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])", , , , "111"], [, , , , , , , , , [-1]], [, , "12[0-6]", , , , "120"], , [, , , , , , , , , [-1]]],
              XK: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], , , , "XK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])", , , , "112"], , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              YE: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[1459]", , , , "191"], [, , , , , , , , , [-1]], , , , "YE", , , , , , , , , , , , , , , , , , [, , "19[1459]", , , , "191"], , [, , "19[1459]", , , , "191"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              YT: [
                ,
                [, , "1\\d\\d?", , , , , , , [2, 3]],
                ,
                ,
                [, , "1(?:12|5)", , , , "15"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "YT",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:12|5)", , , , "15"],
                ,
                [, , "1(?:12|5)", , , , "15"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              ZA: [, [, , "[134]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:01\\d\\d|12)", , , , "112", , , [3, 5]], [, , "41(?:348|851)", , , , "41348", , , [5]], , , , "ZA", , , , , , , , , , , , , , , , , , [, , "1(?:01(?:11|77)|12)", , , , "112", , , [3, 5]], , [, , "1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}", , , , "107"], [, , "3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699", , , , "30782", , , [5]], [, , "111", , , , "111", , , [3]], , [
                ,
                ,
                "[34]\\d{4}",
                ,
                ,
                ,
                "30000",
                ,
                ,
                [5]
              ]],
              ZM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|99[139]", , , , "112"], [, , , , , , , , , [-1]], , , , "ZM", , , , , , , , , , , , , , , , , , [, , "112|99[139]", , , , "112"], , [, , "112|99[139]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              ZW: [, [, , "[139]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112|9(?:5[023]|61|9[3-59])", , , , "112", , , [3]], [, , "3[013-57-9]\\d{3}", , , , "30000", , , [5]], , , , "ZW", , , , , , , , , , , , , , , , , , [, , "112|99[3-59]", , , , "112", , , [3]], , [, , "11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])", , , , "112"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , "114|9(?:5[023]|6[0-25])", , , , "114", , , [3]], , [, , , , , , , , , [-1]]]
            }, i18n.phonenumbers.ShortNumberInfo = function() {
              this.regionToMetadataMap = {};
            }, goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo), i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_ = ["BR", "CL", "NI"], i18n.phonenumbers.ShortNumberInfo.ShortNumberCost = { TOLL_FREE: 0, STANDARD_RATE: 1, PREMIUM_RATE: 2, UNKNOWN_COST: 3 }, i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_ = function(e) {
              return (e = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[e]) ? e : [];
            }, i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_ = function(e, t) {
              return e = this.getRegionCodesForCountryCode_(e.getCountryCodeOrDefault()), t != null && e.includes(t);
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion = function(e, t) {
              return !this.regionDialingFromMatchesNumber_(e, t) || (t = this.getMetadataForRegion_(t), !t) ? !1 : (e = this.getNationalSignificantNumber_(e).length, t.getGeneralDesc().possibleLengthArray().includes(e));
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber = function(e) {
              var t = this.getRegionCodesForCountryCode_(e.getCountryCodeOrDefault());
              e = this.getNationalSignificantNumber_(e).length;
              for (var o = 0; o < t.length; o++) {
                var i = this.getMetadataForRegion_(t[o]);
                if (i && i.getGeneralDesc().possibleLengthArray().includes(e)) return !0;
              }
              return !1;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion = function(e, t) {
              if (!this.regionDialingFromMatchesNumber_(e, t) || (t = this.getMetadataForRegion_(t), !t)) return !1;
              e = this.getNationalSignificantNumber_(e);
              var o = t.getGeneralDesc();
              return this.matchesPossibleNumberAndNationalNumber_(e, o) ? (t = t.getShortCode(), this.matchesPossibleNumberAndNationalNumber_(e, t)) : !1;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber = function(e) {
              var t = this.getRegionCodesForCountryCode_(e.getCountryCodeOrDefault()), o = this.getRegionCodeForShortNumberFromRegionList_(e, t);
              return 1 < t.length && o != null ? !0 : this.isValidShortNumberForRegion(e, o);
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion = function(e, t) {
              var o = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;
              if (!this.regionDialingFromMatchesNumber_(e, t)) return o.UNKNOWN_COST;
              var i = this.getMetadataForRegion_(t);
              return i ? (e = this.getNationalSignificantNumber_(e), i.getGeneralDesc().possibleLengthArray().includes(e.length) ? this.matchesPossibleNumberAndNationalNumber_(e, i.getPremiumRate()) ? o.PREMIUM_RATE : this.matchesPossibleNumberAndNationalNumber_(
                e,
                i.getStandardRate()
              ) ? o.STANDARD_RATE : this.matchesPossibleNumberAndNationalNumber_(e, i.getTollFree()) || this.isEmergencyNumber(e, t) ? o.TOLL_FREE : o.UNKNOWN_COST : o.UNKNOWN_COST) : o.UNKNOWN_COST;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost = function(e) {
              var t = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, o = this.getRegionCodesForCountryCode_(e.getCountryCodeOrDefault());
              if (o.length === 0) return t.UNKNOWN_COST;
              if (o.length === 1) return this.getExpectedCostForRegion(e, o[0]);
              for (var i = t.TOLL_FREE, d = 0; d < o.length; d++) {
                var s = this.getExpectedCostForRegion(e, o[d]);
                switch (s) {
                  case t.PREMIUM_RATE:
                    return t.PREMIUM_RATE;
                  case t.UNKNOWN_COST:
                    i = t.UNKNOWN_COST;
                    break;
                  case t.STANDARD_RATE:
                    i !== t.UNKNOWN_COST && (i = t.STANDARD_RATE);
                    break;
                  case t.TOLL_FREE:
                    break;
                  default:
                    throw Error("Unrecognized cost for region: " + s);
                }
              }
              return i;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_ = function(e, t) {
              if (t.length === 0) return null;
              if (t.length === 1) return t[0];
              e = this.getNationalSignificantNumber_(e);
              for (var o = 0; o < t.length; o++) {
                var i = t[o], d = this.getMetadataForRegion_(i);
                if (d && this.matchesPossibleNumberAndNationalNumber_(e, d.getShortCode())) return i;
              }
              return null;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions = function() {
              return Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata).filter(function(e) {
                return isNaN(e);
              });
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber = function(e) {
              return e = this.getMetadataForRegion_(e), e ? (e = e.getShortCode(), e.hasExampleNumber() && e.getExampleNumber() || "") : "";
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost = function(e, t) {
              if (e = this.getMetadataForRegion_(e), !e) return "";
              var o = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, i = null;
              switch (t) {
                case o.TOLL_FREE:
                  i = e.getTollFree();
                  break;
                case o.STANDARD_RATE:
                  i = e.getStandardRate();
                  break;
                case o.PREMIUM_RATE:
                  i = e.getPremiumRate();
              }
              return i && i.hasExampleNumber() && i.getExampleNumber() || "";
            }, i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber = function(e, t) {
              return this.matchesEmergencyNumberHelper_(e, t, !0);
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber = function(e, t) {
              return this.matchesEmergencyNumberHelper_(e, t, !1);
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_ = function(e) {
              if (!e) return null;
              e = e.toUpperCase();
              var t = this.regionToMetadataMap[e];
              if (t == null) {
                t = new goog.proto2.PbLiteSerializer();
                var o = i18n.phonenumbers.shortnumbermetadata.countryToMetadata[e];
                if (o == null) return null;
                t = t.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), o), this.regionToMetadataMap[e] = t;
              }
              return t;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_ = function(e, t, o) {
              var i = i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(e);
              return i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(i) || (e = this.getMetadataForRegion_(t), e == null || !e.hasEmergency()) ? !1 : (i = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(i), t = o && !i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_.includes(t), o = e.getEmergency().getNationalNumberPatternOrDefault(), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(o, i) || t && i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(o, i));
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific = function(e) {
              var t = this.getRegionCodesForCountryCode_(e.getCountryCodeOrDefault());
              return t = this.getRegionCodeForShortNumberFromRegionList_(e, t), e = this.getNationalSignificantNumber_(e), t = this.getMetadataForRegion_(t), !!t && this.matchesPossibleNumberAndNationalNumber_(e, t.getCarrierSpecific());
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion = function(e, t) {
              return this.regionDialingFromMatchesNumber_(e, t) ? (e = this.getNationalSignificantNumber_(e), t = this.getMetadataForRegion_(t), !!t && this.matchesPossibleNumberAndNationalNumber_(e, t.getCarrierSpecific())) : !1;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion = function(e, t) {
              return this.regionDialingFromMatchesNumber_(e, t) ? (t = this.getMetadataForRegion_(t), e = this.getNationalSignificantNumber_(e), !!t && this.matchesPossibleNumberAndNationalNumber_(e, t.getSmsServices())) : !1;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_ = function(e) {
              if (!e.hasNationalNumber()) return "";
              var t = "" + e.getNationalNumber();
              return e.hasItalianLeadingZero() && e.getItalianLeadingZero() && 0 < e.getNumberOfLeadingZerosOrDefault() ? Array(e.getNumberOfLeadingZerosOrDefault() + 1).join("0") + t : t;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_ = function(e, t) {
              return 0 < t.possibleLengthArray().length && !t.possibleLengthArray().includes(e.length) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(t.getNationalNumberPatternOrDefault(), e.toString());
            }, i18n.phonenumbers.AsYouTypeFormatter = function(e) {
              this.DIGIT_PLACEHOLDER_ = " ", this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_), this.currentOutput_ = "", this.formattingTemplate_ = new goog.string.StringBuffer(), this.currentFormattingPattern_ = "", this.accruedInput_ = new goog.string.StringBuffer(), this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer(), this.ableToFormat_ = !0, this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = !1, this.phoneUtil_ = i18n.phonenumbers.PhoneNumberUtil.getInstance(), this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0, this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer(), this.shouldAddSpaceAfterNationalPrefix_ = !1, this.extractedNationalPrefix_ = "", this.nationalNumber_ = new goog.string.StringBuffer(), this.possibleFormats_ = [], this.defaultCountry_ = e, this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
            }, i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = " ", i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n.phonenumbers.PhoneMetadata(), i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA"), i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*\\$1[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*(\\$\\d[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*)*$"), i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/, i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3, i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function(e) {
              return e = this.phoneUtil_.getCountryCodeForRegion(e), e = this.phoneUtil_.getRegionCodeForCountryCode(e), e = this.phoneUtil_.getMetadataForRegion(e), e ?? i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function() {
              for (var e = this.possibleFormats_.length, t = 0; t < e; ++t) {
                var o = this.possibleFormats_[t], i = o.getPatternOrDefault();
                if (this.currentFormattingPattern_ == i) return !1;
                if (this.createFormattingTemplate_(o)) return this.currentFormattingPattern_ = i, this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(o.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, !0;
              }
              return this.ableToFormat_ = !1;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function(e) {
              for (var t = this.isCompleteNumber_ && this.extractedNationalPrefix_.length == 0 && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), o = t.length, i = 0; i < o; ++i) {
                var d = t[i];
                0 < this.extractedNationalPrefix_.length && this.phoneUtil_.formattingRuleHasFirstGroupOnly(d.getNationalPrefixFormattingRuleOrDefault()) && !d.getNationalPrefixOptionalWhenFormatting() && !d.hasDomesticCarrierCodeFormattingRule() || (this.extractedNationalPrefix_.length != 0 || this.isCompleteNumber_ || this.phoneUtil_.formattingRuleHasFirstGroupOnly(d.getNationalPrefixFormattingRuleOrDefault()) || d.getNationalPrefixOptionalWhenFormatting()) && i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(d.getFormatOrDefault()) && this.possibleFormats_.push(d);
              }
              this.narrowDownPossibleFormats_(e);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function(e) {
              for (var t = [], o = e.length - i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, i = this.possibleFormats_.length, d = 0; d < i; ++d) {
                var s = this.possibleFormats_[d];
                if (s.leadingDigitsPatternCount() == 0) t.push(this.possibleFormats_[d]);
                else {
                  var n = Math.min(o, s.leadingDigitsPatternCount() - 1);
                  s = s.getLeadingDigitsPattern(n), e.search(s) == 0 && t.push(this.possibleFormats_[d]);
                }
              }
              this.possibleFormats_ = t;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function(e) {
              var t = e.getPatternOrDefault();
              return this.formattingTemplate_.clear(), e = this.getFormattingTemplate_(t, e.getFormatOrDefault()), 0 < e.length ? (this.formattingTemplate_.append(e), !0) : !1;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function(e, t) {
              var o = "999999999999999".match(e)[0];
              return o.length < this.nationalNumber_.getLength() ? "" : (e = o.replace(new RegExp(e, "g"), t), e = e.replace(/9/g, this.DIGIT_PLACEHOLDER_));
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.clear = function() {
              this.currentOutput_ = "", this.accruedInput_.clear(), this.accruedInputWithoutFormatting_.clear(), this.formattingTemplate_.clear(), this.lastMatchPosition_ = 0, this.currentFormattingPattern_ = "", this.prefixBeforeNationalNumber_.clear(), this.extractedNationalPrefix_ = "", this.nationalNumber_.clear(), this.ableToFormat_ = !0, this.inputHasFormatting_ = !1, this.originalPosition_ = this.positionToRemember_ = 0, this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = !1, this.possibleFormats_ = [], this.shouldAddSpaceAfterNationalPrefix_ = !1, this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function(e) {
              return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(e, !1);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function(e) {
              return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(e, !0);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function(e, t) {
              if (this.accruedInput_.append(e), t && (this.originalPosition_ = this.accruedInput_.getLength()), this.isDigitOrLeadingPlusSign_(e) ? e = this.normalizeAndAccrueDigitsAndPlusSign_(e, t) : (this.ableToFormat_ = !1, this.inputHasFormatting_ = !0), !this.ableToFormat_) {
                if (!this.inputHasFormatting_) {
                  if (this.attemptToExtractIdd_()) {
                    if (this.attemptToExtractCountryCallingCode_()) return this.attemptToChoosePatternWithPrefixExtracted_();
                  } else if (this.ableToExtractLongerNdd_()) return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
                }
                return this.accruedInput_.toString();
              }
              switch (this.accruedInputWithoutFormatting_.getLength()) {
                case 0:
                case 1:
                case 2:
                  return this.accruedInput_.toString();
                case 3:
                  if (this.attemptToExtractIdd_()) this.isExpectingCountryCallingCode_ = !0;
                  else return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
                default:
                  return this.isExpectingCountryCallingCode_ ? (this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = !1), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString()) : 0 < this.possibleFormats_.length ? (e = this.inputDigitHelper_(e), t = this.attemptToFormatAccruedDigits_(), 0 < t.length ? t : (this.narrowDownPossibleFormats_(this.nationalNumber_.toString()), this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(e) : this.accruedInput_.toString())) : this.attemptToChooseFormattingPattern_();
              }
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function() {
              return this.ableToFormat_ = !0, this.isExpectingCountryCallingCode_ = !1, this.possibleFormats_ = [], this.lastMatchPosition_ = 0, this.formattingTemplate_.clear(), this.currentFormattingPattern_ = "", this.attemptToChooseFormattingPattern_();
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function() {
              return this.extractedNationalPrefix_;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function() {
              if (0 < this.extractedNationalPrefix_.length) {
                var e = this.nationalNumber_.toString();
                this.nationalNumber_.clear(), this.nationalNumber_.append(this.extractedNationalPrefix_), this.nationalNumber_.append(e), e = this.prefixBeforeNationalNumber_.toString();
                var t = e.lastIndexOf(this.extractedNationalPrefix_);
                this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(e.substring(0, t));
              }
              return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(e) || this.accruedInput_.getLength() == 1 && i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(e);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function() {
              for (var e = this.nationalNumber_.toString(), t = this.possibleFormats_.length, o = 0; o < t; ++o) {
                var i = this.possibleFormats_[o], d = i.getPatternOrDefault();
                if (new RegExp("^(?:" + d + ")$").test(e) && (this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(i.getNationalPrefixFormattingRule()), i = e.replace(new RegExp(d, "g"), i.getFormat()), i = this.appendNationalNumber_(i), i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(i) == this.accruedInputWithoutFormatting_)) return i;
              }
              return "";
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function(e) {
              var t = this.prefixBeforeNationalNumber_.getLength();
              return this.shouldAddSpaceAfterNationalPrefix_ && 0 < t && this.prefixBeforeNationalNumber_.toString().charAt(t - 1) != i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + e : this.prefixBeforeNationalNumber_ + e;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function() {
              if (!this.ableToFormat_) return this.originalPosition_;
              for (var e = 0, t = 0, o = this.accruedInputWithoutFormatting_.toString(), i = this.currentOutput_.toString(); e < this.positionToRemember_ && t < i.length; ) o.charAt(e) == i.charAt(t) && e++, t++;
              return t;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function() {
              var e = this.nationalNumber_.toString();
              return e.length >= i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(e), e = this.attemptToFormatAccruedDigits_(), 0 < e.length ? e : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(e);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function() {
              var e = this.nationalNumber_.toString(), t = e.length;
              if (0 < t) {
                for (var o = "", i = 0; i < t; i++) o = this.inputDigitHelper_(e.charAt(i));
                return this.ableToFormat_ ? this.appendNationalNumber_(o) : this.accruedInput_.toString();
              }
              return this.prefixBeforeNationalNumber_.toString();
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function() {
              if (this.currentMetadata_.getCountryCode() != 1) return !1;
              var e = this.nationalNumber_.toString();
              return e.charAt(0) == "1" && e.charAt(1) != "0" && e.charAt(1) != "1";
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function() {
              var e = this.nationalNumber_.toString(), t = 0;
              if (this.isNanpaNumberWithNationalPrefix_()) t = 1, this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = !0;
              else if (this.currentMetadata_.hasNationalPrefixForParsing()) {
                var o = new RegExp("^(?:" + this.currentMetadata_.getNationalPrefixForParsing() + ")");
                o = e.match(o), o != null && o[0] != null && 0 < o[0].length && (this.isCompleteNumber_ = !0, t = o[0].length, this.prefixBeforeNationalNumber_.append(e.substring(0, t)));
              }
              return this.nationalNumber_.clear(), this.nationalNumber_.append(e.substring(t)), e.substring(0, t);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function() {
              var e = this.accruedInputWithoutFormatting_.toString(), t = new RegExp("^(?:\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + "|" + this.currentMetadata_.getInternationalPrefix() + ")");
              return t = e.match(t), t != null && t[0] != null && 0 < t[0].length ? (this.isCompleteNumber_ = !0, t = t[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(e.substring(t)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(e.substring(
                0,
                t
              )), e.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), !0) : !1;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function() {
              if (this.nationalNumber_.getLength() == 0) return !1;
              var e = new goog.string.StringBuffer(), t = this.phoneUtil_.extractCountryCode(this.nationalNumber_, e);
              return t == 0 ? !1 : (this.nationalNumber_.clear(), this.nationalNumber_.append(e.toString()), e = this.phoneUtil_.getRegionCodeForCountryCode(t), i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == e ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(t) : e != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(e)), this.prefixBeforeNationalNumber_.append("" + t).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.extractedNationalPrefix_ = "", !0);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function(e, t) {
              if (e == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
                var o = e;
                this.accruedInputWithoutFormatting_.append(e);
              } else o = i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[e], this.accruedInputWithoutFormatting_.append(o), this.nationalNumber_.append(o);
              return t && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength()), o;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function(e) {
              var t = this.formattingTemplate_.toString();
              if (0 <= t.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
                var o = t.search(this.DIGIT_PATTERN_);
                return e = t.replace(this.DIGIT_PATTERN_, e), this.formattingTemplate_.clear(), this.formattingTemplate_.append(e), this.lastMatchPosition_ = o, e.substring(0, this.lastMatchPosition_ + 1);
              }
              return this.possibleFormats_.length == 1 && (this.ableToFormat_ = !1), this.currentFormattingPattern_ = "", this.accruedInput_.toString();
            }, Object.defineProperty(exports$1, "__esModule", { value: !0 }), exports$1.default = i18n.phonenumbers, module.exports = exports$1.default;
          }).call(this);
        }).call(this, typeof commonjsGlobal < "u" ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, {}] }, {}, [1])(1);
    });
  })(libphonenumber)), libphonenumber.exports;
}
var libphonenumberExports = /* @__PURE__ */ requireLibphonenumber();
const googleLibphonenumber = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null
}, [libphonenumberExports]);
var countryCodes = {
  AUSTRALIA: { alphaTwo: "AU", alphaThree: "AUS", numeric: "036" },
  AUSTRIA: { alphaTwo: "AT", alphaThree: "AUT", numeric: "040" },
  BAHRAIN: { alphaTwo: "BH", alphaThree: "BHR", numeric: "048" },
  BARBADOS: { alphaTwo: "BB", alphaThree: "BRB", numeric: "052" },
  BELGIUM: { alphaTwo: "BE", alphaThree: "BEL", numeric: "056" },
  BOTSWANA: { alphaTwo: "BW", alphaThree: "BWA", numeric: "072" },
  BRAZIL: { alphaTwo: "BR", alphaThree: "BRA", numeric: "076" },
  BRUNEI_DARUSSALAM: { alphaTwo: "BN", alphaThree: "BRN", numeric: "096" },
  BULGARIA: { alphaTwo: "BG", alphaThree: "BGR", numeric: "100" },
  CAMBODIA: { alphaTwo: "KH", alphaThree: "KHM", numeric: "116" },
  CANADA: { alphaTwo: "CA", alphaThree: "CAN", numeric: "124" },
  CHILE: { alphaTwo: "CL", alphaThree: "CHL", numeric: "152" },
  CHINA: { alphaTwo: "CN", alphaThree: "CHN", numeric: "156" },
  CROATIA: { alphaTwo: "HR", alphaThree: "HRV", numeric: "191" },
  CYPRUS: { alphaTwo: "CY", alphaThree: "CYP", numeric: "196" },
  CZECH_REPUBLIC: { alphaTwo: "CZ", alphaThree: "CZE", numeric: "203" },
  DENMARK: { alphaTwo: "DK", alphaThree: "DNK", numeric: "208" },
  DOMINICA: { alphaTwo: "DM", alphaThree: "DMA", numeric: "212" },
  ESTONIA: { alphaTwo: "EE", alphaThree: "EST", numeric: "233" },
  FINLAND: { alphaTwo: "FI", alphaThree: "FIN", numeric: "246" },
  FRANCE: { alphaTwo: "FR", alphaThree: "FRA", numeric: "250" },
  GERMANY: { alphaTwo: "DE", alphaThree: "DEU", numeric: "276" },
  GREECE: { alphaTwo: "GR", alphaThree: "GRC", numeric: "300" },
  HONG_KONG: { alphaTwo: "HK", alphaThree: "HKG", numeric: "344" },
  HUNGARY: { alphaTwo: "HU", alphaThree: "HUN", numeric: "348" },
  ICELAND: { alphaTwo: "IS", alphaThree: "ISL", numeric: "352" },
  INDONESIA: { alphaTwo: "ID", alphaThree: "IDN", numeric: "360" },
  IRELAND: { alphaTwo: "IE", alphaThree: "IRL", numeric: "372" },
  ITALY: { alphaTwo: "IT", alphaThree: "ITA", numeric: "380" },
  JAPAN: { alphaTwo: "JP", alphaThree: "JPN", numeric: "392" },
  KAZAKHSTAN: { alphaTwo: "KZ", alphaThree: "KAZ", numeric: "398" },
  SOUTH_KOREA: { alphaTwo: "KR", alphaThree: "KOR", numeric: "410" },
  KUWAIT: { alphaTwo: "KW", alphaThree: "KWT", numeric: "414" },
  LATVIA: { alphaTwo: "LV", alphaThree: "LVA", numeric: "428" },
  LIECHTENSTEIN: { alphaTwo: "LI", alphaThree: "LIE", numeric: "438" },
  LITHUANIA: { alphaTwo: "LT", alphaThree: "LTU", numeric: "440" },
  LUXEMBOURG: { alphaTwo: "LU", alphaThree: "LUX", numeric: "442" },
  MACAU: { alphaTwo: "MO", alphaThree: "MAC", numeric: "446" },
  MALAYSIA: { alphaTwo: "MY", alphaThree: "MYS", numeric: "458" },
  MALTA: { alphaTwo: "MT", alphaThree: "MLT", numeric: "470" },
  MAURITIUS: { alphaTwo: "MU", alphaThree: "MUS", numeric: "480" },
  MEXICO: { alphaTwo: "MX", alphaThree: "MEX", numeric: "484" },
  NETHERLANDS: { alphaTwo: "NL", alphaThree: "NLD", numeric: "528" },
  NEW_ZEALAND: { alphaTwo: "NZ", alphaThree: "NZL", numeric: "554" },
  NORWAY: { alphaTwo: "NO", alphaThree: "NOR", numeric: "578" },
  OMAN: { alphaTwo: "OM", alphaThree: "OMN", numeric: "512" },
  PERU: { alphaTwo: "PE", alphaThree: "PER", numeric: "604" },
  POLAND: { alphaTwo: "PL", alphaThree: "POL", numeric: "616" },
  PORTUGAL: { alphaTwo: "PT", alphaThree: "PRT", numeric: "620" },
  QATAR: { alphaTwo: "QA", alphaThree: "QAT", numeric: "634" },
  ROMANIA: { alphaTwo: "RO", alphaThree: "ROU", numeric: "642" },
  SINGAPORE: { alphaTwo: "SG", alphaThree: "SGP", numeric: "702" },
  SLOVAKIA: { alphaTwo: "SK", alphaThree: "SVK", numeric: "703" },
  SLOVENIA: { alphaTwo: "SI", alphaThree: "SVN", numeric: "705" },
  SPAIN: { alphaTwo: "ES", alphaThree: "ESP", numeric: "724" },
  SWEDEN: { alphaTwo: "SE", alphaThree: "SWE", numeric: "752" },
  SWITZERLAND: { alphaTwo: "CH", alphaThree: "CHE", numeric: "756" },
  TAIWAN: { alphaTwo: "TW", alphaThree: "TWN", numeric: "158" },
  THAILAND: { alphaTwo: "TH", alphaThree: "THA", numeric: "764" },
  TUNISIA: { alphaTwo: "TN", alphaThree: "TUN", numeric: "788" },
  UNITED_ARAB_EMIRATES: { alphaTwo: "AE", alphaThree: "ARE", numeric: "784" },
  UNITED_STATES_OF_AMERICA: { alphaTwo: "US", alphaThree: "USA", numeric: "840" },
  SERBIA: { alphaTwo: "RS", alphaThree: "SRB", numeric: "688" },
  AFGHANISTAN: { alphaTwo: "AF", alphaThree: "AFG", numeric: "004" },
  ALBANIA: { alphaTwo: "AL", alphaThree: "ALB", numeric: "008" },
  ALGERIA: { alphaTwo: "DZ", alphaThree: "DZA", numeric: "012" },
  AMERICAN_SAMOA: { alphaTwo: "AS", alphaThree: "ASM", numeric: "016" },
  ANDORRA: { alphaTwo: "AD", alphaThree: "AND", numeric: "020" },
  ANGOLA: { alphaTwo: "AO", alphaThree: "AGO", numeric: "024" },
  ANGUILLA: { alphaTwo: "AI", alphaThree: "AIA", numeric: "660" },
  ANTARCTICA: { alphaTwo: "AQ", alphaThree: "ATA", numeric: "010" },
  ANTIGUA_AND_BARBUDA: { alphaTwo: "AG", alphaThree: "ATG", numeric: "028" },
  ARGENTINA: { alphaTwo: "AR", alphaThree: "ARG", numeric: "032" },
  ARMENIA: { alphaTwo: "AM", alphaThree: "ARM", numeric: "051" },
  ARUBA: { alphaTwo: "AW", alphaThree: "ABW", numeric: "533" },
  AZERBAIJAN: { alphaTwo: "AZ", alphaThree: "AZE", numeric: "031" },
  BAHAMAS: { alphaTwo: "BS", alphaThree: "BHS", numeric: "044" },
  BANGLADESH: { alphaTwo: "BD", alphaThree: "BGD", numeric: "050" },
  BELARUS: { alphaTwo: "BY", alphaThree: "BLR", numeric: "112" },
  BELIZE: { alphaTwo: "BZ", alphaThree: "BLZ", numeric: "084" },
  BENIN: { alphaTwo: "BJ", alphaThree: "BEN", numeric: "204" },
  BERMUDA: { alphaTwo: "BM", alphaThree: "BMU", numeric: "060" },
  BHUTAN: { alphaTwo: "BT", alphaThree: "BTN", numeric: "064" },
  BOLIVIA: { alphaTwo: "BO", alphaThree: "BOL", numeric: "068" },
  BOSNIA_AND_HERZEGOVINA: { alphaTwo: "BA", alphaThree: "BIH", numeric: "070" },
  BOUVET_ISLAND: { alphaTwo: "BV", alphaThree: "BVT", numeric: "074" },
  BRITISH_INDIAN_OCEAN_TERRITORY: { alphaTwo: "IO", alphaThree: "IOT", numeric: "086" },
  BURKINA_FASO: { alphaTwo: "BF", alphaThree: "BFA", numeric: "854" },
  BURUNDI: { alphaTwo: "BI", alphaThree: "BDI", numeric: "108" },
  CAMEROON: { alphaTwo: "CM", alphaThree: "CMR", numeric: "120" },
  CAPE_VERDE: { alphaTwo: "CV", alphaThree: "CPV", numeric: "132" },
  CAYMAN_ISLANDS: { alphaTwo: "KY", alphaThree: "CYM", numeric: "136" },
  CENTRAL_AFRICAN_REPUBLIC: { alphaTwo: "CF", alphaThree: "CAF", numeric: "140" },
  CHAD: { alphaTwo: "TD", alphaThree: "TCD", numeric: "148" },
  CHRISTMAS_ISLAND: { alphaTwo: "CX", alphaThree: "CXR", numeric: "162" },
  COCOS_KEELING_ISLANDS: { alphaTwo: "CC", alphaThree: "CCK", numeric: "166" },
  COLOMBIA: { alphaTwo: "CO", alphaThree: "COL", numeric: "170" },
  COMOROS: { alphaTwo: "KM", alphaThree: "COM", numeric: "174" },
  CONGO: { alphaTwo: "CG", alphaThree: "COG", numeric: "178" },
  CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE: { alphaTwo: "CD", alphaThree: "COD", numeric: "180" },
  COOK_ISLANDS: { alphaTwo: "CK", alphaThree: "COK", numeric: "184" },
  COSTA_RICA: { alphaTwo: "CR", alphaThree: "CRI", numeric: "188" },
  COTE_DIVOIRE: { alphaTwo: "CI", alphaThree: "CIV", numeric: "384" },
  CUBA: { alphaTwo: "CU", alphaThree: "CUB", numeric: "192" },
  DJIBOUTI: { alphaTwo: "DJ", alphaThree: "DJI", numeric: "262" },
  DOMINICAN_REPUBLIC: { alphaTwo: "DO", alphaThree: "DOM", numeric: "214" },
  ECUADOR: { alphaTwo: "EC", alphaThree: "ECU", numeric: "218" },
  EGYPT: { alphaTwo: "EG", alphaThree: "EGY", numeric: "818" },
  EL_SALVADOR: { alphaTwo: "SV", alphaThree: "SLV", numeric: "222" },
  EQUATORIAL_GUINEA: { alphaTwo: "GQ", alphaThree: "GNQ", numeric: "226" },
  ERITREA: { alphaTwo: "ER", alphaThree: "ERI", numeric: "232" },
  ETHIOPIA: { alphaTwo: "ET", alphaThree: "ETH", numeric: "231" },
  FALKLAND_ISLANDS_MALVINAS: { alphaTwo: "FK", alphaThree: "FLK", numeric: "238" },
  FAROE_ISLANDS: { alphaTwo: "FO", alphaThree: "FRO", numeric: "234" },
  FIJI: { alphaTwo: "FJ", alphaThree: "FJI", numeric: "242" },
  FRENCH_GUIANA: { alphaTwo: "GF", alphaThree: "GUF", numeric: "254" },
  FRENCH_POLYNESIA: { alphaTwo: "PF", alphaThree: "PYF", numeric: "258" },
  FRENCH_SOUTHERN_TERRITORIES: { alphaTwo: "TF", alphaThree: "ATF", numeric: "260" },
  GABON: { alphaTwo: "GA", alphaThree: "GAB", numeric: "266" },
  GAMBIA: { alphaTwo: "GM", alphaThree: "GMB", numeric: "270" },
  GEORGIA: { alphaTwo: "GE", alphaThree: "GEO", numeric: "268" },
  GHANA: { alphaTwo: "GH", alphaThree: "GHA", numeric: "288" },
  GIBRALTAR: { alphaTwo: "GI", alphaThree: "GIB", numeric: "292" },
  GREENLAND: { alphaTwo: "GL", alphaThree: "GRL", numeric: "304" },
  GRENADA: { alphaTwo: "GD", alphaThree: "GRD", numeric: "308" },
  GUADELOUPE: { alphaTwo: "GP", alphaThree: "GLP", numeric: "312" },
  GUAM: { alphaTwo: "GU", alphaThree: "GUM", numeric: "316" },
  GUATEMALA: { alphaTwo: "GT", alphaThree: "GTM", numeric: "320" },
  GUINEA: { alphaTwo: "GN", alphaThree: "GIN", numeric: "324" },
  GUINEA_BISSAU: { alphaTwo: "GW", alphaThree: "GNB", numeric: "624" },
  GUYANA: { alphaTwo: "GY", alphaThree: "GUY", numeric: "328" },
  HAITI: { alphaTwo: "HT", alphaThree: "HTI", numeric: "332" },
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: { alphaTwo: "HM", alphaThree: "HMD", numeric: "334" },
  VATICAN: { alphaTwo: "VA", alphaThree: "VAT", numeric: "336" },
  HONDURAS: { alphaTwo: "HN", alphaThree: "HND", numeric: "340" },
  INDIA: { alphaTwo: "IN", alphaThree: "IND", numeric: "356" },
  IRAN_ISLAMIC_REPUBLIC_OF: { alphaTwo: "IR", alphaThree: "IRN", numeric: "364" },
  IRAQ: { alphaTwo: "IQ", alphaThree: "IRQ", numeric: "368" },
  ISRAEL: { alphaTwo: "IL", alphaThree: "ISR", numeric: "376" },
  JAMAICA: { alphaTwo: "JM", alphaThree: "JAM", numeric: "388" },
  JORDAN: { alphaTwo: "JO", alphaThree: "JOR", numeric: "400" },
  KENYA: { alphaTwo: "KE", alphaThree: "KEN", numeric: "404" },
  KIRIBATI: { alphaTwo: "KI", alphaThree: "KIR", numeric: "296" },
  NORTH_KOREA: { alphaTwo: "KP", alphaThree: "PRK", numeric: "408" },
  KYRGYZSTAN: { alphaTwo: "KG", alphaThree: "KGZ", numeric: "417" },
  LAOS: { alphaTwo: "LA", alphaThree: "LAO", numeric: "418" },
  LEBANON: { alphaTwo: "LB", alphaThree: "LBN", numeric: "422" },
  LESOTHO: { alphaTwo: "LS", alphaThree: "LSO", numeric: "426" },
  LIBERIA: { alphaTwo: "LR", alphaThree: "LBR", numeric: "430" },
  LIBYA: { alphaTwo: "LY", alphaThree: "LBY", numeric: "434" },
  MADAGASCAR: { alphaTwo: "MG", alphaThree: "MDG", numeric: "450" },
  MALAWI: { alphaTwo: "MW", alphaThree: "MWI", numeric: "454" },
  MALDIVES: { alphaTwo: "MV", alphaThree: "MDV", numeric: "462" },
  MALI: { alphaTwo: "ML", alphaThree: "MLI", numeric: "466" },
  MARSHALL_ISLANDS: { alphaTwo: "MH", alphaThree: "MHL", numeric: "584" },
  MARTINIQUE: { alphaTwo: "MQ", alphaThree: "MTQ", numeric: "474" },
  MAURITANIA: { alphaTwo: "MR", alphaThree: "MRT", numeric: "478" },
  MAYOTTE: { alphaTwo: "YT", alphaThree: "MYT", numeric: "175" },
  MICRONESIA_FEDERATED_STATES_OF: { alphaTwo: "FM", alphaThree: "FSM", numeric: "583" },
  MOLDOVA_REPUBLIC_OF: { alphaTwo: "MD", alphaThree: "MDA", numeric: "498" },
  MONACO: { alphaTwo: "MC", alphaThree: "MCO", numeric: "492" },
  MONGOLIA: { alphaTwo: "MN", alphaThree: "MNG", numeric: "496" },
  MONTSERRAT: { alphaTwo: "MS", alphaThree: "MSR", numeric: "500" },
  MOROCCO: { alphaTwo: "MA", alphaThree: "MAR", numeric: "504" },
  MOZAMBIQUE: { alphaTwo: "MZ", alphaThree: "MOZ", numeric: "508" },
  MYANMAR: { alphaTwo: "MM", alphaThree: "MMR", numeric: "104" },
  NAMIBIA: { alphaTwo: "NA", alphaThree: "NAM", numeric: "516" },
  NAURU: { alphaTwo: "NR", alphaThree: "NRU", numeric: "520" },
  NEPAL: { alphaTwo: "NP", alphaThree: "NPL", numeric: "524" },
  NEW_CALEDONIA: { alphaTwo: "NC", alphaThree: "NCL", numeric: "540" },
  NICARAGUA: { alphaTwo: "NI", alphaThree: "NIC", numeric: "558" },
  NIGER: { alphaTwo: "NE", alphaThree: "NER", numeric: "562" },
  NIGERIA: { alphaTwo: "NG", alphaThree: "NGA", numeric: "566" },
  NIUE: { alphaTwo: "NU", alphaThree: "NIU", numeric: "570" },
  NORFOLK_ISLAND: { alphaTwo: "NF", alphaThree: "NFK", numeric: "574" },
  NORTH_MACEDONIA_REPUBLIC_OF: { alphaTwo: "MK", alphaThree: "MKD", numeric: "807" },
  NORTHERN_MARIANA_ISLANDS: { alphaTwo: "MP", alphaThree: "MNP", numeric: "580" },
  PAKISTAN: { alphaTwo: "PK", alphaThree: "PAK", numeric: "586" },
  PALAU: { alphaTwo: "PW", alphaThree: "PLW", numeric: "585" },
  PALESTINE: { alphaTwo: "PS", alphaThree: "PSE", numeric: "275" },
  PANAMA: { alphaTwo: "PA", alphaThree: "PAN", numeric: "591" },
  PAPUA_NEW_GUINEA: { alphaTwo: "PG", alphaThree: "PNG", numeric: "598" },
  PARAGUAY: { alphaTwo: "PY", alphaThree: "PRY", numeric: "600" },
  PHILIPPINES: { alphaTwo: "PH", alphaThree: "PHL", numeric: "608" },
  PITCAIRN: { alphaTwo: "PN", alphaThree: "PCN", numeric: "612" },
  PUERTO_RICO: { alphaTwo: "PR", alphaThree: "PRI", numeric: "630" },
  REUNION: { alphaTwo: "RE", alphaThree: "REU", numeric: "638" },
  RUSSIA: { alphaTwo: "RU", alphaThree: "RUS", numeric: "643" },
  RWANDA: { alphaTwo: "RW", alphaThree: "RWA", numeric: "646" },
  SAINT_HELENA: { alphaTwo: "SH", alphaThree: "SHN", numeric: "654" },
  SAINT_KITTS_AND_NEVIS: { alphaTwo: "KN", alphaThree: "KNA", numeric: "659" },
  SAINT_LUCIA: { alphaTwo: "LC", alphaThree: "LCA", numeric: "662" },
  SAINT_PIERRE_AND_MIQUELON: { alphaTwo: "PM", alphaThree: "SPM", numeric: "666" },
  SAINT_VINCENT_AND_THE_GRENADINES: { alphaTwo: "VC", alphaThree: "VCT", numeric: "670" },
  SAMOA: { alphaTwo: "WS", alphaThree: "WSM", numeric: "882" },
  SAN_MARINO: { alphaTwo: "SM", alphaThree: "SMR", numeric: "674" },
  SAO_TOME_AND_PRINCIPE: { alphaTwo: "ST", alphaThree: "STP", numeric: "678" },
  SAUDI_ARABIA: { alphaTwo: "SA", alphaThree: "SAU", numeric: "682" },
  SENEGAL: { alphaTwo: "SN", alphaThree: "SEN", numeric: "686" },
  SEYCHELLES: { alphaTwo: "SC", alphaThree: "SYC", numeric: "690" },
  SIERRA_LEONE: { alphaTwo: "SL", alphaThree: "SLE", numeric: "694" },
  SOLOMON_ISLANDS: { alphaTwo: "SB", alphaThree: "SLB", numeric: "090" },
  SOMALIA: { alphaTwo: "SO", alphaThree: "SOM", numeric: "706" },
  SOUTH_AFRICA: { alphaTwo: "ZA", alphaThree: "ZAF", numeric: "710" },
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: { alphaTwo: "GS", alphaThree: "SGS", numeric: "239" },
  SRI_LANKA: { alphaTwo: "LK", alphaThree: "LKA", numeric: "144" },
  SUDAN: { alphaTwo: "SD", alphaThree: "SDN", numeric: "729" },
  SURINAME: { alphaTwo: "SR", alphaThree: "SUR", numeric: "740" },
  SVALBARD_AND_JAN_MAYEN: { alphaTwo: "SJ", alphaThree: "SJM", numeric: "744" },
  SWAZILAND: { alphaTwo: "SZ", alphaThree: "SWZ", numeric: "748" },
  SYRIA: { alphaTwo: "SY", alphaThree: "SYR", numeric: "760" },
  TAJIKISTAN: { alphaTwo: "TJ", alphaThree: "TJK", numeric: "762" },
  TANZANIA_UNITED_REPUBLIC_OF: { alphaTwo: "TZ", alphaThree: "TZA", numeric: "834" },
  TIMOR_LESTE: { alphaTwo: "TL", alphaThree: "TLS", numeric: "626" },
  TOGO: { alphaTwo: "TG", alphaThree: "TGO", numeric: "768" },
  TOKELAU: { alphaTwo: "TK", alphaThree: "TKL", numeric: "772" },
  TONGA: { alphaTwo: "TO", alphaThree: "TON", numeric: "776" },
  TRINIDAD_AND_TOBAGO: { alphaTwo: "TT", alphaThree: "TTO", numeric: "780" },
  TURKEY: { alphaTwo: "TR", alphaThree: "TUR", numeric: "792" },
  TURKMENISTAN: { alphaTwo: "TM", alphaThree: "TKM", numeric: "795" },
  TURKS_AND_CAICOS_ISLANDS: { alphaTwo: "TC", alphaThree: "TCA", numeric: "796" },
  TUVALU: { alphaTwo: "TV", alphaThree: "TUV", numeric: "798" },
  UGANDA: { alphaTwo: "UG", alphaThree: "UGA", numeric: "800" },
  UKRAINE: { alphaTwo: "UA", alphaThree: "UKR", numeric: "804" },
  UNITED_KINGDOM: { alphaTwo: "GB", alphaThree: "GBR", numeric: "826" },
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: { alphaTwo: "UM", alphaThree: "UMI", numeric: "581" },
  URUGUAY: { alphaTwo: "UY", alphaThree: "URY", numeric: "858" },
  UZBEKISTAN: { alphaTwo: "UZ", alphaThree: "UZB", numeric: "860" },
  VANUATU: { alphaTwo: "VU", alphaThree: "VUT", numeric: "548" },
  VENEZUELA: { alphaTwo: "VE", alphaThree: "VEN", numeric: "862" },
  VIETNAM: { alphaTwo: "VN", alphaThree: "VNM", numeric: "704" },
  VIRGIN_ISLANDS_BRITISH: { alphaTwo: "VG", alphaThree: "VGB", numeric: "092" },
  VIRGIN_ISLANDS_US: { alphaTwo: "VI", alphaThree: "VIR", numeric: "850" },
  WALLIS_AND_FUTUNA: { alphaTwo: "WF", alphaThree: "WLF", numeric: "876" },
  WESTERN_SAHARA: { alphaTwo: "EH", alphaThree: "ESH", numeric: "732" },
  YEMEN: { alphaTwo: "YE", alphaThree: "YEM", numeric: "887" },
  ZAMBIA: { alphaTwo: "ZM", alphaThree: "ZMB", numeric: "894" },
  ZIMBABWE: { alphaTwo: "ZW", alphaThree: "ZWE", numeric: "716" },
  ALAND_ISLANDS: { alphaTwo: "AX", alphaThree: "ALA", numeric: "248" },
  BONAIRE_SINT_EUSTATIUS_AND_SABA: { alphaTwo: "BQ", alphaThree: "BES", numeric: "535" },
  CURACAO: { alphaTwo: "CW", alphaThree: "CUW", numeric: "531" },
  GUERNSEY: { alphaTwo: "GG", alphaThree: "GGY", numeric: "831" },
  ISLE_OF_MAN: { alphaTwo: "IM", alphaThree: "IMN", numeric: "833" },
  JERSEY: { alphaTwo: "JE", alphaThree: "JEY", numeric: "832" },
  MONTENEGRO: { alphaTwo: "ME", alphaThree: "MNE", numeric: "499" },
  SAINT_BARTHELEMY: { alphaTwo: "BL", alphaThree: "BLM", numeric: "652" },
  SAINT_MARTIN_FRANCE: { alphaTwo: "MF", alphaThree: "MAF", numeric: "663" },
  SINT_MAARTEN_DUTCH: { alphaTwo: "SX", alphaThree: "SXM", numeric: "534" },
  SOUTH_SUDAN: { alphaTwo: "SS", alphaThree: "SSD", numeric: "728" },
  KOSOVO: { alphaTwo: "XK", alphaThree: "XKX", numeric: "" }
}, recognisedCountries = {
  AUSTRALIA: {
    key: "AUSTRALIA",
    region: "Oceania",
    countryName: "Australia",
    transferMate: 14,
    nationality: "Australian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.AUSTRALIA
  },
  AUSTRIA: {
    key: "AUSTRIA",
    region: "Europe",
    countryName: "Austria",
    transferMate: 16,
    nationality: "Austrian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.AUSTRIA
  },
  BAHRAIN: {
    key: "BAHRAIN",
    region: "Middle East",
    countryName: "Bahrain",
    transferMate: 19,
    nationality: "Bahraini",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BAHRAIN
  },
  BARBADOS: {
    key: "BARBADOS",
    region: "North America",
    countryName: "Barbados",
    transferMate: 21,
    nationality: "Barbadian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BARBADOS
  },
  BELGIUM: {
    key: "BELGIUM",
    region: "Europe",
    countryName: "Belgium",
    transferMate: 23,
    nationality: "Belgian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.BELGIUM
  },
  BOTSWANA: {
    key: "BOTSWANA",
    region: "Africa",
    countryName: "Botswana",
    transferMate: 30,
    nationality: "Motswana",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BOTSWANA
  },
  BRAZIL: {
    key: "BRAZIL",
    region: "South America",
    countryName: "Brazil",
    transferMate: 32,
    nationality: "Brazilian",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BRAZIL
  },
  BRUNEI_DARUSSALAM: {
    key: "BRUNEI_DARUSSALAM",
    region: "Southeast Asia",
    countryName: "Brunei Darussalam",
    nationality: "Bruneian",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BRUNEI_DARUSSALAM
  },
  BULGARIA: {
    key: "BULGARIA",
    region: "Europe",
    countryName: "Bulgaria",
    transferMate: 35,
    nationality: "Bulgarian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.BULGARIA
  },
  CAMBODIA: {
    key: "CAMBODIA",
    region: "Southeast Asia",
    countryName: "Cambodia",
    transferMate: 38,
    nationality: "Cambodian",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CAMBODIA
  },
  CANADA: {
    key: "CANADA",
    region: "North America",
    countryName: "Canada",
    transferMate: 40,
    nationality: "Canadian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CANADA
  },
  CHILE: {
    key: "CHILE",
    region: "South America",
    countryName: "Chile",
    transferMate: 46,
    nationality: "Chilean",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CHILE
  },
  CHINA: {
    key: "CHINA",
    region: "East Asia",
    countryName: "China",
    transferMate: 47,
    nationality: "Chinese",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CHINA
  },
  CROATIA: {
    key: "CROATIA",
    region: "Europe",
    countryName: "Croatia",
    transferMate: 56,
    nationality: "Croatian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.CROATIA
  },
  CYPRUS: {
    key: "CYPRUS",
    region: "Europe",
    countryName: "Cyprus",
    transferMate: 58,
    nationality: "Cypriot",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.CYPRUS
  },
  CZECH_REPUBLIC: {
    key: "CZECH_REPUBLIC",
    region: "Europe",
    countryName: "Czech Republic",
    transferMate: 60,
    nationality: "Czech",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.CZECH_REPUBLIC
  },
  DENMARK: {
    key: "DENMARK",
    region: "Europe",
    countryName: "Denmark",
    transferMate: 61,
    nationality: "Danish",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.DENMARK
  },
  DOMINICA: {
    key: "DOMINICA",
    region: "North America",
    countryName: "Dominica",
    transferMate: 64,
    nationality: "Dominican",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.DOMINICA
  },
  ESTONIA: {
    key: "ESTONIA",
    region: "Europe",
    countryName: "Estonia",
    transferMate: 72,
    nationality: "Estonian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ESTONIA
  },
  FINLAND: {
    key: "FINLAND",
    region: "Europe",
    countryName: "Finland",
    transferMate: 77,
    nationality: "Finnish",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.FINLAND
  },
  FRANCE: {
    key: "FRANCE",
    region: "Europe",
    countryName: "France",
    transferMate: 79,
    nationality: "French",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.FRANCE
  },
  GERMANY: {
    key: "GERMANY",
    region: "Europe",
    countryName: "Germany",
    transferMate: 87,
    nationality: "German",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.GERMANY
  },
  GREECE: {
    key: "GREECE",
    region: "Europe",
    countryName: "Greece",
    transferMate: 91,
    nationality: "Greek",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.GREECE
  },
  HONG_KONG: {
    key: "HONG_KONG",
    region: "East Asia",
    countryName: "Hong Kong",
    nationality: "Hong Konger",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.HONG_KONG
  },
  HUNGARY: {
    key: "HUNGARY",
    region: "Europe",
    countryName: "Hungary",
    transferMate: 107,
    nationality: "Hungarian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.HUNGARY
  },
  ICELAND: {
    key: "ICELAND",
    region: "Non_EU Europe",
    countryName: "Iceland",
    transferMate: 108,
    nationality: "Icelander",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ICELAND
  },
  INDONESIA: {
    key: "INDONESIA",
    region: "Southeast Asia",
    countryName: "Indonesia",
    transferMate: 110,
    nationality: "Indonesian",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.INDONESIA
  },
  IRELAND: {
    key: "IRELAND",
    region: "Europe",
    countryName: "Ireland",
    transferMate: 113,
    nationality: "Irish",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.IRELAND
  },
  ITALY: {
    key: "ITALY",
    region: "Europe",
    countryName: "Italy",
    transferMate: 116,
    nationality: "Italian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ITALY
  },
  JAPAN: {
    key: "JAPAN",
    region: "East Asia",
    countryName: "Japan",
    transferMate: 119,
    nationality: "Japanese",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.JAPAN
  },
  KAZAKHSTAN: {
    key: "KAZAKHSTAN",
    region: "Central Asia (CIS)",
    countryName: "Kazakhstan",
    transferMate: 122,
    nationality: "Kazakhstani",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.KAZAKHSTAN
  },
  SOUTH_KOREA: {
    key: "SOUTH_KOREA",
    region: "East Asia",
    countryName: "South Korea",
    nationality: "South Korean",
    atas: !1,
    tb: !0,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.SOUTH_KOREA
  },
  KUWAIT: {
    key: "KUWAIT",
    region: "Middle East",
    countryName: "Kuwait",
    transferMate: 126,
    nationality: "Kuwaiti",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.KUWAIT
  },
  LATVIA: {
    key: "LATVIA",
    region: "Europe",
    countryName: "Latvia",
    transferMate: 129,
    nationality: "Latvian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LATVIA
  },
  LIECHTENSTEIN: {
    key: "LIECHTENSTEIN",
    region: "Non_EU Europe",
    countryName: "Liechtenstein",
    transferMate: 134,
    nationality: "Liechtensteiner",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LIECHTENSTEIN
  },
  LITHUANIA: {
    key: "LITHUANIA",
    region: "Europe",
    countryName: "Lithuania",
    transferMate: 135,
    nationality: "Lithuanian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LITHUANIA
  },
  LUXEMBOURG: {
    key: "LUXEMBOURG",
    region: "Europe",
    countryName: "Luxembourg",
    transferMate: 136,
    nationality: "Luxembourger",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LUXEMBOURG
  },
  MACAU: {
    key: "MACAU",
    region: "East Asia",
    countryName: "Macau",
    nationality: "Macanese",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MACAU
  },
  MALAYSIA: {
    key: "MALAYSIA",
    region: "Southeast Asia",
    countryName: "Malaysia",
    transferMate: 141,
    nationality: "Malaysian",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MALAYSIA
  },
  MALTA: {
    key: "MALTA",
    region: "Europe",
    countryName: "Malta",
    transferMate: 144,
    nationality: "Maltese",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.MALTA
  },
  MAURITIUS: {
    key: "MAURITIUS",
    region: "Africa",
    countryName: "Mauritius",
    transferMate: 149,
    nationality: "Mauritian",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MAURITIUS
  },
  MEXICO: {
    key: "MEXICO",
    region: "North America",
    countryName: "Mexico",
    transferMate: 151,
    nationality: "Mexican",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MEXICO
  },
  NETHERLANDS: {
    key: "NETHERLANDS",
    region: "Europe",
    countryName: "Netherlands",
    nationality: "Dutch",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.NETHERLANDS
  },
  NEW_ZEALAND: {
    key: "NEW_ZEALAND",
    region: "Oceania",
    countryName: "New Zealand",
    transferMate: 164,
    nationality: "New Zealander",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.NEW_ZEALAND
  },
  NORWAY: {
    key: "NORWAY",
    region: "Non_EU Europe",
    countryName: "Norway",
    transferMate: 171,
    nationality: "Norwegian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.NORWAY
  },
  OMAN: {
    key: "OMAN",
    region: "Middle East",
    countryName: "Oman",
    transferMate: 172,
    nationality: "Omani",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.OMAN
  },
  PERU: {
    key: "PERU",
    region: "South America",
    countryName: "Peru",
    transferMate: 178,
    nationality: "Peruvian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.PERU
  },
  POLAND: {
    key: "POLAND",
    region: "Europe",
    countryName: "Poland",
    transferMate: 181,
    nationality: "Polish",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.POLAND
  },
  PORTUGAL: {
    key: "PORTUGAL",
    region: "Europe",
    countryName: "Portugal",
    transferMate: 182,
    nationality: "Portuguese",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.PORTUGAL
  },
  QATAR: {
    key: "QATAR",
    region: "Middle East",
    countryName: "Qatar",
    transferMate: 184,
    nationality: "Qatari",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.QATAR
  },
  ROMANIA: {
    key: "ROMANIA",
    region: "Europe",
    countryName: "Romania",
    transferMate: 186,
    nationality: "Romanian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ROMANIA
  },
  SINGAPORE: {
    key: "SINGAPORE",
    region: "Southeast Asia",
    countryName: "Singapore",
    transferMate: 203,
    nationality: "Singaporean",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.SINGAPORE
  },
  SLOVAKIA: {
    key: "SLOVAKIA",
    region: "Europe",
    countryName: "Slovakia",
    transferMate: 204,
    nationality: "Slovakian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SLOVAKIA
  },
  SLOVENIA: {
    key: "SLOVENIA",
    region: "Europe",
    countryName: "Slovenia",
    transferMate: 205,
    nationality: "Slovenian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SLOVENIA
  },
  SPAIN: {
    key: "SPAIN",
    region: "Europe",
    countryName: "Spain",
    transferMate: 211,
    nationality: "Spanish",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SPAIN
  },
  SWEDEN: {
    key: "SWEDEN",
    region: "Europe",
    countryName: "Sweden",
    transferMate: 217,
    nationality: "Swedish",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SWEDEN
  },
  SWITZERLAND: {
    key: "SWITZERLAND",
    region: "Non_EU Europe",
    countryName: "Switzerland",
    transferMate: 218,
    nationality: "Swiss",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SWITZERLAND
  },
  TAIWAN: {
    key: "TAIWAN",
    region: "East Asia",
    countryName: "Taiwan",
    transferMate: 220,
    nationality: "Taiwanese",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.TAIWAN
  },
  THAILAND: {
    key: "THAILAND",
    region: "Southeast Asia",
    countryName: "Thailand",
    transferMate: 223,
    nationality: "Thai",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.THAILAND
  },
  TUNISIA: {
    key: "TUNISIA",
    region: "Africa",
    countryName: "Tunisia",
    transferMate: 228,
    nationality: "Tunisian",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.TUNISIA
  },
  UNITED_ARAB_EMIRATES: {
    key: "UNITED_ARAB_EMIRATES",
    region: "Middle East",
    countryName: "United Arab Emirates",
    transferMate: 235,
    nationality: "Emirati",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.UNITED_ARAB_EMIRATES
  },
  UNITED_STATES_OF_AMERICA: {
    key: "UNITED_STATES_OF_AMERICA",
    region: "North America",
    countryName: "United States of America",
    nationality: "American",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.UNITED_STATES_OF_AMERICA
  },
  SERBIA: {
    key: "SERBIA",
    region: "Non_EU Europe",
    countryName: "Serbia",
    transferMate: 200,
    nationality: "Serbian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.SERBIA
  },
  AFGHANISTAN: {
    key: "AFGHANISTAN",
    region: "Middle East",
    countryName: "Afghanistan",
    transferMate: 2,
    nationality: "Afghan",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.AFGHANISTAN
  },
  ALBANIA: {
    key: "ALBANIA",
    region: "Non_EU Europe",
    countryName: "Albania",
    transferMate: 3,
    nationality: "Albanian",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ALBANIA
  },
  ALGERIA: {
    key: "ALGERIA",
    region: "Africa",
    countryName: "Algeria",
    transferMate: 4,
    nationality: "Algerian",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ALGERIA
  },
  AMERICAN_SAMOA: {
    key: "AMERICAN_SAMOA",
    region: "Oceania",
    countryName: "American Samoa",
    transferMate: 5,
    nationality: "Samoan (American)",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.AMERICAN_SAMOA
  },
  ANDORRA: {
    key: "ANDORRA",
    region: "Europe",
    countryName: "Andorra",
    transferMate: 6,
    nationality: "Andorran",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANDORRA
  },
  ANGOLA: {
    key: "ANGOLA",
    region: "Africa",
    countryName: "Angola",
    transferMate: 7,
    nationality: "Angolan",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANGOLA
  },
  ANGUILLA: {
    key: "ANGUILLA",
    region: "North America",
    countryName: "Anguilla",
    transferMate: 8,
    nationality: "Anguillan",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANGUILLA
  },
  ANTARCTICA: {
    key: "ANTARCTICA",
    region: "Antarctica",
    countryName: "Antarctica",
    transferMate: 9,
    nationality: "Antarctic",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANTARCTICA
  },
  ANTIGUA_AND_BARBUDA: {
    key: "ANTIGUA_AND_BARBUDA",
    region: "North America",
    countryName: "Antigua and Barbuda",
    transferMate: 10,
    nationality: "Antiguans",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANTIGUA_AND_BARBUDA
  },
  ARGENTINA: {
    key: "ARGENTINA",
    region: "South America",
    countryName: "Argentina",
    transferMate: 11,
    nationality: "Argentinean",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ARGENTINA
  },
  ARMENIA: {
    key: "ARMENIA",
    region: "Central Asia (CIS)",
    countryName: "Armenia",
    transferMate: 12,
    nationality: "Armenian",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ARMENIA
  },
  ARUBA: {
    key: "ARUBA",
    region: "South America",
    countryName: "Aruba",
    transferMate: 13,
    nationality: "Arubian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ARUBA
  },
  AZERBAIJAN: {
    key: "AZERBAIJAN",
    region: "Central Asia (CIS)",
    countryName: "Azerbaijan",
    transferMate: 17,
    nationality: "Azerbaijani",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.AZERBAIJAN
  },
  BAHAMAS: {
    key: "BAHAMAS",
    region: "North America",
    countryName: "Bahamas",
    transferMate: 18,
    nationality: "Bahamian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BAHAMAS
  },
  BANGLADESH: {
    key: "BANGLADESH",
    region: "South Asia",
    countryName: "Bangladesh",
    transferMate: 20,
    nationality: "Bangladeshi",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BANGLADESH
  },
  BELARUS: {
    key: "BELARUS",
    region: "Non_EU Europe|Central Asia (CIS)",
    countryName: "Belarus",
    transferMate: 22,
    nationality: "Belarusian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BELARUS
  },
  BELIZE: {
    key: "BELIZE",
    region: "North America",
    countryName: "Belize",
    transferMate: 24,
    nationality: "Belizean",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BELIZE
  },
  BENIN: {
    key: "BENIN",
    region: "Africa",
    countryName: "Benin",
    transferMate: 25,
    nationality: "Beninese",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BENIN
  },
  BERMUDA: {
    key: "BERMUDA",
    region: "North America",
    countryName: "Bermuda",
    transferMate: 26,
    nationality: "Bermudan",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BERMUDA
  },
  BHUTAN: {
    key: "BHUTAN",
    region: "South Asia",
    countryName: "Bhutan",
    transferMate: 27,
    nationality: "Bhutanese",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BHUTAN
  },
  BOLIVIA: {
    key: "BOLIVIA",
    region: "South America",
    countryName: "Bolivia",
    transferMate: 28,
    nationality: "Bolivian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BOLIVIA
  },
  BOSNIA_AND_HERZEGOVINA: {
    key: "BOSNIA_AND_HERZEGOVINA",
    region: "Non_EU Europe",
    countryName: "Bosnia and Herzegovina",
    transferMate: 29,
    nationality: "Bosnian",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BOSNIA_AND_HERZEGOVINA
  },
  BOUVET_ISLAND: {
    key: "BOUVET_ISLAND",
    region: "South America",
    countryName: "Bouvet Island",
    transferMate: 31,
    nationality: "Bouvet Island",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BOUVET_ISLAND
  },
  BRITISH_INDIAN_OCEAN_TERRITORY: {
    key: "BRITISH_INDIAN_OCEAN_TERRITORY",
    region: "South Asia",
    countryName: "British Indian Ocean Territory",
    transferMate: 33,
    nationality: "British (IOT)",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY
  },
  BURKINA_FASO: {
    key: "BURKINA_FASO",
    region: "Africa",
    countryName: "Burkina Faso",
    transferMate: 36,
    nationality: "Burkinabe",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BURKINA_FASO
  },
  BURUNDI: {
    key: "BURUNDI",
    region: "Africa",
    countryName: "Burundi",
    transferMate: 37,
    nationality: "Burundian",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BURUNDI
  },
  CAMEROON: {
    key: "CAMEROON",
    region: "Africa",
    countryName: "Cameroon",
    transferMate: 39,
    nationality: "Cameroonian",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CAMEROON
  },
  CAPE_VERDE: {
    key: "CAPE_VERDE",
    region: "Africa",
    countryName: "Cape Verde",
    transferMate: 42,
    nationality: "Cape Verdean",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CAPE_VERDE
  },
  CAYMAN_ISLANDS: {
    key: "CAYMAN_ISLANDS",
    region: "North America",
    countryName: "Cayman Islands",
    transferMate: 43,
    nationality: "Caymanian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CAYMAN_ISLANDS
  },
  CENTRAL_AFRICAN_REPUBLIC: {
    key: "CENTRAL_AFRICAN_REPUBLIC",
    region: "Africa",
    countryName: "Central African Republic",
    transferMate: 44,
    nationality: "Central African",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CENTRAL_AFRICAN_REPUBLIC
  },
  CHAD: {
    key: "CHAD",
    region: "Africa",
    countryName: "Chad",
    transferMate: 45,
    nationality: "Chadian",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CHAD
  },
  CHRISTMAS_ISLAND: {
    key: "CHRISTMAS_ISLAND",
    region: "Southeast Asia",
    countryName: "Christmas Island",
    transferMate: 48,
    nationality: "Christmas Islander",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CHRISTMAS_ISLAND
  },
  COCOS_KEELING_ISLANDS: {
    key: "COCOS_KEELING_ISLANDS",
    region: "Southeast Asia",
    countryName: "Cocos (Keeling) Islands",
    transferMate: 49,
    nationality: "Cocossian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COCOS_KEELING_ISLANDS
  },
  COLOMBIA: {
    key: "COLOMBIA",
    region: "South America",
    countryName: "Colombia",
    transferMate: 50,
    nationality: "Colombian",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COLOMBIA
  },
  COMOROS: {
    key: "COMOROS",
    region: "Africa",
    countryName: "Comoros",
    transferMate: 51,
    nationality: "Comoran",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COMOROS
  },
  CONGO: {
    key: "CONGO",
    region: "Africa",
    countryName: "Congo",
    transferMate: 52,
    nationality: "Congolese",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CONGO
  },
  CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE: {
    key: "CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE",
    region: "Africa",
    transferMate: 256,
    countryName: "Congo, the Democratic Republic of the",
    nationality: "Congolese (DRC)",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE
  },
  COOK_ISLANDS: {
    key: "COOK_ISLANDS",
    region: "Oceania",
    countryName: "Cook Islands",
    transferMate: 53,
    nationality: "Cook Islander",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COOK_ISLANDS
  },
  COSTA_RICA: {
    key: "COSTA_RICA",
    region: "North America",
    countryName: "Costa Rica",
    transferMate: 54,
    nationality: "Costa Rican",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COSTA_RICA
  },
  COTE_DIVOIRE: {
    key: "COTE_DIVOIRE",
    region: "Africa",
    countryName: "Cote D'Ivoire",
    nationality: "Ivorian",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COTE_DIVOIRE
  },
  CUBA: {
    key: "CUBA",
    region: "North America",
    countryName: "Cuba",
    transferMate: 57,
    nationality: "Cuban",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CUBA
  },
  DJIBOUTI: {
    key: "DJIBOUTI",
    region: "Africa",
    countryName: "Djibouti",
    transferMate: 63,
    nationality: "Djiboutian",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.DJIBOUTI
  },
  DOMINICAN_REPUBLIC: {
    key: "DOMINICAN_REPUBLIC",
    region: "North America",
    countryName: "Dominican Republic",
    transferMate: 65,
    nationality: "Dominican (Republic)",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.DOMINICAN_REPUBLIC
  },
  ECUADOR: {
    key: "ECUADOR",
    region: "South America",
    countryName: "Ecuador",
    transferMate: 67,
    nationality: "Ecuadorean",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ECUADOR
  },
  EGYPT: {
    key: "EGYPT",
    region: "Middle East|Africa",
    countryName: "Egypt",
    transferMate: 68,
    nationality: "Egyptian",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.EGYPT
  },
  EL_SALVADOR: {
    key: "EL_SALVADOR",
    region: "North America",
    countryName: "El Salvador",
    transferMate: 69,
    nationality: "Salvadorean",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.EL_SALVADOR
  },
  EQUATORIAL_GUINEA: {
    key: "EQUATORIAL_GUINEA",
    region: "Africa",
    countryName: "Equatorial Guinea",
    transferMate: 70,
    nationality: "Equatorial Guinean",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.EQUATORIAL_GUINEA
  },
  ERITREA: {
    key: "ERITREA",
    region: "Africa",
    countryName: "Eritrea",
    transferMate: 71,
    nationality: "Eritrean",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ERITREA
  },
  ETHIOPIA: {
    key: "ETHIOPIA",
    region: "Africa",
    countryName: "Ethiopia",
    transferMate: 73,
    nationality: "Ethiopian",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ETHIOPIA
  },
  FALKLAND_ISLANDS_MALVINAS: {
    key: "FALKLAND_ISLANDS_MALVINAS",
    region: "South America",
    countryName: "Falkland Islands (Malvinas)",
    nationality: "Falkland Islander",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FALKLAND_ISLANDS_MALVINAS
  },
  FAROE_ISLANDS: {
    key: "FAROE_ISLANDS",
    region: "Europe",
    countryName: "Faroe Islands",
    transferMate: 75,
    nationality: "Faroese",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FAROE_ISLANDS
  },
  FIJI: {
    key: "FIJI",
    region: "Oceania",
    countryName: "Fiji",
    nationality: "Fijian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FIJI
  },
  FRENCH_GUIANA: {
    key: "FRENCH_GUIANA",
    region: "South America",
    countryName: "French Guiana",
    transferMate: 81,
    nationality: "French Guianese",
    atas: !1,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FRENCH_GUIANA
  },
  FRENCH_POLYNESIA: {
    key: "FRENCH_POLYNESIA",
    region: "Oceania",
    countryName: "French Polynesia",
    transferMate: 82,
    nationality: "French Polynesian",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FRENCH_POLYNESIA
  },
  FRENCH_SOUTHERN_TERRITORIES: {
    key: "FRENCH_SOUTHERN_TERRITORIES",
    region: "South Asia",
    countryName: "French Southern Territories",
    transferMate: 83,
    nationality: "French (Southern Territories)",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FRENCH_SOUTHERN_TERRITORIES
  },
  GABON: {
    key: "GABON",
    region: "Africa",
    countryName: "Gabon",
    transferMate: 84,
    nationality: "Gabonese",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GABON
  },
  GAMBIA: {
    key: "GAMBIA",
    region: "Africa",
    countryName: "Gambia",
    transferMate: 85,
    nationality: "Gambian",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GAMBIA
  },
  GEORGIA: {
    key: "GEORGIA",
    region: "Non_EU Europe",
    countryName: "Georgia",
    transferMate: 86,
    nationality: "Georgian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GEORGIA
  },
  GHANA: {
    key: "GHANA",
    region: "Africa",
    countryName: "Ghana",
    transferMate: 89,
    nationality: "Ghanaian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GHANA
  },
  GIBRALTAR: {
    key: "GIBRALTAR",
    region: "Europe",
    countryName: "Gibraltar",
    transferMate: 90,
    nationality: "Gibraltarian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GIBRALTAR
  },
  GREENLAND: {
    key: "GREENLAND",
    region: "Europe",
    countryName: "Greenland",
    transferMate: 92,
    nationality: "Greenlander",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GREENLAND
  },
  GRENADA: {
    key: "GRENADA",
    region: "North America",
    countryName: "Grenada",
    transferMate: 93,
    nationality: "Grenadian",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GRENADA
  },
  GUADELOUPE: {
    key: "GUADELOUPE",
    region: "North America",
    countryName: "Guadeloupe",
    transferMate: 94,
    nationality: "Guadeloupean",
    atas: !1,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUADELOUPE
  },
  GUAM: {
    key: "GUAM",
    region: "East Asia",
    countryName: "Guam",
    transferMate: 95,
    nationality: "Guamanian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUAM
  },
  GUATEMALA: {
    key: "GUATEMALA",
    region: "North America",
    countryName: "Guatemala",
    transferMate: 96,
    nationality: "Guatemalan",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUATEMALA
  },
  GUINEA: {
    key: "GUINEA",
    region: "Africa",
    countryName: "Guinea",
    transferMate: 97,
    nationality: "Guinean",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUINEA
  },
  GUINEA_BISSAU: {
    key: "GUINEA_BISSAU",
    region: "Africa",
    countryName: "Guinea-Bissau",
    transferMate: 98,
    nationality: "Guinean (Bissau)",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUINEA_BISSAU
  },
  GUYANA: {
    key: "GUYANA",
    region: "South America",
    countryName: "Guyana",
    transferMate: 99,
    nationality: "Guyanese",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUYANA
  },
  HAITI: {
    key: "HAITI",
    region: "North America",
    countryName: "Haiti",
    transferMate: 100,
    nationality: "Haitian",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.HAITI
  },
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: {
    key: "HEARD_ISLAND_AND_MCDONALD_ISLANDS",
    region: "Oceania",
    countryName: "Heard Island and Mcdonald Islands",
    nationality: "Heard Island and Mcdonald Island",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS
  },
  VATICAN: {
    key: "VATICAN",
    region: "Europe",
    countryName: "Vatican",
    nationality: "Vatican",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VATICAN
  },
  HONDURAS: {
    key: "HONDURAS",
    region: "North America",
    countryName: "Honduras",
    transferMate: 104,
    nationality: "Honduran",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.HONDURAS
  },
  INDIA: {
    key: "INDIA",
    region: "South Asia",
    countryName: "India",
    transferMate: 109,
    nationality: "Indian",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.INDIA
  },
  IRAN_ISLAMIC_REPUBLIC_OF: {
    key: "IRAN_ISLAMIC_REPUBLIC_OF",
    region: "Middle East",
    countryName: "Iran, Islamic Republic of",
    nationality: "Iranian",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.IRAN_ISLAMIC_REPUBLIC_OF
  },
  IRAQ: {
    key: "IRAQ",
    region: "Middle East",
    countryName: "Iraq",
    transferMate: 112,
    nationality: "Iraqi",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.IRAQ
  },
  ISRAEL: {
    key: "ISRAEL",
    region: "Middle East",
    countryName: "Israel",
    transferMate: 115,
    nationality: "Israeli",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ISRAEL
  },
  JAMAICA: {
    key: "JAMAICA",
    region: "North America",
    countryName: "Jamaica",
    transferMate: 118,
    nationality: "Jamaican",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.JAMAICA
  },
  JORDAN: {
    key: "JORDAN",
    region: "Middle East",
    countryName: "Jordan",
    transferMate: 121,
    nationality: "Jordanian",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.JORDAN
  },
  KENYA: {
    key: "KENYA",
    region: "Africa",
    countryName: "Kenya",
    transferMate: 123,
    nationality: "Kenyan",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KENYA
  },
  KIRIBATI: {
    key: "KIRIBATI",
    region: "Oceania",
    countryName: "Kiribati",
    transferMate: 124,
    nationality: "I_Kiribati",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KIRIBATI
  },
  NORTH_KOREA: {
    key: "NORTH_KOREA",
    region: "East Asia",
    countryName: "North Korea",
    nationality: "North Korean",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORTH_KOREA
  },
  KYRGYZSTAN: {
    key: "KYRGYZSTAN",
    region: "Central Asia (CIS)",
    countryName: "Kyrgyzstan",
    transferMate: 127,
    nationality: "Kyrgyzstani",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KYRGYZSTAN
  },
  LAOS: {
    key: "LAOS",
    region: "Southeast Asia",
    countryName: "Laos",
    transferMate: 128,
    nationality: "Laotian",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LAOS
  },
  LEBANON: {
    key: "LEBANON",
    region: "Middle East",
    countryName: "Lebanon",
    transferMate: 130,
    nationality: "Lebanese",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LEBANON
  },
  LESOTHO: {
    key: "LESOTHO",
    region: "Africa",
    countryName: "Lesotho",
    transferMate: 131,
    nationality: "Mosotho",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LESOTHO
  },
  LIBERIA: {
    key: "LIBERIA",
    region: "Africa",
    countryName: "Liberia",
    transferMate: 132,
    nationality: "Liberian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LIBERIA
  },
  LIBYA: {
    key: "LIBYA",
    region: "Africa",
    countryName: "Libya",
    nationality: "Libyan",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LIBYA
  },
  MADAGASCAR: {
    key: "MADAGASCAR",
    region: "Africa",
    countryName: "Madagascar",
    transferMate: 139,
    nationality: "Malagasy",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MADAGASCAR
  },
  MALAWI: {
    key: "MALAWI",
    region: "Africa",
    countryName: "Malawi",
    transferMate: 140,
    nationality: "Malawian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MALAWI
  },
  MALDIVES: {
    key: "MALDIVES",
    region: "South Asia",
    countryName: "Maldives",
    transferMate: 142,
    nationality: "Maldivan",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MALDIVES
  },
  MALI: {
    key: "MALI",
    region: "Africa",
    countryName: "Mali",
    transferMate: 143,
    nationality: "Malian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MALI
  },
  MARSHALL_ISLANDS: {
    key: "MARSHALL_ISLANDS",
    region: "Oceania",
    countryName: "Marshall Islands",
    transferMate: 146,
    nationality: "Marshallese",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MARSHALL_ISLANDS
  },
  MARTINIQUE: {
    key: "MARTINIQUE",
    region: "North America",
    countryName: "Martinique",
    transferMate: 147,
    nationality: "Martinican",
    atas: !1,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MARTINIQUE
  },
  MAURITANIA: {
    key: "MAURITANIA",
    region: "Africa",
    countryName: "Mauritania",
    transferMate: 148,
    nationality: "Mauritanian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MAURITANIA
  },
  MAYOTTE: {
    key: "MAYOTTE",
    region: "Africa",
    countryName: "Mayotte",
    transferMate: 150,
    nationality: "Mahoran",
    atas: !1,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MAYOTTE
  },
  MICRONESIA_FEDERATED_STATES_OF: {
    key: "MICRONESIA_FEDERATED_STATES_OF",
    region: "Oceania",
    countryName: "Micronesia, Federated States of",
    nationality: "Micronesian",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MICRONESIA_FEDERATED_STATES_OF
  },
  MOLDOVA_REPUBLIC_OF: {
    key: "MOLDOVA_REPUBLIC_OF",
    region: "Non_EU Europe|Central Asia (CIS)",
    countryName: "Moldova, Republic of",
    nationality: "Moldovan",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MOLDOVA_REPUBLIC_OF
  },
  MONACO: {
    key: "MONACO",
    region: "Europe",
    countryName: "Monaco",
    transferMate: 154,
    nationality: "Monacan",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONACO
  },
  MONGOLIA: {
    key: "MONGOLIA",
    region: "East Asia",
    countryName: "Mongolia",
    transferMate: 155,
    nationality: "Mongolian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONGOLIA
  },
  MONTSERRAT: {
    key: "MONTSERRAT",
    region: "North America",
    countryName: "Montserrat",
    transferMate: 156,
    nationality: "Montserratian",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONTSERRAT
  },
  MOROCCO: {
    key: "MOROCCO",
    region: "Africa",
    countryName: "Morocco",
    transferMate: 157,
    nationality: "Moroccan",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MOROCCO
  },
  MOZAMBIQUE: {
    key: "MOZAMBIQUE",
    region: "Africa",
    countryName: "Mozambique",
    transferMate: 158,
    nationality: "Mozambican",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MOZAMBIQUE
  },
  MYANMAR: {
    key: "MYANMAR",
    region: "Southeast Asia",
    countryName: "Myanmar",
    transferMate: 159,
    nationality: "Myanmarese",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MYANMAR
  },
  NAMIBIA: {
    key: "NAMIBIA",
    region: "Africa",
    countryName: "Namibia",
    transferMate: 160,
    nationality: "Namibian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NAMIBIA
  },
  NAURU: {
    key: "NAURU",
    region: "Oceania",
    countryName: "Nauru",
    transferMate: 161,
    nationality: "Nauruan",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NAURU
  },
  NEPAL: {
    key: "NEPAL",
    region: "South Asia",
    countryName: "Nepal",
    transferMate: 162,
    nationality: "Nepalese",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NEPAL
  },
  NEW_CALEDONIA: {
    key: "NEW_CALEDONIA",
    region: "Oceania",
    countryName: "New Caledonia",
    transferMate: 262,
    nationality: "New Caledonian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NEW_CALEDONIA
  },
  NICARAGUA: {
    key: "NICARAGUA",
    region: "North America",
    countryName: "Nicaragua",
    transferMate: 165,
    nationality: "Nicaraguan",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NICARAGUA
  },
  NIGER: {
    key: "NIGER",
    region: "Africa",
    countryName: "Niger",
    transferMate: 166,
    nationality: "Nigerien",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NIGER
  },
  NIGERIA: {
    key: "NIGERIA",
    region: "Africa",
    countryName: "Nigeria",
    transferMate: 167,
    nationality: "Nigerian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NIGERIA
  },
  NIUE: {
    key: "NIUE",
    region: "Oceania",
    countryName: "Niue",
    transferMate: 168,
    nationality: "Niuean",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NIUE
  },
  NORFOLK_ISLAND: {
    key: "NORFOLK_ISLAND",
    region: "Oceania",
    countryName: "Norfolk Island",
    transferMate: 169,
    nationality: "Norfolk Islander",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORFOLK_ISLAND
  },
  NORTH_MACEDONIA_REPUBLIC_OF: {
    key: "NORTH_MACEDONIA_REPUBLIC_OF",
    region: "Non_EU Europe",
    countryName: "North Macedonia, Republic of",
    nationality: "Macedonian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORTH_MACEDONIA_REPUBLIC_OF
  },
  NORTHERN_MARIANA_ISLANDS: {
    key: "NORTHERN_MARIANA_ISLANDS",
    region: "Oceania",
    countryName: "Northern Mariana Islands",
    transferMate: 170,
    nationality: "Northern Mariana Islander",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORTHERN_MARIANA_ISLANDS
  },
  PAKISTAN: {
    key: "PAKISTAN",
    region: "South Asia",
    countryName: "Pakistan",
    transferMate: 173,
    nationality: "Pakistani",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PAKISTAN
  },
  PALAU: {
    key: "PALAU",
    region: "Oceania",
    countryName: "Palau",
    transferMate: 174,
    nationality: "Palauan",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PALAU
  },
  PALESTINE: {
    key: "PALESTINE",
    region: "Middle East",
    countryName: "Palestine",
    nationality: "Palestinian",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PALESTINE
  },
  PANAMA: {
    key: "PANAMA",
    region: "North America",
    countryName: "Panama",
    transferMate: 175,
    nationality: "Panamanian",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PANAMA
  },
  PAPUA_NEW_GUINEA: {
    key: "PAPUA_NEW_GUINEA",
    region: "Oceania",
    countryName: "Papua New Guinea",
    nationality: "Papua New Guinean",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PAPUA_NEW_GUINEA
  },
  PARAGUAY: {
    key: "PARAGUAY",
    region: "South America",
    countryName: "Paraguay",
    transferMate: 177,
    nationality: "Paraguayan",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PARAGUAY
  },
  PHILIPPINES: {
    key: "PHILIPPINES",
    region: "Southeast Asia",
    countryName: "Philippines",
    transferMate: 179,
    nationality: "Filipino",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PHILIPPINES
  },
  PITCAIRN: {
    key: "PITCAIRN",
    region: "Oceania",
    countryName: "Pitcairn",
    nationality: "Pitcairn Islander",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PITCAIRN
  },
  PUERTO_RICO: {
    key: "PUERTO_RICO",
    region: "North America",
    countryName: "Puerto Rico",
    transferMate: 183,
    nationality: "Puerto Rican",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PUERTO_RICO
  },
  REUNION: {
    key: "REUNION",
    region: "South Asia",
    countryName: "Reunion",
    transferMate: 185,
    nationality: "Reunion",
    atas: !1,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.REUNION
  },
  RUSSIA: {
    key: "RUSSIA",
    region: "Non_EU Europe|Central Asia (CIS)",
    countryName: "Russia",
    transferMate: 187,
    nationality: "Russian",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.RUSSIA
  },
  RWANDA: {
    key: "RWANDA",
    region: "Africa",
    countryName: "Rwanda",
    transferMate: 188,
    nationality: "Rwandan",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.RWANDA
  },
  SAINT_HELENA: {
    key: "SAINT_HELENA",
    region: "Africa",
    countryName: "Saint Helena",
    transferMate: 190,
    nationality: "Saint Helenian",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_HELENA
  },
  SAINT_KITTS_AND_NEVIS: {
    key: "SAINT_KITTS_AND_NEVIS",
    region: "North America",
    countryName: "Saint Kitts and Nevis",
    nationality: "Kittian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_KITTS_AND_NEVIS
  },
  SAINT_LUCIA: {
    key: "SAINT_LUCIA",
    region: "North America",
    countryName: "Saint Lucia",
    transferMate: 192,
    nationality: "Saint Lucian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_LUCIA
  },
  SAINT_PIERRE_AND_MIQUELON: {
    key: "SAINT_PIERRE_AND_MIQUELON",
    region: "North America",
    countryName: "Saint Pierre and Miquelon",
    transferMate: 193,
    nationality: "Saint_Pierrais",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_PIERRE_AND_MIQUELON
  },
  SAINT_VINCENT_AND_THE_GRENADINES: {
    key: "SAINT_VINCENT_AND_THE_GRENADINES",
    region: "North America",
    countryName: "Saint Vincent and the Grenadines",
    nationality: "Saint Vincentian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_VINCENT_AND_THE_GRENADINES
  },
  SAMOA: {
    key: "SAMOA",
    region: "Oceania",
    countryName: "Samoa",
    transferMate: 195,
    nationality: "Samoan",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAMOA
  },
  SAN_MARINO: {
    key: "SAN_MARINO",
    region: "Europe",
    countryName: "San Marino",
    transferMate: 196,
    nationality: "Sanmarinese",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAN_MARINO
  },
  SAO_TOME_AND_PRINCIPE: {
    key: "SAO_TOME_AND_PRINCIPE",
    region: "Africa",
    countryName: "Sao Tome and Principe",
    transferMate: 197,
    nationality: "Sao Tomean",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAO_TOME_AND_PRINCIPE
  },
  SAUDI_ARABIA: {
    key: "SAUDI_ARABIA",
    region: "Middle East",
    countryName: "Saudi Arabia",
    transferMate: 198,
    nationality: "Saudi Arabian",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAUDI_ARABIA
  },
  SENEGAL: {
    key: "SENEGAL",
    region: "Africa",
    countryName: "Senegal",
    transferMate: 199,
    nationality: "Senegalese",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SENEGAL
  },
  SEYCHELLES: {
    key: "SEYCHELLES",
    region: "Africa",
    countryName: "Seychelles",
    transferMate: 201,
    nationality: "Seychellois",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SEYCHELLES
  },
  SIERRA_LEONE: {
    key: "SIERRA_LEONE",
    region: "Africa",
    countryName: "Sierra Leone",
    transferMate: 202,
    nationality: "Sierra Leonean",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SIERRA_LEONE
  },
  SOLOMON_ISLANDS: {
    key: "SOLOMON_ISLANDS",
    region: "Oceania",
    countryName: "Solomon Islands",
    transferMate: 206,
    nationality: "Solomon Islander",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOLOMON_ISLANDS
  },
  SOMALIA: {
    key: "SOMALIA",
    region: "Africa",
    countryName: "Somalia",
    transferMate: 207,
    nationality: "Somali",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOMALIA
  },
  SOUTH_AFRICA: {
    key: "SOUTH_AFRICA",
    region: "Africa",
    countryName: "South Africa",
    transferMate: 208,
    nationality: "South African",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOUTH_AFRICA
  },
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: {
    key: "SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS",
    region: "Central Asia (CIS)",
    countryName: "South Georgia and the South Sandwich Islands",
    nationality: "South Georgia and the South Sandwich Islands",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS
  },
  SRI_LANKA: {
    key: "SRI_LANKA",
    region: "South Asia",
    countryName: "Sri Lanka",
    transferMate: 212,
    nationality: "Sri Lankan",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SRI_LANKA
  },
  SUDAN: {
    key: "SUDAN",
    region: "Africa",
    countryName: "Sudan",
    transferMate: 213,
    nationality: "Sudanese",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SUDAN
  },
  SURINAME: {
    key: "SURINAME",
    region: "South America",
    countryName: "Suriname",
    transferMate: 214,
    nationality: "Surinamer",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SURINAME
  },
  SVALBARD_AND_JAN_MAYEN: {
    key: "SVALBARD_AND_JAN_MAYEN",
    region: "Europe",
    countryName: "Svalbard and Jan Mayen",
    nationality: "Svalbard and Jan Mayen",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SVALBARD_AND_JAN_MAYEN
  },
  SWAZILAND: {
    key: "SWAZILAND",
    region: "Africa",
    countryName: "Swaziland",
    transferMate: 216,
    nationality: "Swazi",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SWAZILAND
  },
  SYRIA: {
    key: "SYRIA",
    region: "Middle East",
    countryName: "Syria",
    nationality: "Syrian",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SYRIA
  },
  TAJIKISTAN: {
    key: "TAJIKISTAN",
    region: "Central Asia (CIS)",
    countryName: "Tajikistan",
    transferMate: 221,
    nationality: "Tajikistani",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TAJIKISTAN
  },
  TANZANIA_UNITED_REPUBLIC_OF: {
    key: "TANZANIA_UNITED_REPUBLIC_OF",
    region: "Africa",
    countryName: "Tanzania, United Republic of",
    nationality: "Tanzanian",
    atas: !0,
    tb: !0,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TANZANIA_UNITED_REPUBLIC_OF
  },
  TIMOR_LESTE: {
    key: "TIMOR_LESTE",
    region: "Southeast Asia",
    countryName: "Timor-Leste",
    nationality: "Timorese",
    atas: !0,
    tb: !0,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TIMOR_LESTE
  },
  TOGO: {
    key: "TOGO",
    region: "Africa",
    countryName: "Togo",
    transferMate: 224,
    nationality: "Togolese",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TOGO
  },
  TOKELAU: {
    key: "TOKELAU",
    region: "Oceania",
    countryName: "Tokelau",
    transferMate: 225,
    nationality: "Tokelauan",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TOKELAU
  },
  TONGA: {
    key: "TONGA",
    region: "Oceania",
    countryName: "Tonga",
    transferMate: 226,
    nationality: "Tongan",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TONGA
  },
  TRINIDAD_AND_TOBAGO: {
    key: "TRINIDAD_AND_TOBAGO",
    region: "North America",
    countryName: "Trinidad and Tobago",
    nationality: "Trinidadian",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TRINIDAD_AND_TOBAGO
  },
  TURKEY: {
    key: "TURKEY",
    region: "Non_EU Europe",
    countryName: "Turkey",
    transferMate: 229,
    nationality: "Turkish",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TURKEY
  },
  TURKMENISTAN: {
    key: "TURKMENISTAN",
    region: "Central Asia (CIS)",
    countryName: "Turkmenistan",
    transferMate: 230,
    nationality: "Turkmen",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TURKMENISTAN
  },
  TURKS_AND_CAICOS_ISLANDS: {
    key: "TURKS_AND_CAICOS_ISLANDS",
    region: "North America",
    countryName: "Turks and Caicos Islands",
    nationality: "Turks and Caicos Islander",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TURKS_AND_CAICOS_ISLANDS
  },
  TUVALU: {
    key: "TUVALU",
    region: "Oceania",
    countryName: "Tuvalu",
    transferMate: 232,
    nationality: "Tuvaluan",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TUVALU
  },
  UGANDA: {
    key: "UGANDA",
    region: "Africa",
    countryName: "Uganda",
    transferMate: 233,
    nationality: "Ugandan",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UGANDA
  },
  UKRAINE: {
    key: "UKRAINE",
    region: "Non_EU Europe",
    countryName: "Ukraine",
    transferMate: 234,
    nationality: "Ukrainian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UKRAINE
  },
  UNITED_KINGDOM: {
    key: "UNITED_KINGDOM",
    region: "UK",
    countryName: "United Kingdom",
    transferMate: 236,
    nationality: "British",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UNITED_KINGDOM
  },
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: {
    key: "UNITED_STATES_MINOR_OUTLYING_ISLANDS",
    region: "Oceania",
    countryName: "United States Minor Outlying Islands",
    nationality: "American (MOI)",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS
  },
  URUGUAY: {
    key: "URUGUAY",
    region: "South America",
    countryName: "Uruguay",
    transferMate: 239,
    nationality: "Uruguayan",
    atas: !0,
    tb: !1,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.URUGUAY
  },
  UZBEKISTAN: {
    key: "UZBEKISTAN",
    region: "Central Asia (CIS)",
    countryName: "Uzbekistan",
    transferMate: 241,
    nationality: "Uzbekistani",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UZBEKISTAN
  },
  VANUATU: {
    key: "VANUATU",
    region: "Oceania",
    countryName: "Vanuatu",
    transferMate: 242,
    nationality: "Ni_Vanuatu",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VANUATU
  },
  VENEZUELA: {
    key: "VENEZUELA",
    region: "South America",
    countryName: "Venezuela",
    transferMate: 244,
    nationality: "Venezuelan",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VENEZUELA
  },
  VIETNAM: {
    key: "VIETNAM",
    region: "Southeast Asia",
    countryName: "Vietnam",
    transferMate: 245,
    nationality: "Vietnamese",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VIETNAM
  },
  VIRGIN_ISLANDS_BRITISH: {
    key: "VIRGIN_ISLANDS_BRITISH",
    region: "North America",
    countryName: "Virgin Islands, British",
    nationality: "Virgin Islander (British)",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VIRGIN_ISLANDS_BRITISH
  },
  VIRGIN_ISLANDS_US: {
    key: "VIRGIN_ISLANDS_US",
    region: "North America",
    countryName: "Virgin Islands, U.S.",
    nationality: "Virgin Islander (American)",
    atas: !0,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VIRGIN_ISLANDS_US
  },
  WALLIS_AND_FUTUNA: {
    key: "WALLIS_AND_FUTUNA",
    region: "Oceania",
    countryName: "Wallis and Futuna",
    nationality: "Wallisian",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.WALLIS_AND_FUTUNA
  },
  WESTERN_SAHARA: {
    key: "WESTERN_SAHARA",
    region: "Africa",
    countryName: "Western Sahara",
    transferMate: 266,
    nationality: "Western Saharan",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.WESTERN_SAHARA
  },
  YEMEN: {
    key: "YEMEN",
    region: "Middle East",
    countryName: "Yemen",
    transferMate: 249,
    nationality: "Yemenese",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.YEMEN
  },
  ZAMBIA: {
    key: "ZAMBIA",
    region: "Africa",
    countryName: "Zambia",
    transferMate: 250,
    nationality: "Zambian",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ZAMBIA
  },
  ZIMBABWE: {
    key: "ZIMBABWE",
    region: "Africa",
    countryName: "Zimbabwe",
    transferMate: 251,
    nationality: "Zimbabwean",
    atas: !0,
    tb: !0,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ZIMBABWE
  },
  ALAND_ISLANDS: {
    key: "ALAND_ISLANDS",
    region: "Europe",
    countryName: "Åland Islands",
    nationality: "Ålandic",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ALAND_ISLANDS
  },
  BONAIRE_SINT_EUSTATIUS_AND_SABA: {
    key: "BONAIRE_SINT_EUSTATIUS_AND_SABA",
    region: "North America",
    countryName: "Bonaire, Sint Eustatius and Saba",
    nationality: "Dutch (Caribbean)",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA
  },
  CURACAO: {
    key: "CURACAO",
    region: "North America",
    countryName: "Curaçao",
    nationality: "Curaçaoan",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CURACAO
  },
  GUERNSEY: {
    key: "GUERNSEY",
    region: "Europe",
    countryName: "Guernsey",
    transferMate: 258,
    nationality: "Guernsey",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUERNSEY
  },
  ISLE_OF_MAN: {
    key: "ISLE_OF_MAN",
    region: "Europe",
    countryName: "Isle of Man",
    transferMate: 259,
    nationality: "Manx",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ISLE_OF_MAN
  },
  JERSEY: {
    key: "JERSEY",
    region: "Europe",
    countryName: "Jersey",
    transferMate: 260,
    nationality: "Jersey",
    atas: !1,
    tb: !1,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.JERSEY
  },
  MONTENEGRO: {
    key: "MONTENEGRO",
    region: "Non_EU Europe",
    countryName: "Montenegro",
    nationality: "Montenegrin",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONTENEGRO
  },
  SAINT_BARTHELEMY: {
    key: "SAINT_BARTHELEMY",
    region: "North America",
    countryName: "Saint Barthélemy",
    nationality: "Barthélemois",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_BARTHELEMY
  },
  SAINT_MARTIN_FRANCE: {
    key: "SAINT_MARTIN_FRANCE",
    region: "North America",
    countryName: "Saint Martin (France)",
    nationality: "French (Saint Martin)",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_MARTIN_FRANCE
  },
  SINT_MAARTEN_DUTCH: {
    key: "SINT_MAARTEN_DUTCH",
    region: "North America",
    countryName: "Sint Maarten (Dutch)",
    nationality: "Dutch (St. Martin)",
    atas: !0,
    tb: !1,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SINT_MAARTEN_DUTCH
  },
  SOUTH_SUDAN: {
    key: "SOUTH_SUDAN",
    region: "Africa",
    countryName: "South Sudan",
    nationality: "Sudanese (South)",
    atas: !0,
    tb: !0,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOUTH_SUDAN
  },
  KOSOVO: {
    key: "KOSOVO",
    region: "Non_EU Europe",
    countryName: "Kosovo",
    nationality: "Kosovian",
    atas: !0,
    tb: !1,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KOSOVO
  }
}, countries = [
  recognisedCountries.AUSTRALIA,
  recognisedCountries.AUSTRIA,
  recognisedCountries.BAHRAIN,
  recognisedCountries.BARBADOS,
  recognisedCountries.BELGIUM,
  recognisedCountries.BERMUDA,
  recognisedCountries.BOTSWANA,
  recognisedCountries.BRAZIL,
  recognisedCountries.BRUNEI_DARUSSALAM,
  recognisedCountries.BULGARIA,
  recognisedCountries.CANADA,
  recognisedCountries.CAYMAN_ISLANDS,
  recognisedCountries.CHILE,
  recognisedCountries.CHINA,
  recognisedCountries.COLOMBIA,
  recognisedCountries.COSTA_RICA,
  recognisedCountries.CROATIA,
  recognisedCountries.CYPRUS,
  recognisedCountries.CZECH_REPUBLIC,
  recognisedCountries.DENMARK,
  recognisedCountries.ESTONIA,
  recognisedCountries.FINLAND,
  recognisedCountries.FRANCE,
  recognisedCountries.GERMANY,
  recognisedCountries.GREECE,
  recognisedCountries.HUNGARY,
  recognisedCountries.INDIA,
  recognisedCountries.INDONESIA,
  recognisedCountries.IRAN_ISLAMIC_REPUBLIC_OF,
  recognisedCountries.IRELAND,
  recognisedCountries.ISRAEL,
  recognisedCountries.ITALY,
  recognisedCountries.JAPAN,
  recognisedCountries.KENYA,
  recognisedCountries.NORTH_KOREA,
  recognisedCountries.SOUTH_KOREA,
  recognisedCountries.KUWAIT,
  recognisedCountries.LATVIA,
  recognisedCountries.LITHUANIA,
  recognisedCountries.LUXEMBOURG,
  recognisedCountries.MALAYSIA,
  recognisedCountries.MALTA,
  recognisedCountries.MEXICO,
  recognisedCountries.NETHERLANDS,
  recognisedCountries.NEW_ZEALAND,
  recognisedCountries.NORWAY,
  recognisedCountries.OMAN,
  recognisedCountries.PAKISTAN,
  recognisedCountries.PHILIPPINES,
  recognisedCountries.POLAND,
  recognisedCountries.PORTUGAL,
  recognisedCountries.QATAR,
  recognisedCountries.ROMANIA,
  recognisedCountries.SAUDI_ARABIA,
  recognisedCountries.SINGAPORE,
  recognisedCountries.SLOVAKIA,
  recognisedCountries.SLOVENIA,
  recognisedCountries.SOUTH_AFRICA,
  recognisedCountries.SPAIN,
  recognisedCountries.SWEDEN,
  recognisedCountries.SWITZERLAND,
  recognisedCountries.TAIWAN,
  recognisedCountries.THAILAND,
  recognisedCountries.TUNISIA,
  recognisedCountries.TURKEY,
  recognisedCountries.UNITED_ARAB_EMIRATES,
  recognisedCountries.UNITED_KINGDOM,
  recognisedCountries.UNITED_STATES_OF_AMERICA,
  recognisedCountries.VIETNAM,
  recognisedCountries.ZAMBIA,
  recognisedCountries.EGYPT,
  recognisedCountries.SRI_LANKA,
  recognisedCountries.MOROCCO,
  recognisedCountries.NIGERIA,
  recognisedCountries.NIGER,
  recognisedCountries.GHANA,
  recognisedCountries.BANGLADESH,
  recognisedCountries.PERU,
  recognisedCountries.VENEZUELA,
  recognisedCountries.ICELAND,
  recognisedCountries.CAMBODIA,
  recognisedCountries.BOLIVIA,
  recognisedCountries.URUGUAY,
  recognisedCountries.JORDAN,
  recognisedCountries.LIECHTENSTEIN,
  recognisedCountries.MACAU,
  recognisedCountries.MOLDOVA_REPUBLIC_OF,
  recognisedCountries.MONACO,
  recognisedCountries.NEPAL,
  recognisedCountries.SENEGAL,
  recognisedCountries.UZBEKISTAN,
  recognisedCountries.FIJI,
  recognisedCountries.BURUNDI,
  recognisedCountries.BENIN,
  recognisedCountries.CHAD,
  recognisedCountries.DJIBOUTI,
  recognisedCountries.ERITREA,
  recognisedCountries.GABON,
  recognisedCountries.LIBERIA,
  recognisedCountries.MAURITIUS,
  recognisedCountries.RWANDA,
  recognisedCountries.SIERRA_LEONE,
  recognisedCountries.SOMALIA,
  recognisedCountries.SWAZILAND,
  recognisedCountries.YEMEN,
  recognisedCountries.MALAWI,
  recognisedCountries.ZIMBABWE,
  recognisedCountries.MYANMAR,
  recognisedCountries.LAOS,
  recognisedCountries.NAMIBIA,
  recognisedCountries.BAHAMAS,
  recognisedCountries.GUATEMALA,
  recognisedCountries.HONDURAS,
  recognisedCountries.EL_SALVADOR,
  recognisedCountries.CUBA,
  recognisedCountries.JAMAICA,
  recognisedCountries.TRINIDAD_AND_TOBAGO,
  recognisedCountries.DOMINICAN_REPUBLIC,
  recognisedCountries.PARAGUAY,
  recognisedCountries.FAROE_ISLANDS,
  recognisedCountries.GREENLAND,
  recognisedCountries.ISLE_OF_MAN,
  recognisedCountries.JERSEY,
  recognisedCountries.GUERNSEY,
  recognisedCountries.SAINT_LUCIA,
  recognisedCountries.ANGUILLA,
  recognisedCountries.COOK_ISLANDS,
  recognisedCountries.GIBRALTAR,
  recognisedCountries.MONTENEGRO,
  recognisedCountries.SAINT_VINCENT_AND_THE_GRENADINES,
  recognisedCountries.TURKS_AND_CAICOS_ISLANDS,
  recognisedCountries.NORTH_MACEDONIA_REPUBLIC_OF,
  recognisedCountries.SAINT_KITTS_AND_NEVIS,
  recognisedCountries.ANTIGUA_AND_BARBUDA,
  recognisedCountries.DOMINICA,
  recognisedCountries.HONG_KONG,
  recognisedCountries.KAZAKHSTAN,
  recognisedCountries.SERBIA,
  recognisedCountries.AFGHANISTAN,
  recognisedCountries.ALBANIA,
  recognisedCountries.ALGERIA,
  recognisedCountries.AMERICAN_SAMOA,
  recognisedCountries.ANDORRA,
  recognisedCountries.ANGOLA,
  recognisedCountries.ANTARCTICA,
  recognisedCountries.ARGENTINA,
  recognisedCountries.ARMENIA,
  recognisedCountries.ARUBA,
  recognisedCountries.AZERBAIJAN,
  recognisedCountries.BELARUS,
  recognisedCountries.BELIZE,
  recognisedCountries.BHUTAN,
  recognisedCountries.BOSNIA_AND_HERZEGOVINA,
  recognisedCountries.BOUVET_ISLAND,
  recognisedCountries.BRITISH_INDIAN_OCEAN_TERRITORY,
  recognisedCountries.BURKINA_FASO,
  recognisedCountries.CAMEROON,
  recognisedCountries.CAPE_VERDE,
  recognisedCountries.CENTRAL_AFRICAN_REPUBLIC,
  recognisedCountries.CHRISTMAS_ISLAND,
  recognisedCountries.COCOS_KEELING_ISLANDS,
  recognisedCountries.COMOROS,
  recognisedCountries.CONGO,
  recognisedCountries.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  recognisedCountries.ECUADOR,
  recognisedCountries.EQUATORIAL_GUINEA,
  recognisedCountries.ETHIOPIA,
  recognisedCountries.FALKLAND_ISLANDS_MALVINAS,
  recognisedCountries.FRENCH_GUIANA,
  recognisedCountries.FRENCH_POLYNESIA,
  recognisedCountries.FRENCH_SOUTHERN_TERRITORIES,
  recognisedCountries.GAMBIA,
  recognisedCountries.GEORGIA,
  recognisedCountries.GRENADA,
  recognisedCountries.GUADELOUPE,
  recognisedCountries.GUAM,
  recognisedCountries.GUINEA,
  recognisedCountries.GUINEA_BISSAU,
  recognisedCountries.GUYANA,
  recognisedCountries.HAITI,
  recognisedCountries.HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  recognisedCountries.VATICAN,
  recognisedCountries.IRAQ,
  recognisedCountries.KIRIBATI,
  recognisedCountries.KYRGYZSTAN,
  recognisedCountries.LEBANON,
  recognisedCountries.LESOTHO,
  recognisedCountries.LIBYA,
  recognisedCountries.MADAGASCAR,
  recognisedCountries.MALDIVES,
  recognisedCountries.MALI,
  recognisedCountries.MARSHALL_ISLANDS,
  recognisedCountries.MARTINIQUE,
  recognisedCountries.MAURITANIA,
  recognisedCountries.MAYOTTE,
  recognisedCountries.MICRONESIA_FEDERATED_STATES_OF,
  recognisedCountries.MONGOLIA,
  recognisedCountries.MONTSERRAT,
  recognisedCountries.MOZAMBIQUE,
  recognisedCountries.NAURU,
  recognisedCountries.NEW_CALEDONIA,
  recognisedCountries.NICARAGUA,
  recognisedCountries.NIUE,
  recognisedCountries.NORFOLK_ISLAND,
  recognisedCountries.NORTHERN_MARIANA_ISLANDS,
  recognisedCountries.PALAU,
  recognisedCountries.PALESTINE,
  recognisedCountries.PANAMA,
  recognisedCountries.PAPUA_NEW_GUINEA,
  recognisedCountries.PITCAIRN,
  recognisedCountries.PUERTO_RICO,
  recognisedCountries.REUNION,
  recognisedCountries.RUSSIA,
  recognisedCountries.SAINT_HELENA,
  recognisedCountries.SAINT_PIERRE_AND_MIQUELON,
  recognisedCountries.SAMOA,
  recognisedCountries.SAN_MARINO,
  recognisedCountries.SAO_TOME_AND_PRINCIPE,
  recognisedCountries.SEYCHELLES,
  recognisedCountries.SOLOMON_ISLANDS,
  recognisedCountries.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  recognisedCountries.SUDAN,
  recognisedCountries.SURINAME,
  recognisedCountries.SVALBARD_AND_JAN_MAYEN,
  recognisedCountries.SYRIA,
  recognisedCountries.TAJIKISTAN,
  recognisedCountries.TANZANIA_UNITED_REPUBLIC_OF,
  recognisedCountries.TIMOR_LESTE,
  recognisedCountries.TOGO,
  recognisedCountries.TOKELAU,
  recognisedCountries.TONGA,
  recognisedCountries.TURKMENISTAN,
  recognisedCountries.TUVALU,
  recognisedCountries.UGANDA,
  recognisedCountries.UKRAINE,
  recognisedCountries.UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  recognisedCountries.VANUATU,
  recognisedCountries.VIRGIN_ISLANDS_BRITISH,
  recognisedCountries.VIRGIN_ISLANDS_US,
  recognisedCountries.WALLIS_AND_FUTUNA,
  recognisedCountries.WESTERN_SAHARA,
  recognisedCountries.ALAND_ISLANDS,
  recognisedCountries.BONAIRE_SINT_EUSTATIUS_AND_SABA,
  recognisedCountries.CURACAO,
  recognisedCountries.SAINT_BARTHELEMY,
  recognisedCountries.SAINT_MARTIN_FRANCE,
  recognisedCountries.SINT_MAARTEN_DUTCH,
  recognisedCountries.SOUTH_SUDAN,
  recognisedCountries.KOSOVO,
  recognisedCountries.COTE_DIVOIRE
];
function deepFreeze(e) {
  return Object.keys(e).forEach((t) => {
    typeof e[t] == "object" && e[t] !== null && !Object.isFrozen(e[t]) && deepFreeze(e[t]);
  }), Object.freeze(e);
}
var nationalityCountriesMapTemp = {};
for (const e of countries) {
  const { nationality: t, countryName: o } = e;
  nationalityCountriesMapTemp[t] = [...nationalityCountriesMapTemp[t] || [], o];
}
deepFreeze(nationalityCountriesMapTemp);
deepFreeze(
  countries.reduce((e, t) => (Object.assign(e, { [t.nationality]: t }), e), {})
);
deepFreeze(
  countries.reduce((e, t) => (Object.assign(e, { [t.countryName]: t }), e), {})
);
deepFreeze(
  countries.reduce((e, t) => (Object.assign(e, { [t.alphaThree]: t }), e), {})
);
deepFreeze(
  countries.reduce((e, t) => (Object.assign(e, { [t.numeric]: t }), e), {})
);
deepFreeze(
  countries.reduce((e, t) => (Object.assign(e, { [t.region]: t }), e), {})
);
function deepFreeze2(e) {
  return Object.keys(e).forEach((t) => {
    typeof e[t] == "object" && e[t] !== null && !Object.isFrozen(e[t]) && deepFreeze2(e[t]);
  }), Object.freeze(e);
}
deepFreeze2({
  [countryCodes.BANGLADESH.alphaTwo]: "880",
  [countryCodes.BELGIUM.alphaTwo]: "32",
  [countryCodes.BURKINA_FASO.alphaTwo]: "226",
  [countryCodes.BULGARIA.alphaTwo]: "359",
  [countryCodes.BOSNIA_AND_HERZEGOVINA.alphaTwo]: "387",
  [countryCodes.BARBADOS.alphaTwo]: "1246",
  [countryCodes.WALLIS_AND_FUTUNA.alphaTwo]: "681",
  [countryCodes.SAINT_BARTHELEMY.alphaTwo]: "590",
  [countryCodes.BERMUDA.alphaTwo]: "1441",
  [countryCodes.BRUNEI_DARUSSALAM.alphaTwo]: "673",
  [countryCodes.BOLIVIA.alphaTwo]: "591",
  [countryCodes.BAHRAIN.alphaTwo]: "973",
  [countryCodes.BURUNDI.alphaTwo]: "257",
  [countryCodes.BENIN.alphaTwo]: "229",
  [countryCodes.BHUTAN.alphaTwo]: "975",
  [countryCodes.JAMAICA.alphaTwo]: "1876",
  [countryCodes.BOUVET_ISLAND.alphaTwo]: "",
  [countryCodes.BOTSWANA.alphaTwo]: "267",
  [countryCodes.SAMOA.alphaTwo]: "685",
  [countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA.alphaTwo]: "599",
  [countryCodes.BRAZIL.alphaTwo]: "55",
  [countryCodes.BAHAMAS.alphaTwo]: "1242",
  [countryCodes.JERSEY.alphaTwo]: "441534",
  [countryCodes.BELARUS.alphaTwo]: "375",
  [countryCodes.BELIZE.alphaTwo]: "501",
  [countryCodes.RUSSIA.alphaTwo]: "7",
  [countryCodes.RWANDA.alphaTwo]: "250",
  [countryCodes.SERBIA.alphaTwo]: "381",
  [countryCodes.TIMOR_LESTE.alphaTwo]: "670",
  [countryCodes.REUNION.alphaTwo]: "262",
  [countryCodes.TURKMENISTAN.alphaTwo]: "993",
  [countryCodes.TAJIKISTAN.alphaTwo]: "992",
  [countryCodes.ROMANIA.alphaTwo]: "40",
  [countryCodes.TOKELAU.alphaTwo]: "690",
  [countryCodes.GUINEA_BISSAU.alphaTwo]: "245",
  [countryCodes.GUAM.alphaTwo]: "1671",
  [countryCodes.GUATEMALA.alphaTwo]: "502",
  [countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS.alphaTwo]: "",
  [countryCodes.GREECE.alphaTwo]: "30",
  [countryCodes.EQUATORIAL_GUINEA.alphaTwo]: "240",
  [countryCodes.GUADELOUPE.alphaTwo]: "590",
  [countryCodes.JAPAN.alphaTwo]: "81",
  [countryCodes.GUYANA.alphaTwo]: "592",
  [countryCodes.GUERNSEY.alphaTwo]: "441481",
  [countryCodes.FRENCH_GUIANA.alphaTwo]: "594",
  [countryCodes.GEORGIA.alphaTwo]: "995",
  [countryCodes.GRENADA.alphaTwo]: "1473",
  [countryCodes.UNITED_KINGDOM.alphaTwo]: "44",
  [countryCodes.GABON.alphaTwo]: "241",
  [countryCodes.EL_SALVADOR.alphaTwo]: "503",
  [countryCodes.GUINEA.alphaTwo]: "224",
  [countryCodes.GAMBIA.alphaTwo]: "220",
  [countryCodes.GREENLAND.alphaTwo]: "299",
  [countryCodes.GIBRALTAR.alphaTwo]: "350",
  [countryCodes.GHANA.alphaTwo]: "233",
  [countryCodes.OMAN.alphaTwo]: "968",
  [countryCodes.TUNISIA.alphaTwo]: "216",
  [countryCodes.JORDAN.alphaTwo]: "962",
  [countryCodes.CROATIA.alphaTwo]: "385",
  [countryCodes.HAITI.alphaTwo]: "509",
  [countryCodes.HUNGARY.alphaTwo]: "36",
  [countryCodes.HONG_KONG.alphaTwo]: "852",
  [countryCodes.HONDURAS.alphaTwo]: "504",
  [countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS.alphaTwo]: " ",
  [countryCodes.VENEZUELA.alphaTwo]: "58",
  [countryCodes.PUERTO_RICO.alphaTwo]: "1787 and 1939",
  [countryCodes.PALESTINE.alphaTwo]: "970",
  [countryCodes.PALAU.alphaTwo]: "680",
  [countryCodes.PORTUGAL.alphaTwo]: "351",
  [countryCodes.SVALBARD_AND_JAN_MAYEN.alphaTwo]: "47",
  [countryCodes.PARAGUAY.alphaTwo]: "595",
  [countryCodes.IRAQ.alphaTwo]: "964",
  [countryCodes.PANAMA.alphaTwo]: "507",
  [countryCodes.FRENCH_POLYNESIA.alphaTwo]: "689",
  [countryCodes.PAPUA_NEW_GUINEA.alphaTwo]: "675",
  [countryCodes.PERU.alphaTwo]: "51",
  [countryCodes.PAKISTAN.alphaTwo]: "92",
  [countryCodes.PHILIPPINES.alphaTwo]: "63",
  [countryCodes.PITCAIRN.alphaTwo]: "870",
  [countryCodes.POLAND.alphaTwo]: "48",
  [countryCodes.SAINT_PIERRE_AND_MIQUELON.alphaTwo]: "508",
  [countryCodes.ZAMBIA.alphaTwo]: "260",
  [countryCodes.WESTERN_SAHARA.alphaTwo]: "212",
  [countryCodes.ESTONIA.alphaTwo]: "372",
  [countryCodes.EGYPT.alphaTwo]: "20",
  [countryCodes.SOUTH_AFRICA.alphaTwo]: "27",
  [countryCodes.ECUADOR.alphaTwo]: "593",
  [countryCodes.ITALY.alphaTwo]: "39",
  [countryCodes.VIETNAM.alphaTwo]: "84",
  [countryCodes.SOLOMON_ISLANDS.alphaTwo]: "677",
  [countryCodes.ETHIOPIA.alphaTwo]: "251",
  [countryCodes.SOMALIA.alphaTwo]: "252",
  [countryCodes.ZIMBABWE.alphaTwo]: "263",
  [countryCodes.SAUDI_ARABIA.alphaTwo]: "966",
  [countryCodes.SPAIN.alphaTwo]: "34",
  [countryCodes.ERITREA.alphaTwo]: "291",
  [countryCodes.MONTENEGRO.alphaTwo]: "382",
  [countryCodes.MOLDOVA_REPUBLIC_OF.alphaTwo]: "373",
  [countryCodes.MADAGASCAR.alphaTwo]: "261",
  [countryCodes.SAINT_MARTIN_FRANCE.alphaTwo]: "590",
  [countryCodes.MOROCCO.alphaTwo]: "212",
  [countryCodes.MONACO.alphaTwo]: "377",
  [countryCodes.UZBEKISTAN.alphaTwo]: "998",
  [countryCodes.MYANMAR.alphaTwo]: "95",
  [countryCodes.MALI.alphaTwo]: "223",
  [countryCodes.MACAU.alphaTwo]: "853",
  [countryCodes.MONGOLIA.alphaTwo]: "976",
  [countryCodes.MARSHALL_ISLANDS.alphaTwo]: "692",
  [countryCodes.NORTH_MACEDONIA_REPUBLIC_OF.alphaTwo]: "389",
  [countryCodes.MAURITIUS.alphaTwo]: "230",
  [countryCodes.MALTA.alphaTwo]: "356",
  [countryCodes.MALAWI.alphaTwo]: "265",
  [countryCodes.MALDIVES.alphaTwo]: "960",
  [countryCodes.MARTINIQUE.alphaTwo]: "596",
  [countryCodes.NORTHERN_MARIANA_ISLANDS.alphaTwo]: "1670",
  [countryCodes.MONTSERRAT.alphaTwo]: "1664",
  [countryCodes.MAURITANIA.alphaTwo]: "222",
  [countryCodes.ISLE_OF_MAN.alphaTwo]: "441624",
  [countryCodes.UGANDA.alphaTwo]: "256",
  [countryCodes.TANZANIA_UNITED_REPUBLIC_OF.alphaTwo]: "255",
  [countryCodes.MALAYSIA.alphaTwo]: "60",
  [countryCodes.MEXICO.alphaTwo]: "52",
  [countryCodes.ISRAEL.alphaTwo]: "972",
  [countryCodes.FRANCE.alphaTwo]: "33",
  [countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY.alphaTwo]: "246",
  [countryCodes.SAINT_HELENA.alphaTwo]: "290",
  [countryCodes.FINLAND.alphaTwo]: "358",
  [countryCodes.FIJI.alphaTwo]: "679",
  [countryCodes.FALKLAND_ISLANDS_MALVINAS.alphaTwo]: "500",
  [countryCodes.MICRONESIA_FEDERATED_STATES_OF.alphaTwo]: "691",
  [countryCodes.FAROE_ISLANDS.alphaTwo]: "298",
  [countryCodes.NICARAGUA.alphaTwo]: "505",
  [countryCodes.NETHERLANDS.alphaTwo]: "31",
  [countryCodes.NORWAY.alphaTwo]: "47",
  [countryCodes.NAMIBIA.alphaTwo]: "264",
  [countryCodes.VANUATU.alphaTwo]: "678",
  [countryCodes.NEW_CALEDONIA.alphaTwo]: "687",
  [countryCodes.NIGER.alphaTwo]: "227",
  [countryCodes.NORFOLK_ISLAND.alphaTwo]: "672",
  [countryCodes.NIGERIA.alphaTwo]: "234",
  [countryCodes.NEW_ZEALAND.alphaTwo]: "64",
  [countryCodes.NEPAL.alphaTwo]: "977",
  [countryCodes.NAURU.alphaTwo]: "674",
  [countryCodes.NIUE.alphaTwo]: "683",
  [countryCodes.COOK_ISLANDS.alphaTwo]: "682",
  [countryCodes.KOSOVO.alphaTwo]: "",
  [countryCodes.COTE_DIVOIRE.alphaTwo]: "225",
  [countryCodes.SWITZERLAND.alphaTwo]: "41",
  [countryCodes.COLOMBIA.alphaTwo]: "57",
  [countryCodes.CHINA.alphaTwo]: "86",
  [countryCodes.CAMEROON.alphaTwo]: "237",
  [countryCodes.CHILE.alphaTwo]: "56",
  [countryCodes.COCOS_KEELING_ISLANDS.alphaTwo]: "61",
  [countryCodes.CANADA.alphaTwo]: "1",
  [countryCodes.CONGO.alphaTwo]: "242",
  [countryCodes.CENTRAL_AFRICAN_REPUBLIC.alphaTwo]: "236",
  [countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE.alphaTwo]: "243",
  [countryCodes.CZECH_REPUBLIC.alphaTwo]: "420",
  [countryCodes.CYPRUS.alphaTwo]: "357",
  [countryCodes.CHRISTMAS_ISLAND.alphaTwo]: "61",
  [countryCodes.COSTA_RICA.alphaTwo]: "506",
  [countryCodes.CURACAO.alphaTwo]: "599",
  [countryCodes.CAPE_VERDE.alphaTwo]: "238",
  [countryCodes.CUBA.alphaTwo]: "53",
  [countryCodes.SWAZILAND.alphaTwo]: "268",
  [countryCodes.SYRIA.alphaTwo]: "963",
  [countryCodes.SINT_MAARTEN_DUTCH.alphaTwo]: "599",
  [countryCodes.KYRGYZSTAN.alphaTwo]: "996",
  [countryCodes.KENYA.alphaTwo]: "254",
  [countryCodes.SOUTH_SUDAN.alphaTwo]: "211",
  [countryCodes.SURINAME.alphaTwo]: "597",
  [countryCodes.KIRIBATI.alphaTwo]: "686",
  [countryCodes.CAMBODIA.alphaTwo]: "855",
  [countryCodes.SAINT_KITTS_AND_NEVIS.alphaTwo]: "1869",
  [countryCodes.COMOROS.alphaTwo]: "269",
  [countryCodes.SAO_TOME_AND_PRINCIPE.alphaTwo]: "239",
  [countryCodes.SLOVAKIA.alphaTwo]: "421",
  [countryCodes.SOUTH_KOREA.alphaTwo]: "82",
  [countryCodes.SLOVENIA.alphaTwo]: "386",
  [countryCodes.NORTH_KOREA.alphaTwo]: "850",
  [countryCodes.KUWAIT.alphaTwo]: "965",
  [countryCodes.SENEGAL.alphaTwo]: "221",
  [countryCodes.SAN_MARINO.alphaTwo]: "378",
  [countryCodes.SIERRA_LEONE.alphaTwo]: "232",
  [countryCodes.SEYCHELLES.alphaTwo]: "248",
  [countryCodes.KAZAKHSTAN.alphaTwo]: "7",
  [countryCodes.CAYMAN_ISLANDS.alphaTwo]: "1345",
  [countryCodes.SINGAPORE.alphaTwo]: "65",
  [countryCodes.SWEDEN.alphaTwo]: "46",
  [countryCodes.SUDAN.alphaTwo]: "249",
  [countryCodes.DOMINICAN_REPUBLIC.alphaTwo]: "1809 and 1829",
  [countryCodes.DOMINICA.alphaTwo]: "1767",
  [countryCodes.DJIBOUTI.alphaTwo]: "253",
  [countryCodes.DENMARK.alphaTwo]: "45",
  [countryCodes.VIRGIN_ISLANDS_BRITISH.alphaTwo]: "1284",
  [countryCodes.GERMANY.alphaTwo]: "49",
  [countryCodes.YEMEN.alphaTwo]: "967",
  [countryCodes.ALGERIA.alphaTwo]: "213",
  [countryCodes.UNITED_STATES_OF_AMERICA.alphaTwo]: "1",
  [countryCodes.URUGUAY.alphaTwo]: "598",
  [countryCodes.MAYOTTE.alphaTwo]: "262",
  [countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS.alphaTwo]: "1",
  [countryCodes.LEBANON.alphaTwo]: "961",
  [countryCodes.SAINT_LUCIA.alphaTwo]: "1758",
  [countryCodes.LAOS.alphaTwo]: "856",
  [countryCodes.TUVALU.alphaTwo]: "688",
  [countryCodes.TAIWAN.alphaTwo]: "886",
  [countryCodes.TRINIDAD_AND_TOBAGO.alphaTwo]: "1868",
  [countryCodes.TURKEY.alphaTwo]: "90",
  [countryCodes.SRI_LANKA.alphaTwo]: "94",
  [countryCodes.LIECHTENSTEIN.alphaTwo]: "423",
  [countryCodes.LATVIA.alphaTwo]: "371",
  [countryCodes.TONGA.alphaTwo]: "676",
  [countryCodes.LITHUANIA.alphaTwo]: "370",
  [countryCodes.LUXEMBOURG.alphaTwo]: "352",
  [countryCodes.LIBERIA.alphaTwo]: "231",
  [countryCodes.LESOTHO.alphaTwo]: "266",
  [countryCodes.THAILAND.alphaTwo]: "66",
  [countryCodes.FRENCH_SOUTHERN_TERRITORIES.alphaTwo]: "",
  [countryCodes.TOGO.alphaTwo]: "228",
  [countryCodes.CHAD.alphaTwo]: "235",
  [countryCodes.TURKS_AND_CAICOS_ISLANDS.alphaTwo]: "1649",
  [countryCodes.LIBYA.alphaTwo]: "218",
  [countryCodes.VATICAN.alphaTwo]: "379",
  [countryCodes.SAINT_VINCENT_AND_THE_GRENADINES.alphaTwo]: "1784",
  [countryCodes.UNITED_ARAB_EMIRATES.alphaTwo]: "971",
  [countryCodes.ANDORRA.alphaTwo]: "376",
  [countryCodes.ANTIGUA_AND_BARBUDA.alphaTwo]: "1268",
  [countryCodes.AFGHANISTAN.alphaTwo]: "93",
  [countryCodes.ANGUILLA.alphaTwo]: "1264",
  [countryCodes.VIRGIN_ISLANDS_US.alphaTwo]: "1340",
  [countryCodes.ICELAND.alphaTwo]: "354",
  [countryCodes.IRAN_ISLAMIC_REPUBLIC_OF.alphaTwo]: "98",
  [countryCodes.ARMENIA.alphaTwo]: "374",
  [countryCodes.ALBANIA.alphaTwo]: "355",
  [countryCodes.ANGOLA.alphaTwo]: "244",
  [countryCodes.ANTARCTICA.alphaTwo]: "",
  [countryCodes.AMERICAN_SAMOA.alphaTwo]: "1684",
  [countryCodes.ARGENTINA.alphaTwo]: "54",
  [countryCodes.AUSTRALIA.alphaTwo]: "61",
  [countryCodes.AUSTRIA.alphaTwo]: "43",
  [countryCodes.ARUBA.alphaTwo]: "297",
  [countryCodes.INDIA.alphaTwo]: "91",
  [countryCodes.ALAND_ISLANDS.alphaTwo]: "35818",
  [countryCodes.AZERBAIJAN.alphaTwo]: "994",
  [countryCodes.IRELAND.alphaTwo]: "353",
  [countryCodes.INDONESIA.alphaTwo]: "62",
  [countryCodes.UKRAINE.alphaTwo]: "380",
  [countryCodes.QATAR.alphaTwo]: "974",
  [countryCodes.MOZAMBIQUE.alphaTwo]: "258"
});
deepFreeze2({
  [countryCodes.BANGLADESH.alphaTwo]: "Bangladesh",
  [countryCodes.BELGIUM.alphaTwo]: "Belgium",
  [countryCodes.BURKINA_FASO.alphaTwo]: "Burkina Faso",
  [countryCodes.BULGARIA.alphaTwo]: "Bulgaria",
  [countryCodes.BOSNIA_AND_HERZEGOVINA.alphaTwo]: "Bosnia and Herzegovina",
  [countryCodes.BARBADOS.alphaTwo]: "Barbados",
  [countryCodes.WALLIS_AND_FUTUNA.alphaTwo]: "Wallis and Futuna",
  [countryCodes.SAINT_BARTHELEMY.alphaTwo]: "Saint Barthelemy",
  [countryCodes.BERMUDA.alphaTwo]: "Bermuda",
  [countryCodes.BRUNEI_DARUSSALAM.alphaTwo]: "Brunei",
  [countryCodes.BOLIVIA.alphaTwo]: "Bolivia",
  [countryCodes.BAHRAIN.alphaTwo]: "Bahrain",
  [countryCodes.BURUNDI.alphaTwo]: "Burundi",
  [countryCodes.BENIN.alphaTwo]: "Benin",
  [countryCodes.BHUTAN.alphaTwo]: "Bhutan",
  [countryCodes.JAMAICA.alphaTwo]: "Jamaica",
  [countryCodes.BOUVET_ISLAND.alphaTwo]: "Bouvet Island",
  [countryCodes.BOTSWANA.alphaTwo]: "Botswana",
  [countryCodes.SAMOA.alphaTwo]: "Samoa",
  [countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA.alphaTwo]: "Bonaire, Saint Eustatius and Saba ",
  [countryCodes.BRAZIL.alphaTwo]: "Brazil",
  [countryCodes.BAHAMAS.alphaTwo]: "Bahamas",
  [countryCodes.JERSEY.alphaTwo]: "Jersey",
  [countryCodes.BELARUS.alphaTwo]: "Belarus",
  [countryCodes.BELIZE.alphaTwo]: "Belize",
  [countryCodes.RUSSIA.alphaTwo]: "Russia",
  [countryCodes.RWANDA.alphaTwo]: "Rwanda",
  [countryCodes.SERBIA.alphaTwo]: "Serbia",
  [countryCodes.TIMOR_LESTE.alphaTwo]: "East Timor",
  [countryCodes.REUNION.alphaTwo]: "Reunion",
  [countryCodes.TURKMENISTAN.alphaTwo]: "Turkmenistan",
  [countryCodes.TAJIKISTAN.alphaTwo]: "Tajikistan",
  [countryCodes.ROMANIA.alphaTwo]: "Romania",
  [countryCodes.TOKELAU.alphaTwo]: "Tokelau",
  [countryCodes.GUINEA_BISSAU.alphaTwo]: "Guinea-Bissau",
  [countryCodes.GUAM.alphaTwo]: "Guam",
  [countryCodes.GUATEMALA.alphaTwo]: "Guatemala",
  [countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS.alphaTwo]: "South Georgia and the South Sandwich Islands",
  [countryCodes.GREECE.alphaTwo]: "Greece",
  [countryCodes.EQUATORIAL_GUINEA.alphaTwo]: "Equatorial Guinea",
  [countryCodes.GUADELOUPE.alphaTwo]: "Guadeloupe",
  [countryCodes.JAPAN.alphaTwo]: "Japan",
  [countryCodes.GUYANA.alphaTwo]: "Guyana",
  [countryCodes.GUERNSEY.alphaTwo]: "Guernsey",
  [countryCodes.FRENCH_GUIANA.alphaTwo]: "French Guiana",
  [countryCodes.GEORGIA.alphaTwo]: "Georgia",
  [countryCodes.GRENADA.alphaTwo]: "Grenada",
  [countryCodes.UNITED_KINGDOM.alphaTwo]: "United Kingdom",
  [countryCodes.GABON.alphaTwo]: "Gabon",
  [countryCodes.EL_SALVADOR.alphaTwo]: "El Salvador",
  [countryCodes.GUINEA.alphaTwo]: "Guinea",
  [countryCodes.GAMBIA.alphaTwo]: "Gambia",
  [countryCodes.GREENLAND.alphaTwo]: "Greenland",
  [countryCodes.GIBRALTAR.alphaTwo]: "Gibraltar",
  [countryCodes.GHANA.alphaTwo]: "Ghana",
  [countryCodes.OMAN.alphaTwo]: "Oman",
  [countryCodes.TUNISIA.alphaTwo]: "Tunisia",
  [countryCodes.JORDAN.alphaTwo]: "Jordan",
  [countryCodes.CROATIA.alphaTwo]: "Croatia",
  [countryCodes.HAITI.alphaTwo]: "Haiti",
  [countryCodes.HUNGARY.alphaTwo]: "Hungary",
  [countryCodes.HONG_KONG.alphaTwo]: "Hong Kong",
  [countryCodes.HONDURAS.alphaTwo]: "Honduras",
  [countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS.alphaTwo]: "Heard Island and McDonald Islands",
  [countryCodes.VENEZUELA.alphaTwo]: "Venezuela",
  [countryCodes.PUERTO_RICO.alphaTwo]: "Puerto Rico",
  [countryCodes.PALESTINE.alphaTwo]: "Palestinian Territory",
  [countryCodes.PALAU.alphaTwo]: "Palau",
  [countryCodes.PORTUGAL.alphaTwo]: "Portugal",
  [countryCodes.SVALBARD_AND_JAN_MAYEN.alphaTwo]: "Svalbard and Jan Mayen",
  [countryCodes.PARAGUAY.alphaTwo]: "Paraguay",
  [countryCodes.IRAQ.alphaTwo]: "Iraq",
  [countryCodes.PANAMA.alphaTwo]: "Panama",
  [countryCodes.FRENCH_POLYNESIA.alphaTwo]: "French Polynesia",
  [countryCodes.PAPUA_NEW_GUINEA.alphaTwo]: "Papua New Guinea",
  [countryCodes.PERU.alphaTwo]: "Peru",
  [countryCodes.PAKISTAN.alphaTwo]: "Pakistan",
  [countryCodes.PHILIPPINES.alphaTwo]: "Philippines",
  [countryCodes.PITCAIRN.alphaTwo]: "Pitcairn",
  [countryCodes.POLAND.alphaTwo]: "Poland",
  [countryCodes.SAINT_PIERRE_AND_MIQUELON.alphaTwo]: "Saint Pierre and Miquelon",
  [countryCodes.ZAMBIA.alphaTwo]: "Zambia",
  [countryCodes.WESTERN_SAHARA.alphaTwo]: "Western Sahara",
  [countryCodes.ESTONIA.alphaTwo]: "Estonia",
  [countryCodes.EGYPT.alphaTwo]: "Egypt",
  [countryCodes.SOUTH_AFRICA.alphaTwo]: "South Africa",
  [countryCodes.ECUADOR.alphaTwo]: "Ecuador",
  [countryCodes.ITALY.alphaTwo]: "Italy",
  [countryCodes.VIETNAM.alphaTwo]: "Vietnam",
  [countryCodes.SOLOMON_ISLANDS.alphaTwo]: "Solomon Islands",
  [countryCodes.ETHIOPIA.alphaTwo]: "Ethiopia",
  [countryCodes.SOMALIA.alphaTwo]: "Somalia",
  [countryCodes.ZIMBABWE.alphaTwo]: "Zimbabwe",
  [countryCodes.SAUDI_ARABIA.alphaTwo]: "Saudi Arabia",
  [countryCodes.SPAIN.alphaTwo]: "Spain",
  [countryCodes.ERITREA.alphaTwo]: "Eritrea",
  [countryCodes.MONTENEGRO.alphaTwo]: "Montenegro",
  [countryCodes.MOLDOVA_REPUBLIC_OF.alphaTwo]: "Moldova",
  [countryCodes.MADAGASCAR.alphaTwo]: "Madagascar",
  [countryCodes.SAINT_MARTIN_FRANCE.alphaTwo]: "Saint Martin",
  [countryCodes.MOROCCO.alphaTwo]: "Morocco",
  [countryCodes.MONACO.alphaTwo]: "Monaco",
  [countryCodes.UZBEKISTAN.alphaTwo]: "Uzbekistan",
  [countryCodes.MYANMAR.alphaTwo]: "Myanmar",
  [countryCodes.MALI.alphaTwo]: "Mali",
  [countryCodes.MACAU.alphaTwo]: "Macao",
  [countryCodes.MONGOLIA.alphaTwo]: "Mongolia",
  [countryCodes.MARSHALL_ISLANDS.alphaTwo]: "Marshall Islands",
  [countryCodes.NORTH_MACEDONIA_REPUBLIC_OF.alphaTwo]: "Macedonia",
  [countryCodes.MAURITIUS.alphaTwo]: "Mauritius",
  [countryCodes.MALTA.alphaTwo]: "Malta",
  [countryCodes.MALAWI.alphaTwo]: "Malawi",
  [countryCodes.MALDIVES.alphaTwo]: "Maldives",
  [countryCodes.MARTINIQUE.alphaTwo]: "Martinique",
  [countryCodes.NORTHERN_MARIANA_ISLANDS.alphaTwo]: "Northern Mariana Islands",
  [countryCodes.MONTSERRAT.alphaTwo]: "Montserrat",
  [countryCodes.MAURITANIA.alphaTwo]: "Mauritania",
  [countryCodes.ISLE_OF_MAN.alphaTwo]: "Isle of Man",
  [countryCodes.UGANDA.alphaTwo]: "Uganda",
  [countryCodes.TANZANIA_UNITED_REPUBLIC_OF.alphaTwo]: "Tanzania",
  [countryCodes.MALAYSIA.alphaTwo]: "Malaysia",
  [countryCodes.MEXICO.alphaTwo]: "Mexico",
  [countryCodes.ISRAEL.alphaTwo]: "Israel",
  [countryCodes.FRANCE.alphaTwo]: "France",
  [countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY.alphaTwo]: "British Indian Ocean Territory",
  [countryCodes.SAINT_HELENA.alphaTwo]: "Saint Helena",
  [countryCodes.FINLAND.alphaTwo]: "Finland",
  [countryCodes.FIJI.alphaTwo]: "Fiji",
  [countryCodes.FALKLAND_ISLANDS_MALVINAS.alphaTwo]: "Falkland Islands",
  [countryCodes.MICRONESIA_FEDERATED_STATES_OF.alphaTwo]: "Micronesia",
  [countryCodes.FAROE_ISLANDS.alphaTwo]: "Faroe Islands",
  [countryCodes.NICARAGUA.alphaTwo]: "Nicaragua",
  [countryCodes.NETHERLANDS.alphaTwo]: "Netherlands",
  [countryCodes.NORWAY.alphaTwo]: "Norway",
  [countryCodes.NAMIBIA.alphaTwo]: "Namibia",
  [countryCodes.VANUATU.alphaTwo]: "Vanuatu",
  [countryCodes.NEW_CALEDONIA.alphaTwo]: "New Caledonia",
  [countryCodes.NIGER.alphaTwo]: "Niger",
  [countryCodes.NORFOLK_ISLAND.alphaTwo]: "Norfolk Island",
  [countryCodes.NIGERIA.alphaTwo]: "Nigeria",
  [countryCodes.NEW_ZEALAND.alphaTwo]: "New Zealand",
  [countryCodes.NEPAL.alphaTwo]: "Nepal",
  [countryCodes.NAURU.alphaTwo]: "Nauru",
  [countryCodes.NIUE.alphaTwo]: "Niue",
  [countryCodes.COOK_ISLANDS.alphaTwo]: "Cook Islands",
  [countryCodes.KOSOVO.alphaTwo]: "Kosovo",
  [countryCodes.COTE_DIVOIRE.alphaTwo]: "Ivory Coast",
  [countryCodes.SWITZERLAND.alphaTwo]: "Switzerland",
  [countryCodes.COLOMBIA.alphaTwo]: "Colombia",
  [countryCodes.CHINA.alphaTwo]: "China",
  [countryCodes.CAMEROON.alphaTwo]: "Cameroon",
  [countryCodes.CHILE.alphaTwo]: "Chile",
  [countryCodes.COCOS_KEELING_ISLANDS.alphaTwo]: "Cocos Islands",
  [countryCodes.CANADA.alphaTwo]: "Canada",
  [countryCodes.CONGO.alphaTwo]: "Republic of the Congo",
  [countryCodes.CENTRAL_AFRICAN_REPUBLIC.alphaTwo]: "Central African Republic",
  [countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE.alphaTwo]: "Democratic Republic of the Congo",
  [countryCodes.CZECH_REPUBLIC.alphaTwo]: "Czech Republic",
  [countryCodes.CYPRUS.alphaTwo]: "Cyprus",
  [countryCodes.CHRISTMAS_ISLAND.alphaTwo]: "Christmas Island",
  [countryCodes.COSTA_RICA.alphaTwo]: "Costa Rica",
  [countryCodes.CURACAO.alphaTwo]: "Curacao",
  [countryCodes.CAPE_VERDE.alphaTwo]: "Cape Verde",
  [countryCodes.CUBA.alphaTwo]: "Cuba",
  [countryCodes.SWAZILAND.alphaTwo]: "Swaziland",
  [countryCodes.SYRIA.alphaTwo]: "Syria",
  [countryCodes.SINT_MAARTEN_DUTCH.alphaTwo]: "Sint Maarten",
  [countryCodes.KYRGYZSTAN.alphaTwo]: "Kyrgyzstan",
  [countryCodes.KENYA.alphaTwo]: "Kenya",
  [countryCodes.SOUTH_SUDAN.alphaTwo]: "South Sudan",
  [countryCodes.SURINAME.alphaTwo]: "Suriname",
  [countryCodes.KIRIBATI.alphaTwo]: "Kiribati",
  [countryCodes.CAMBODIA.alphaTwo]: "Cambodia",
  [countryCodes.SAINT_KITTS_AND_NEVIS.alphaTwo]: "Saint Kitts and Nevis",
  [countryCodes.COMOROS.alphaTwo]: "Comoros",
  [countryCodes.SAO_TOME_AND_PRINCIPE.alphaTwo]: "Sao Tome and Principe",
  [countryCodes.SLOVAKIA.alphaTwo]: "Slovakia",
  [countryCodes.SOUTH_KOREA.alphaTwo]: "South Korea",
  [countryCodes.SLOVENIA.alphaTwo]: "Slovenia",
  [countryCodes.NORTH_KOREA.alphaTwo]: "North Korea",
  [countryCodes.KUWAIT.alphaTwo]: "Kuwait",
  [countryCodes.SENEGAL.alphaTwo]: "Senegal",
  [countryCodes.SAN_MARINO.alphaTwo]: "San Marino",
  [countryCodes.SIERRA_LEONE.alphaTwo]: "Sierra Leone",
  [countryCodes.SEYCHELLES.alphaTwo]: "Seychelles",
  [countryCodes.KAZAKHSTAN.alphaTwo]: "Kazakhstan",
  [countryCodes.CAYMAN_ISLANDS.alphaTwo]: "Cayman Islands",
  [countryCodes.SINGAPORE.alphaTwo]: "Singapore",
  [countryCodes.SWEDEN.alphaTwo]: "Sweden",
  [countryCodes.SUDAN.alphaTwo]: "Sudan",
  [countryCodes.DOMINICAN_REPUBLIC.alphaTwo]: "Dominican Republic",
  [countryCodes.DOMINICA.alphaTwo]: "Dominica",
  [countryCodes.DJIBOUTI.alphaTwo]: "Djibouti",
  [countryCodes.DENMARK.alphaTwo]: "Denmark",
  [countryCodes.VIRGIN_ISLANDS_BRITISH.alphaTwo]: "British Virgin Islands",
  [countryCodes.GERMANY.alphaTwo]: "Germany",
  [countryCodes.YEMEN.alphaTwo]: "Yemen",
  [countryCodes.ALGERIA.alphaTwo]: "Algeria",
  [countryCodes.UNITED_STATES_OF_AMERICA.alphaTwo]: "United States",
  [countryCodes.URUGUAY.alphaTwo]: "Uruguay",
  [countryCodes.MAYOTTE.alphaTwo]: "Mayotte",
  [countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS.alphaTwo]: "United States Minor Outlying Islands",
  [countryCodes.LEBANON.alphaTwo]: "Lebanon",
  [countryCodes.SAINT_LUCIA.alphaTwo]: "Saint Lucia",
  [countryCodes.LAOS.alphaTwo]: "Laos",
  [countryCodes.TUVALU.alphaTwo]: "Tuvalu",
  [countryCodes.TAIWAN.alphaTwo]: "Taiwan",
  [countryCodes.TRINIDAD_AND_TOBAGO.alphaTwo]: "Trinidad and Tobago",
  [countryCodes.TURKEY.alphaTwo]: "Turkey",
  [countryCodes.SRI_LANKA.alphaTwo]: "Sri Lanka",
  [countryCodes.LIECHTENSTEIN.alphaTwo]: "Liechtenstein",
  [countryCodes.LATVIA.alphaTwo]: "Latvia",
  [countryCodes.TONGA.alphaTwo]: "Tonga",
  [countryCodes.LITHUANIA.alphaTwo]: "Lithuania",
  [countryCodes.LUXEMBOURG.alphaTwo]: "Luxembourg",
  [countryCodes.LIBERIA.alphaTwo]: "Liberia",
  [countryCodes.LESOTHO.alphaTwo]: "Lesotho",
  [countryCodes.THAILAND.alphaTwo]: "Thailand",
  [countryCodes.FRENCH_SOUTHERN_TERRITORIES.alphaTwo]: "French Southern Territories",
  [countryCodes.TOGO.alphaTwo]: "Togo",
  [countryCodes.CHAD.alphaTwo]: "Chad",
  [countryCodes.TURKS_AND_CAICOS_ISLANDS.alphaTwo]: "Turks and Caicos Islands",
  [countryCodes.LIBYA.alphaTwo]: "Libya",
  [countryCodes.VATICAN.alphaTwo]: "Vatican",
  [countryCodes.SAINT_VINCENT_AND_THE_GRENADINES.alphaTwo]: "Saint Vincent and the Grenadines",
  [countryCodes.UNITED_ARAB_EMIRATES.alphaTwo]: "United Arab Emirates",
  [countryCodes.ANDORRA.alphaTwo]: "Andorra",
  [countryCodes.ANTIGUA_AND_BARBUDA.alphaTwo]: "Antigua and Barbuda",
  [countryCodes.AFGHANISTAN.alphaTwo]: "Afghanistan",
  [countryCodes.ANGUILLA.alphaTwo]: "Anguilla",
  [countryCodes.VIRGIN_ISLANDS_US.alphaTwo]: "U.S. Virgin Islands",
  [countryCodes.ICELAND.alphaTwo]: "Iceland",
  [countryCodes.IRAN_ISLAMIC_REPUBLIC_OF.alphaTwo]: "Iran",
  [countryCodes.ARMENIA.alphaTwo]: "Armenia",
  [countryCodes.ALBANIA.alphaTwo]: "Albania",
  [countryCodes.ANGOLA.alphaTwo]: "Angola",
  [countryCodes.ANTARCTICA.alphaTwo]: "Antarctica",
  [countryCodes.AMERICAN_SAMOA.alphaTwo]: "American Samoa",
  [countryCodes.ARGENTINA.alphaTwo]: "Argentina",
  [countryCodes.AUSTRALIA.alphaTwo]: "Australia",
  [countryCodes.AUSTRIA.alphaTwo]: "Austria",
  [countryCodes.ARUBA.alphaTwo]: "Aruba",
  [countryCodes.INDIA.alphaTwo]: "India",
  [countryCodes.ALAND_ISLANDS.alphaTwo]: "Aland Islands",
  [countryCodes.AZERBAIJAN.alphaTwo]: "Azerbaijan",
  [countryCodes.IRELAND.alphaTwo]: "Ireland",
  [countryCodes.INDONESIA.alphaTwo]: "Indonesia",
  [countryCodes.UKRAINE.alphaTwo]: "Ukraine",
  [countryCodes.QATAR.alphaTwo]: "Qatar",
  [countryCodes.MOZAMBIQUE.alphaTwo]: "Mozambique"
});
function deepFreeze3(e) {
  return Object.keys(e).forEach((t) => {
    typeof e[t] == "object" && e[t] !== null && !Object.isFrozen(e[t]) && deepFreeze3(e[t]);
  }), Object.freeze(e);
}
deepFreeze3([
  { name: "January", value: "01" },
  { name: "February", value: "02" },
  { name: "March", value: "03" },
  { name: "April", value: "04" },
  { name: "May", value: "05" },
  { name: "June", value: "06" },
  { name: "July", value: "07" },
  { name: "August", value: "08" },
  { name: "September", value: "09" },
  { name: "October", value: "10" },
  { name: "November", value: "11" },
  { name: "December", value: "12" }
]);
var EStudentImportAttributeFieldNames = /* @__PURE__ */ ((e) => (e.ADDRESS_LINE_1 = "addressLine1", e.ADDRESS_LINE_2 = "addressLine2", e.ADDRESS_LINE_3 = "addressLine3", e.AGENT_COMPANY = "agentCompany", e.AGENT_COMPANY_EMAIL = "agentCompanyEmail", e.AGENT_EMAIL = "agentEmail", e.AGENT_NAME = "agentName", e.AGENT_OFFICE = "agentOffice", e.APPLICATION_DATE = "applicationDate", e.APPLICATION_ID = "applicationId", e.BRANCH_OFFICE = "branchOffice", e.CITY = "city", e.CONFIRMED = "confirmed", e.COUNSELLOR_EMAIL = "counsellorEmail", e.COUNSELLOR_NAME = "counsellorName", e.COUNTRY = "country", e.COUNTRY_OF_BIRTH = "countryOfBirth", e.CRIMINAL_CONVICTIONS = "criminalConvictions", e.DOB = "dob", e.EMAIL = "email", e.ENGLISH_LEVEL_ATTAINED = "englishLevelAttained", e.ENGLISH_TEST_PROVIDER = "englishTestProvider", e.FAMILY_NAME = "familyName", e.GENDER = "gender", e.GIVEN_NAME = "givenName", e.NATIONALITY = "nationality", e.OTHER_NAME = "otherName", e.PASSPORT_EXPIRY = "passportExpiry", e.PASSPORT_NUMBER = "passportNumber", e.PHONE = "phone", e.PLACE_OF_BIRTH = "placeOfBirth", e.POSTCODE = "postcode", e.PREVIOUS_COURSE_COMPLETION = "previousCourseCompletion", e.PREV_UK_STUDY = "prevUKStudy", e.SELT_LISTENING = "seltListening", e.SELT_READING = "seltReading", e.SELT_SPEAKING = "seltSpeaking", e.SELT_WRITING = "seltWriting", e.STUDENT_NO = "studentNo", e.UCAS_ID = "ucasId", e.WITH_AGENT = "withAgent", e.ADMISSIONS_OFFICE = "admissionsOffice", e.SERVICES_ASSIGNED = "servicesAssigned", e.TAGS_ASSIGNED = "tagsAssigned", e.STAGE = "stage", e.AGE = "age", e.VISA_APPLICATION_COUNTRY = "visaApplicationCountry", e.RISK_REGION = "riskRegion", e.COURSE_FEE_PAID_TO_DATE = "courseFeePaidToDate", e.ACCOM_FEE_PAID_TO_DATE = "accomFeePaidToDate", e.IS_SELT_REQD = "isSELTReqd", e.REASON_SELT_NOT_REQD = "reasonSELTNotReqd", e.PREVIOUS_COURSE_LEVEL = "previousCourseLevel", e.COURSE_PROGRESSION = "courseProgression", e.PROGRESSION_TEXT = "progressionText", e.DOCS_USED_TO_OBTAIN_OFFER = "docsUsedToObtainOffer", e.IS_ACCOM_PROVIDED = "isAccomProvided", e.IS_ACCOM_INCLUDED_COURSE_FEE = "isAccomIncludedCourseFee", e.IS_WORK_PLACEMENT = "isWorkPlacement", e.WORK_PLACEMENT_PERC = "workPlacementPerc", e.WORK_PLACEMENT_TEXT = "workPlacementText", e.WORK_PLACEMENT_ADDRESS_LINE_1 = "workPlacementAddressLine1", e.WORK_PLACEMENT_ADDRESS_LINE_2 = "workPlacementAddressLine2", e.WORK_PLACEMENT_ADDRESS_LINE_3 = "workPlacementAddressLine3", e.OFFERS_COURSES_ID = "offers_courses_id", e.OFFERS_PRESESSIONAL_TITLE = "offers_presessional_title", e.OFFERS_COURSES_TITLE = "offers_courses_title", e.OFFERS_COURSES_CONDITIONAL = "offers_courses_conditional", e.OFFERS_COURSES_DECLINED = "offers_courses_declined", e.OFFERS_COURSES_CAH3 = "offers_courses_cah3", e.OFFERS_COURSES_LEVEL = "offers_courses_level", e.OFFERS_COURSES_SECONDARY_LEVEL = "offers_courses_secondaryLevel", e.OFFERS_PRESESSIONAL_START_DATE = "offers_presessional_start_date", e.OFFERS_COURSES_START_DATE = "offers_courses_start_date", e.OFFERS_PRESESSIONAL_END_DATE = "offers_presessional_end_date", e.OFFERS_COURSES_END_DATE = "offers_courses_end_date", e.OFFERS_PRESESSIONAL_FEE = "offers_presessional_fee", e.OFFERS_COURSES_FEE = "offers_courses_fee", e.OFFERS_COURSES_SCHOLARSHIP_AMOUNT1 = "offers_courses_scholarshipAmount1", e.OFFERS_COURSES_SCHOLARSHIP_TITLE1 = "offers_courses_scholarshipTitle1", e.OFFERS_COURSES_INNER_LONDON = "offers_courses_inner_london", e.OFFERS_COURSES_LAST_ACCEPTANCE_DATE = "offers_courses_lastAcceptanceDate", e.OFFERS_COURSES_IS_FULL_TIME = "offers_courses_isFullTime", e.OFFERS_COURSES_HOURS_PER_WEEK = "offers_courses_hoursPerWeek", e.OFFERS_COURSES_ATAS = "offers_courses_atas", e.OFFERS_COURSES_CONDITIONS_TEXT1 = "offers_courses_conditions_text1", e.OFFERS_COURSES_CONDITIONS_TEXT2 = "offers_courses_conditions_text2", e.OFFERS_COURSES_CONDITIONS_TEXT3 = "offers_courses_conditions_text3", e.OFFERS_COURSES_CONDITIONS_TEXT4 = "offers_courses_conditions_text4", e.OFFERS_COURSES_CONDITIONS_TEXT5 = "offers_courses_conditions_text5", e.OFFERS_COURSES_CONDITIONS_TEXT6 = "offers_courses_conditions_text6", e.OFFERS_COURSES_CONDITIONS_TEXT7 = "offers_courses_conditions_text7", e.OFFERS_COURSES_CONDITIONS_TEXT8 = "offers_courses_conditions_text8", e.OFFERS_COURSES_CONDITIONS_TEXT9 = "offers_courses_conditions_text9", e.OFFERS_COURSES_FACULTY = "offers_courses_faculty", e.MAIN_STUDY_ADDRESS_LINE_1 = "mainStudyAddressLine1", e.MAIN_STUDY_ADDRESS_LINE_2 = "mainStudyAddressLine2", e.MAIN_STUDY_ADDRESS_LINE_3 = "mainStudyAddressLine3", e.MAIN_STUDY_ADDRESS_CITY = "mainStudyAddressCity", e.MAIN_STUDY_ADDRESS_COUNTRY = "mainStudyAddressCountry", e.MAIN_STUDY_ADDRESS_POSTCODE = "mainStudyAddressPostcode", e.WORK_PLACEMENT_ADDRESS_CITY = "workPlacementAddressCity", e.WORK_PLACEMENT_ADDRESS_COUNTRY = "workPlacementAddressCountry", e.WORK_PLACEMENT_ADDRESS_POSTCODE = "workPlacementAddressPostcode", e.OFFERS_COURSES_OFFER_EVIDENCE = "offers_courses_offerEvidence", e.OFFERS_COURSES_ACCEPTED = "offers_courses_accepted", e.OFFERS_COURSES_QUAL_HECOS1 = "offers_courses_qual_hecos1", e.OFFERS_COURSES_QUAL_HECOS2 = "offers_courses_qual_hecos2", e.OFFERS_COURSES_QUAL_HECOS3 = "offers_courses_qual_hecos3", e.OFFERS_COURSES_QUAL_HECOS4 = "offers_courses_qual_hecos4", e.OFFERS_COURSES_QUAL_HECOS5 = "offers_courses_qual_hecos5", e.OFFERS_COURSES_QUAL_PROPORTION1 = "offers_courses_qual_proportion1", e.OFFERS_COURSES_QUAL_PROPORTION2 = "offers_courses_qual_proportion2", e.OFFERS_COURSES_QUAL_PROPORTION3 = "offers_courses_qual_proportion3", e.OFFERS_COURSES_QUAL_PROPORTION4 = "offers_courses_qual_proportion4", e.OFFERS_COURSES_QUAL_PROPORTION5 = "offers_courses_qual_proportion5", e.OFFERS_COURSES_QUAL_CAT = "offers_courses_qual_cat", e.OFFER_ID = "offerId", e.INTAKE_ID = "intakeId", e.UNI_PARTNER_ID = "uniPartnerId", e.UNI = "uni", e.PATHWAY = "pathway", e.EXTERNAL_CAS_STATUS = "externalCasStatus", e.OFFERS_DURATION_MONTHS = "offersDurationMonths", e.TUITION_DEPOSIT = "tuitionDeposit", e.DEPOSIT_AMOUNT = "depositAmount", e.AGENT_FAMILY_NAME = "agentFamilyName", e.AGENT_GIVEN_NAME = "agentGivenName", e.BRANCH_ADDRESS_LINE_1 = "branchAddressLine1", e.BRANCH_ADDRESS_LINE_2 = "branchAddressLine2", e.BRANCH_ADDRESS_LINE_3 = "branchAddressLine3", e.BRANCH_CITY = "branchCity", e.BRANCH_COUNTRY = "branchCountry", e.BRANCH_POSTCODE = "branchPostcode", e))(EStudentImportAttributeFieldNames || {});
function deepFreeze4(e) {
  return Object.keys(e).forEach((t) => {
    typeof e[t] == "object" && e[t] !== null && !Object.isFrozen(e[t]) && deepFreeze4(e[t]);
  }), Object.freeze(e);
}
deepFreeze4({
  // GENERAL FIELDS
  addressLine1: {
    summaryField: null,
    name: "addressLine1",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  addressLine2: {
    summaryField: null,
    name: "addressLine2",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  addressLine3: {
    summaryField: null,
    name: "addressLine3",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  agentCompany: {
    summaryField: null,
    name: "agentCompany",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  agentCompanyEmail: {
    summaryField: null,
    name: "agentCompanyEmail",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  agentEmail: {
    summaryField: null,
    name: "agentEmail",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  agentName: {
    summaryField: "agentName",
    summaryFieldType: "string",
    name: "agentName",
    type: "offer",
    isPresessional: null,
    label: "Agent Name"
  },
  agentOffice: {
    summaryField: null,
    name: "agentOffice",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  applicationDate: {
    summaryField: null,
    name: "applicationDate",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  applicationId: {
    summaryField: null,
    name: "applicationId",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  branchOffice: {
    summaryField: null,
    name: "branchOffice",
    type: "offer",
    isPresessional: null,
    label: "Branch Office"
  },
  city: {
    summaryField: "city",
    summaryFieldType: "string",
    name: "city",
    type: "general student",
    isPresessional: null,
    label: "City"
  },
  confirmed: {
    summaryField: null,
    name: "confirmed",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  counsellorEmail: {
    summaryField: null,
    name: "counsellorEmail",
    type: "offer",
    isPresessional: null,
    label: "Counsellor Email"
  },
  counsellorName: {
    summaryField: null,
    name: "counsellorName",
    type: "offer",
    isPresessional: null,
    label: "Counsellor Name"
  },
  country: {
    summaryField: "country",
    summaryFieldType: "string",
    name: "country",
    type: "general student",
    isPresessional: null,
    label: "Country"
  },
  countryOfBirth: {
    summaryField: null,
    name: "countryOfBirth",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  criminalConvictions: {
    summaryField: "criminalConvictions",
    summaryFieldType: "boolean",
    name: "criminalConvictions",
    type: "general student",
    isPresessional: null,
    label: "Criminal Convictions"
  },
  dob: {
    summaryField: "dob",
    summaryFieldType: "string",
    name: "dob",
    type: "general student",
    isPresessional: null,
    label: "Date of Birth"
  },
  email: {
    summaryField: "email",
    summaryFieldType: "string",
    name: "email",
    type: "general student",
    isPresessional: null,
    label: "Email"
  },
  englishLevelAttained: {
    summaryField: null,
    name: "englishLevelAttained",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  englishTestProvider: {
    summaryField: null,
    name: "englishTestProvider",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  familyName: {
    summaryField: "surname",
    summaryFieldType: "string",
    name: "familyName",
    type: "general student",
    isPresessional: null,
    label: "Family Name"
  },
  gender: {
    summaryField: null,
    name: "gender",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  givenName: {
    summaryField: "givenName",
    summaryFieldType: "string",
    name: "givenName",
    type: "general student",
    isPresessional: null,
    label: "Given Name"
  },
  nationality: {
    summaryField: "nationality",
    summaryFieldType: "string",
    name: "nationality",
    type: "general student",
    isPresessional: null,
    label: "Nationality"
  },
  otherName: {
    summaryField: null,
    name: "otherName",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  passportExpiry: {
    summaryField: null,
    name: "passportExpiry",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  passportNumber: {
    summaryField: null,
    name: "passportNumber",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  phone: {
    summaryField: "phone",
    summaryFieldType: "string",
    name: "phone",
    type: "general student",
    isPresessional: null,
    label: "Phone"
  },
  placeOfBirth: {
    summaryField: null,
    name: "placeOfBirth",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  postcode: {
    summaryField: "postcode",
    summaryFieldType: "string",
    name: "postcode",
    type: "general student",
    isPresessional: null,
    label: "Postcode"
  },
  previousCourseCompletion: {
    summaryField: null,
    name: "previousCourseCompletion",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  prevUKStudy: {
    summaryField: null,
    name: "prevUKStudy",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  seltListening: {
    summaryField: null,
    name: "seltListening",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  seltReading: {
    summaryField: null,
    name: "seltReading",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  seltSpeaking: {
    summaryField: null,
    name: "seltSpeaking",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  seltWriting: {
    summaryField: null,
    name: "seltWriting",
    type: "general student",
    isPresessional: null,
    label: ""
  },
  studentNo: {
    summaryField: "studentNo",
    summaryFieldType: "string",
    name: "studentNo",
    type: "general student",
    isPresessional: null,
    label: "Student Number"
  },
  ucasId: {
    summaryField: "ucasId",
    summaryFieldType: "string",
    name: "ucasId",
    type: "general student",
    isPresessional: null,
    label: "UCAS ID"
  },
  withAgent: {
    summaryField: "withAgent",
    summaryFieldType: "boolean",
    name: "withAgent",
    type: "offer",
    isPresessional: null,
    label: "With Agent"
  },
  admissionsOffice: {
    summaryField: "admissionsOffice",
    summaryFieldType: "string",
    name: "admissionsOffice",
    type: "general student",
    isPresessional: null,
    label: "Uni Office"
  },
  servicesAssigned: {
    summaryField: "partners",
    summaryFieldType: "string",
    name: null,
    type: "general student",
    isPresessional: null,
    label: "Services"
  },
  tagsAssigned: {
    summaryField: "tags",
    summaryFieldType: "string",
    name: null,
    type: "general student",
    isPresessional: null,
    label: "Tags"
  },
  stage: {
    summaryField: "cas_status",
    summaryFieldType: "string",
    name: null,
    type: "general student",
    isPresessional: null,
    label: "Stage"
  },
  age: {
    summaryField: "age",
    summaryFieldType: "number",
    name: null,
    type: "general student",
    isPresessional: null,
    label: "Age"
  },
  visaApplicationCountry: {
    summaryField: "countryOfVisaApplication",
    summaryFieldType: "string",
    name: null,
    type: "general student",
    isPresessional: null,
    label: "Country of Visa Application"
  },
  riskRegion: {
    summaryField: "regionConfigId",
    summaryFieldType: "string",
    name: null,
    type: "general student",
    isPresessional: null,
    label: "Risk Region"
  },
  // OFFER FIELDS
  courseFeePaidToDate: {
    summaryField: "courseFeePaidToDate",
    summaryFieldType: "number",
    name: "courseFeePaidToDate",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  accomFeePaidToDate: {
    summaryField: null,
    name: "accomFeePaidToDate",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  isSELTReqd: {
    summaryField: null,
    name: "isSELTReqd",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  reasonSELTNotReqd: {
    summaryField: null,
    name: "reasonSELTNotReqd",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  previousCourseLevel: {
    summaryField: null,
    name: "previousCourseLevel",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  courseProgression: {
    summaryField: null,
    name: "courseProgression",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  progressionText: {
    summaryField: null,
    name: "progressionText",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  docsUsedToObtainOffer: {
    summaryField: null,
    name: "docsUsedToObtainOffer",
    type: "offer",
    isPresessional: null,
    label: ""
  },
  // COURSE FIELDS
  isAccomProvided: {
    summaryField: null,
    name: "isAccomProvided",
    type: "course",
    isPresessional: null,
    label: ""
  },
  isAccomIncludedCourseFee: {
    summaryField: null,
    name: "isAccomIncludedCourseFee",
    type: "course",
    isPresessional: null,
    label: ""
  },
  isWorkPlacement: {
    summaryField: null,
    name: "isWorkPlacement",
    type: "course",
    isPresessional: null,
    label: ""
  },
  workPlacementPerc: {
    summaryField: null,
    name: "workPlacementPerc",
    type: "course",
    isPresessional: null,
    label: ""
  },
  workPlacementText: {
    summaryField: null,
    name: "workPlacementText",
    type: "course",
    isPresessional: null,
    label: ""
  },
  workPlacementAddressLine1: {
    summaryField: null,
    name: "workPlacementAddressLine1",
    type: "course",
    isPresessional: null,
    label: ""
  },
  workPlacementAddressLine2: {
    summaryField: null,
    name: "workPlacementAddressLine2",
    type: "course",
    isPresessional: null,
    label: ""
  },
  workPlacementAddressLine3: {
    summaryField: null,
    name: "workPlacementAddressLine3",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_id: {
    summaryField: "id",
    summaryFieldType: "string",
    name: "id",
    type: "course",
    isPresessional: null,
    label: "Course ID"
  },
  offers_presessional_title: {
    summaryField: "title",
    summaryFieldType: "string",
    name: "title",
    type: "course",
    isPresessional: !0,
    label: "PSE Course Title"
  },
  offers_courses_title: {
    summaryField: "title",
    summaryFieldType: "string",
    name: "title",
    type: "course",
    isPresessional: !1,
    label: "Course Title"
  },
  offers_courses_conditional: {
    summaryField: null,
    name: "conditional",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_declined: {
    summaryField: null,
    name: "isDeclined",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_cah3: {
    summaryField: null,
    name: "cah3",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_level: {
    summaryField: "level",
    summaryFieldType: "string",
    name: "level",
    type: "course",
    isPresessional: null,
    label: "Course Level"
  },
  offers_courses_secondaryLevel: {
    summaryField: null,
    name: "secondaryLevel",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_presessional_start_date: {
    summaryField: "startDate",
    summaryFieldType: "string",
    name: "startDate",
    type: "course",
    isPresessional: !0,
    label: "PSE Course Start Date"
  },
  offers_courses_start_date: {
    summaryField: "startDate",
    summaryFieldType: "string",
    name: "startDate",
    type: "course",
    isPresessional: !1,
    label: "Course Start Date"
  },
  offers_presessional_end_date: {
    summaryField: null,
    name: "endDate",
    type: "course",
    isPresessional: !0,
    label: ""
  },
  offers_courses_end_date: {
    summaryField: null,
    name: "endDate",
    type: "course",
    isPresessional: !1,
    label: ""
  },
  offers_presessional_fee: {
    summaryField: null,
    name: "courseFeeFirstYear",
    type: "course",
    isPresessional: !0,
    label: ""
  },
  offers_courses_fee: {
    summaryField: null,
    name: "courseFeeFirstYear",
    type: "course",
    isPresessional: !1,
    label: ""
  },
  offers_courses_scholarshipAmount1: {
    summaryField: null,
    name: "courseScholarshipAmount1",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_scholarshipTitle1: {
    summaryField: null,
    name: "courseScholarshipTitle1",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_inner_london: {
    summaryField: "innerLondon",
    name: "innerLondon",
    type: "course",
    summaryFieldType: "boolean",
    isPresessional: null,
    label: "Inner London"
  },
  offers_courses_lastAcceptanceDate: {
    summaryField: null,
    name: "lastAcceptanceDate",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_isFullTime: {
    summaryField: null,
    name: "isFullTime",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_hoursPerWeek: {
    summaryField: null,
    name: "hoursPerWeek",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_atas: {
    summaryField: null,
    name: "isATASRequired",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_conditions_text1: {
    summaryField: null,
    name: "conditionText1",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_conditions_text2: {
    summaryField: null,
    name: "conditionText2",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_conditions_text3: {
    summaryField: null,
    name: "conditionText3",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_conditions_text4: {
    summaryField: null,
    name: "conditionText4",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_conditions_text5: {
    summaryField: null,
    name: "conditionText5",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_conditions_text6: {
    summaryField: null,
    name: "conditionText6",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_conditions_text7: {
    summaryField: null,
    name: "conditionText7",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_conditions_text8: {
    summaryField: null,
    name: "conditionText8",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_conditions_text9: {
    summaryField: null,
    name: "conditionText9",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_faculty: {
    summaryField: "faculty",
    summaryFieldType: "string",
    name: "faculty",
    type: "course",
    isPresessional: null,
    label: "Faculty"
  },
  mainStudyAddressLine1: {
    summaryField: null,
    name: "studyAddressLine1",
    type: "course",
    isPresessional: null,
    label: ""
  },
  mainStudyAddressLine2: {
    summaryField: null,
    name: "studyAddressLine2",
    type: "course",
    isPresessional: null,
    label: ""
  },
  mainStudyAddressLine3: {
    summaryField: null,
    name: "studyAddressLine3",
    type: "course",
    isPresessional: null,
    label: ""
  },
  mainStudyAddressCity: {
    summaryField: null,
    name: "studyCity",
    type: "course",
    isPresessional: null,
    label: ""
  },
  mainStudyAddressCountry: {
    summaryField: null,
    name: "studyCountry",
    type: "course",
    isPresessional: null,
    label: ""
  },
  mainStudyAddressPostcode: {
    summaryField: null,
    name: "studyPostcode",
    type: "course",
    isPresessional: null,
    label: ""
  },
  workPlacementAddressCity: {
    summaryField: null,
    name: "workPlacementCity",
    type: "course",
    isPresessional: null,
    label: ""
  },
  workPlacementAddressCountry: {
    summaryField: null,
    name: "workPlacementCountry",
    type: "course",
    isPresessional: null,
    label: ""
  },
  workPlacementAddressPostcode: {
    summaryField: null,
    name: "workPlacementPostcode",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_offerEvidence: {
    summaryField: null,
    name: "offerEvidence",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_accepted: {
    summaryField: null,
    name: "coursesAccepted",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_qual_hecos1: {
    summaryField: null,
    name: "offers_courses_qual_hecos1",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_qual_hecos2: {
    summaryField: null,
    name: "offers_courses_qual_hecos2",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_qual_hecos3: {
    summaryField: null,
    name: "offers_courses_qual_hecos3",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_qual_hecos4: {
    summaryField: null,
    name: "offers_courses_qual_hecos4",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_qual_hecos5: {
    summaryField: null,
    name: "offers_courses_qual_hecos5",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_qual_proportion1: {
    summaryField: null,
    name: "offers_courses_qual_proportion1",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_qual_proportion2: {
    summaryField: null,
    name: "offers_courses_qual_proportion2",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_qual_proportion3: {
    summaryField: null,
    name: "offers_courses_qual_proportion3",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_qual_proportion4: {
    summaryField: null,
    name: "offers_courses_qual_proportion4",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_qual_proportion5: {
    summaryField: null,
    name: "offers_courses_qual_proportion5",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offers_courses_qual_cat: {
    summaryField: null,
    name: "offers_courses_qual_cat",
    type: "course",
    isPresessional: null,
    label: ""
  },
  offerId: {
    summaryField: "offerId",
    summaryFieldType: "string",
    name: "offerId",
    type: "offer",
    isPresessional: null,
    label: "Offer ID"
  },
  intakeId: {
    summaryField: "intakeId",
    summaryFieldType: "string",
    name: "intakeId",
    type: "offer",
    isPresessional: null,
    label: "Intake ID"
  },
  uniPartnerId: {
    summaryField: "uniPartnerId",
    summaryFieldType: "string",
    name: "uniPartnerId",
    type: "offer",
    isPresessional: null,
    label: "Secondary Student Number"
  },
  uni: {
    summaryField: "uni",
    summaryFieldType: "string",
    name: "uni",
    type: "general student",
    isPresessional: null,
    label: "University"
  },
  pathway: {
    summaryField: "pathway",
    summaryFieldType: "string",
    name: "pathway",
    type: "general student",
    isPresessional: null,
    label: "Pathway Provider"
  },
  externalCasStatus: {
    summaryField: "externalCasStatus",
    summaryFieldType: "string",
    name: "externalCasStatus",
    type: "offer",
    isPresessional: null,
    label: "CAS Bypass"
  },
  offersDurationMonths: {
    summaryField: "offersDurationMonths",
    summaryFieldType: "number",
    name: "offersDurationMonths",
    type: "offer",
    isPresessional: null,
    label: "Offers Duration Months"
  },
  tuitionDeposit: {
    summaryField: "tuitionDeposit",
    summaryFieldType: "number",
    name: "depositAmount",
    type: "offer",
    isPresessional: null,
    label: "Tuition Deposit"
  },
  depositAmount: {
    summaryField: "depositAmount",
    summaryFieldType: "number",
    name: "depositAmount",
    type: "offer",
    isPresessional: null,
    label: "Tuition Deposit"
  },
  agentFamilyName: {
    summaryField: null,
    name: "agentFamilyName",
    type: "offer",
    isPresessional: null,
    label: "Key Contact Family Name"
  },
  agentGivenName: {
    summaryField: null,
    name: "agentGivenName",
    type: "offer",
    isPresessional: null,
    label: "Key Contact Given Name"
  },
  branchAddressLine1: {
    summaryField: null,
    name: "branchAddressLine1",
    type: "offer",
    isPresessional: null,
    label: "Branch Address Line 1"
  },
  branchAddressLine2: {
    summaryField: null,
    name: "branchAddressLine2",
    type: "offer",
    isPresessional: null,
    label: "Branch Address Line 2"
  },
  branchAddressLine3: {
    summaryField: null,
    name: "branchAddressLine3",
    type: "offer",
    isPresessional: null,
    label: "Branch Address Line 3"
  },
  branchCity: {
    summaryField: null,
    name: "branchCity",
    type: "offer",
    isPresessional: null,
    label: "Branch City"
  },
  branchCountry: {
    summaryField: null,
    name: "branchCountry",
    type: "offer",
    isPresessional: null,
    label: "Branch Country"
  },
  branchPostcode: {
    summaryField: null,
    name: "branchPostcode",
    type: "offer",
    isPresessional: null,
    label: "Branch Postcode"
  }
});
var __defProp = Object.defineProperty, __export = (e, t) => {
  for (var o in t)
    __defProp(e, o, { get: t[o], enumerable: !0 });
}, optionalTrimmedString = z.preprocess(
  (e) => typeof e == "string" && e.trim() === "" ? void 0 : e,
  z.string().trim().optional()
);
z.object({
  name: z.string().trim().min(1, "Required"),
  addressLine1: z.string().trim().min(1, "Required"),
  addressLine2: optionalTrimmedString,
  addressLine3: optionalTrimmedString,
  city: z.string().trim().min(1, "Required"),
  postcode: optionalTrimmedString,
  country: z.string().trim().min(1, "Required"),
  contactGivenName: optionalTrimmedString,
  contactFamilyName: optionalTrimmedString,
  contactEmail: z.preprocess(
    (e) => typeof e == "string" && e.trim() === "" ? void 0 : e,
    z.string().trim().email("Email is not valid").optional()
  )
});
var MAX_PERCENTAGE = 100, MIN_PERCENTAGE = 0;
z.array(z.number().min(MIN_PERCENTAGE).max(MAX_PERCENTAGE)).refine(
  (e) => e.reduce((o, i) => o + i, MIN_PERCENTAGE) !== MAX_PERCENTAGE,
  {
    message: "The values in the array must sum to 100%."
  }
);
z.array(z.string()).refine(
  (e) => {
    let t = !1;
    for (const [o, i] of e.entries())
      if (e.findIndex((d) => d === i) !== o) {
        t = !0;
        break;
      }
    return t;
  },
  {
    message: "The values in the HECoS list must not be duplicated."
  }
);
z.array(z.string()).refine(
  (e) => {
    let t = !1;
    for (const o of e)
      if (o === "undefined" || o === void 0) {
        t = !0;
        break;
      }
    return t;
  },
  {
    message: "The values in the HECoS must not be undefined."
  }
);
var intakeIdValidator = z.string().min(1, { message: "Required" }).regex(/^\d{4}-\d{2}$/, { message: "Invalid intake ID" }), ApplicantStatus = /* @__PURE__ */ ((e) => (e.New = "NEW", e))(ApplicantStatus || {}), StudyLevel = /* @__PURE__ */ ((e) => (e.Foundation = "Foundation", e.Undergraduate = "Undergraduate", e.Postgraduate = "Postgraduate", e.Research = "Research", e))(StudyLevel || {}), StudyMode = /* @__PURE__ */ ((e) => (e.FullTime = "Full-time", e.PartTime = "Part-time", e.MixedMode = "Mixed-mode", e.Sandwich = "Sandwich", e.DistanceLearning = "Distance-learning", e))(StudyMode || {}), PreviousStudyLevel = /* @__PURE__ */ ((e) => (e.HighSchool = "HighSchool", e.Undergraduate = "Undergraduate", e.Postgraduate = "Postgraduate", e))(PreviousStudyLevel || {}), GradeLevel = /* @__PURE__ */ ((e) => (e.HighSchool = "High School", e.GcseEnglish = "GCSE", e.AsLevel = "AS Level", e.ALevel = "A Level", e.InternationalBaccalaureateDiploma = "International Baccalaureate Diploma", e.UniversityFoundation = "University Foundation", e.CertificateOfHigherEducation = "Certificate of Higher Education", e.DiplomaOfHigherEducation = "Diploma of Higher Education (DipHE)", e.HigherNationalDiploma = "Higher National Diploma (HND)", e.BachelorDegree = "Bachelor Degree", e.MastersDegree = "Masters Degree", e.GraduateCertificateOrDiploma = "Graduate Certificate or Diploma", e.PostGraduateCertificateOrDiploma = "Post Graduate Certificate or Diploma", e.ResearchDegree = "Research degree", e.Other = "Other", e))(GradeLevel || {}), FeeStatus = /* @__PURE__ */ ((e) => (e.Home = "HOME", e.Overseas = "OVERSEAS", e.NotSure = "NOT_SURE", e))(FeeStatus || {}), ResultStatus = /* @__PURE__ */ ((e) => (e.FinalResults = "FinalResults", e.InterimResults = "InterimResults", e.NoResults = "NoResults", e))(ResultStatus || {}), Ethnicity = /* @__PURE__ */ ((e) => (e.Arab = "Arab", e.AsianBangladeshi = "Asian - Bangladeshi", e.AsianChinese = "Asian - Chinese", e.AsianIndian = "Asian - Indian", e.AsianPakistani = "Asian - Pakistani", e.AsianOther = "Asian - Other background", e.BlackAfrican = "Black - African", e.BlackCaribbean = "Black - Caribbean", e.BlackOther = "Black - Other background", e.GypsyTraveller = "Gypsy, Traveller or Irish Traveller", e.MixedWhiteAsian = "Mixed - White & Asian", e.MixedWhiteBlackAfrican = "Mixed - White & Black African", e.MixedWhiteBlackCaribbean = "Mixed - White & Black Caribbean", e.MixedOther = "Mixed - Other background", e.White = "White", e.WhiteIrish = "White - Irish", e.WhiteRoma = "White - Roma", e.WhiteOther = "White - Other background", e.Other = "Other ethnic background", e.PreferNotToSay = "I prefer not to say", e))(Ethnicity || {}), DisabilityType = /* @__PURE__ */ ((e) => (e.VisualImpairment = "A visual impairment uncorrected by glasses", e.HearingImpairment = "A hearing impairment", e.MentalHealthCondition = "A mental health condition, challenge, or disorder", e.LearningDifficulty = "A learning difficulty", e.PhysicalImpairment = "A physical impairment, including challenges with mobility or dexterity", e.LongTermIllness = "A long-term illness or health condition that may cause pain, fatigue, loss of concentration, or breathing difficulties – including any effects from related medication", e.SocialBehaviouralImpairment = "A social, behavioural, or communication impairment", e.MultiDomainCondition = "A development condition since childhood which affects motor, cognitive, social and emotional skills, speech, and language", e.NotListed = "A condition or impairment not listed", e))(DisabilityType || {}), FirstApplicationStatus = /* @__PURE__ */ ((e) => (e.FirstTime = "FirstTime", e.AppliedOnly = "AppliedOnly", e.StudiedBefore = "StudiedBefore", e))(FirstApplicationStatus || {}), ReferralSource = /* @__PURE__ */ ((e) => (e.Agent = "AGENT", e.CampusVisit = "CAMPUS_VISIT", e.EducationFair = "EDUCATION_FAIR", e.FamilyMember = "FAMILY_MEMBER", e.Friend = "FRIEND", e.OnlineSearch = "ONLINE_SEARCH", e.SchoolCounselor = "SCHOOL_COUNSELOR", e.SocialMedia = "SOCIAL_MEDIA", e.Teacher = "TEACHER", e.Ucas = "UCAS", e.UniversityStudent = "UNIVERSITY_STUDENT", e.UniversityWebsite = "UNIVERSITY_WEBSITE", e.Other = "OTHER", e.PreferNotToSay = "PREFER_NOT_TO_SAY", e))(ReferralSource || {}), IDType = /* @__PURE__ */ ((e) => (e.Passport = "Passport", e.Id = "ID", e.None = "None", e))(IDType || {}), Gender = /* @__PURE__ */ ((e) => (e.Male = "Male", e.Female = "Female", e.NotListed = "Not Listed", e))(Gender || {}), GenderIdentity = /* @__PURE__ */ ((e) => (e.Man = "Man", e.Women = "Women", e.AnotherTerm = "I use another term", e.PreferNotToSay = "I prefer not to say", e))(GenderIdentity || {}), EnglishTestType = /* @__PURE__ */ ((e) => (e.IeltsForUkvi = "IELTS for UKVI", e.IeltsAcademic = "IELTS Academic", e.Ielts = "IELTS General", e.EsolSelt = "LanguageCert International ESOL SELT", e.Ise = "Trinity College London Integrated Skills in English (ISE)", e.PteUkvi = "PTE Academic UKVI", e.Pte = "PTE Academic", e.Psi = "PSI Services Skills for English UKVI", e.Cambridge = "Cambridge Assessment English test", e.Toefl = "TOEFL", e.Uni = "University's English test", e.Ellt = "OI Digital Institute English Language Level Test (ELLT)", e.Other = "Other", e))(EnglishTestType || {}), EnglishTestNotReqdReason = /* @__PURE__ */ ((e) => (e.MajEngCountry = "I am a national of a majority English-speaking country", e.PlanTest = "I plan to take an English language test to meet the requirements", e.PrevQual = "My English can be assessed based on my previous academic qualification", e.PrevVisa = "I have met the English language requirement in my previous visa application", e.UsStudyProgram = "I'm coming as a part of US study abroad programme", e.Other = "Other/I don’t know", e))(EnglishTestNotReqdReason || {}), EmploymentType = /* @__PURE__ */ ((e) => (e.FullTime = "Full Time", e.PartTime = "Part Time", e.Casual = "Casual", e.Freelance = "Freelance", e.Contract = "Contract", e.Temporary = "Temporary", e.Volunteer = "Volunteer", e.Apprenticeship = "Apprenticeship", e.WorkExperience = "Work Experience", e.Other = "Other", e))(EmploymentType || {}), UkAccommodationType = /* @__PURE__ */ ((e) => (e.UniversityAccommodation = "University accommodation", e.PrivateStudentAccommodation = "Private student accommodation", e.PrivateRental = "Private rental", e.StayingWithFamily = "Staying with family", e.Homestay = "Homestay", e.Other = "Other", e))(UkAccommodationType || {}), VisaType = /* @__PURE__ */ ((e) => (e.ShortTermStudyStudentVisa = "Short-term study / student visa", e.StudentVisa = "Student visa (Tier 4 General/Student Route)", e.ChildStudentVisa = "Child Student visa (Tier 4 Child/Child Student Route)", e.Other = "Other (my visa is not listed here)", e))(VisaType || {}), VisaLevelOfStudy = /* @__PURE__ */ ((e) => (e.HighSchool = "High School", e.Foundation = "Foundation", e.Bachelor = "Bachelor (UG)", e.Masters = "Masters (PG)", e.Research = "Research (PhD etc.)", e.ShortCourse = "Short Course", e.EnglishLanguageCourse = "English Language Course", e))(VisaLevelOfStudy || {}), CourseCompare = /* @__PURE__ */ ((e) => (e.HigherLevelCourse = "The course I am applying for now is at a higher level", e.SameLevelCourse = "The course I am applying for now is at the same level", e.LowerLevelCourse = "The course I am applying for now is at a lower level", e.NoUkAcademicStudy = "I have not studied any academic courses in the UK", e))(CourseCompare || {}), VisaOrPermitType = /* @__PURE__ */ ((e) => (e.PreSettledStatus = "Pre-settled status under the EU Settlement Scheme", e.SettledStatus = "Settled status under the EU Settlement Scheme", e.IndefiniteLeaveToRemain = "Indefinite leave to remain", e.LeaveToRemain = "Leave to remain", e.UkraineSchemeVisa = "Ukraine scheme visa", e.PartnerChildBritishIlr = "Partner or child visa of someone with British citizenship or ILR", e.PartnerChildWorkStudy = "Partner or child visa of someone with a work or study visa", e.EuFamilyDependant = "EU or EEA family member/dependant", e.DependantVisa = "Dependant visa", e.WorkVisa = "Work visa", e.PendingEussApplication = "Pending application for EUSS with certificate of application", e.AsylumSeeker = "Asylum seeker", e.Refugee = "Refugee", e.HumanitarianProtection = "Humanitarian Protection", e.ChildOfTurkishWorker = "Child of a Turkish Worker", e.TouristVisitorVisa = "Tourist / visitor visa", e.VisaNotListed = "My visa or permit are not listed", e))(VisaOrPermitType || {}), RefusedVisaType = /* @__PURE__ */ ((e) => (e.TouristVisitorVisa = "Tourist / visitor visa", e.InnovatorVisa = "Innovator visa", e.StartupVisa = "Start-up visa", e.InvestorEntrepreneurVisa = "Investor / entrepreneur visa (Tier 1)", e.ExceptionalTalentVisa = "Exceptional talent visa (Tier 1)", e.GraduateEntrepreneurVisa = "Graduate Entrepreneur visa (Tier 1)", e.LongTermWorkVisa = "Long-term work visa (Tier 2)", e.ShortTermWorkVisa = "Short-term work visa (Tier 5)", e.IntraCompanyTransferVisa = "Intra-company Transfer visa (Tier 2)", e.MinisterOfReligionVisa = "Minister of Religion visa (Tier 2)", e.SportspersonVisa = "Sportsperson visa (Tier 2)", e.LowSkilledWorkerVisa = "Low Skilled Worker (Tier 3)", e.StandardVisitorVisa = "Standard Visitor visa", e.MarriageVisitorVisa = "Marriage Visitor visa", e.PaidEngagementVisa = "Permitted Paid Engagement visa", e.ParentTier4ChildVisa = "Parent of a Tier 4 child visa", e.ChineseTourGroupVisa = "Visit the UK in a Chinese tour group", e.TransitVisa = "Visa to pass through the UK in transit", e.ShortTermStudyVisa = "Short-term study / student visa", e.StudentVisa = "Student visa (Tier 4 General/Student Route)", e.ChildStudentVisa = "Child Student visa (Tier 4 Child/Child Student Route)", e.TempWorkCharityVisa = "Temporary Worker - Charity Worker visa (Tier 5)", e.TempWorkCreativeSportingVisa = "Temporary Worker - Creative and Sporting visa (Tier 5)", e.TempWorkAuthorisedExchangeVisa = "Temporary Worker - Government Authorised Exchange visa (Tier 5)", e.TempWorkIntlAgreementVisa = "Temporary Worker - International Agreement visa (Tier 5)", e.TempWorkReligiousWorkerVisa = "Temporary Worker - Religious Worker visa (Tier 5)", e.TempWorkSeasonalWorkerVisa = "Temporary Worker - Seasonal Worker Visa (Tier 5)", e.YouthMobilitySchemeVisa = "Youth mobility scheme visa (Tier 5)", e.FamilyVisa = "Family visas: apply, extend or switch", e.EuEeaFamilyPermit = "Apply for a permit to join your EU or EEA family member in the UK", e.DependantVisa = "Dependant Visa", e.OtherVisaNotListed = "Other (My visa is not listed here)", e))(RefusedVisaType || {}), ApplicationRefereeRelation = /* @__PURE__ */ ((e) => (e.Manager = "Manager", e.Colleague = "Colleague", e.Teacher = "Teacher", e.CareersAdvisor = "Careers advisor", e.Other = "Other", e))(ApplicationRefereeRelation || {}), FundingOption = /* @__PURE__ */ ((e) => (e.PrivateFinance = "PrivateFinance", e.StudentFinance = "StudentFinance", e.HealthAuthority = "HealthAuthority", e.ResearchCouncils = "ResearchCouncils", e.TrainingAgency = "TrainingAgency", e.UkIndustry = "UkIndustry", e.UkGovtInternational = "UkGovtInternational", e.UkGovtOther = "UkGovtOther", e.UniversityScholarship = "UniversityScholarship", e.OverseasAgency = "OverseasAgency", e.OverseasGovt = "OverseasGovt", e.OverseasIndustry = "OverseasIndustry", e.OverseasUniversity = "OverseasUniversity", e.Other = "Other", e.Unknown = "Unknown", e))(FundingOption || {}), CourseAvailability = /* @__PURE__ */ ((e) => (e.ALL = "all", e.LIMITED_PARTNERS = "limited_partners", e))(CourseAvailability || {}), ModuleSchema = z.object({
  subject: z.string(),
  grade: z.string()
}).refine(
  (e) => {
    const t = e.subject && e.subject.trim().length > 0, o = e.grade && e.grade.trim().length > 0;
    return !t && !o ? !0 : t && o;
  },
  (e) => {
    const t = e.subject && e.subject.trim().length > 0, o = e.grade && e.grade.trim().length > 0;
    return !t && o ? { message: "Subject can't be empty", path: ["subject"] } : t && !o ? { message: "Grade can't be empty", path: ["grade"] } : { message: "Subject can't be empty", path: ["subject"] };
  }
).refine(
  (e) => !(e.subject && e.subject.length > 100),
  { message: "Subject is too long.", path: ["subject"] }
).refine(
  (e) => !(e.grade && e.grade.length > 100),
  { message: "Grade is too long.", path: ["grade"] }
), documentsPerRoute = {
  "/your-information/your-highest-study": [
    "academicTranscript"
    /* AcademicTranscript */
  ],
  "/applications/{applicationId}/identity": [
    "passport",
    "photoId"
    /* PhotoId */
  ],
  "/applications/{applicationId}/education-history": [
    "academicTranscript"
    /* AcademicTranscript */
  ],
  "/applications/{applicationId}/personal-statement": [
    "personalStatement"
    /* PersonalStatement */
  ],
  "/applications/{applicationId}/employment": [
    "cv"
    /* CV */
  ],
  "/applications/{applicationId}/references": [
    "referenceLetter"
    /* ReferenceLetter */
  ],
  "/applications/{applicationId}/research-proposal": [
    "researchProposal"
    /* ResearchProposal */
  ],
  "/applications/{applicationId}/english-language": [
    "englishTest"
    /* EnglishTest */
  ],
  "/programmes/{offerId}/academic-transcript": [
    "academicTranscript"
    /* AcademicTranscript */
  ],
  "/programmes/{offerId}/academic-certificate": [
    "academicCertificate"
    /* AcademicCertificate */
  ],
  "/programmes/{offerId}/cv": [
    "cv"
    /* CV */
  ],
  "/programmes/{offerId}/english-language-certificate": [
    "englishTest"
    /* EnglishTest */
  ],
  "/programmes/{offerId}/letter-of-recommendation": [
    "referenceLetter"
    /* ReferenceLetter */
  ],
  "/programmes/{offerId}/passport": [
    "passport"
    /* Passport */
  ],
  "/programmes/{offerId}/personal-statement": [
    "personalStatement"
    /* PersonalStatement */
  ],
  "/programmes/{offerId}/photo-id": [
    "photoId"
    /* PhotoId */
  ],
  "/programmes/{offerId}/portfolio": [
    "portfolio"
    /* Portfolio */
  ],
  "/programmes/{offerId}/proof-of-address": [
    "proofOfAddress"
    /* ProofOfAddress */
  ],
  "/programmes/{offerId}/proof-of-name-change": [
    "proofOfNameChange"
    /* ProofOfNameChange */
  ],
  "/programmes/{offerId}/name-affidavit": [
    "nameAffidavit"
    /* NameAffidavit */
  ],
  "/programmes/{offerId}/birth-cert": [
    "birthCert"
    /* BirthCert */
  ],
  "/programmes/{offerId}/proof-of-immigration-status": [
    "proofOfImmigrationStatus"
    /* ProofOfImmigrationStatus */
  ],
  "/programmes/{offerId}/proof-of-managerial-experience": [
    "proofOfManagerialExperience"
    /* ProofOfManagerialExperience */
  ],
  "/programmes/{offerId}/proof-of-payment": [
    "proofOfPayment"
    /* ProofOfPayment */
  ],
  "/programmes/{offerId}/requirement-proof-of-payment": [
    "proofOfPayment"
    /* ProofOfPayment */
  ],
  "/programmes/{offerId}/research-proposal": [
    "researchProposal"
    /* ResearchProposal */
  ],
  "/programmes/{offerId}/{requirementId}": [
    "customRequirement"
    /* CustomRequirement */
  ]
}, ApplicantOfferRequirementTaskLevel = /* @__PURE__ */ ((e) => (e.Off = "Off", e.PreOffer = "PreOffer", e.Condition = "Condition", e.PreEnrolment = "PreEnrolment", e.AlwaysAvailable = "AlwaysAvailable", e))(ApplicantOfferRequirementTaskLevel || {}), ApplicantOfferRequirementTaskStatus = /* @__PURE__ */ ((e) => (e.Assess = "Assess", e.Satisfied = "Satisfied", e.Provisional = "Provisional", e.Condition = "Condition", e.Exempt = "Exempt", e.NotSatisfied = "NotSatisfied", e))(ApplicantOfferRequirementTaskStatus || {}), ApplicantOfferStatus = /* @__PURE__ */ ((e) => (e.Applied = "Applied", e.Draft = "Draft", e.Conditional = "Conditional", e.Unconditional = "Unconditional", e.Withdrawn = "Withdrawn", e.Rejected = "Rejected", e.Completed = "Completed", e))(ApplicantOfferStatus || {}), ApplicantOfferPaymentStatus = /* @__PURE__ */ ((e) => (e.Request = "Request", e.Review = "Review", e.Exempt = "Exempt", e.Approved = "Approved", e))(ApplicantOfferPaymentStatus || {}), ApplicantStatusReason = /* @__PURE__ */ ((e) => (e.EntryCriteriaNotMet = "EntryCriteriaNotMet", e.FailedAcademicAssessment = "FailedAcademicAssessment", e.FailedCredibilityAssessment = "FailedCredibilityAssessment", e.FraudulentApplication = "FraudulentApplication", e.CourseClosure = "CourseClosure", e.CourseFull = "CourseFull", e.UnableToOfferCourse = "UnableToOfferCourse", e.DeadlineHasPassed = "DeadlineHasPassed", e.ClosedByApplicant = "ClosedByApplicant", e.AcceptedByApplicant = "AcceptedByApplicant", e.CompletedByApplicant = "CompletedByApplicant", e.WithdrawnOnCompletion = "WithdrawnOnCompletion", e.WrongApplicationForm = "WrongApplicationForm", e.FailedPreCasInterview = "FailedPreCasInterview", e.FailedComplianceInterview = "FailedComplianceInterview", e.NegativeQualificationVerification = "NegativeQualificationVerification", e.DuplicateApplication = "DuplicateApplication", e.InactiveApplication = "InactiveApplication", e.RegionExclusiveToAgent = "RegionExclusiveToAgent", e.Other = "Other", e))(ApplicantStatusReason || {}), ApplicantOfferResponseStatus = /* @__PURE__ */ ((e) => (e.Accepted = "Accepted", e.Declined = "Declined", e))(ApplicantOfferResponseStatus || {}), EntryPoint = /* @__PURE__ */ ((e) => (e.Year0 = "Year 0", e.Year1 = "Year 1", e.Year2 = "Year 2", e.Year3 = "Year 3", e.Year4 = "Year 4", e.Year5 = "Year 5", e.Year6 = "Year 6", e))(EntryPoint || {}), ApplicantOfferPaymentMethod = /* @__PURE__ */ ((e) => (e.Deposit = "Deposit", e.Sponsorship = "Sponsorship", e.SLCFunding = "SLCFunding", e))(ApplicantOfferPaymentMethod || {}), ApplicantOfferPaymentSponsorType = /* @__PURE__ */ ((e) => (e.UkGovernment = "UkGovernment", e.BritishCouncil = "BritishCouncil", e.YourGovernment = "YourGovernment", e.InternationalOrganisation = "InternationalOrganisation", e.InternationalCompany = "InternationalCompany", e))(ApplicantOfferPaymentSponsorType || {}), PassportSchema = z.object({
  passportNo: z.string().min(1, { message: "Required" }),
  dateOfExpiry: z.string().min(1, { message: "Required" }).date(),
  dateOfIssue: z.string().min(1, { message: "Required" }).date(),
  passportIssuingAuthority: z.string().min(1, { message: "Required" })
}).superRefine((e, t) => {
  const { dateOfIssue: o, dateOfExpiry: i } = e;
  if (!o || !i) return;
  const d = new Date(o), s = new Date(i);
  d > /* @__PURE__ */ new Date() && t.addIssue({
    code: "custom",
    path: ["dateOfIssue"],
    message: "Date of issue should be earlier than today"
  }), d > s && t.addIssue({
    code: "custom",
    path: ["dateOfExpiry"],
    message: "Date of expiry should not be earlier than date of issue"
  });
}), SharedFormKeyNames = /* @__PURE__ */ ((e) => (e.EMAIL = "email", e.PREFERRED_NAME = "preferredName", e.MOBILE_NUMBER = "phoneNumber", e.NATIONALITY = "nationality", e.DOB = "dob", e.UNIVERSITY_ID = "universityId", e.INTAKE_ID = "intakeId", e.STUDY_LEVEL = "studyLevel", e.FEE_STATUS = "feeStatus", e.COURSE_ID = "courseId", e.MODE = "mode", e.CAMPUS = "campus", e.ENTRY_POINT = "entryPoint", e.COURSE_NAME = "courseName", e.PROGRAMME_CHOICES = "programmeChoices", e.DISABLE_EMAIL_NOTIFICATIONS = "disableEmailNotifications", e))(SharedFormKeyNames || {});
({ ...SharedFormKeyNames });
({ ...SharedFormKeyNames });
var ExclusiveAgentFormKeyNames = /* @__PURE__ */ ((e) => (e.AGENT_CONSENT = "agentConsent", e))(ExclusiveAgentFormKeyNames || {}), AgentFormKeyNames = {
  ...SharedFormKeyNames,
  ...ExclusiveAgentFormKeyNames
}, ProgrammeChoiceSchema = z.object({
  intakeId: intakeIdValidator.min(1, "Please select an intake"),
  intendedLevelOfStudy: z.nativeEnum(StudyLevel, { message: "Please select a study level" }),
  courseName: z.string().min(1, { message: "Please select a course name" }),
  mode: z.nativeEnum(StudyMode),
  campus: z.string().min(1),
  entryPoint: z.nativeEnum(EntryPoint),
  courseId: z.string().min(1, { message: "Please select a course" })
}), MIN_PASSWORD_LENGTH = 8, MAX_PASSWORD_LENGTH = 256, emailValidationSchema = z.string().trim().toLowerCase().email("Email is not valid."), minLengthSchema = z.string().min(MIN_PASSWORD_LENGTH, { message: "Password must be at least 8 characters long." }), maxLengthSchema = z.string().max(MAX_PASSWORD_LENGTH, { message: "Password must be maximum least 256 characters long." }), letterSchema = z.string().regex(/[a-zA-Z]/, { message: "Password must contain at least one letter." }), digitSchema = z.string().regex(/\d/, { message: "Password must contain at least one digit." }), specialCharSchema = z.string().regex(/[=+\-^$*.[\]{}()?"!@#%&/,><\\':;|_~`]+/, {
  message: "Password must contain at least one special character."
}), noWhitespaceSchema = z.string().regex(/^\S+$/, { message: "Password must not start or end with whitespace." }), passwordSchema = minLengthSchema.and(maxLengthSchema).and(letterSchema).and(digitSchema).and(specialCharSchema).and(noWhitespaceSchema);
z.object({
  clientId: z.string(),
  email: emailValidationSchema,
  newPassword: z.string().min(MIN_PASSWORD_LENGTH),
  session: z.string()
});
z.object({
  knownBy: z.string().trim().min(1).max(50, "Known by cannot exceed 50 characters.").regex(
    /^[a-zA-Z\s'-]+$/,
    "Use letters A–Z only, plus spaces, hyphens (-) or apostrophes ('). Accents and special characters aren’t supported"
  ),
  email: emailValidationSchema,
  marketing: z.boolean(),
  referrer: z.string()
});
var ApplicantLoginSchema = z.object({
  email: emailValidationSchema,
  password: passwordSchema
});
ApplicantLoginSchema.extend({
  code: z.string().optional()
});
z.object({
  studentAuthoriseAgent: z.coerce.boolean(),
  marketingConsent: z.boolean().optional()
});
var BasicApplicantExternalRegistrationSchema = z.object({
  email: z.string().email("Email is not valid.").max(128, "Email cannot exceed 128 characters."),
  disableEmailNotifications: z.boolean().optional(),
  preferredName: z.string().regex(
    /^[a-zA-Z\s'-]+$/,
    "Use letters A–Z only, plus spaces, hyphens (-) or apostrophes ('). Accents and special characters aren’t supported"
  ).min(1, "Preferred name is required").max(50, "Preferred name cannot exceed 50 characters."),
  universityId: z.string().min(2, "Institution is required"),
  programmeChoices: z.array(ProgrammeChoiceSchema).length(1, "You must select exactly one programme choice to proceed"),
  feeStatus: z.nativeEnum(FeeStatus, { message: "Fee status is required" }),
  nationality: z.string().min(3, "Nationality is required"),
  dob: z.string().min(1, "Date of birth is required").refine(
    (e) => {
      const [t, o, i] = e.split("-");
      return i && o && t && i.length === 2 && o.length === 2 && t.length === 4 && parseInt(i) <= 31 && parseInt(o) <= 12 && parseInt(t) > 1900;
    },
    { message: "Date of birth is incomplete or invalid." }
  ).refine(
    (e) => {
      const t = /* @__PURE__ */ new Date(), o = new Date(e);
      return o < t && o.toDateString() !== t.toDateString();
    },
    { message: "Date of birth cannot be in the future or today" }
  ).refine(
    (e) => {
      const [t, o, i] = e.split("-").map(Number), d = /* @__PURE__ */ new Date(), s = d.getMonth() + 1;
      return d.getFullYear() - t - (s < o || s === o && d.getDate() < i ? 1 : 0) > 13;
    },
    { message: "Must be older than 13 years old." }
  ),
  phoneNumber: z.string().min(1, "Phone number is required.").min(2, "Invalid phone number length.").regex(/^\d+(-\d+)*$/, "Invalid phone number.").refine((e) => e.includes("-"), { message: "Phone number must include country code." }).refine(
    (e) => {
      const [t, o] = e.split("-");
      return t && o && t.length && o.length && /^\d+$/.test(t) && /^\d+$/.test(o);
    },
    { message: "Invalid phone number." }
  )
});
BasicApplicantExternalRegistrationSchema.extend({
  [AgentFormKeyNames.AGENT_CONSENT]: z.boolean().refine((e) => e === !0, {
    message: "Agent consent is required"
  })
});
z.object({
  agent: z.null(),
  applicationId: z.string(),
  applicationStatus: z.nativeEnum(ApplicantStatus),
  courseId: z.string(),
  dob: z.string(),
  email: z.string().and(emailValidationSchema),
  familyName: z.string(),
  feeStatus: z.nativeEnum(FeeStatus),
  gender: z.nativeEnum(Gender),
  givenName: z.string(),
  hasAgent: z.null(),
  intakeId: z.string(),
  intendedLevelOfStudy: z.string(),
  isExistingStudent: z.boolean(),
  nationality: z.string(),
  pKey: z.string(),
  phoneNumber: z.string(),
  ucasId: z.string(),
  uni: z.string(),
  userId: z.string()
});
var DocumentKey = {
  academicTranscript: "academic-transcript",
  passport: "passport",
  personalStatement: "personal-statement",
  photoId: "photo-id",
  cv: "cv",
  englishTest: "english-test",
  referenceLetter: "letter-of-recommendation",
  academicCertificate: "academic-certificate",
  proofOfAddress: "proof-of-address",
  proofOfNameChange: "proof-of-name-change",
  nameAffidavit: "name-affidavit",
  birthCert: "birth-certificate",
  proofOfImmigrationStatus: "proof-of-immigration-status",
  proofOfManagerialExperience: "proof-of-managerial-experience",
  proofOfPayment: "proof-of-payment",
  portfolio: "portfolio",
  researchProposal: "research-proposal",
  customRequest: "custom-request",
  customRequirement: "custom-requirement"
}, phoneCountryCodes = {
  BD: "880",
  BE: "32",
  BF: "226",
  BG: "359",
  BA: "387",
  BB: "1246",
  WF: "681",
  BL: "590",
  BM: "1441",
  BN: "673",
  BO: "591",
  BH: "973",
  BI: "257",
  BJ: "229",
  BT: "975",
  JM: "1876",
  BV: "",
  BW: "267",
  WS: "685",
  BQ: "599",
  BR: "55",
  BS: "1242",
  JE: "441534",
  BY: "375",
  BZ: "501",
  RU: "7",
  RW: "250",
  RS: "381",
  TL: "670",
  RE: "262",
  TM: "993",
  TJ: "992",
  RO: "40",
  TK: "690",
  GW: "245",
  GU: "1671",
  GT: "502",
  GS: "",
  GR: "30",
  GQ: "240",
  GP: "590",
  JP: "81",
  GY: "592",
  GG: "441481",
  GF: "594",
  GE: "995",
  GD: "1473",
  GB: "44",
  GA: "241",
  SV: "503",
  GN: "224",
  GM: "220",
  GL: "299",
  GI: "350",
  GH: "233",
  OM: "968",
  TN: "216",
  JO: "962",
  HR: "385",
  HT: "509",
  HU: "36",
  HK: "852",
  HN: "504",
  HM: " ",
  VE: "58",
  PR: "1787 and 1939",
  PS: "970",
  PW: "680",
  PT: "351",
  SJ: "47",
  PY: "595",
  IQ: "964",
  PA: "507",
  PF: "689",
  PG: "675",
  PE: "51",
  PK: "92",
  PH: "63",
  PN: "870",
  PL: "48",
  PM: "508",
  ZM: "260",
  EH: "212",
  EE: "372",
  EG: "20",
  ZA: "27",
  EC: "593",
  IT: "39",
  VN: "84",
  SB: "677",
  ET: "251",
  SO: "252",
  ZW: "263",
  SA: "966",
  ES: "34",
  ER: "291",
  ME: "382",
  MD: "373",
  MG: "261",
  MF: "590",
  MA: "212",
  MC: "377",
  UZ: "998",
  MM: "95",
  ML: "223",
  MO: "853",
  MN: "976",
  MH: "692",
  MK: "389",
  MU: "230",
  MT: "356",
  MW: "265",
  MV: "960",
  MQ: "596",
  MP: "1670",
  MS: "1664",
  MR: "222",
  IM: "441624",
  UG: "256",
  TZ: "255",
  MY: "60",
  MX: "52",
  IL: "972",
  FR: "33",
  IO: "246",
  SH: "290",
  FI: "358",
  FJ: "679",
  FK: "500",
  FM: "691",
  FO: "298",
  NI: "505",
  NL: "31",
  NO: "47",
  NA: "264",
  VU: "678",
  NC: "687",
  NE: "227",
  NF: "672",
  NG: "234",
  NZ: "64",
  NP: "977",
  NR: "674",
  NU: "683",
  CK: "682",
  XK: "",
  CI: "225",
  CH: "41",
  CO: "57",
  CN: "86",
  CM: "237",
  CL: "56",
  CC: "61",
  CA: "1",
  CG: "242",
  CF: "236",
  CD: "243",
  CZ: "420",
  CY: "357",
  CX: "61",
  CR: "506",
  CW: "599",
  CV: "238",
  CU: "53",
  SZ: "268",
  SY: "963",
  SX: "599",
  KG: "996",
  KE: "254",
  SS: "211",
  SR: "597",
  KI: "686",
  KH: "855",
  KN: "1869",
  KM: "269",
  ST: "239",
  SK: "421",
  KR: "82",
  SI: "386",
  KP: "850",
  KW: "965",
  SN: "221",
  SM: "378",
  SL: "232",
  SC: "248",
  KZ: "7",
  KY: "1345",
  SG: "65",
  SE: "46",
  SD: "249",
  DO: "1809 and 1829",
  DM: "1767",
  DJ: "253",
  DK: "45",
  VG: "1284",
  DE: "49",
  YE: "967",
  DZ: "213",
  US: "1",
  UY: "598",
  YT: "262",
  UM: "1",
  LB: "961",
  LC: "1758",
  LA: "856",
  TV: "688",
  TW: "886",
  TT: "1868",
  TR: "90",
  LK: "94",
  LI: "423",
  LV: "371",
  TO: "676",
  LT: "370",
  LU: "352",
  LR: "231",
  LS: "266",
  TH: "66",
  TF: "",
  TG: "228",
  TD: "235",
  TC: "1649",
  LY: "218",
  VA: "379",
  VC: "1784",
  AE: "971",
  AD: "376",
  AG: "1268",
  AF: "93",
  AI: "1264",
  VI: "1340",
  IS: "354",
  IR: "98",
  AM: "374",
  AL: "355",
  AO: "244",
  AQ: "",
  AS: "1684",
  AR: "54",
  AU: "61",
  AT: "43",
  AW: "297",
  IN: "91",
  AX: "35818",
  AZ: "994",
  IE: "353",
  ID: "62",
  UA: "380",
  QA: "974",
  MZ: "258"
}, isValidPhoneCode = (e) => Object.values(phoneCountryCodes).includes(e), { PhoneNumberUtil } = googleLibphonenumber, jsonParser = (e) => z.preprocess((t, o) => {
  try {
    return typeof t == "string" ? JSON.parse(t) : t;
  } catch (i) {
    return o.addIssue({
      code: z.ZodIssueCode.custom,
      message: i instanceof Error ? i.message : "Invalid JSON format."
    }), z.NEVER;
  }
}, e), AttachDocumentSchema = z.object({
  sKey: z.string().nullable(),
  // Allow null for deletion, required for uploads
  s3Keys: z.array(z.string()).nullable()
  // Allow null for deletion, required for uploads
}), ProgrammeChoiceSchema2 = z.object({
  intakeId: intakeIdValidator.min(1, "Please select an intake"),
  intendedLevelOfStudy: z.nativeEnum(StudyLevel, { message: "Please select a study level" }),
  courseName: z.string().min(1, { message: "Please select a course name" }),
  mode: z.nativeEnum(StudyMode, { message: "Please select a study mode" }),
  campus: z.string().min(1, { message: "Please select a campus" }),
  entryPoint: z.nativeEnum(EntryPoint, { message: "Please select an entry year" }),
  courseId: z.string().min(1, { message: "Please select a course" })
}), MAX_PROGRAMME_CHOICES = 6, createProgrammeChoicesSchema = (e) => {
  let t = z.array(ProgrammeChoiceSchema2).min(1, "You must add at least one programme choice to proceed");
  return e && (t = t.max(MAX_PROGRAMME_CHOICES, "You have added the maximum number of choices")), z.object({
    programmeChoices: t.refine(
      (o) => {
        const i = /* @__PURE__ */ new Set();
        for (const d of o) {
          if (i.has(d.courseId))
            return !1;
          i.add(d.courseId);
        }
        return !0;
      },
      {
        message: "Duplicate programme combinations are not allowed"
      }
    )
  });
};
createProgrammeChoicesSchema(!1);
createProgrammeChoicesSchema(!0);
var AddressSchema = z.object({
  addressLine1: z.string().min(1, "Address Line 1 can't be empty").max(50, "Address Line 1 is too long"),
  addressLine2: z.string().max(50, "Address line 2 is too long").optional(),
  addressLine3: z.string().max(50, "Address line 3 is too long").optional(),
  city: z.string().min(1, "City can't be empty").max(50, "City is too long"),
  addressHasSubdivision: z.boolean().default(!1),
  subdivisionCode: z.string().max(10, "Subdivision code is too long").default(""),
  state: z.string().max(50, "State is too long").optional(),
  postcode: z.string().min(1, "Postcode can't be empty.").max(20, "Postcode is too long"),
  country: z.string()
}), employmentAddressSchema = AddressSchema.omit({
  addressLine1: !0,
  addressLine2: !0,
  addressLine3: !0,
  postcode: !0
}).extend({
  // These specific address fields have different names and this is to be maintained for backwards compatibility
  employerAddress: z.string().min(1, "Address line 1 cannot be empty").max(50, "Address line 1 is too long"),
  employerAddressLine2: z.string().max(50, "Address line 2 is too long").optional(),
  employerAddressLine3: z.string().max(50, "Address line 3 is too long").optional(),
  postalCode: z.string().min(1, "Postal code can't be empty.").max(20, "Postal code is too long")
});
z.object({
  feeStatus: z.nativeEnum(FeeStatus)
});
z.object({
  isVisaRequired: z.boolean()
});
z.object({
  highestQualification: z.string()
});
var PhoneNumberSchema = z.string().min(1, "Phone number is required.").min(2, "Invalid phone number length.").regex(/^\d+(-\d+)*$/, "Invalid phone number.").refine((e) => e.includes("-"), { message: "Phone number must include country code." }).refine(
  (e) => {
    const [t, o] = e.split("-");
    return t && o && t.length && o.length && /^\d+$/.test(t) && /^\d+$/.test(o);
  },
  { message: "Invalid phone number." }
).refine(
  (e) => {
    const [t] = e.split("-");
    return isValidPhoneCode(t);
  },
  { message: "Invalid country code." }
).refine(
  (e) => {
    const [t, o] = e.split("-");
    try {
      const i = PhoneNumberUtil.getInstance(), d = `${t}${o}`.replace(/[^0-9]/g, ""), s = i.parseAndKeepRawInput(`+${d}`);
      if (!i.isPossibleNumber(s))
        return !1;
      const r = i.isValidNumber(s), u = /^[0-9]{4}$/.test(t) && /^[0-9]{7}$/.test(o);
      return r || u;
    } catch {
      return t.length >= 1 && t.length <= 4 && o.length >= 7 && o.length <= 15;
    }
  },
  { message: "Your phone number is invalid or incomplete." }
);
z.object({
  nationality: z.string(),
  dob: z.string().date().refine(
    (e) => {
      const [t, o, i] = e.split("-");
      return i && o && t && i.length === 2 && o.length === 2 && t.length === 4 && parseInt(i) <= 31 && parseInt(o) <= 12 && parseInt(t) > 1900;
    },
    { message: "Date of birth is incomplete or invalid." }
  ).refine(
    (e) => {
      const t = /* @__PURE__ */ new Date(), o = new Date(e);
      return o < t && o.toDateString() !== t.toDateString();
    },
    { message: "Date of birth cannot be in the future or today" }
  ).refine(
    (e) => {
      const [t, o, i] = e.split("-").map(Number), d = /* @__PURE__ */ new Date(), s = d.getMonth() + 1;
      return d.getFullYear() - t - (s < o || s === o && d.getDate() < i ? 1 : 0) > 13;
    },
    { message: "Must be older than 13 years old." }
  ),
  phoneNumber: PhoneNumberSchema
});
var QualificationSchema = z.object({
  level: z.string().refine((e) => e in GradeLevel).optional(),
  levelLabel: z.string().optional(),
  qualificationTypeId: z.string().optional(),
  // For YHS: qualification type ID from database (e.g., "34", "125")
  qualificationTypeLabel: z.string().optional(),
  // For YHS: qualification type label (e.g., "Advanced Extension Award")
  otherQualificationName: z.string().nullish(),
  subject: z.string().optional(),
  gradeSystem: z.string().min(1, "Please select the grading system"),
  gradeSystemLabel: z.string().optional(),
  groupId: z.string().optional(),
  // For YHS: tracks which study group this qualification belongs to
  qualificationTypeRowId: z.string().optional(),
  // For YHS: tracks which specific studyRow (qualification type row) within the group this qualification belongs to
  grade: z.string().min(1, "Grade can't be empty").max(100, "Grade is too long."),
  graduationDate: z.string().optional().refine(
    (e) => {
      if (!e) return !0;
      const t = (/* @__PURE__ */ new Date()).getFullYear(), o = t - 130, i = t + 50, [d] = e.split("-"), s = d && d.length === 4 ? new Date(d).getFullYear() : void 0;
      return s && s > o && s < i;
    },
    { message: "Invalid date" }
  ),
  awardingOrganisationId: z.string().optional(),
  awardingOrganisationLabel: z.string().optional(),
  // Visibility flags from qualification type metadata (stored for future reference)
  awardingOrganisationVisible: z.boolean().optional(),
  modulesVisible: z.boolean().optional(),
  subjectsVisible: z.boolean().optional(),
  modules: z.array(ModuleSchema).optional()
}).superRefine((e, t) => {
  const { level: o, otherQualificationName: i } = e;
  o && GradeLevel[o] === "Other" && typeof i == "string" && i.trim() === "" && t.addIssue({
    code: z.ZodIssueCode.custom,
    message: "Qualification name is required",
    path: ["otherQualificationName"]
  });
});
z.object({
  otherQualificationName: z.string().nullish(),
  subject: z.string().min(1, "Subject can't be empty").max(100, "Subject is too long."),
  gradeSystem: z.string().optional(),
  gradeSystemLabel: z.string().optional(),
  grade: z.string().min(1, "Grade can't be empty").max(100, "Grade is too long."),
  graduationDate: z.string().optional().refine(
    (e) => {
      if (!e) return !0;
      const t = (/* @__PURE__ */ new Date()).getFullYear(), o = t - 130, i = t + 50, [d] = e.split("-"), s = d && d.length === 4 ? new Date(d).getFullYear() : void 0;
      return s && s > o && s < i;
    },
    { message: "Invalid date" }
  ),
  awardingOrganisationId: z.string().min(1, "Please select an awarding organisation"),
  awardingOrganisationLabel: z.string().optional(),
  modules: z.array(ModuleSchema)
});
var StudySchema = z.object({
  level: z.nativeEnum(PreviousStudyLevel).optional(),
  resultStatus: z.nativeEnum(ResultStatus),
  country: z.string().min(1, "Country can't be empty"),
  institutionName: z.string().min(1, "The name can't be empty"),
  institutionAddress: jsonParser(AddressSchema.omit({ country: !0 })),
  taughtInEnglish: z.boolean().optional(),
  // Persist Step 2 multi-type selections for Highest Study revisit/prefill
  qualificationTypeSelections: z.array(
    z.object({
      id: z.string().optional(),
      // unique identifier for this studyRow (to distinguish multiple rows with same qualificationType)
      qualificationType: z.string(),
      qualificationTypeLabel: z.string().optional(),
      customQualificationTypeName: z.string().optional(),
      gradingSystem: z.string(),
      gradingSystemLabel: z.string().optional(),
      groupId: z.string().optional(),
      resultStatus: z.nativeEnum(ResultStatus).optional(),
      // Per-group result status
      taughtInEnglish: z.boolean().optional()
      // Per-group taught in English
    })
  ).optional(),
  // Highest Study page does not collect study start/end dates yet.
  // Make them optional and validate only when provided.
  date: z.string().optional().refine(
    (e) => {
      if (!e) return !0;
      const t = (/* @__PURE__ */ new Date()).getFullYear(), o = t - 130, i = t + 50, [d, s] = e.split("-"), n = s && s.length === 2, r = d && d.length === 4 ? new Date(d).getFullYear() : void 0;
      return !!r && r > o && r < i && n;
    },
    { message: "Invalid date" }
  ),
  validUntil: z.string().optional().refine(
    (e) => {
      if (!e) return !0;
      const t = (/* @__PURE__ */ new Date()).getFullYear(), o = t - 130, i = t + 50, [d, s] = e.split("-"), n = s && s.length === 2, r = d && d.length === 4 ? new Date(d).getFullYear() : void 0;
      return !!r && r > o && r < i && n;
    },
    { message: "Invalid date" }
  ),
  academicTranscriptDocument: AttachDocumentSchema.optional(),
  qualifications: z.record(z.string(), QualificationSchema).optional()
}).superRefine((e, t) => {
  if (e.date) {
    const [i, d] = e.date.split("-");
    if (i && d && i.length === 4 && d.length === 2) {
      const s = /* @__PURE__ */ new Date(`${i}-${d}-01`), n = /* @__PURE__ */ new Date(), r = new Date(n.getFullYear(), n.getMonth(), 1);
      s > r && t.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["date"],
        message: "Start date cannot be in the future"
      });
    }
  }
  e.date && e.validUntil && new Date(e.date) >= new Date(e.validUntil) && t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["date"],
    message: "Start date could not be later then the end date"
  });
  const o = (i) => i !== void 0 && i.trim().length > 0;
  e.institutionAddress.addressHasSubdivision && (!o(e.institutionAddress.state) || !o(e.institutionAddress.subdivisionCode)) && t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["institutionAddress", "state"],
    message: "Please select a valid state/province for the selected country"
  });
});
z.object({
  studyHisitoryId: z.string().optional(),
  action: z.enum(["ADD", "UPDATE", "REMOVE"]),
  studyHistory: StudySchema.optional()
});
z.object({
  highest: StudySchema.optional(),
  previous: z.record(z.string(), StudySchema).optional()
});
z.object({
  firstApplicationStatus: z.nativeEnum(FirstApplicationStatus),
  ucasId: z.string().optional(),
  referralSource: z.nativeEnum(ReferralSource),
  studentReferrerName: z.string().optional(),
  previousApplicationOrStudentNumber: z.string().optional(),
  previousStudentNumber: z.string().optional()
}).refine(
  (e) => e.firstApplicationStatus === "FirstTime" ? e.referralSource !== void 0 : !0,
  {
    message: "Referral source is required for first-time applications",
    path: ["referralSource"]
  }
).refine(
  (e) => e.firstApplicationStatus === "AppliedOnly" ? e.previousApplicationOrStudentNumber !== void 0 && e.previousApplicationOrStudentNumber.trim() !== "" : !0,
  {
    message: "Previous application number is required when you have applied before",
    path: ["previousApplicationOrStudentNumber"]
  }
).refine(
  (e) => e.firstApplicationStatus === "StudiedBefore" ? e.previousStudentNumber !== void 0 && e.previousStudentNumber.trim() !== "" : !0,
  {
    message: "Previous student number is required when you have enrolled before",
    path: ["previousStudentNumber"]
  }
);
var OtherNameSchema = z.object({
  givenName: z.string().min(1),
  middleName: z.string().optional(),
  familyName: z.string().min(1),
  reason: z.string().min(1)
}), ApplicantIdentitySchema = z.object({
  givenName: z.string().regex(
    /^[a-zA-Z\s'-]+$/,
    "Use letters A–Z only, plus spaces, hyphens (-) or apostrophes ('). Accents and special characters aren’t supported"
  ).min(1, "Given name is required").max(128, "Given name is too long"),
  middleName: z.string().regex(
    /^[a-zA-Z\s'-]*$/,
    "Use letters A–Z only, plus spaces, hyphens (-) or apostrophes ('). Accents and special characters aren’t supported"
  ).max(128, "Middle name is too long").nullish().optional(),
  familyName: z.string().regex(
    /^[a-zA-Z\s'-]+$/,
    "Use letters A–Z only, plus spaces, hyphens (-) or apostrophes ('). Accents and special characters aren’t supported"
  ).max(128, "Family name is too long").min(1, "Family name is required"),
  title: z.string().min(1),
  gender: z.nativeEnum(Gender),
  genderIdentity: z.nativeEnum(GenderIdentity).optional(),
  passport: PassportSchema.nullish(),
  idType: z.nativeEnum(IDType),
  otherNames: z.record(z.string(), OtherNameSchema).nullish(),
  passportDocument: AttachDocumentSchema.optional(),
  idDocument: AttachDocumentSchema.optional()
});
ApplicantIdentitySchema.extend({
  hasOtherName: z.boolean(),
  otherNames: z.array(OtherNameSchema).nullish()
}).refine(
  (e) => {
    const { hasOtherName: t, otherNames: o } = e;
    return t ? (o ?? []).length !== 0 : !0;
  },
  { message: "Add other name", path: ["otherNames"] }
);
z.object({
  otherName: OtherNameSchema
});
z.object({
  otherNames: z.record(z.string(), OtherNameSchema).nullish()
});
var DisiblityTypeSchema = z.nativeEnum(DisabilityType);
z.object({
  ethnicity: z.nativeEnum(Ethnicity),
  hasDisability: z.boolean(),
  disabilityTypes: z.array(DisiblityTypeSchema).nullish().default(null),
  hasBeenInCare: z.boolean().nullish().default(null),
  careStartDate: z.string().nullish().default(null).refine(
    (e) => {
      if (e === null) return !0;
      const t = (/* @__PURE__ */ new Date()).getFullYear(), o = t - 130, i = t + 50, [d, s] = (e ?? "").split("-"), n = s && s.length === 2, r = d && d.length === 4 ? new Date(d).getFullYear() : void 0;
      return r && r > o && r < i && n;
    },
    { message: "Invalid date" }
  ),
  careEndDate: z.string().nullish().default(null).refine(
    (e) => {
      if (e === null) return !0;
      const t = (/* @__PURE__ */ new Date()).getFullYear(), o = t - 130, i = t + 50, [d, s] = (e ?? "").split("-"), n = s && s.length === 2, r = d && d.length === 4 ? new Date(d).getFullYear() : void 0;
      return r && r > o && r < i && n;
    },
    { message: "Invalid date" }
  ),
  careDetails: z.string().nullish().default(null),
  occupation: z.string().min(1, "Cannot be empty").nullish().default(null),
  disabilityTypeOther: z.string().nullish().default(null),
  lastSchoolDescription: z.string().nullish().default(null),
  hasParentsInHE: z.boolean().nullish().default(null),
  isDisabilityStudentAllowance: z.boolean().nullish().default(null)
});
var OtherNationalitySchema = z.object({
  isCurrent: z.boolean(),
  nationality: z.string()
}), ResidenceEntrySchema = z.object({
  countryOfResidence: z.string(),
  description: z.string().nullable(),
  areaOfResidence: z.string().nullable(),
  entryIntoUKDate: z.string().date().nullable()
}).refine(
  (e) => e.countryOfResidence === "United Kingdom" ? !!e.description : !0,
  {
    message: "Description is required for UK residence.",
    path: ["description"]
  }
).refine(
  (e) => e.countryOfResidence === "United Kingdom" ? !!e.entryIntoUKDate : !0,
  {
    message: "Date of entry into the UK is required.",
    path: ["entryIntoUKDate"]
  }
).refine(
  (e) => {
    if (e.countryOfResidence !== "United Kingdom")
      return !0;
    const { entryIntoUKDate: t } = e, [o, i, d] = typeof t == "string" ? t.split("-") : "";
    return d && i && o && d.length === 2 && i.length === 2 && o.length === 4 && parseInt(d) <= 31 && parseInt(i) <= 12 && parseInt(o) > 1900;
  },
  {
    message: "Date of entry into the UK is incomplete or invalid.",
    path: ["entryIntoUKDate"]
  }
).refine(
  (e) => {
    if (e.countryOfResidence !== "United Kingdom")
      return !0;
    const { entryIntoUKDate: t } = e, o = /* @__PURE__ */ new Date(), i = new Date(typeof t == "string" ? t : "");
    return i < o && i.toDateString() !== o.toDateString();
  },
  {
    message: "Date of entry into the UK cannot be in the future or today",
    path: ["entryIntoUKDate"]
  }
).refine(
  (e) => e.countryOfResidence === "United Kingdom" ? !!e.areaOfResidence : !0,
  {
    message: "Area of residence is required for UK residence.",
    path: ["areaOfResidence"]
  }
), OtherResidenceEntrySchema = z.object({
  countryOfResidence: z.string(),
  yearOfResidence: z.number()
}).refine(
  (e) => {
    const t = (/* @__PURE__ */ new Date()).getFullYear();
    return e.yearOfResidence <= t;
  },
  {
    message: "Year of residence cannot be in the future",
    path: ["yearOfResidence"]
  }
).refine(
  (e) => e.yearOfResidence >= 1900 && e.yearOfResidence.toString().length === 4,
  {
    message: "Please enter a valid 4-digit year (1900 or later)",
    path: ["yearOfResidence"]
  }
);
z.object({
  applyingFrom: z.string(),
  countryOfBirth: z.string(),
  nationalityForApplicationPurposes: z.string(),
  isOnlyCountry: z.boolean(),
  isOtherResidence: z.boolean(),
  otherNationalities: z.array(OtherNationalitySchema).nullish(),
  primaryResidence: ResidenceEntrySchema,
  otherResidences: z.array(OtherResidenceEntrySchema).nullish(),
  statementsCorrect: z.boolean()
}).refine(
  (e) => {
    const { isOnlyCountry: t, otherNationalities: o } = e;
    return t ? o && o.length > 0 : !0;
  },
  { message: "Other nationalities cannot be left empty", path: ["isOnlyCountry"] }
).refine(
  (e) => {
    const { isOtherResidence: t, otherResidences: o } = e;
    return t ? o && o.length > 0 : !0;
  },
  { message: "Other residences cannot be left empty", path: ["isOtherResidence"] }
);
var EmploymentHistorySchema = employmentAddressSchema.extend({
  jobTitle: z.string().min(1),
  employerName: z.string().min(1),
  type: z.nativeEnum(EmploymentType),
  startDate: z.string().refine(
    (e) => {
      const t = (/* @__PURE__ */ new Date()).getFullYear(), o = t - 130, i = t + 50, [d, s] = e.split("-"), n = s && s.length === 2, r = d && d.length === 4 ? new Date(d).getFullYear() : void 0;
      return r && r > o && r < i && n;
    },
    { message: "Invalid date" }
  ),
  endDate: z.string().refine(
    (e) => {
      if (e === void 0 || e === "") return !0;
      const [t] = e.split("-");
      if (t === void 0 || t === "") return !0;
      const o = (/* @__PURE__ */ new Date()).getFullYear(), i = o - 130, d = o + 50, s = t && t.length === 4 ? new Date(t).getFullYear() : void 0;
      return s && s > i && s < d;
    },
    { message: "Invalid year" }
  ).optional()
}).superRefine((e, t) => {
  e.endDate && new Date(e.startDate) >= new Date(e.endDate) && t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["endDate"],
    message: "End Date could not be earlier than the Start Date"
  });
  const o = (i) => i !== void 0 && i.trim().length > 0;
  e.addressHasSubdivision && (!o(e.subdivisionCode) || !o(e.state)) && t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["state"],
    message: "Please select a valid state/province for the selected country"
  });
}).superRefine((e, t) => {
  const { country: o, state: i, addressHasSubdivision: d, subdivisionCode: s } = e, n = (r) => !!(r && typeof r == "string" && r.trim().length > 0);
  d && (!n(s) || !n(i)) && t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["state"],
    message: "State/Province is required for the selected country"
  }), o === "United Kingdom" && !n(i) && t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["state"],
    message: "UK addresses require a county"
  });
});
z.object({
  hasEmploymentHistory: z.boolean(),
  hasCV: z.boolean().optional(),
  employmentHistory: z.array(EmploymentHistorySchema).nullish(),
  cvDocument: AttachDocumentSchema.optional()
});
var EnglishTestTakenBaseSchema = z.object({
  hasTakenTest: z.literal(!0),
  type: z.nativeEnum(EnglishTestType),
  typeOther: z.string().optional(),
  referenceNo: z.string(),
  score: z.string(),
  date: z.string().min(1, "English test date is required").refine(
    (e) => {
      const t = (/* @__PURE__ */ new Date()).getFullYear(), o = t - 130, i = t, [d, s] = e.split("-"), n = s && s.length === 2, r = d && d.length === 4 ? new Date(d).getFullYear() : void 0;
      return r && r > o && r <= i && n;
    },
    { message: "Invalid date" }
  ),
  validUntil: z.string().optional().refine(
    (e) => {
      if (!e) return !0;
      const t = (/* @__PURE__ */ new Date()).getFullYear(), o = t - 130, i = t + 50, [d, s] = e.split("-"), n = s && s.length === 2, r = d && d.length === 4 ? new Date(d).getFullYear() : void 0;
      return r && r > o && r <= i && n;
    },
    { message: "Invalid date" }
  )
}), EnglishTestNotTakenBaseSchema = z.object({
  hasTakenTest: z.literal(!1),
  reasonNotReqd: z.nativeEnum(EnglishTestNotReqdReason),
  reasonNotReqdOther: z.string().optional()
}), EnglishTestBaseUnion = z.discriminatedUnion("hasTakenTest", [
  EnglishTestTakenBaseSchema,
  EnglishTestNotTakenBaseSchema
]), EnglishTestSchema = EnglishTestBaseUnion.superRefine((e, t) => {
  if (e.hasTakenTest) {
    const { type: o, typeOther: i, score: d, referenceNo: s, date: n, validUntil: r } = e;
    if ((!d || d.trim() === "") && t.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["score"],
      message: "Test score is required"
    }), (!s || s.trim() === "") && t.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["referenceNo"],
      message: "Reference number is required"
    }), o === "Other" && (!i || i.trim() === "") && t.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["typeOther"],
      message: "Please specify the name of the English test"
    }), n) {
      const [u, l] = n.split("-");
      u && l && new Date(n) > /* @__PURE__ */ new Date() && t.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["date"],
        message: "The English Test Date cannot be later than today"
      });
    }
    if (n && r) {
      const [u, l] = n.split("-"), [c, g] = r.split("-");
      if (u && l && c && g) {
        const p = /* @__PURE__ */ new Date(`${u}-${l}-01`), m = /* @__PURE__ */ new Date(`${c}-${g}-01`);
        p > m && t.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["validUntil"],
          message: "The Valid Until date cannot be earlier than the Test Date."
        });
      }
    }
  } else if (e.hasTakenTest === !1) {
    const { reasonNotReqd: o, reasonNotReqdOther: i } = e;
    o === "Other/I don’t know" && (!i || i.trim() === "") && t.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Please provide an explanation",
      path: ["reasonNotReqdOther"]
    });
  }
});
z.object({
  hasEnglishTest: z.boolean(),
  englishTest: EnglishTestSchema,
  reasonNotReqd: z.nativeEnum(EnglishTestNotReqdReason).optional().nullish(),
  reasonNotReqdOther: z.string().optional().nullish(),
  englishQualification: z.string().optional().nullish(),
  englishTestDocument: AttachDocumentSchema.optional()
}).superRefine((e, t) => {
  e.englishTest.hasTakenTest !== e.hasEnglishTest && t.addIssue({
    code: z.ZodIssueCode.custom,
    message: "English test status mismatch",
    path: ["englishTest"]
  }), e.hasEnglishTest || (e.reasonNotReqd || t.addIssue({
    code: z.ZodIssueCode.custom,
    message: "Please select a reason why an English test is not required",
    path: ["reasonNotReqd"]
  }), e.reasonNotReqd === "My English can be assessed based on my previous academic qualification" && !e.englishQualification && t.addIssue({
    code: z.ZodIssueCode.custom,
    message: "Please select a qualification",
    path: ["englishQualification"]
  }), e.reasonNotReqd === "Other/I don’t know" && (!e.reasonNotReqdOther || e.reasonNotReqdOther.trim() === "") && t.addIssue({
    code: z.ZodIssueCode.custom,
    message: "Please provide an explanation",
    path: ["reasonNotReqdOther"]
  }));
});
z.object({
  residentialAddress: jsonParser(AddressSchema).nullish(),
  residentialPhoneNo: PhoneNumberSchema,
  contactAddressSameAsResidential: z.boolean(),
  contactAddress: jsonParser(AddressSchema.nullish()),
  termAddressSameAsPermanent: z.boolean().nullish().optional(),
  termAddress: jsonParser(AddressSchema.omit({ country: !0 }).nullish()),
  hasUkAccommodation: z.boolean().nullish().optional(),
  ukAccommodationType: z.string().refine((e) => e in UkAccommodationType).nullish(),
  ukAccommodationAddress: jsonParser(AddressSchema.omit({ country: !0 }).nullish()),
  ukAccommodationPhone: PhoneNumberSchema.nullish()
}).superRefine((e, t) => {
  e.residentialAddress?.addressHasSubdivision && (!e.residentialAddress.subdivisionCode || !e.residentialAddress.state) && t.addIssue({
    code: "custom",
    path: ["residentialAddress", "state"],
    message: "State/Province is required for the selected country"
  });
  const o = (i) => i !== void 0 && i.trim().length > 0;
  e.contactAddress?.addressHasSubdivision && (!o(e.contactAddress.subdivisionCode) || !o(e.contactAddress.state)) && t.addIssue({
    code: "custom",
    path: ["contactAddress", "state"],
    message: "State/Province is required for the selected country"
  }), e.termAddress?.addressHasSubdivision && (!o(e.termAddress.subdivisionCode) || !o(e.termAddress.state)) && t.addIssue({
    code: "custom",
    path: ["termAddress", "state"],
    message: "State/Province is required for the selected country"
  }), e.ukAccommodationAddress?.addressHasSubdivision && t.addIssue({
    code: "custom",
    path: ["ukAccommodationAddress", "state"],
    message: "UK accomodation does not require a state/province subdivision"
  }), e.contactAddressSameAsResidential === !1 && !e.contactAddress && t.addIssue({
    code: "custom",
    path: ["contactAddress"],
    message: "Contact address is required when contact address is different"
  }), e.termAddressSameAsPermanent === !1 && !e.termAddress && t.addIssue({
    code: "custom",
    path: ["termAddress"],
    message: "Term address is required when term address is different then permanent address"
  }), e.termAddressSameAsPermanent === !1 && !e.ukAccommodationType && t.addIssue({
    code: "custom",
    path: ["ukAccommodationType"],
    message: "Accomodation type is required"
  }), e.termAddressSameAsPermanent === !0 && e.termAddress && t.addIssue({
    code: "custom",
    path: ["termAddress"],
    message: "Term address should not be provided when it is the same as permanent address"
  }), e.hasUkAccommodation === !1 && e.ukAccommodationAddress && t.addIssue({
    code: "custom",
    path: ["ukAccommodationAddress"],
    message: "UK accommodation address should not be provided when you do not have UK accommodation"
  }), e.hasUkAccommodation && (e.ukAccommodationType || t.addIssue({
    code: "custom",
    path: ["ukAccommodationType"],
    message: "Accomodation type is required"
  }), e.ukAccommodationAddress || t.addIssue({
    code: "custom",
    path: ["ukAccommodationAddress"],
    message: "Accomodation address is required"
  }), e.ukAccommodationPhone || t.addIssue({
    code: "custom",
    path: ["ukAccommodationPhone"],
    message: "Phone number is required"
  })), e.contactAddress && e.contactAddress.country === "United Kingdom" && (o(e.contactAddress.state) || t.addIssue({
    code: "custom",
    path: ["contactAddress", "state"],
    message: "A UK county is required for the contact address"
  })), e.residentialAddress && e.residentialAddress.country === "United Kingdom" && (o(e.residentialAddress.state) || t.addIssue({
    code: "custom",
    path: ["residentialAddress", "state"],
    message: "A UK county is required for the residential address"
  })), e.ukAccommodationAddress && (o(e.ukAccommodationAddress.state) || t.addIssue({
    code: "custom",
    path: ["ukAccommodationAddress", "state"],
    message: "A UK county is required for the UK accommodation address"
  })), e.termAddress && (o(e.termAddress.state) || t.addIssue({
    code: "custom",
    path: ["termAddress", "state"],
    message: "A UK county is required for the term address"
  }));
});
var VisaNotListedOption = z.object({
  visaNotListedCustomValue: z.string().nullish()
}), UkStudentVisaSchema = z.object({
  studentVisaType: z.string().refine((e) => e in VisaType),
  levelOfStudy: z.string().refine((e) => e in VisaLevelOfStudy),
  visaReceivedYear: z.number().gt(1900).lte((/* @__PURE__ */ new Date()).getFullYear()),
  isCourseCompleted: z.boolean(),
  compareCourse: z.string().refine((e) => e in CourseCompare)
}).merge(VisaNotListedOption), UkNonStudentVisasSchema = z.object({
  studentVisaType: z.string().refine((e) => e in VisaOrPermitType),
  issuedDate: z.string().date("Date format is DD MM YYYY").refine(
    (e) => {
      const [t, o, i] = e.split("-");
      return i && o && t && i.length === 2 && o.length === 2 && t.length === 4 && parseInt(i) <= 31 && parseInt(o) <= 12 && parseInt(t) > 1900;
    },
    { message: "Issue date is incomplete or invalid." }
  ).refine(
    (e) => {
      const t = /* @__PURE__ */ new Date(), o = new Date(e);
      return o < t && o.toDateString() !== t.toDateString();
    },
    { message: "Issue date cannot be in the future or today" }
  ),
  validTill: z.string().optional().refine(
    (e) => {
      if (!e || e.trim() === "") return !0;
      const [t, o, i] = e.split("-");
      return i && o && t && i.length === 2 && o.length === 2 && t.length === 4 && parseInt(i) <= 31 && parseInt(o) <= 12 && parseInt(t) > 1900;
    },
    { message: "Valid until date is incomplete or invalid." }
  ).refine(
    (e) => {
      if (!e || e.trim() === "") return !0;
      const t = new Date(e), [o, i, d] = e.split("-").map(Number);
      return !isNaN(t.getTime()) && t.getFullYear() === o && t.getMonth() + 1 === i && t.getDate() === d;
    },
    { message: "Please enter a valid date." }
  )
}).merge(VisaNotListedOption).superRefine((e, t) => {
  const o = new Date(e.issuedDate), i = e.validTill ? new Date(e.validTill) : null;
  i && o > i && t.addIssue({
    code: "custom",
    path: ["issuedDate"],
    message: "Issued date should be less than valid till date"
  }), VisaOrPermitType[e.studentVisaType] === "My visa or permit are not listed" && (!e.visaNotListedCustomValue || e.visaNotListedCustomValue.trim().length < 1) && t.addIssue({
    code: "custom",
    path: ["visaNotListedCustomValue"],
    message: 'Custom visa or permit type is required when student visa type is "My visa or permit are not listed"'
  });
}), UkVisaRefusalSchema = z.object({
  refusedVisaType: z.string().refine((e) => e in RefusedVisaType),
  visaRefusalYear: z.number({ invalid_type_error: "Must be a number" }).min(1900).max((/* @__PURE__ */ new Date()).getFullYear())
}), NonUkVisaRefusalSchema = z.object({
  visaRefusalCountry: z.string(),
  isStudentVisaRefused: z.boolean(),
  visaRefusalYear: z.number({ invalid_type_error: "Must be a number" }).min(1900).max((/* @__PURE__ */ new Date()).getFullYear())
});
function isEmptyOrNonExistentArray(e) {
  return !e || !Array.isArray(e) || e.length === 0;
}
z.object({
  isVisaRequired: z.boolean().nullish(),
  //Overseas
  visaExemptionReason: z.string().nullish(),
  //Overseas
  hasVisaForCurrentOrPreviousUkStudy: z.boolean().nullish(),
  //Overseas
  hasStudentVisaForThisUkStudy: z.boolean().nullish(),
  //Overseas
  ukStudentVisas: z.array(UkStudentVisaSchema).nullish(),
  //Overseas
  hasEuEeaSwitzerlandExperience: z.boolean().nullish(),
  //ALL (HOME AND Overseas and British or Irish)
  hasEuFamilyMember: z.boolean().nullish(),
  //ALL (HOME AND Overseas and British or Irish)
  hasNonStudentVisaOrPermit: z.boolean().nullish(),
  // HOME (non British or Irish) AND Overseas
  ukNonStudentVisaOrPermit: z.array(UkNonStudentVisasSchema).nullish(),
  // HOME (non British or Irish) AND Overseas
  hasPreviousVisaRefusal: z.boolean().nullish(),
  //Overseas
  ukVisaRefusals: z.array(UkVisaRefusalSchema).nullish(),
  //Overseas
  hasPreviousNonUkVisaRefusal: z.boolean().nullish(),
  //Overseas
  nonUkVisaRefusals: z.array(NonUkVisaRefusalSchema).nullish()
  //Overseas
}).superRefine((e, t) => {
  [
    {
      condition: e.isVisaRequired === !1 && !e.visaExemptionReason,
      path: "visaExemptionReason",
      message: "Specify visa not required reason"
    },
    {
      condition: e.hasStudentVisaForThisUkStudy && isEmptyOrNonExistentArray(e.ukStudentVisas),
      path: "ukStudentVisas",
      message: "Specify your current or previous UK study visas"
    },
    {
      condition: e.hasNonStudentVisaOrPermit && isEmptyOrNonExistentArray(e.ukNonStudentVisaOrPermit),
      path: "ukNonStudentVisaOrPermit",
      message: "Specify your UK permit or non-student visas"
    },
    {
      condition: e.hasPreviousVisaRefusal && isEmptyOrNonExistentArray(e.ukVisaRefusals),
      path: "ukVisaRefusals",
      message: "Specify if visa is required"
    },
    {
      condition: e.hasPreviousNonUkVisaRefusal && isEmptyOrNonExistentArray(e.nonUkVisaRefusals),
      path: "nonUkVisaRefusals",
      message: "Specify your non-UK visa refusals"
    },
    {
      condition: e.hasEuEeaSwitzerlandExperience === void 0,
      path: "hasEuEeaSwitzerlandExperience",
      message: "Required"
    },
    {
      condition: e.hasEuFamilyMember === void 0,
      path: "hasEuFamilyMember",
      message: "Required"
    }
  ].forEach((i) => {
    i.condition && t.addIssue({
      code: "custom",
      path: [i.path],
      message: i.message
    });
  });
});
var GradingSystemSchema = z.object({
  id: z.number(),
  label: z.string()
});
z.object({
  id: z.number(),
  label: z.string(),
  awardingOrganisationsVisible: z.boolean(),
  modulesVisible: z.boolean(),
  subjectsVisible: z.boolean(),
  gradingSystems: z.array(GradingSystemSchema)
});
z.object({
  id: z.number(),
  label: z.string(),
  acronym: z.string()
});
z.object({
  uni: z.string(),
  userId: z.string(),
  applicationId: z.string(),
  isDuplicate: z.boolean(),
  studentNo: z.string().optional()
});
z.object({
  givenName: z.string().min(1, "Given name is required").max(100, "Given name is too long"),
  middleName: z.string().optional(),
  familyName: z.string().min(1, "Family name is required").max(100, "Family name is too long"),
  email: z.string().email("Please enter a valid email address"),
  nationality: z.string().min(1, "Nationality is required"),
  feeStatus: z.nativeEnum(FeeStatus),
  highestQualificationCode: z.string().optional(),
  agentId: z.string().min(1, "Agent selection is required"),
  isVisaRequired: z.boolean().optional(),
  dob: z.string().date().refine(
    (e) => {
      const [t, o, i] = e.split("-");
      return i && o && t && i.length === 2 && o.length === 2 && t.length === 4 && parseInt(i) <= 31 && parseInt(o) <= 12 && parseInt(t) > 1900;
    },
    { message: "Date of birth is incomplete or invalid." }
  ).refine(
    (e) => {
      const t = /* @__PURE__ */ new Date(), o = new Date(e);
      return o < t && o.toDateString() !== t.toDateString();
    },
    { message: "Date of birth cannot be in the future or today" }
  ).refine(
    (e) => {
      const [t, o, i] = e.split("-").map(Number), d = /* @__PURE__ */ new Date(), s = d.getMonth() + 1;
      return d.getFullYear() - t - (s < o || s === o && d.getDate() < i ? 1 : 0) > 13;
    },
    { message: "Must be older than 13 years old." }
  ),
  phoneNumber: z.string().includes("-").min(2).regex(/^\d+(-\d+)*$/, "Invalid phone number.")
});
z.object({
  primaryFundingSource: z.nativeEnum(FundingOption),
  otherSourceOfFunding: z.string().nullish(),
  isSLCGrant: z.boolean().nullish(),
  isSLCLoan: z.boolean().nullish(),
  isPlanningToWork: z.boolean()
});
z.object({
  hasPersonalStatementDocument: z.boolean(),
  personalStatementDocument: AttachDocumentSchema.optional()
});
z.object({
  hasResearchProposalDocument: z.boolean(),
  researchProposalDocument: AttachDocumentSchema.optional()
});
var RefereeSchema = AddressSchema.extend({
  name: z.string().min(1, "Name can't be empty"),
  email: z.string().email(),
  phone: PhoneNumberSchema,
  relationship: z.nativeEnum(ApplicationRefereeRelation, { message: "Please provide the value" }),
  otherRelationshipDetails: z.string().optional(),
  organisation: z.string().min(1, "Organisation can't be empty"),
  occupation: z.string().min(1, "Occupation can't be empty"),
  yearsKnown: z.number()
}).superRefine((e, t) => {
  e.relationship === "Other" && !e.otherRelationshipDetails && t.addIssue({
    code: "custom",
    path: ["otherRelationshipDetails"],
    message: "Other Relationship details are required"
  });
  const o = (i) => i !== void 0 && i.trim().length > 0;
  e.addressHasSubdivision && (!o(e.subdivisionCode) || !o(e.state)) && t.addIssue({
    code: "custom",
    path: ["state"],
    message: "State/Province is required when the address has a subdivision"
  }), e.country === "United Kingdom" && (o(e.state) || t.addIssue({
    code: "custom",
    path: ["state"],
    message: "County is required for United Kingdom addresses"
  }));
});
z.object({
  hasReferee: z.boolean(),
  references: z.array(RefereeSchema).nullish(),
  referenceLetterDocument: AttachDocumentSchema.optional()
});
var AgentSchema = z.object({
  name: z.string().nullish(),
  agency: z.string().nullish(),
  email: z.string().email().nullish()
}), OtherPresentative = z.object({
  relation: z.string().nullish(),
  name: z.string().nullish()
}), RepresentationSchema = z.object({
  hasRepresentative: z.boolean({
    required_error: "Please select whether anyone is helping you submit your application"
  }),
  isHelpedByAgent: z.boolean().optional(),
  isHelpedByFamilyMember: z.boolean().optional(),
  isHelpedByFriend: z.boolean().optional(),
  isHelpedBySchoolCounsellor: z.boolean().optional(),
  isHelpedByTeacher: z.boolean().optional(),
  isHelpedByStudent: z.boolean().optional(),
  isHelpedByOther: z.boolean().optional(),
  studentName: z.string().nullish(),
  teacherName: z.string().nullish(),
  schoolCounsellorName: z.string().nullish(),
  friendName: z.string().nullish(),
  familyMemberName: z.string().nullish(),
  consent: z.boolean().nullish(),
  agent: AgentSchema.nullish(),
  otherPresentative: OtherPresentative.nullish()
}).superRefine((e, t) => {
  if (e.hasRepresentative === !0) {
    const i = [
      e.isHelpedByAgent,
      e.isHelpedByFamilyMember,
      e.isHelpedByFriend,
      e.isHelpedBySchoolCounsellor,
      e.isHelpedByTeacher,
      e.isHelpedByStudent,
      e.isHelpedByOther
    ];
    i.some((d) => d === !0) || t.addIssue({
      code: "custom",
      path: ["representationType"],
      message: "At least one representation type must be selected"
    }), i.some((d) => d === !0) && e?.consent === void 0 && t.addIssue({
      code: "custom",
      path: ["consent"],
      message: "Consent is required"
    });
  }
  const o = [
    {
      condition: e.isHelpedByAgent && !e.agent?.name,
      path: "agent.name",
      message: "Agent name is required"
    },
    {
      condition: e.isHelpedByAgent && !e.agent?.email,
      path: "agent.email",
      message: "Agent email is required"
    },
    {
      condition: e.isHelpedByAgent && !e.agent?.agency,
      path: "agent.agency",
      message: "Agent agency is required"
    },
    {
      condition: e.isHelpedByFamilyMember && !e.familyMemberName,
      path: "familyMemberName",
      message: "Family member name is required"
    },
    {
      condition: e.isHelpedByFriend && !e.friendName,
      path: "friendName",
      message: "Friend name is required"
    },
    {
      condition: e.isHelpedBySchoolCounsellor && !e.schoolCounsellorName,
      path: "schoolCounsellorName",
      message: "School counsellor name is required"
    },
    {
      condition: e.isHelpedByTeacher && !e.teacherName,
      path: "teacherName",
      message: "Teacher name is required"
    },
    {
      condition: e.isHelpedByStudent && !e.studentName,
      path: "studentName",
      message: "Student name is required"
    },
    {
      condition: e.isHelpedByOther && !e.otherPresentative?.name,
      path: "otherPresentative.name",
      message: "Other person name is required"
    },
    {
      condition: e.isHelpedByOther && !e.otherPresentative?.relation,
      path: "otherPresentative.relation",
      message: "Other person relation is required"
    }
  ];
  for (const i of o)
    i.condition && t.addIssue({
      code: "custom",
      path: [i.path],
      message: i.message
    });
});
z.object({
  representative: RepresentationSchema.optional()
});
z.object({
  interruptedStudy: z.boolean(),
  criminalConvictions: z.boolean().nullish(),
  detailedInterruptionReason: z.string().nullish(),
  offenceDetails: z.string().nullish()
}).superRefine((e, t) => (e.interruptedStudy === !0 && (e.detailedInterruptionReason?.trim?.()?.length || t.addIssue({
  code: z.ZodIssueCode.custom,
  message: "Detailed interruption reason is required when study was interrupted",
  path: ["detailedInterruptionReason"]
})), e?.criminalConvictions === !0 && (e.offenceDetails?.trim?.()?.length || t.addIssue({
  code: z.ZodIssueCode.custom,
  message: "Offence details are required when criminal convictions exist",
  path: ["offenceDetails"]
})), !0));
var InformationProcessingConsentSchema = z.object({
  informationProcessingConsent: z.boolean().refine((e) => e === !0, {
    message: "You must agree to the information processing consent."
  })
}), PrivacyPolicyConsentSchema = z.object({
  privacyPolicyConsent: z.boolean().refine((e) => e === !0, {
    message: "You must agree to the privacy policy."
  })
}), TermsAndConditionsConsentSchema = z.object({
  termsAndConditionsConsent: z.boolean().refine((e) => e === !0, {
    message: "You must agree to the terms and conditions."
  })
}), AccuracyOfDataConsentSchema = z.object({
  accuracyOfDataConsent: z.boolean().refine((e) => e === !0, {
    message: "You must confirm the accuracy of the provided data."
  })
});
z.object({
  ...InformationProcessingConsentSchema.shape,
  ...PrivacyPolicyConsentSchema.shape,
  ...TermsAndConditionsConsentSchema.shape,
  ...AccuracyOfDataConsentSchema.shape
});
z.object({
  agentId: z.string()
});
var ApplyRequirementIdMapping = {
  Passport: "/programmes/{offerId}/passport",
  PhotoID: "/programmes/{offerId}/photo-id",
  AcademicResults: "/programmes/{offerId}/academic-results",
  FinalAcademicResults: "/programmes/{offerId}/final-academic-results",
  AcademicCertificate: "/programmes/{offerId}/academic-certificate",
  AcademicTranscript: "/programmes/{offerId}/academic-transcript",
  EnglishLanguageResults: "/programmes/{offerId}/english-language-results",
  EnglishLanguageCertificate: "/programmes/{offerId}/english-language-certificate",
  CV: "/programmes/{offerId}/cv",
  ProofOfManagerialExperience: "/programmes/{offerId}/proof-of-managerial-experience",
  ProofOfAddress: "/programmes/{offerId}/proof-of-address",
  ProofOfNameChange: "/programmes/{offerId}/proof-of-name-change",
  NameAffidavit: "/programmes/{offerId}/name-affidavit",
  BirthCert: "/programmes/{offerId}/birth-cert",
  ProofOfImmigrationStatus: "/programmes/{offerId}/proof-of-immigration-status",
  Payment: "/programmes/{offerId}/requirement-payment",
  ProofOfPayment: "/programmes/{offerId}/requirement-proof-of-payment",
  LetterOfRecommendation: "/programmes/{offerId}/letter-of-recommendation",
  PersonalStatement: "/programmes/{offerId}/personal-statement",
  ResearchProposal: "/programmes/{offerId}/research-proposal",
  Portfolio: "/programmes/{offerId}/portfolio",
  RefereeDetails: "/programmes/{offerId}/referee-details",
  Custom: "/programmes/{offerId}/{requirementId}"
  /* Custom */
};
function buildRequirementSlugMap() {
  const e = {};
  for (const [t, o] of Object.entries(ApplyRequirementIdMapping)) {
    if (!o)
      continue;
    const i = o.split("/").pop();
    if (!i || i.includes("{"))
      continue;
    const d = documentsPerRoute[o];
    if (!d || d.length === 0)
      continue;
    const [s] = d;
    if (e[i])
      throw new Error(
        `Duplicate requirement slug mapping detected for "${i}": existing=${e[i].requirementId} (${e[i].route}), new=${t} (${o})`
      );
    e[i] = {
      requirementId: t,
      route: o,
      docType: s,
      docKey: DocumentKey[s] ?? `${i}-1`
    };
  }
  return e;
}
buildRequirementSlugMap();
var DepositAmountDetailSchema = z.object({
  depositAmount: z.number({
    message: "Please provide the amount"
  }).min(0, "Please provide the amount"),
  paymentDate: z.string({
    message: "Please provide the date"
  }).date()
}).superRefine((e, t) => {
  const { paymentDate: o } = e;
  new Date(o) > /* @__PURE__ */ new Date() && t.addIssue({
    code: "custom",
    path: ["paymentDate"],
    message: "Payment date should not be future date"
  });
}), SponsorshipDetailSchema = z.object({
  sponsorType: z.nativeEnum(ApplicantOfferPaymentSponsorType, { message: "Please provide the type" }),
  sponsorName: z.string({ message: "Please provide the name" }).min(1, "Please provide the name"),
  isSponsorOrgMultinational: z.boolean().optional().nullish()
}).superRefine((e, t) => {
  const { sponsorType: o, isSponsorOrgMultinational: i } = e;
  [
    "InternationalOrganisation",
    "InternationalCompany"
    /* InternationalCompany */
  ].includes(o) && typeof i != "boolean" && t.addIssue({
    code: "custom",
    path: ["isSponsorOrgMultinational"],
    message: "Provide sponsor global presence information"
  });
}), crnMessage = "Please enter a valid Customer Reference Number (CRN) with 11 characters", ssnMessage = "Please enter a valid Student Support Number (SSN) with 13 characters", SLCDetailSchema = z.object({
  customerRefNumber: z.string({ message: crnMessage }).length(11, crnMessage).regex(/^[a-zA-Z0-9]+$/, crnMessage),
  studentSupportNumber: z.string({ message: ssnMessage }).length(13, ssnMessage).regex(/^[a-zA-Z0-9]+$/, ssnMessage)
}), defaultRefineFn = (e, t) => {
  const { paymentMethod: o, depositDetail: i, sponsorshipDetail: d, slcDetail: s } = e;
  o === "Deposit" && !i ? t.addIssue({
    code: "custom",
    path: ["depositDetail"],
    message: "Provide deposit detail"
  }) : o === "Sponsorship" && !d ? t.addIssue({
    code: "custom",
    path: ["sponsorshipDetail"],
    message: "Provide sponsorship detail"
  }) : o === "SLCFunding" && !s && t.addIssue({
    code: "custom",
    path: ["slcDetail"],
    message: "Provide student loan company details"
  });
}, ProofOfPaymentSchema = z.object({
  fileName: z.string().nullable(),
  // Allow null for deletion, required for uploads
  s3Keys: z.array(z.string()).nullable(),
  // Allow null for deletion, required for uploads
  sKey: z.string().nullable(),
  // Allow null for deletion, required for uploads
  urls: z.array(z.string()).optional(),
  status: z.nativeEnum(ApplicantOfferPaymentStatus).optional().nullish(),
  statusInternalNote: z.string().optional().nullish()
});
z.object({
  paymentMethod: z.nativeEnum(ApplicantOfferPaymentMethod, { message: "Please provide the value" }),
  depositDetail: DepositAmountDetailSchema.optional().nullish(),
  sponsorshipDetail: SponsorshipDetailSchema.optional().nullish(),
  slcDetail: SLCDetailSchema.optional().nullish(),
  proofOfPayment: ProofOfPaymentSchema.optional().nullish(),
  status: z.nativeEnum(ApplicantOfferPaymentStatus).optional().nullish(),
  statusInternalNote: z.string().optional().nullish()
}).superRefine((e, t) => {
  defaultRefineFn(e, t);
});
z.object({
  status: z.nativeEnum(ApplicantOfferPaymentStatus),
  statusInternalNote: z.string().optional()
});
var DocumentFulfilmentSchema = z.object({
  sKey: z.string().nullable(),
  // Allow null for deletion, required for uploads
  s3Keys: z.array(z.string()).nullable(),
  // Allow null for deletion, required for uploads
  urls: z.array(z.string()).optional(),
  linkText: z.string().optional(),
  isDeleted: z.boolean().optional()
});
z.object({
  text: z.string().optional(),
  subtext: z.string().optional()
});
var PassportFulfilmentSchema = DocumentFulfilmentSchema;
PassportFulfilmentSchema.extend({
  passport: PassportSchema
});
z.object({
  studyHistory: StudySchema
});
z.object({
  englishTest: EnglishTestSchema
});
z.object({
  referees: z.array(RefereeSchema).min(1, "At least one referee is required")
});
z.object({
  paymentMethod: z.nativeEnum(ApplicantOfferPaymentMethod, { message: "Please provide the value" }),
  depositDetail: DepositAmountDetailSchema.optional().nullish(),
  sponsorshipDetail: SponsorshipDetailSchema.optional().nullish(),
  slcDetail: SLCDetailSchema.optional().nullish(),
  statusInternalNote: z.string().optional().nullish()
}).superRefine((e, t) => {
  defaultRefineFn(e, t);
});
z.object({
  s3Keys: z.array(z.string()),
  fileNames: z.array(z.string()).optional(),
  urls: z.array(z.string()).optional()
});
z.object({
  status: z.nativeEnum(ApplicantOfferStatus),
  conditions: z.array(z.string()).optional(),
  assess: z.array(z.string()).optional(),
  startText: z.string().optional(),
  endText: z.string().optional(),
  statusReason: z.nativeEnum(ApplicantStatusReason).optional(),
  statusInternalNote: z.string().optional(),
  statusExplanationToApplicant: z.string().optional(),
  notifyApplicant: z.boolean().optional()
}).superRefine((e, t) => {
  const { status: o, conditions: i, statusReason: d } = e;
  return [
    "Conditional",
    "Unconditional"
    /* Unconditional */
  ].includes(o) && i === void 0 && t.addIssue({
    code: "custom",
    path: ["conditions"],
    message: `Status ${o} requires conditions`
  }), [
    "Withdrawn",
    "Rejected"
    /* Rejected */
  ].includes(o) && !d && t.addIssue({
    code: "custom",
    path: ["statusReason"],
    message: `Status ${o} requires status reason`
  }), !0;
});
z.object({
  startText: z.string().optional(),
  endText: z.string().optional()
}).superRefine((e, t) => {
  const { startText: o, endText: i } = e;
  return !o && !i && t.addIssue({
    code: "custom",
    path: ["startText", "endText"],
    message: "start text or end text is required"
  }), !0;
});
z.object({
  status: z.nativeEnum(ApplicantOfferRequirementTaskStatus),
  noteText: z.string().nullish(),
  conditionText: z.string().optional()
}).superRefine((e, t) => {
  const { status: o, noteText: i, conditionText: d } = e;
  return o === "Condition" && !d && t.addIssue({
    code: "custom",
    path: ["conditionText"],
    message: `ConditionText required when updating to status ${o}`
  }), [].includes(o) && !i && t.addIssue({
    code: "custom",
    path: ["noteText"],
    message: `Reason required when updating to status ${o}`
  }), !0;
});
z.object({
  level: z.nativeEnum(ApplicantOfferRequirementTaskLevel)
}).refine((e) => e.level !== "Off", {
  message: "Level cannot be set to Off",
  path: ["level"]
});
z.object({
  noteText: z.string().nullish()
});
var FixedScholarshipSchema = z.object({
  name: z.string(),
  type: z.literal(
    "FIXED"
    /* FIXED */
  ),
  amount: z.number()
}), PercentageScholarshipSchema = z.object({
  name: z.string(),
  type: z.literal(
    "PERCENTAGE"
    /* PERCENTAGE */
  ),
  percentage: z.number()
}), ScholarshipSchema = z.discriminatedUnion("type", [FixedScholarshipSchema, PercentageScholarshipSchema]), UpdateApplicantOfferProgrammeDetailsSchema = z.object({
  entryPoint: z.nativeEnum(EntryPoint),
  startDate: z.string().date(),
  endDate: z.string().date(),
  fee: z.number(),
  feeTotal: z.number().optional(),
  scholarships: z.array(ScholarshipSchema).optional(),
  campus: z.string().optional()
});
UpdateApplicantOfferProgrammeDetailsSchema.extend({
  intakeId: z.string(),
  courseId: z.string()
});
z.object({
  applicantStatus: z.nativeEnum(ApplicantOfferResponseStatus)
});
var CreateApplicantOfferRequirementTaskSchema = z.object({
  requirementId: z.string(),
  requirementText: z.string().optional(),
  conditionText: z.string().optional()
}).superRefine((e, t) => {
  e.requirementText && (!e.conditionText || !e.conditionText.trim()) && t.addIssue({
    code: "custom",
    path: ["conditionText"],
    message: "conditionText is required for custom requirements"
  });
});
z.object({
  requirements: z.array(CreateApplicantOfferRequirementTaskSchema)
});
z.object({});
var noSpecialChars = /^[a-zA-Z0-9_ ():,&-]*$/, safeString = z.string().regex(noSpecialChars, {
  message: "Only letters, numbers, _, -, :, ,, &, (,) and spaces are allowed"
});
z.object({
  p_key: safeString.optional(),
  s_key: safeString.optional(),
  username: z.string().optional(),
  lastModified: z.string().optional(),
  shortId: safeString,
  name: safeString,
  shortName: safeString.optional(),
  availableHome: z.boolean(),
  feeHome: z.number().nonnegative().optional(),
  feeHomeTotal: z.number().nonnegative().optional(),
  availableOverseas: z.boolean(),
  feeOverseas: z.number().nonnegative().optional(),
  feeOverseasTotal: z.number().nonnegative().optional(),
  mode: safeString,
  startMonthHome: z.string().optional(),
  duration: z.number().nonnegative(),
  startDateHome: z.string().date().optional(),
  endDateHome: z.string().date().optional(),
  lastApplicationDate: z.string().date().optional(),
  lastAcceptanceDate: z.string().date().optional(),
  award: safeString,
  level: safeString,
  entryPoint: z.nativeEnum(EntryPoint),
  campus: safeString.optional(),
  department: safeString.optional(),
  faculty: safeString.optional(),
  category: safeString.optional(),
  awardingBody: safeString.optional(),
  isHTQ: z.boolean().optional(),
  hecos: z.array(z.object({ code: safeString, percentage: z.number() })).optional(),
  abbreviatedTitle: safeString.optional(),
  UCASApplyCode: safeString.optional(),
  UCASFacultyCode: safeString.optional(),
  availability: z.object({
    type: z.nativeEnum(CourseAvailability),
    allowedPartners: z.array(z.string()).optional()
  }).optional()
}).refine(
  (e) => !e.lastAcceptanceDate || !e.startDateHome || e.lastAcceptanceDate >= e.startDateHome,
  {
    path: ["lastAcceptanceDate"],
    message: "Last acceptance date must be after start date"
  }
).refine(
  (e) => !e.lastAcceptanceDate || !e.endDateHome || e.lastAcceptanceDate <= e.endDateHome,
  {
    path: ["lastAcceptanceDate"],
    message: "Last acceptance date must be before end date"
  }
).refine(
  (e) => {
    let t = 0;
    return e.hecos?.map((o) => {
      t += o.percentage;
    }), t === 100;
  },
  {
    path: ["hecos"],
    message: "The HECoS proportion for this course must add up to 100."
  }
).refine(
  (e) => e.availability?.type === "limited_partners" ? e.availability.allowedPartners && e.availability.allowedPartners.length > 0 : !0,
  {
    path: ["availability", "allowedPartners"],
    message: "At least one partner must be selected when limiting availability"
  }
);
var ApplicationTaskSchema = z.enum([
  "EnglishLanguage",
  "Employment",
  "References",
  "PersonalStatement",
  "ResearchProposal",
  "Funding",
  "ImmigrationHistory",
  "DiversityInclusion",
  "Representation",
  "Referral",
  "Declarations"
]);
z.record(ApplicationTaskSchema, z.boolean()).optional();
var ApplicationTaskFlagsSchema = z.object({
  enabled: z.boolean().optional(),
  default: z.boolean().optional()
});
z.record(ApplicationTaskSchema, ApplicationTaskFlagsSchema);
ApplicationTaskSchema.enum;
z.object({
  country: z.string().min(1, "Country can't be empty"),
  institutionName: z.string().min(1, "The name can't be empty"),
  institutionAddress: AddressSchema.omit({ country: !0 }).extend({
    state: z.string().optional()
    // Override to make state optional
  })
});
var HighestStudyQualificationTypeSelectionSchema = z.object({
  id: z.string().optional(),
  // unique identifier for this studyRow (to distinguish multiple rows with same qualificationType)
  qualificationType: z.string().min(1, "Please select the qualification type"),
  // id
  qualificationTypeLabel: z.string().optional(),
  customQualificationTypeName: z.string().optional(),
  // required if 'Other' is selected
  gradingSystem: z.string().min(1, "Please select the grading system"),
  gradingSystemLabel: z.string().optional(),
  groupId: z.string().optional(),
  // groupId to track which selections belong to the same study group
  resultStatus: z.nativeEnum(ResultStatus).optional(),
  // Per-group result status
  taughtInEnglish: z.boolean().optional()
  // Per-group taught in English
}).refine(
  (e) => {
    if (e.qualificationTypeLabel === "Other") {
      const t = e.customQualificationTypeName;
      return t && typeof t == "string" && t.trim().length > 0;
    }
    return !0;
  },
  {
    message: "Please enter the qualification type",
    path: ["customQualificationTypeName"]
  }
);
z.object({
  country: z.string().min(1),
  qualificationTypeSelections: z.array(HighestStudyQualificationTypeSelectionSchema).min(1),
  resultStatus: z.nativeEnum(ResultStatus),
  taughtInEnglish: z.boolean().nullish()
});
z.object({
  subject: z.string().optional(),
  grade: z.string().optional(),
  graduationDate: z.string().optional().refine(
    (e) => {
      if (!e) return !0;
      const t = /* @__PURE__ */ new Date(), o = t.getFullYear(), i = t.getMonth() + 1, d = o - 130, [s, n] = e.split("-"), r = s && s.length === 4 ? parseInt(s, 10) : void 0, u = n && n.length > 0 ? parseInt(n, 10) : void 0;
      return !(!r || r <= d || r > o || r === o && u && u > i);
    },
    { message: "Invalid date" }
  ),
  awardingOrganisationId: z.string().optional(),
  modules: z.array(ModuleSchema).optional()
});
z.string().min(1, "Intake is required"), z.string().min(1, "Study level is required"), z.string().min(1, "Course is required"), z.string().min(1, "Course is required"), z.string().min(1, "Mode is required"), z.string().min(1, "Campus is required"), z.string().min(1, "Entry year is required"), z.array(ProgrammeChoiceSchema2).optional();
var EllucianAuthMethod = /* @__PURE__ */ ((e) => (e.Basic = "Basic", e.OAuth = "OAuth", e.SecretToken = "SecretToken", e))(EllucianAuthMethod || {});
Object.freeze({
  [EStudentImportAttributeFieldNames.COUNTRY_OF_BIRTH]: "birth_country",
  [EStudentImportAttributeFieldNames.NATIONALITY]: "nationality",
  [EStudentImportAttributeFieldNames.COUNTRY]: "application_country",
  [EStudentImportAttributeFieldNames.INTAKE_ID]: "intake_id",
  [EStudentImportAttributeFieldNames.UNI]: "uni",
  [EStudentImportAttributeFieldNames.OFFERS_COURSES_ID]: "course_id",
  [EStudentImportAttributeFieldNames.OFFERS_COURSES_TITLE]: "course_name",
  [EStudentImportAttributeFieldNames.STAGE]: "status",
  [EStudentImportAttributeFieldNames.TAGS_ASSIGNED]: "tags"
  /* TAGS */
});
Object.freeze({
  [EStudentImportAttributeFieldNames.COUNTRY]: "application_country",
  [EStudentImportAttributeFieldNames.NATIONALITY]: "nationality",
  [EStudentImportAttributeFieldNames.INTAKE_ID]: "intake_id",
  [EStudentImportAttributeFieldNames.UNI]: "uni",
  [EStudentImportAttributeFieldNames.OFFERS_COURSES_ID]: "course_id",
  [EStudentImportAttributeFieldNames.OFFERS_COURSES_TITLE]: "course_name",
  [EStudentImportAttributeFieldNames.STAGE]: "application_status"
  /* STATUS */
});
var FilterKey = /* @__PURE__ */ ((e) => (e.ACTIVITY_STATUS = "filter_activityStatus", e.COMPLETE = "filter_complete", e.INCOMPLETE = "filter_incomplete", e.INTERVIEW = "filter_interview", e.RECORDED_INTERVIEW = "filter_recordedInterview", e.FUNDS_MATURITY = "filter_fundsMaturity", e.CONDITIONAL_STATUS = "filter_conditionalStatus", e.COURSE_CONDITIONAL_STATUS = "filter_courseConditionalStatus", e.COURSE = "filter_course", e.FACULTY = "filter_faculty", e.UNIVERSITY = "filter_university", e.IMMIGRATION_PROVIDERS = "filter_immigrationProviders", e.PROGRAMMABLE_TAGS = "filter_programmableTags", e.SERVICES = "filter_services", e.TAGS = "filter_tags", e.VISA_STATUS = "filter_visaStatus", e.AGENT_NAME = "filter_agentName", e.APPLICATION_COUNTRY = "filter_applicationCountry", e.CONFIDENCE = "filter_confidence", e.COUNTRY_OF_RESIDENCE = "filter_countryOfResidence", e.EVIDENCE_REQUIREMENTS = "filter_evidenceRequirements", e.MARKET = "filter_market", e.NATIONALITY = "filter_nationality", e.RISK_REGION = "filter_riskRegion", e.IDLE_DAYS = "filter_idle_days", e.MINIMUM_DAYS_IDLE = "filter_minimum_days_idle", e.MAXIMUM_DAYS_IDLE = "filter_maximum_days_idle", e.DEPENDANTS = "filter_dependants", e.STUDENT_NUMBER = "filter_student_number", e.GIVEN_NAME = "filter_given_name", e.FAMILY_NAME = "filter_surname", e.FEE_STATUS = "filter_feeStatus", e.OFFER_STATUS = "filter_offerStatus", e.SHARE_CODE = "filter_shareCode", e))(FilterKey || {});
Object.values(FilterKey);
var ImportSource = /* @__PURE__ */ ((e) => (e.CSV = "CSV", e.SFTP = "SFTP", e.SITS = "SITS", e.APPLY = "APPLY", e))(ImportSource || {});
z.object({
  ellucianEnabled: z.boolean(),
  ellucianAuthMethod: z.enum(Object.values(EllucianAuthMethod)),
  ellucianUrl: z.string().url({ message: "Invalid URL" }).optional(),
  ellucianUrlBasePath: z.string().optional(),
  ellucianUserName: z.string().optional(),
  ellucianPassword: z.string().optional(),
  ellucianClientId: z.string().optional(),
  ellucianSecret: z.string().optional(),
  ellucianToken: z.string().optional(),
  ellucianOAuthScope: z.string().optional(),
  ellucianValueMappings: z.array(z.object({ fieldType: z.string(), values: z.array(z.object({ source: z.string(), target: z.string() })) })).optional(),
  ellucianFeatures: z.record(
    z.object({
      label: z.string(),
      enable: z.boolean()
    })
  ).default({})
}).superRefine((e, t) => {
  e.ellucianEnabled && (e.ellucianEnabled && (e.ellucianUrl || t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["ellucianUrl"],
    message: "Ellucian Base URL is required"
  }), e.ellucianUrlBasePath || t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["ellucianUrlBasePath"],
    message: "Ellucian URL Base Path is required"
  })), e.ellucianAuthMethod === "Basic" && (e.ellucianUserName || t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["ellucianUserName"],
    message: "Username is required for Basic authentication"
  }), e.ellucianPassword || t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["ellucianPassword"],
    message: "Password is required for Basic authentication"
  })), e.ellucianAuthMethod === "OAuth" && (e.ellucianClientId || t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["ellucianClientId"],
    message: "Client ID is required for OAuth authentication"
  }), e.ellucianSecret || t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["ellucianSecret"],
    message: "Secret is required for OAuth authentication"
  }), e.ellucianOAuthScope || t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["ellucianOAuthScope"],
    message: "OAuth Scope is required for OAuth authentication"
  })), e.ellucianAuthMethod === "SecretToken" && (e.ellucianToken || t.addIssue({
    code: z.ZodIssueCode.custom,
    path: ["ellucianToken"],
    message: "Ellucian Secret Token is required for authentication"
  })));
});
var generics_integration_exports = {};
__export(generics_integration_exports, {
  EntryPointNumber: () => EntryPointNumber,
  IntegrationDeliveryKeys: () => IntegrationDeliveryKeys,
  Integrations: () => Integrations
});
var IntegrationDeliveryKeys = /* @__PURE__ */ ((e) => (e.ORACLE_OUTBOUND = "ORACLE_OUTBOUND", e.SITS_OUTBOUND = "SITS_OUTBOUND", e.ELLUCIAN_OUTBOUND = "ELLUCIAN_OUTBOUND", e))(IntegrationDeliveryKeys || {}), Integrations = /* @__PURE__ */ ((e) => (e.ORACLE = "oracle", e.SITS = "sits", e.ELLUCIAN = "ellucian", e))(Integrations || {}), EntryPointNumber = {
  "Year 0": 0,
  "Year 1": 1,
  "Year 2": 2,
  "Year 3": 3,
  "Year 4": 4,
  "Year 5": 5,
  "Year 6": 6
}, VALID_EXTENSIONS_GENERAL = ["pdf", "jpg", "jpeg", "png", "gif", "bmp", "webp"], VALID_EXTENSIONS_APPLICANT = [...VALID_EXTENSIONS_GENERAL], VALID_TYPES_GENERAL = ["application/pdf", "image/jpeg", "image/png", "image/gif", "image/bmp", "image/webp"], VALID_TYPES_APPLICANT = [...VALID_TYPES_GENERAL], ApplicantDocUploadRequestSchema = z.object({
  docType: z.string(),
  // .refine(value => VALID_DOCUMENT_TYPES_APPLICANT.includes(value), {
  //   message: `Unsupported document type!`
  // })
  // .optional()
  // .nullable(),
  fileName: z.string().transform((e) => {
    const t = e.lastIndexOf(".");
    if (t === -1) return e;
    const o = e.substring(0, t), i = e.substring(t).toLowerCase();
    return o + i;
  }).refine((e) => VALID_EXTENSIONS_APPLICANT.some((t) => e.endsWith(`.${t}`)), {
    message: "Unsupported file type!"
  }),
  fileType: z.string().refine((e) => VALID_TYPES_APPLICANT.includes(e), {
    message: "Unsupported file type!"
  }),
  docKey: z.string(),
  studyId: z.string().optional()
}), TYPE = /* @__PURE__ */ ((e) => (e.RECEIVED = "RECEIVED", e.SENT = "SENT", e))(TYPE || {}), FileSchema = z.object({
  label: z.string(),
  isPdfFile: z.boolean().optional(),
  noOfPages: z.number().optional(),
  isProcessing: z.boolean().optional(),
  fileName: z.string(),
  fileSize: z.number().optional(),
  // KB size
  fileType: z.string().optional(),
  s3Key: z.string().optional()
}), DocAccessType = /* @__PURE__ */ ((e) => (e.STAFF_ONLY = "STAFF_ONLY", e.AGENT_ONLY = "AGENT_ONLY", e))(DocAccessType || {}), DocStatus = /* @__PURE__ */ ((e) => (e.AWAITING = "AWAITING", e.UPLOADED_OK = "UPLOADED_OK", e.UPLOADED_WITH_ERROR = "UPLOADED_WITH_ERROR", e.REJECTED = "REJECTED", e.REJECTED_WITHOUT_ALTERNATIVE = "REJECTED_WITHOUT_ALTERNATIVE", e.APPROVED = "APPROVED", e.REPLACED = "REPLACED", e.DELETED = "DELETED", e.SKIPPED = "SKIPPED", e.INFO_ONLY = "INFO_ONLY", e.NOT_ACKNOWLEDGED = "NOT_ACKNOWLEDGED", e.ACKNOWLEDGED = "ACKNOWLEDGED", e))(DocStatus || {}), DocumentStatusSchema = z.nativeEnum(DocStatus), UploadedBySchema = z.union([
  z.literal(""),
  z.literal(
    "Admin"
    /* ADMIN */
  ),
  z.literal(
    "Agent"
    /* AGENT */
  ),
  z.literal(
    "University"
    /* UNIVERSITY */
  ),
  z.literal(
    "Enroly"
    /* ENROLY */
  ),
  z.literal(
    "SITS"
    /* SITS */
  )
]), DocumentSchema = z.object({
  label: z.string(),
  status: DocumentStatusSchema,
  prevStatus: DocumentStatusSchema.optional(),
  fileNames: z.array(z.string()),
  // refactor this out after STM-392
  files: z.array(FileSchema).optional(),
  reason: z.string().optional(),
  signedUrls: z.array(z.string()).optional(),
  uploadedBy: UploadedBySchema.optional(),
  userAccess: z.nativeEnum(DocAccessType).optional(),
  isProcessingPdf: z.boolean().optional(),
  eTags: z.array(z.string()).optional(),
  // eTags from s3 fro faster lookups
  s3Keys: z.array(z.string()).optional(),
  fileLabels: z.array(z.string()).optional(),
  // Original user-facing filenames (fileNames may contain S3-mangled names)
  /** If a document is a stub after TTL deletion, it should have `deletedByTTL = true`  */
  deletedByTTL: z.boolean().optional()
}), emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/, dateRegex = /^\d{4}-\d{2}-\d{2}$/, dateStringSchema = (e) => z.string().regex(dateRegex, `${e} must be in YYYY-MM-DD format`).refine((t) => {
  const o = new Date(t);
  return !isNaN(o.getTime());
}, `Invalid ${e}`).optional(), MAX_STRING_LENGTH = 1e3, PERCENTAGE_MAX = 100, sanitizedStringSchema = z.string().transform((e) => e.trim()).transform((e) => e.replace(/[\x00-\x1F\x7F]/g, "")).transform((e) => e.substring(0, MAX_STRING_LENGTH)).transform((e) => e || void 0), phoneNumberSchema = z.string().transform((e) => e.replace(/[^\d+-]/g, "")).transform((e) => e || void 0).optional(), ImportCourseSchema = z.object({
  title: z.string().min(1, "Course title is required"),
  level: sanitizedStringSchema.optional(),
  conditional: z.boolean().optional(),
  startDate: dateStringSchema("Start date").optional(),
  endDate: dateStringSchema("End date").optional(),
  isFullTime: z.boolean().optional(),
  hoursPerWeek: z.number().min(0).optional(),
  isATASRequired: z.boolean().optional(),
  courseFeeFirstYear: z.number().min(0, "Course fee cannot be negative").optional(),
  courseScholarshipTitle1: sanitizedStringSchema.optional(),
  courseScholarshipAmount1: z.number().min(0).optional(),
  coursesAccepted: z.boolean().optional(),
  // Conditional offer fields
  conditionText1: sanitizedStringSchema.optional(),
  conditionText2: sanitizedStringSchema.optional(),
  conditionText3: sanitizedStringSchema.optional(),
  conditionText4: sanitizedStringSchema.optional(),
  conditionText5: sanitizedStringSchema.optional(),
  // Study address fields
  studyAddressLine1: sanitizedStringSchema.optional(),
  studyAddressLine2: sanitizedStringSchema.optional(),
  studyCity: sanitizedStringSchema.optional(),
  studyCountry: sanitizedStringSchema.optional(),
  studyPostcode: sanitizedStringSchema.optional(),
  // Work placement fields
  isWorkPlacement: z.boolean().optional(),
  workPlacementPerc: z.number().min(0).max(PERCENTAGE_MAX).optional(),
  workPlacementText: sanitizedStringSchema.optional()
}).superRefine((e, t) => {
  if (e.startDate && e.endDate) {
    const o = new Date(e.startDate), i = new Date(e.endDate);
    o >= i && t.addIssue({
      code: "custom",
      path: ["endDate"],
      message: "End date must be after start date"
    });
  }
  e.courseScholarshipTitle1 && !e.courseScholarshipAmount1 && t.addIssue({
    code: "custom",
    path: ["courseScholarshipAmount1"],
    message: `Scholarship amount required for "${e.courseScholarshipTitle1}"`
  });
}), ImportOfferSchema = z.object({
  intakeId: z.string().min(1, "Intake ID is required"),
  offerId: z.string().min(1, "Offer ID is required"),
  courses: z.array(ImportCourseSchema).min(1, "At least one course is required"),
  // Optional fields
  withAgent: z.boolean().optional(),
  agentName: sanitizedStringSchema.optional(),
  agentCompany: sanitizedStringSchema.optional(),
  scholarshipTitle: sanitizedStringSchema.optional(),
  scholarshipAmount: z.number().min(0).optional(),
  courseCode: sanitizedStringSchema.optional(),
  courseId: sanitizedStringSchema.optional(),
  courseName: sanitizedStringSchema.optional()
}).superRefine((e, t) => {
  e.withAgent && !e.agentName && t.addIssue({
    code: "custom",
    path: ["agentName"],
    message: "Agent name required when withAgent is true"
  }), e.scholarshipTitle && !e.scholarshipAmount && t.addIssue({
    code: "custom",
    path: ["scholarshipAmount"],
    message: `Scholarship amount required for "${e.scholarshipTitle}"`
  });
});
z.object({
  // Required fields
  studentNo: z.string({ required_error: "Student number is required" }).min(1, "Student number is required"),
  email: z.string({ required_error: "Email is required" }).regex(emailRegex, "Invalid email format"),
  familyName: z.string({ required_error: "Family name is required" }).min(1, "Family name is required"),
  givenName: z.string({ required_error: "Given name is required" }).min(1, "Given name is required"),
  // Optional fields
  uni: z.string().optional(),
  source: z.nativeEnum(ImportSource).optional(),
  otherName: sanitizedStringSchema.optional(),
  dob: dateStringSchema("Date of birth").optional(),
  phone: phoneNumberSchema,
  nationality: sanitizedStringSchema.optional(),
  placeOfBirth: sanitizedStringSchema.optional(),
  countryOfBirth: sanitizedStringSchema.optional(),
  gender: sanitizedStringSchema.optional(),
  // Address fields
  addressLine1: sanitizedStringSchema.optional(),
  addressLine2: sanitizedStringSchema.optional(),
  addressLine3: sanitizedStringSchema.optional(),
  city: sanitizedStringSchema.optional(),
  country: sanitizedStringSchema.optional(),
  postcode: sanitizedStringSchema.optional(),
  // Passport fields
  passportNumber: sanitizedStringSchema.optional(),
  passportExpiry: dateStringSchema("Passport expiry").optional(),
  // Academic fields
  ucasId: sanitizedStringSchema.optional(),
  applicationId: sanitizedStringSchema.optional(),
  englishLevelAttained: sanitizedStringSchema.optional(),
  englishTestProvider: sanitizedStringSchema.optional(),
  prevUKStudy: z.boolean().optional(),
  criminalConvictions: z.boolean().optional(),
  // Agent fields
  withAgent: z.boolean().optional(),
  agentName: sanitizedStringSchema.optional(),
  agentCompany: sanitizedStringSchema.optional(),
  // Offers
  offers: z.array(ImportOfferSchema).default([])
});
var ApplicantDetailsValidationSchema = z.object({
  email: z.string().optional(),
  passport: z.object({
    passportNo: z.string().optional(),
    dateOfExpiry: z.string().optional(),
    dateOfIssue: z.string().optional(),
    passportIssuingAuthority: z.string().optional()
  }).optional().nullable(),
  englishTest: z.object({
    type: z.string().optional(),
    typeOther: z.string().optional(),
    score: z.string().optional(),
    date: z.string().optional(),
    referenceNo: z.string().optional(),
    validUntil: z.string().optional()
  }).optional().nullable(),
  reasonNotReqd: z.string().optional().nullable(),
  ukStudentVisas: z.array(
    z.object({
      type: z.string().optional(),
      startDate: z.string().optional(),
      endDate: z.string().optional()
    })
  ).optional().nullable()
}), ApplicationValidationSchema = z.object({
  userId: z.string(),
  applicationId: z.string(),
  intakeId: z.string().optional(),
  email: z.string().email("Invalid email format"),
  familyName: z.string().min(1, "Family name is required"),
  givenName: z.string().min(1, "Given name is required"),
  otherNames: z.array(
    z.object({
      givenName: z.string().optional(),
      familyName: z.string().optional()
    })
  ).optional().nullable(),
  dob: z.string().optional(),
  phoneNumber: z.string().optional(),
  nationality: z.string().optional(),
  countryOfBirth: z.string().optional(),
  gender: z.string().optional(),
  contactAddress: z.object({
    addressLine1: z.string().optional(),
    addressLine2: z.string().optional(),
    city: z.string().optional(),
    postcode: z.string().optional(),
    country: z.string().optional()
  }).optional().nullable(),
  ucasId: z.string().optional(),
  criminalConvictions: z.boolean().optional(),
  hasAgent: z.string().optional(),
  agent: z.string().optional().nullable(),
  feeStatus: z.nativeEnum(FeeStatus)
});
z.object({
  application: ApplicationValidationSchema,
  applicantDetails: ApplicantDetailsValidationSchema.nullable()
});
var ApiValidationError = class extends Error {
  constructor(e, t, o) {
    super(e), this.fields = t, this.details = o, this.name = "ApiValidationError", Object.defineProperty(this, "stack", {
      get: () => `${this.name}: ${this.message}`,
      configurable: !0
    });
  }
  // Override toString to show only the message without stack
  toString() {
    return `${this.name}: ${this.message}`;
  }
  // Provide clean JSON serialization
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      fields: this.fields,
      details: this.details
    };
  }
};
function formatZodError(e, t) {
  const o = e.format(), i = {}, d = [];
  for (const [u, l] of Object.entries(o))
    if (u !== "_errors" && typeof l == "object" && l !== null && "_errors" in l) {
      const c = l._errors;
      i[u] = c, c.forEach((g) => {
        d.push(`${u}: ${g}`);
      });
    }
  o._errors && o._errors.length > 0 && o._errors.forEach((u) => {
    d.push(u);
  });
  const s = Object.keys(i).length, n = Object.keys(i).join(", ");
  let r = `Validation failed for ${t}.`;
  return s > 0 && (r += ` The following field${s > 1 ? "s are" : " is"} missing or invalid: ${n}`), { message: r, fields: i, details: d };
}
function makeRequest(e, t, o, i) {
  throw new Error("API client not configured. Call configureFetch() before making requests.");
}
function buildQueryString(e) {
  const t = new URLSearchParams();
  for (const [o, i] of Object.entries(e))
    if (i != null)
      if (Array.isArray(i)) {
        if (i.length === 0) continue;
        for (const d of i)
          d != null && t.append(o, String(d));
      } else
        t.append(o, String(i));
  return t.toString();
}
(() => {
  const e = "POST", t = "/unsubscribe", o = () => "/unsubscribe";
  return Object.assign(async (d) => {
    let s = o();
    if (d.queryParams) {
      const n = buildQueryString(d.queryParams);
      n && (s += "?" + n);
    }
    return makeRequest(e, s, d.body, d.options);
  }, {
    method: e,
    path: t,
    buildUrl: o
  });
})(), (() => {
  const e = "POST", t = "/messages", o = () => "/messages";
  return Object.assign(async (d) => {
    let s = o();
    if (d.queryParams) {
      const n = buildQueryString(d.queryParams);
      n && (s += "?" + n);
    }
    return makeRequest(e, s, d.body, d.options);
  }, {
    method: e,
    path: t,
    buildUrl: o
  });
})(), (() => {
  const e = "POST", t = "/messages/{uni}/{studentNo}/{intakeId}/{offerId}/messages", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/messages/{uni}/{studentNo}/{intakeId}/{offerId}/messages";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markRead", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markRead";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markUnread", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markUnread";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/interviews/{uni}/{studentNo}/recorded-interviews", o = z.object({ uni: z.string(), studentNo: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/interviews/{uni}/{studentNo}/recorded-interviews";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/interviews/{uni}/{studentNo}/recorded-interviews-check", o = z.object({ uni: z.string(), studentNo: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/interviews/{uni}/{studentNo}/recorded-interviews-check";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/scores", o = z.object({ uni: z.string(), studentNo: z.string(), interviewId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/scores";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{interviewId}", encodeURIComponent(String(n.interviewId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/questions", o = z.object({ uni: z.string(), studentNo: z.string(), interviewId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/questions";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{interviewId}", encodeURIComponent(String(n.interviewId ?? n.INTERVIEWID ?? n.interviewId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/edit-scores", o = z.object({ uni: z.string(), studentNo: z.string(), interviewId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/edit-scores";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{interviewId}", encodeURIComponent(String(n.interviewId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/assessment", o = z.object({ uni: z.string(), studentNo: z.string(), interviewId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/assessment";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{interviewId}", encodeURIComponent(String(n.interviewId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/processing/{videoId}", o = z.object({ uni: z.string(), studentNo: z.string(), interviewId: z.string(), videoId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/processing/{videoId}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{interviewId}", encodeURIComponent(String(n.interviewId))), r = r.replace("{videoId}", encodeURIComponent(String(n.videoId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = z.object({ includeHidden: z.boolean().optional() }), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{studentNo}", encodeURIComponent(String(r.studentNo ?? r.STUDENTNO ?? r.studentNo))), u = u.replace("{intakeId}", encodeURIComponent(String(r.intakeId ?? r.INTAKEID ?? r.intakeId))), u = u.replace("{offerId}", encodeURIComponent(String(r.offerId ?? r.OFFERID ?? r.offerId))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/finance", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/finance";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "DELETE", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/noDoc", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/noDoc";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/replace", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/replace";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/update-status", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/update-status";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/customRequest", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/customRequest";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "DELETE", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/update-status", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/update-status";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/customRequest", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/customRequest";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/risks", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/risks";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("PUT", n, s.body, s.options);
  }, {
    method: "PUT",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "DELETE", t = "/student/{uni}/{studentNo}/scheduled-interview/doc", o = z.object({ uni: z.string(), studentNo: z.string() }), i = z.union([z.object({ eventName: z.string(), interviewType: z.string(), eventType: z.string(), eventKey: z.string(), fileNames: z.array(z.string()) }), z.object({ interviewType: z.string(), eventType: z.string(), eventKey: z.string(), deletedFileName: z.string(), uploadedBy: z.string() })]), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/student/{uni}/{studentNo}/scheduled-interview/doc";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{studentNo}", encodeURIComponent(String(r.studentNo ?? r.STUDENTNO ?? r.studentNo))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/scheduled-interview/doc", o = z.object({ uni: z.string(), studentNo: z.string() }), i = z.union([z.object({ eventName: z.string(), interviewType: z.string(), eventType: z.string(), eventKey: z.string(), fileNames: z.array(z.string()) }), z.object({ interviewType: z.string(), eventType: z.string(), eventKey: z.string(), deletedFileName: z.string(), uploadedBy: z.string() })]), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/student/{uni}/{studentNo}/scheduled-interview/doc";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{studentNo}", encodeURIComponent(String(r.studentNo ?? r.STUDENTNO ?? r.studentNo))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/scheduled-interview/pass", o = z.object({ uni: z.string(), studentNo: z.string() }), i = z.object({ eventType: z.string(), eventName: z.string(), eventKey: z.string(), status: z.enum(["PASSED", "FAILED", "RESIT", "DELETED"]).optional() }), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/student/{uni}/{studentNo}/scheduled-interview/pass";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{studentNo}", encodeURIComponent(String(r.studentNo ?? r.STUDENTNO ?? r.studentNo))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/scheduled-interview/resit", o = z.object({ uni: z.string(), studentNo: z.string() }), i = z.object({ eventType: z.string(), eventKey: z.string(), eventName: z.string(), note: z.string(), undo: z.boolean().optional() }), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/student/{uni}/{studentNo}/scheduled-interview/resit";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{studentNo}", encodeURIComponent(String(r.studentNo ?? r.STUDENTNO ?? r.studentNo))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/scheduled-interview/fail", o = z.object({ uni: z.string(), studentNo: z.string() }), i = z.object({ eventType: z.string(), eventKey: z.string(), eventName: z.string(), note: z.string(), undo: z.boolean().optional() }), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/student/{uni}/{studentNo}/scheduled-interview/fail";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{studentNo}", encodeURIComponent(String(r.studentNo ?? r.STUDENTNO ?? r.studentNo))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/scheduled-interview/request", o = z.object({ uni: z.string(), studentNo: z.string() }), i = z.object({ eventType: z.object({ id: z.string().nullable(), schedulingUrl: z.string().optional(), name: z.string().optional(), description: z.string().optional() }), note: z.string().optional() }), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/student/{uni}/{studentNo}/scheduled-interview/request";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{studentNo}", encodeURIComponent(String(r.studentNo ?? r.STUDENTNO ?? r.studentNo))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/scheduled-interview/cancel", o = z.object({ uni: z.string(), studentNo: z.string() }), i = z.object({ eventType: z.string(), eventKey: z.string(), note: z.string() }), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/student/{uni}/{studentNo}/scheduled-interview/cancel";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{studentNo}", encodeURIComponent(String(r.studentNo ?? r.STUDENTNO ?? r.studentNo))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "DELETE", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/request", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/request";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/pass", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/pass";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/resit", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/resit";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/fail", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/fail";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/cancel", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/cancel";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/exceeded", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/exceeded";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview/reset", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview/reset";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/offer-evidence", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/offer-evidence";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-conflict", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-conflict";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/agents", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/agents";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/travel-status", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/travel-status";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/accommodation-status", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/accommodation-status";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-support", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-support";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview-images", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview-images";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "DELETE", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/uni-student-number", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/uni-student-number";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-status", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-status";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/student/{uni}/{studentNo}/active-offers", o = z.object({ uni: z.string(), studentNo: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/active-offers";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/active-offers", o = z.object({ uni: z.string(), studentNo: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/active-offers";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "DELETE", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/noDoc", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/noDoc";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/applied", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/applied";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/replace", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/replace";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/update-status", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/update-status";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/customRequest", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/customRequest";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/visaStatusUpdate", o = () => "/visaStatusUpdate";
  return Object.assign(async (d) => {
    let s = o();
    if (d.queryParams) {
      const n = buildQueryString(d.queryParams);
      n && (s += "?" + n);
    }
    return makeRequest("GET", s, d.body, d.options);
  }, {
    method: "GET",
    path: t,
    buildUrl: o
  });
})(), (() => {
  const t = "/confirmArrival", o = () => "/confirmArrival";
  return Object.assign(async (d) => {
    let s = o();
    if (d.queryParams) {
      const n = buildQueryString(d.queryParams);
      n && (s += "?" + n);
    }
    return makeRequest("GET", s, d.body, d.options);
  }, {
    method: "GET",
    path: t,
    buildUrl: o
  });
})(), (() => {
  const e = "DELETE", t = "/student/{uni}/{studentNo}/importHash", o = z.object({ uni: z.string(), studentNo: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/importHash";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/transfer-mate/update-status/{uni}", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/transfer-mate/update-status/{uni}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/student/{uni}/{studentNo}/{intakeId}/{offerId}", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("PUT", n, s.body, s.options);
  }, {
    method: "PUT",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/audit", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/audit";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/messages", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/messages";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/emails", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/emails";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/upload-url", o = z.object({ id: z.string().optional(), university: z.string().optional(), fileName: z.string(), fileType: z.string(), sponsorType: z.string().nullable().optional(), sponsorKey: z.string().nullable().optional(), docType: z.string().nullable().optional(), docKey: z.string().optional(), interviewType: z.string().optional(), eventType: z.string().optional(), eventKey: z.string().optional(), interviewHash: z.string().optional(), attemptHash: z.string().optional() }), i = () => "/upload-url";
  return Object.assign(async (s) => {
    let n = i();
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    try {
      const r = o.parse(s.body);
      return makeRequest(e, n, r, s.options);
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "request body");
        throw console.error("[ApiClient] Request body validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  }, {
    method: e,
    path: t,
    bodySchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/chat", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/chat";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs/approved", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs/approved";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/audit", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/audit";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/sits/ping", o = () => "/sits/ping";
  return Object.assign(async (d) => {
    let s = o();
    if (d.queryParams) {
      const n = buildQueryString(d.queryParams);
      n && (s += "?" + n);
    }
    return makeRequest("GET", s, d.body, d.options);
  }, {
    method: "GET",
    path: t,
    buildUrl: o
  });
})(), (() => {
  const t = "/deliveries/{integration}/{uni}/{userId}/outbound/{deliverySortKey}/retry", o = z.object({ integration: z.string(), uni: z.string(), userId: z.string(), deliverySortKey: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/deliveries/{integration}/{uni}/{userId}/outbound/{deliverySortKey}/retry";
      return r = r.replace("{integration}", encodeURIComponent(String(n.integration))), r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{userId}", encodeURIComponent(String(n.userId))), r = r.replace("{deliverySortKey}", encodeURIComponent(String(n.deliverySortKey))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/student/{studentNo}/{intakeId}/{offerId}", o = z.object({ studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/student/{studentNo}/{intakeId}/{offerId}";
      return r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/deliveries/{integration}/applicants/resolve-duplicate", o = z.object({ integration: z.enum(["oracle", "sits", "ellucian"]) }), i = z.object({ uni: z.string(), applicationId: z.string(), userId: z.string(), isDuplicate: z.boolean(), studentNo: z.string().optional() }), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/deliveries/{integration}/applicants/resolve-duplicate";
      return u = u.replace("{integration}", encodeURIComponent(String(r.integration ?? r.INTEGRATION ?? r.integration))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "POST", t = "/calendly/webhooks", o = () => "/calendly/webhooks";
  return Object.assign(async (d) => {
    let s = o();
    if (d.queryParams) {
      const n = buildQueryString(d.queryParams);
      n && (s += "?" + n);
    }
    return makeRequest(e, s, d.body, d.options);
  }, {
    method: e,
    path: t,
    buildUrl: o
  });
})(), (() => {
  const t = "/event-types/{uni}", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/event-types/{uni}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/calendly-auth/config/{uni}", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/calendly-auth/config/{uni}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/event-types/{uni}/pathway/{pathway}", o = z.object({ uni: z.string(), pathway: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/event-types/{uni}/pathway/{pathway}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r = r.replace("{pathway}", encodeURIComponent(String(n.pathway))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/offices/{uni}", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/offices/{uni}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/offices/{uni}/{id}", o = z.object({ uni: z.string(), id: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/offices/{uni}/{id}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{id}", encodeURIComponent(String(n.id ?? n.ID ?? n.id))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/offices/{uni}", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/offices/{uni}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/offices/{uni}/{id}", o = z.object({ uni: z.string(), id: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/offices/{uni}/{id}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{id}", encodeURIComponent(String(n.id ?? n.ID ?? n.id))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("PUT", n, s.body, s.options);
  }, {
    method: "PUT",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "DELETE", t = "/offices/{uni}/{id}", o = z.object({ uni: z.string(), id: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/offices/{uni}/{id}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{id}", encodeURIComponent(String(n.id ?? n.ID ?? n.id))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/event-types/{uni}/{eventTypeUuid}/scheduling-info", o = z.object({ uni: z.string(), eventTypeUuid: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/event-types/{uni}/{eventTypeUuid}/scheduling-info";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{eventTypeUuid}", encodeURIComponent(String(n.eventTypeUuid ?? n.EVENTTYPEUUID ?? n.eventTypeUuid))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/documents/count-per-type", o = z.object({ academicTranscript: z.number(), passport: z.number(), personalStatement: z.number(), photoId: z.number(), cv: z.number(), englishTest: z.number(), referenceLetter: z.number(), academicCertificate: z.number(), proofOfAddress: z.number(), proofOfNameChange: z.number(), nameAffidavit: z.number(), birthCert: z.number(), proofOfImmigrationStatus: z.number(), proofOfManagerialExperience: z.number(), proofOfPayment: z.number(), portfolio: z.number(), researchProposal: z.number(), customRequest: z.number(), customRequirement: z.number(), staffDocument: z.number(), staffOnlyRequirement: z.number() }), i = () => "/documents/count-per-type";
  return Object.assign(async (s) => {
    let n = i();
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    try {
      const r = o.parse(s.body);
      return makeRequest("GET", n, r, s.options);
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "request body");
        throw console.error("[ApiClient] Request body validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  }, {
    method: "GET",
    path: t,
    bodySchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/documents/{uni}/applicant/{applicantId}/upload", o = z.object({ uni: z.string(), applicantId: z.string() }), i = ApplicantDocUploadRequestSchema, d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/documents/{uni}/applicant/{applicantId}/upload";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni))), u = u.replace("{applicantId}", encodeURIComponent(String(r.applicantId))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "POST", t = "/documents/{uni}/applicant/{applicantId}/staff", o = z.object({ uni: z.string(), applicantId: z.string() }), i = ApplicantDocUploadRequestSchema, d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/documents/{uni}/applicant/{applicantId}/staff";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{applicantId}", encodeURIComponent(String(r.applicantId ?? r.APPLICANTID ?? r.applicantId))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "DELETE", t = "/documents/{uni}/applicant/{applicantId}/staff/{docKey}", o = z.object({ uni: z.string(), applicantId: z.string(), docKey: z.string().optional() }), i = z.object({ s3Key: z.string().optional() }), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/documents/{uni}/applicant/{applicantId}/staff/{docKey}";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{applicantId}", encodeURIComponent(String(r.applicantId ?? r.APPLICANTID ?? r.applicantId))), u = u.replace("{docKey}", encodeURIComponent(String(r.docKey ?? r.DOCKEY ?? r.docKey))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams)
      try {
        const u = i.parse(n.queryParams), l = buildQueryString(u);
        l && (r += "?" + l);
      } catch (u) {
        if (u instanceof z.ZodError) {
          const l = formatZodError(u, "query parameters");
          throw console.error("[ApiClient] Query parameter validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
        }
        throw u;
      }
    return makeRequest(e, r, n.body, n.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    queryParamsSchema: i,
    buildUrl: d
  });
})(), (() => {
  const t = "/documents/{uni}/applicant/{applicantId}/{docType}", o = z.object({ docType: z.string(), uni: z.string().optional(), applicantId: z.string().optional() }), i = z.object({ status: z.enum(["AWAITING", "UPLOADED_OK", "UPLOADED_WITH_ERROR", "REJECTED", "REJECTED_WITHOUT_ALTERNATIVE", "APPROVED", "REPLACED", "DELETED", "SKIPPED", "INFO_ONLY", "NOT_ACKNOWLEDGED", "ACKNOWLEDGED"]), label: z.string(), fileNames: z.array(z.string()), prevStatus: z.enum(["AWAITING", "UPLOADED_OK", "UPLOADED_WITH_ERROR", "REJECTED", "REJECTED_WITHOUT_ALTERNATIVE", "APPROVED", "REPLACED", "DELETED", "SKIPPED", "INFO_ONLY", "NOT_ACKNOWLEDGED", "ACKNOWLEDGED"]).optional(), files: z.array(z.object({ label: z.string(), fileName: z.string(), isPdfFile: z.boolean().optional(), noOfPages: z.number().optional(), isProcessing: z.boolean().optional(), fileSize: z.number().optional(), fileType: z.string().optional(), s3Key: z.string().optional() })), reason: z.string().optional(), signedUrls: z.array(z.string()).optional(), uploadedBy: z.enum(["", "Admin", "Agent", "University", "Enroly", "SITS"]).optional(), userAccess: z.enum(["STAFF_ONLY", "AGENT_ONLY"]).optional(), isProcessingPdf: z.boolean().optional(), eTags: z.array(z.string()).optional(), s3Keys: z.array(z.string()).optional(), fileLabels: z.array(z.string()).optional(), deletedByTTL: z.boolean().optional() }), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/documents/{uni}/applicant/{applicantId}/{docType}";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{applicantId}", encodeURIComponent(String(r.applicantId ?? r.APPLICANTID ?? r.applicantId))), u = u.replace("{docType}", encodeURIComponent(String(r.docType ?? r.DOCTYPE ?? r.docType))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest("GET", r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "POST", t = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}", o = z.object({ docType: z.string(), docKey: z.string() }), i = DocumentSchema, d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{applicantId}", encodeURIComponent(String(r.applicantId ?? r.APPLICANTID ?? r.applicantId))), u = u.replace("{docType}", encodeURIComponent(String(r.docType ?? r.DOCTYPE ?? r.docType))), u = u.replace("{docKey}", encodeURIComponent(String(r.docKey ?? r.DOCKEY ?? r.docKey))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "DELETE", t = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}", o = z.object({ docType: z.string(), docKey: z.string(), uni: z.string().optional(), applicantId: z.string().optional() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{applicantId}", encodeURIComponent(String(n.applicantId ?? n.APPLICANTID ?? n.applicantId))), r = r.replace("{docType}", encodeURIComponent(String(n.docType ?? n.DOCTYPE ?? n.docType))), r = r.replace("{docKey}", encodeURIComponent(String(n.docKey ?? n.DOCKEY ?? n.docKey))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/documents/{uni}/applicant/{applicantId}/count-per-type", o = z.object({ uni: z.string(), applicantId: z.string() }), i = z.object({ academicTranscript: z.number(), passport: z.number(), personalStatement: z.number(), photoId: z.number(), cv: z.number(), englishTest: z.number(), referenceLetter: z.number(), academicCertificate: z.number(), proofOfAddress: z.number(), proofOfNameChange: z.number(), nameAffidavit: z.number(), birthCert: z.number(), proofOfImmigrationStatus: z.number(), proofOfManagerialExperience: z.number(), proofOfPayment: z.number(), portfolio: z.number(), researchProposal: z.number(), customRequest: z.number(), customRequirement: z.number(), staffDocument: z.number(), staffOnlyRequirement: z.number() }), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/documents/{uni}/applicant/{applicantId}/count-per-type";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni))), u = u.replace("{applicantId}", encodeURIComponent(String(r.applicantId))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest("GET", r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const e = "DELETE", t = "/documents/{docType}/{docKey}", o = z.object({ docType: z.string(), docKey: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/documents/{docType}/{docKey}";
      return r = r.replace("{docType}", encodeURIComponent(String(n.docType ?? n.DOCTYPE ?? n.docType))), r = r.replace("{docKey}", encodeURIComponent(String(n.docKey ?? n.DOCKEY ?? n.docKey))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/bulk-action/stage", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/bulk-action/stage";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/bulk-action/immigration-provider", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/bulk-action/immigration-provider";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/bulk-action/recorded-interview/remove", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/bulk-action/recorded-interview/remove";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/bulk-action/recorded-interview/add", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/bulk-action/recorded-interview/add";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/bulk-action/scheduled-interview/remove", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/bulk-action/scheduled-interview/remove";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/bulk-action/scheduled-interview/add", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/bulk-action/scheduled-interview/add";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/bulk-action/tags/add", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/bulk-action/tags/add";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/bulk-action/tags/remove", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/bulk-action/tags/remove";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/tags/pin", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/tags/pin";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/tags/unpin", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/tags/unpin";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/bulk-action/partners/add", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/bulk-action/partners/add";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/bulk-action/partners/remove", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/bulk-action/partners/remove";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/immigration-provider/update", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/immigration-provider/update";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/immigration-provider/remove", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/immigration-provider/remove";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/partners/add", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/partners/add";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/partners/remove", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/partners/remove";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/bulkChange", o = () => "/students/bulkChange";
  return Object.assign(async (d) => {
    let s = o();
    if (d.queryParams) {
      const n = buildQueryString(d.queryParams);
      n && (s += "?" + n);
    }
    return makeRequest(e, s, d.body, d.options);
  }, {
    method: e,
    path: t,
    buildUrl: o
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/reset-import-hashes", o = z.object({ uni: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/reset-import-hashes";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-students", o = z.object({ uni: z.string().optional(), intakeId: z.string().optional(), pathway: z.string().optional(), stage: z.string().optional(), limit: z.number().optional(), offset: z.number().optional(), sortBy: z.string().optional(), sortOrder: z.enum(["asc", "desc"]).optional(), search: z.string().optional(), pathwayVisibility: z.string().optional(), message: z.boolean().optional(), startDate: z.string().optional(), endDate: z.string().optional(), unis: z.unknown().optional(), studentNo: z.unknown().optional(), givenName: z.unknown().optional(), surname: z.unknown().optional(), course: z.unknown().optional(), faculty: z.unknown().optional(), nationality: z.unknown().optional(), country: z.unknown().optional(), applicationCountry: z.unknown().optional(), activityStatus: z.unknown().optional(), notStarted: z.unknown().optional(), idle: z.unknown().optional(), complete: z.unknown().optional(), incomplete: z.unknown().optional(), fundsMaturity: z.unknown().optional(), market: z.unknown().optional(), region: z.unknown().optional(), visaStatus: z.unknown().optional(), confidence: z.unknown().optional(), agent: z.unknown().optional(), conditionalStatus: z.unknown().optional(), courseConditionalStatus: z.unknown().optional(), courseCondtionalStatus: z.unknown().optional(), evidenceRequirements: z.unknown().optional(), customRegion: z.unknown().optional(), tag: z.unknown().optional(), programmableTag: z.unknown().optional(), services: z.unknown().optional(), immigrationProviders: z.unknown().optional(), interview: z.unknown().optional(), recordedInterview: z.unknown().optional(), idleFrom: z.unknown().optional(), idleTo: z.unknown().optional(), dependants: z.unknown().optional(), tagsMatch: z.unknown().optional(), programmableTagsMatch: z.unknown().optional() }), i = () => "/get-students";
  return Object.assign(async (s) => {
    let n = i();
    if (s.queryParams)
      try {
        const r = o.parse(s.queryParams), u = buildQueryString(r);
        u && (n += "?" + u);
      } catch (r) {
        if (r instanceof z.ZodError) {
          const u = formatZodError(r, "query parameters");
          throw console.error("[ApiClient] Query parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
        }
        throw r;
      }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    queryParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-students/totals", o = z.object({ uni: z.string(), intakeId: z.string().optional() }), i = () => "/get-students/totals";
  return Object.assign(async (s) => {
    let n = i();
    if (s.queryParams)
      try {
        const r = o.parse(s.queryParams), u = buildQueryString(r);
        u && (n += "?" + u);
      } catch (r) {
        if (r instanceof z.ZodError) {
          const u = formatZodError(r, "query parameters");
          throw console.error("[ApiClient] Query parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
        }
        throw r;
      }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    queryParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-students/filters", o = z.object({ uni: z.string(), intakeId: z.string().optional() }), i = () => "/get-students/filters";
  return Object.assign(async (s) => {
    let n = i();
    if (s.queryParams)
      try {
        const r = o.parse(s.queryParams), u = buildQueryString(r);
        u && (n += "?" + u);
      } catch (r) {
        if (r instanceof z.ZodError) {
          const u = formatZodError(r, "query parameters");
          throw console.error("[ApiClient] Query parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
        }
        throw r;
      }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    queryParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/get-students/ids", o = z.object({ uni: z.string().optional(), intakeId: z.string().optional(), pathway: z.string().optional(), stage: z.string().optional(), limit: z.number().optional(), offset: z.number().optional(), sortBy: z.string().optional(), sortOrder: z.enum(["asc", "desc"]).optional(), search: z.string().optional(), pathwayVisibility: z.string().optional(), message: z.boolean().optional(), startDate: z.string().optional(), endDate: z.string().optional(), unis: z.unknown().optional(), studentNo: z.unknown().optional(), givenName: z.unknown().optional(), surname: z.unknown().optional(), course: z.unknown().optional(), faculty: z.unknown().optional(), nationality: z.unknown().optional(), country: z.unknown().optional(), applicationCountry: z.unknown().optional(), activityStatus: z.unknown().optional(), notStarted: z.unknown().optional(), idle: z.unknown().optional(), complete: z.unknown().optional(), incomplete: z.unknown().optional(), fundsMaturity: z.unknown().optional(), market: z.unknown().optional(), region: z.unknown().optional(), visaStatus: z.unknown().optional(), confidence: z.unknown().optional(), agent: z.unknown().optional(), conditionalStatus: z.unknown().optional(), courseConditionalStatus: z.unknown().optional(), courseCondtionalStatus: z.unknown().optional(), evidenceRequirements: z.unknown().optional(), customRegion: z.unknown().optional(), tag: z.unknown().optional(), programmableTag: z.unknown().optional(), services: z.unknown().optional(), immigrationProviders: z.unknown().optional(), interview: z.unknown().optional(), recordedInterview: z.unknown().optional(), idleFrom: z.unknown().optional(), idleTo: z.unknown().optional(), dependants: z.unknown().optional(), tagsMatch: z.unknown().optional(), programmableTagsMatch: z.unknown().optional() }), i = () => "/get-students/ids";
  return Object.assign(async (s) => {
    let n = i();
    if (s.queryParams)
      try {
        const r = o.parse(s.queryParams), u = buildQueryString(r);
        u && (n += "?" + u);
      } catch (r) {
        if (r instanceof z.ZodError) {
          const u = formatZodError(r, "query parameters");
          throw console.error("[ApiClient] Query parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
        }
        throw r;
      }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    queryParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/students/{uni}/{studentNo}/active-offers", o = z.object({ uni: z.string(), studentNo: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/{studentNo}/active-offers";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/{studentNo}/active-offer", o = z.object({ uni: z.string(), studentNo: z.string() }), i = z.object({ intakeId: z.string(), offerId: z.string() }), d = (n) => {
    try {
      const r = o.parse(n);
      let u = "/students/{uni}/{studentNo}/active-offer";
      return u = u.replace("{uni}", encodeURIComponent(String(r.uni ?? r.UNI ?? r.uni))), u = u.replace("{studentNo}", encodeURIComponent(String(r.studentNo ?? r.STUDENTNO ?? r.studentNo))), u;
    } catch (r) {
      if (r instanceof z.ZodError) {
        const u = formatZodError(r, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", u.message, u.details), new ApiValidationError(u.message, u.fields, u.details);
      }
      throw r;
    }
  };
  return Object.assign(async (n) => {
    let r = d(n.pathParams);
    if (n.queryParams) {
      const u = buildQueryString(n.queryParams);
      u && (r += "?" + u);
    }
    try {
      const u = i.parse(n.body);
      return makeRequest(e, r, u, n.options);
    } catch (u) {
      if (u instanceof z.ZodError) {
        const l = formatZodError(u, "request body");
        throw console.error("[ApiClient] Request body validation failed:", l.message, l.details), new ApiValidationError(l.message, l.fields, l.details);
      }
      throw u;
    }
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    bodySchema: i,
    buildUrl: d
  });
})(), (() => {
  const t = "/students/{uni}/{studentNo}/{intakeId}/{offerId}", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/{studentNo}/{intakeId}/{offerId}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/{studentNo}/{intakeId}/{offerId}", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/{studentNo}/{intakeId}/{offerId}";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const t = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest("GET", n, s.body, s.options);
  }, {
    method: "GET",
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/{studentNo}/upload", o = z.object({ uni: z.string(), studentNo: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/{studentNo}/upload";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/finance", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/finance";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})(), (() => {
  const e = "POST", t = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status", o = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() }), i = (s) => {
    try {
      const n = o.parse(s);
      let r = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status";
      return r = r.replace("{uni}", encodeURIComponent(String(n.uni ?? n.UNI ?? n.uni))), r = r.replace("{studentNo}", encodeURIComponent(String(n.studentNo ?? n.STUDENTNO ?? n.studentNo))), r = r.replace("{intakeId}", encodeURIComponent(String(n.intakeId ?? n.INTAKEID ?? n.intakeId))), r = r.replace("{offerId}", encodeURIComponent(String(n.offerId ?? n.OFFERID ?? n.offerId))), r;
    } catch (n) {
      if (n instanceof z.ZodError) {
        const r = formatZodError(n, "path parameters");
        throw console.error("[ApiClient] Path parameter validation failed:", r.message, r.details), new ApiValidationError(r.message, r.fields, r.details);
      }
      throw n;
    }
  };
  return Object.assign(async (s) => {
    let n = i(s.pathParams);
    if (s.queryParams) {
      const r = buildQueryString(s.queryParams);
      r && (n += "?" + r);
    }
    return makeRequest(e, n, s.body, s.options);
  }, {
    method: e,
    path: t,
    pathParamsSchema: o,
    buildUrl: i
  });
})();
const defaultState = {
  subscriptions: [],
  messages: [],
  connected: !1
}, actions = createActions({
  STORE_SENT_MESSAGE: (e) => ({
    message: e,
    type: TYPE.SENT
  }),
  STORE_RECEIVED_MESSAGE: (e) => ({
    message: e,
    type: TYPE.RECEIVED
  }),
  SEND: void 0,
  CONNECTION_SUCCESS: () => ({ connected: !0 }),
  CONNECTION_LOST: () => ({ connected: !1 }),
  SUBSCRIBE_TO_WEBSOCKET: ({ key: e, handler: t }) => ({
    key: e,
    handler: t
  }),
  UNSUBSCRIBE_FROM_WEBSOCKET: ({ key: e }) => ({ key: e }),
  ON_MESSAGE: void 0
}), reducer = handleActions(
  {
    [combineActions(
      actions.storeReceivedMessage,
      actions.storeSentMessage
    )]: (e, { payload: { message: t, type: o } }) => ({
      ...e,
      messages: [...e.messages, { ...t, type: o }]
    }),
    [combineActions(
      actions.connectionSuccess,
      actions.connectionLost
    )]: (e, { payload: { connected: t } }) => ({
      ...e,
      connected: t
    }),
    [actions.subscribeToWebsocket]: (e, { payload: { key: t, handler: o } }) => ({
      ...e,
      subscriptions: [...e.subscriptions, { key: t, handler: o }]
    }),
    [actions.unsubscribeFromWebsocket]: (e, { payload: { key: t } }) => {
      const o = [...e.subscriptions], i = o.findIndex((d) => d.key === t);
      return i !== -1 ? (o.splice(i, 1), {
        ...e,
        subscriptions: o
      }) : e;
    }
  },
  defaultState
);
export {
  actions,
  reducer
};
